export const Provinces = [
    {
        label: t('Alberta'),
        value: 'AB'
    },
    {
        label: t('British Columbia'),
        value: 'BC'
    },
    {
        label: t('Prince Edward Island'),
        value: 'PE'
    },
    {
        label: t('Manitoba'),
        value: 'MB'
    },
    {
        label: t('New Brunswick'),
        value: 'NB'
    },
    {
        label: t('Nova Scotia'),
        value: 'NS'
    },
    {
        label: t('Ontario'),
        value: 'ON'
    },
    {
        label: t('Quebec'),
        value: 'QC'
    },
    {
        label: t('Saskatchewan'),
        value: 'SK'
    },
    {
        label: t('Newfoundland and Labrador'),
        value: 'NL'
    },
    {
        label: t('Nunavut'),
        value: 'NU'
    },
    {
        label: t('Northwest Territories'),
        value: 'NT'
    },
    {
        label: t('Yukon'),
        value: 'YT'
    },
    {
        label: t('California'),
        value: 'CA'
    },
    {
        label: t('Colorado'),
        value: 'CO'
    },
    {
        label: t('Connecticut'),
        value: 'CT'
    },
    {
        label: t('Delaware'),
        value: 'DE'
    },
    {
        label: t('District of Columbia'),
        value: 'DC'
    },
    {
        label: t('Florida'),
        value: 'FL'
    },
    {
        label: t('Georgia'),
        value: 'GA'
    },
    {
        label: t('Hawaii'),
        value: 'HI'
    },
    {
        label: t('Idaho'),
        value: 'ID'
    },
    {
        label: t('Illinois'),
        value: 'IL'
    },
    {
        label: t('Indiana'),
        value: 'IN'
    },
    {
        label: t('Iowa'),
        value: 'IA'
    },
    {
        label: t('Kansas'),
        value: 'KS'
    },
    {
        label: t('Kentucky'),
        value: 'KY'
    },
    {
        label: t('Louisiana'),
        value: 'LA'
    },
    {
        label: t('Maine'),
        value: 'ME'
    },
    {
        label: t('Maryland'),
        value: 'MD'
    },
    {
        label: t('Massachusetts'),
        value: 'MA'
    },
    {
        label: t('Michigan'),
        value: 'MI'
    },
    {
        label: t('Minnesota'),
        value: 'MN'
    },
    {
        label: t('Mississippi'),
        value: 'MS'
    },
    {
        label: t('Missouri'),
        value: 'MO'
    },
    {
        label: t('Montana'),
        value: 'MT'
    },
    {
        label: t('Nebraska'),
        value: 'NE'
    },
    {
        label: t('Nevada'),
        value: 'NV'
    },
    {
        label: t('New Hampshire'),
        value: 'NH'
    },
    {
        label: t('New Jersey'),
        value: 'NJ'
    },
    {
        label: t('New Mexico'),
        value: 'NM'
    },
    {
        label: t('New York'),
        value: 'NY'
    },
    {
        label: t('North Carolina'),
        value: 'NC'
    },
    {
        label: t('North Dakota'),
        value: 'ND'
    },
    {
        label: t('Ohio'),
        value: 'OH'
    },
    {
        label: t('Oklahoma'),
        value: 'OK'
    },
    {
        label: t('Oregon'),
        value: 'OR'
    },
    {
        label: t('Pennsylvania'),
        value: 'PA'
    },
    {
        label: t('Rhode Island'),
        value: 'RI'
    },
    {
        label: t('South Carolina'),
        value: 'SC'
    },
    {
        label: t('South Dakota'),
        value: 'SD'
    },
    {
        label: t('Tennessee'),
        value: 'TN'
    },
    {
        label: t('Texas'),
        value: 'TX'
    },
    {
        label: t('Utah'),
        value: 'UT'
    },
    {
        label: t('Vermont'),
        value: 'VT'
    },
    {
        label: t('Virginia'),
        value: 'VA'
    },
    {
        label: t('Washington'),
        value: 'WA'
    },
    {
        label: t('West Virginia'),
        value: 'WV'
    },
    {
        label: t('Wisconsin'),
        value: 'WI'
    },
    {
        label: t('Wyoming'),
        value: 'WY'
    },
    {
        label: t('Alabama'),
        value: 'AL'
    },
    {
        label: t('Alaska'),
        value: 'AK'
    },
    {
        label: t('Arizona'),
        value: 'AZ'
    },
    {
        label: t('Arkansas'),
        value: 'AR'
    },
    {
        label: t('Nothern Mariana Islands'),
        value: 'MP'
    },
    {
        label: t('Puerto Rico'),
        value: 'PR'
    },
    {
        label: t('Virgin Islands'),
        value: 'VI'
    },
    {
        label: t('American Samoa'),
        value: 'AS'
    },
    {
        label: t('Guam'),
        value: 'GU'
    }
];
export const States = [
    {
        id: 1,
        states: [
            {
                id: 3901,
                name: 'Badakhshan',
                state_code: 'BDS',
                hasCities: true,
                latitude: '36.8040254',
                longitude: '71.367658'
            },
            {
                id: 3871,
                name: 'Badghis',
                state_code: 'BDG',
                hasCities: true,
                latitude: '35.0',
                longitude: '63.75'
            },
            {
                id: 3875,
                name: 'Baghlan',
                state_code: 'BGL',
                hasCities: true,
                latitude: '35.75',
                longitude: '69.0'
            },
            {
                id: 3884,
                name: 'Balkh',
                state_code: 'BAL',
                hasCities: true,
                latitude: '36.7991624',
                longitude: '67.2372587'
            },
            {
                id: 3872,
                name: 'Bamyan',
                state_code: 'BAM',
                hasCities: true,
                latitude: '34.75',
                longitude: '67.25'
            },
            {
                id: 3892,
                name: 'Daykundi',
                state_code: 'DAY',
                hasCities: true,
                latitude: '33.725113',
                longitude: '66.2196554'
            },
            {
                id: 3899,
                name: 'Farah',
                state_code: 'FRA',
                hasCities: true,
                latitude: '32.607111',
                longitude: '62.671011'
            },
            {
                id: 3889,
                name: 'Faryab',
                state_code: 'FYB',
                hasCities: true,
                latitude: '35.9261784',
                longitude: '64.6237758'
            },
            {
                id: 3870,
                name: 'Ghazni',
                state_code: 'GHA',
                hasCities: true,
                latitude: '33.3149631',
                longitude: '67.828989'
            },
            {
                id: 3888,
                name: 'Ghōr',
                state_code: 'GHO',
                hasCities: true,
                latitude: '34.1605257',
                longitude: '64.9201949'
            },
            {
                id: 3873,
                name: 'Helmand',
                state_code: 'HEL',
                hasCities: true,
                latitude: '31.0',
                longitude: '64.0'
            },
            {
                id: 3887,
                name: 'Herat',
                state_code: 'HER',
                hasCities: true,
                latitude: '34.1577182',
                longitude: '62.2905676'
            },
            {
                id: 3886,
                name: 'Jowzjan',
                state_code: 'JOW',
                hasCities: true,
                latitude: '36.9665706',
                longitude: '65.9560232'
            },
            {
                id: 3902,
                name: 'Kabul',
                state_code: 'KAB',
                hasCities: true,
                latitude: '34.5',
                longitude: '69.416667'
            },
            {
                id: 3890,
                name: 'Kandahar',
                state_code: 'KAN',
                hasCities: true,
                latitude: '30.9910033',
                longitude: '65.7068525'
            },
            {
                id: 3879,
                name: 'Kapisa',
                state_code: 'KAP',
                hasCities: true,
                latitude: '34.905556',
                longitude: '69.741667'
            },
            {
                id: 3878,
                name: 'Khost',
                state_code: 'KHO',
                hasCities: true,
                latitude: '33.4014634',
                longitude: '69.8912294'
            },
            {
                id: 3876,
                name: 'Kunar',
                state_code: 'KNR',
                hasCities: true,
                latitude: '34.95',
                longitude: '71.133333'
            },
            {
                id: 3900,
                name: 'Kunduz Province',
                state_code: 'KDZ',
                hasCities: true,
                latitude: '36.8707187',
                longitude: '68.7563528'
            },
            {
                id: 3891,
                name: 'Laghman',
                state_code: 'LAG',
                hasCities: true,
                latitude: '34.783333',
                longitude: '70.183333'
            },
            {
                id: 3897,
                name: 'Logar',
                state_code: 'LOG',
                hasCities: true,
                latitude: '34.0653595',
                longitude: '69.160172'
            },
            {
                id: 3882,
                name: 'Nangarhar',
                state_code: 'NAN',
                hasCities: true,
                latitude: '34.220389',
                longitude: '70.3800314'
            },
            {
                id: 3896,
                name: 'Nimruz',
                state_code: 'NIM',
                hasCities: true,
                latitude: '30.7753811',
                longitude: '62.4793088'
            },
            {
                id: 3880,
                name: 'Nuristan',
                state_code: 'NUR',
                hasCities: true,
                latitude: '35.3',
                longitude: '70.833333'
            },
            {
                id: 3894,
                name: 'Paktia',
                state_code: 'PIA',
                hasCities: true,
                latitude: '33.705724',
                longitude: '69.4083555'
            },
            {
                id: 3877,
                name: 'Paktika',
                state_code: 'PKA',
                hasCities: true,
                latitude: '32.3936231',
                longitude: '68.7036514'
            },
            {
                id: 3881,
                name: 'Panjshir',
                state_code: 'PAN',
                hasCities: true,
                latitude: '35.4338536',
                longitude: '69.7930899'
            },
            {
                id: 3895,
                name: 'Parwan',
                state_code: 'PAR',
                hasCities: true,
                latitude: '34.9797014',
                longitude: '68.9146703'
            },
            {
                id: 3883,
                name: 'Samangan',
                state_code: 'SAM',
                hasCities: true,
                latitude: '36.0',
                longitude: '67.666667'
            },
            {
                id: 3885,
                name: 'Sar-e Pol',
                state_code: 'SAR',
                hasCities: true,
                latitude: '35.5532126',
                longitude: '66.2426766'
            },
            {
                id: 3893,
                name: 'Takhar',
                state_code: 'TAK',
                hasCities: true,
                latitude: '36.5940732',
                longitude: '69.7938996'
            },
            {
                id: 3898,
                name: 'Urozgan',
                state_code: 'URU',
                hasCities: true,
                latitude: '32.8129681',
                longitude: '66.0183185'
            },
            {
                id: 3874,
                name: 'Zabul',
                state_code: 'ZAB',
                hasCities: true,
                latitude: '32.3068942',
                longitude: '67.129904'
            }
        ]
    },
    { id: 2, states: [] },
    {
        id: 3,
        states: [
            {
                id: 629,
                name: 'Berat County',
                state_code: 'BR',
                hasCities: true
            },
            {
                id: 607,
                name: 'Bulqizë District',
                state_code: 'BU',
                hasCities: false
            },
            {
                id: 618,
                name: 'Delvinë District',
                state_code: 'DL',
                hasCities: false
            },
            {
                id: 608,
                name: 'Devoll District',
                state_code: 'DV',
                hasCities: false
            },
            {
                id: 610,
                name: 'Dibër County',
                state_code: 'DI',
                hasCities: true
            },
            {
                id: 639,
                name: 'Durrës',
                state_code: 'DR',
                hasCities: true
            },
            {
                id: 598,
                name: 'Elbasan County',
                state_code: '03',
                hasCities: false
            },
            {
                id: 631,
                name: 'Fier County',
                state_code: 'FR',
                hasCities: true
            },
            {
                id: 621,
                name: 'Gjirokastër District',
                state_code: 'GJ',
                hasCities: true
            },
            {
                id: 617,
                name: 'Gramsh District',
                state_code: 'GR',
                hasCities: false
            },
            {
                id: 600,
                name: 'Has District',
                state_code: 'HA',
                hasCities: false
            },
            {
                id: 594,
                name: 'Kavajë District',
                state_code: 'KA',
                hasCities: false
            },
            {
                id: 628,
                name: 'Kolonjë District',
                state_code: 'ER',
                hasCities: false
            },
            {
                id: 630,
                name: 'Korçë County',
                state_code: '06',
                hasCities: true
            },
            {
                id: 597,
                name: 'Korçë District',
                state_code: 'KO',
                hasCities: false
            },
            {
                id: 614,
                name: 'Krujë District',
                state_code: 'KR',
                hasCities: false
            },
            {
                id: 612,
                name: 'Kuçovë District',
                state_code: 'KC',
                hasCities: false
            },
            {
                id: 601,
                name: 'Kukës County',
                state_code: '07',
                hasCities: false
            },
            {
                id: 623,
                name: 'Kukës District',
                state_code: 'KU',
                hasCities: true
            },
            {
                id: 622,
                name: 'Kurbin District',
                state_code: 'KB',
                hasCities: false
            },
            {
                id: 609,
                name: 'Lezhë County',
                state_code: '08',
                hasCities: true
            },
            {
                id: 595,
                name: 'Lezhë District',
                state_code: 'LE',
                hasCities: false
            },
            {
                id: 596,
                name: 'Librazhd District',
                state_code: 'LB',
                hasCities: false
            },
            {
                id: 599,
                name: 'Lushnjë District',
                state_code: 'LU',
                hasCities: false
            },
            {
                id: 602,
                name: 'Malësi e Madhe District',
                state_code: 'MM',
                hasCities: false
            },
            {
                id: 637,
                name: 'Mallakastër District',
                state_code: 'MK',
                hasCities: false
            },
            {
                id: 635,
                name: 'Mat District',
                state_code: 'MT',
                hasCities: false
            },
            {
                id: 638,
                name: 'Mirditë District',
                state_code: 'MR',
                hasCities: false
            },
            {
                id: 619,
                name: 'Peqin District',
                state_code: 'PQ',
                hasCities: false
            },
            {
                id: 625,
                name: 'Përmet District',
                state_code: 'PR',
                hasCities: false
            },
            {
                id: 606,
                name: 'Pogradec District',
                state_code: 'PG',
                hasCities: false
            },
            {
                id: 620,
                name: 'Pukë District',
                state_code: 'PU',
                hasCities: false
            },
            {
                id: 624,
                name: 'Sarandë District',
                state_code: 'SR',
                hasCities: false
            },
            {
                id: 611,
                name: 'Shkodër County',
                state_code: '10',
                hasCities: false
            },
            {
                id: 626,
                name: 'Shkodër District',
                state_code: 'SH',
                hasCities: true
            },
            {
                id: 593,
                name: 'Skrapar District',
                state_code: 'SK',
                hasCities: false
            },
            {
                id: 616,
                name: 'Tepelenë District',
                state_code: 'TE',
                hasCities: false
            },
            {
                id: 615,
                name: 'Tirana County',
                state_code: '11',
                hasCities: false
            },
            {
                id: 633,
                name: 'Tirana District',
                state_code: 'TR',
                hasCities: true
            },
            {
                id: 636,
                name: 'Tropojë District',
                state_code: 'TP',
                hasCities: false
            },
            {
                id: 634,
                name: 'Vlorë County',
                state_code: '12',
                hasCities: true
            },
            {
                id: 613,
                name: 'Vlorë District',
                state_code: 'VL',
                hasCities: false
            }
        ]
    },
    {
        id: 4,
        states: [
            {
                id: 1118,
                name: 'Adrar',
                state_code: '01',
                hasCities: true,
                latitude: '26.4888155',
                longitude: '-1.3582442169365363'
            },
            {
                id: 1119,
                name: 'Aïn Defla',
                state_code: '44',
                hasCities: true,
                latitude: '36.15868425',
                longitude: '2.084281730358365'
            },
            {
                id: 1122,
                name: 'Aïn Témouchent',
                state_code: '46',
                hasCities: true,
                latitude: '35.36512965',
                longitude: '-0.9452170664335665'
            },
            {
                id: 1144,
                name: 'Algiers',
                state_code: '16',
                hasCities: true,
                latitude: '36.70005095',
                longitude: '3.029126556356098'
            },
            {
                id: 1103,
                name: 'Annaba',
                state_code: '23',
                hasCities: true,
                latitude: '36.843844849999996',
                longitude: '7.598173831663802'
            },
            {
                id: 1142,
                name: 'Batna',
                state_code: '05',
                hasCities: true,
                latitude: '35.3384291',
                longitude: '5.731545299000572'
            },
            {
                id: 1108,
                name: 'Béchar',
                state_code: '08',
                hasCities: true,
                latitude: '31.385726',
                longitude: '-2.011595847987405'
            },
            {
                id: 1128,
                name: 'Béjaïa',
                state_code: '06',
                hasCities: true,
                latitude: '36.5569005',
                longitude: '4.785892522272571'
            },
            {
                id: 4909,
                name: 'Béni Abbès',
                state_code: '53',
                hasCities: false,
                latitude: '29.083202',
                longitude: '-2.65900601043017'
            },
            {
                id: 1114,
                name: 'Biskra',
                state_code: '07',
                hasCities: true,
                latitude: '34.784563500000004',
                longitude: '5.812435334419206'
            },
            {
                id: 1111,
                name: 'Blida',
                state_code: '09',
                hasCities: true,
                latitude: '36.5012595',
                longitude: '2.9517665558061674'
            },
            {
                id: 4908,
                name: 'Bordj Baji Mokhtar',
                state_code: '52',
                hasCities: false,
                latitude: '22.626146050000003',
                longitude: '0.12758168507861467'
            },
            {
                id: 1116,
                name: 'Bordj Bou Arréridj',
                state_code: '34',
                hasCities: true,
                latitude: '36.09620285',
                longitude: '4.660274234539607'
            },
            {
                id: 1104,
                name: 'Bouïra',
                state_code: '10',
                hasCities: true,
                latitude: '36.2316481',
                longitude: '3.9082579191011253'
            },
            {
                id: 1125,
                name: 'Boumerdès',
                state_code: '35',
                hasCities: true,
                latitude: '36.7358032',
                longitude: '3.6163045700585252'
            },
            {
                id: 1105,
                name: 'Chlef',
                state_code: '02',
                hasCities: true,
                latitude: '36.203419999999994',
                longitude: '1.2680696005416272'
            },
            {
                id: 1121,
                name: 'Constantine',
                state_code: '25',
                hasCities: true,
                latitude: '36.3584165',
                longitude: '6.667167381153502'
            },
            {
                id: 4912,
                name: 'Djanet',
                state_code: '56',
                hasCities: false,
                latitude: '24.071521',
                longitude: '9.615584725366856'
            },
            {
                id: 1098,
                name: 'Djelfa',
                state_code: '17',
                hasCities: true,
                latitude: '34.342841',
                longitude: '3.217253079090331'
            },
            {
                id: 1129,
                name: 'El Bayadh',
                state_code: '32',
                hasCities: true,
                latitude: '32.570302999999996',
                longitude: '1.1259581442818078'
            },
            {
                id: 4905,
                name: "El M'ghair",
                state_code: '49',
                hasCities: false,
                latitude: '33.95807',
                longitude: '5.701126230439295'
            },
            {
                id: 4906,
                name: 'El Menia',
                state_code: '50',
                hasCities: false,
                latitude: '30.7071885',
                longitude: '3.048062480049727'
            },
            {
                id: 1099,
                name: 'El Oued',
                state_code: '39',
                hasCities: true,
                latitude: '33.215441',
                longitude: '7.155321399098325'
            },
            {
                id: 1100,
                name: 'El Tarf',
                state_code: '36',
                hasCities: true,
                latitude: '36.67135625',
                longitude: '8.070134002053635'
            },
            {
                id: 1127,
                name: 'Ghardaïa',
                state_code: '47',
                hasCities: true,
                latitude: '32.440827',
                longitude: '3.5618208521628776'
            },
            {
                id: 1137,
                name: 'Guelma',
                state_code: '24',
                hasCities: true,
                latitude: '36.3491635',
                longitude: '7.409498952760461'
            },
            {
                id: 1112,
                name: 'Illizi',
                state_code: '33',
                hasCities: true,
                latitude: '27.852850500000002',
                longitude: '7.8189636047396895'
            },
            {
                id: 4914,
                name: 'In Guezzam',
                state_code: '58',
                hasCities: false,
                latitude: '20.427529999999997',
                longitude: '4.6766309838048326'
            },
            {
                id: 4913,
                name: 'In Salah',
                state_code: '57',
                hasCities: false,
                latitude: '27.197705499999998',
                longitude: '3.5212375793144277'
            },
            {
                id: 1113,
                name: 'Jijel',
                state_code: '18',
                hasCities: true,
                latitude: '36.72921875',
                longitude: '5.960777606253644'
            },
            {
                id: 1126,
                name: 'Khenchela',
                state_code: '40',
                hasCities: true,
                latitude: '34.913345500000005',
                longitude: '6.905943093880865'
            },
            {
                id: 1138,
                name: 'Laghouat',
                state_code: '03',
                hasCities: true,
                latitude: '33.750440499999996',
                longitude: '2.6431093610595155'
            },
            {
                id: 1134,
                name: "M'Sila",
                state_code: '28',
                hasCities: true,
                latitude: '35.1300205',
                longitude: '4.200310671358427'
            },
            {
                id: 1124,
                name: 'Mascara',
                state_code: '29',
                hasCities: true,
                latitude: '35.397838500000006',
                longitude: '0.24301949927219488'
            },
            {
                id: 1109,
                name: 'Médéa',
                state_code: '26',
                hasCities: true,
                latitude: '35.975204500000004',
                longitude: '3.012350405608216'
            },
            {
                id: 1132,
                name: 'Mila',
                state_code: '43',
                hasCities: true,
                latitude: '36.2502135',
                longitude: '6.165216333385166'
            },
            {
                id: 1140,
                name: 'Mostaganem',
                state_code: '27',
                hasCities: true,
                latitude: '36.0026915',
                longitude: '0.3686866818796205'
            },
            {
                id: 1102,
                name: 'Naama',
                state_code: '45',
                hasCities: true,
                latitude: '33.2336851',
                longitude: '-0.8151958390775952'
            },
            {
                id: 1101,
                name: 'Oran',
                state_code: '31',
                hasCities: true,
                latitude: '35.62158615',
                longitude: '-0.7016142676845641'
            },
            {
                id: 1139,
                name: 'Ouargla',
                state_code: '30',
                hasCities: true,
                latitude: '30.9980145',
                longitude: '6.766453639443059'
            },
            {
                id: 4907,
                name: 'Ouled Djellal',
                state_code: '51',
                hasCities: false,
                latitude: '34.104904000000005',
                longitude: '4.820300902475401'
            },
            {
                id: 1136,
                name: 'Oum El Bouaghi',
                state_code: '04',
                hasCities: true,
                latitude: '35.8105805',
                longitude: '7.018417796577514'
            },
            {
                id: 1130,
                name: 'Relizane',
                state_code: '48',
                hasCities: true,
                latitude: '35.836318500000004',
                longitude: '0.9118537366540664'
            },
            {
                id: 1123,
                name: 'Saïda',
                state_code: '20',
                hasCities: true,
                latitude: '34.743349',
                longitude: '0.2440763627808458'
            },
            {
                id: 1141,
                name: 'Sétif',
                state_code: '19',
                hasCities: true,
                latitude: '36.105661',
                longitude: '5.562027618601267'
            },
            {
                id: 4902,
                name: 'Sidi Bel Abbès',
                state_code: '22',
                hasCities: true,
                latitude: '34.682268',
                longitude: '-0.43575550651239253'
            },
            {
                id: 1110,
                name: 'Skikda',
                state_code: '21',
                hasCities: true,
                latitude: '36.75451150000001',
                longitude: '6.885625492591183'
            },
            {
                id: 1143,
                name: 'Souk Ahras',
                state_code: '41',
                hasCities: true,
                latitude: '36.1378681',
                longitude: '7.826242640053763'
            },
            {
                id: 1135,
                name: 'Tamanghasset',
                state_code: '11',
                hasCities: true,
                latitude: '24.3753438',
                longitude: '4.3208436'
            },
            {
                id: 1117,
                name: 'Tébessa',
                state_code: '12',
                hasCities: true,
                latitude: '35.124945',
                longitude: '7.901173504229375'
            },
            {
                id: 1106,
                name: 'Tiaret',
                state_code: '14',
                hasCities: true,
                latitude: '34.8947575',
                longitude: '1.594579173136212'
            },
            {
                id: 4910,
                name: 'Timimoun',
                state_code: '54',
                hasCities: false,
                latitude: '30.0244725',
                longitude: '0.8485978976216642'
            },
            {
                id: 1120,
                name: 'Tindouf',
                state_code: '37',
                hasCities: true,
                latitude: '27.54390695',
                longitude: '-6.240041058655946'
            },
            {
                id: 1115,
                name: 'Tipasa',
                state_code: '42',
                hasCities: true,
                latitude: '36.527157',
                longitude: '2.1672011802712086'
            },
            {
                id: 1133,
                name: 'Tissemsilt',
                state_code: '38',
                hasCities: true,
                latitude: '35.785897500000004',
                longitude: '1.8340956752427218'
            },
            {
                id: 1131,
                name: 'Tizi Ouzou',
                state_code: '15',
                hasCities: true,
                latitude: '36.6816175',
                longitude: '4.237186047040007'
            },
            {
                id: 1107,
                name: 'Tlemcen',
                state_code: '13',
                hasCities: true,
                latitude: '34.667468',
                longitude: '-1.297813226234569'
            },
            {
                id: 4911,
                name: 'Touggourt',
                state_code: '55',
                hasCities: false,
                latitude: '32.98251965',
                longitude: '6.235443156542997'
            }
        ]
    },
    { id: 5, states: [] },
    {
        id: 6,
        states: [
            {
                id: 488,
                name: 'Andorra la Vella',
                state_code: '07',
                hasCities: true
            },
            { id: 489, name: 'Canillo', state_code: '02', hasCities: true },
            {
                id: 487,
                name: 'Encamp',
                state_code: '03',
                hasCities: true,
                latitude: '42.502355949999995',
                longitude: '1.6571452363070542'
            },
            {
                id: 492,
                name: 'Escaldes-Engordany',
                state_code: '08',
                hasCities: true,
                latitude: '42.51276315',
                longitude: '1.5364744131311874'
            },
            {
                id: 493,
                name: 'La Massana',
                state_code: '04',
                hasCities: true,
                latitude: '42.544962850000005',
                longitude: '1.5165449472664485'
            },
            {
                id: 491,
                name: 'Ordino',
                state_code: '05',
                hasCities: true,
                latitude: '42.6271621',
                longitude: '1.4912605793978895'
            },
            {
                id: 490,
                name: 'Sant Julià de Lòria',
                state_code: '06',
                hasCities: true
            }
        ]
    },
    {
        id: 7,
        states: [
            {
                id: 221,
                name: 'Bengo Province',
                state_code: 'BGO',
                hasCities: true,
                latitude: '-8.3196672',
                longitude: '13.8656195'
            },
            {
                id: 218,
                name: 'Benguela Province',
                state_code: 'BGU',
                hasCities: true,
                latitude: '-12.9104657',
                longitude: '14.0356608'
            },
            {
                id: 212,
                name: 'Bié Province',
                state_code: 'BIE',
                hasCities: true,
                latitude: '-12.2630485',
                longitude: '17.4967812'
            },
            {
                id: 228,
                name: 'Cabinda Province',
                state_code: 'CAB',
                hasCities: true,
                latitude: '-5.056395',
                longitude: '12.3211749'
            },
            {
                id: 226,
                name: 'Cuando Cubango Province',
                state_code: 'CCU',
                hasCities: true,
                latitude: '-16.0457694',
                longitude: '19.5621532'
            },
            {
                id: 217,
                name: 'Cuanza Norte Province',
                state_code: 'CNO',
                hasCities: true,
                latitude: '-9.0296752',
                longitude: '15.0926324'
            },
            {
                id: 216,
                name: 'Cuanza Sul',
                state_code: 'CUS',
                hasCities: true,
                latitude: '-10.7707527',
                longitude: '15.0975712'
            },
            {
                id: 215,
                name: 'Cunene Province',
                state_code: 'CNN',
                hasCities: true,
                latitude: '-16.5568536',
                longitude: '15.7867319'
            },
            {
                id: 213,
                name: 'Huambo Province',
                state_code: 'HUA',
                hasCities: true,
                latitude: '-12.6076318',
                longitude: '15.7411039'
            },
            {
                id: 225,
                name: 'Huíla Province',
                state_code: 'HUI',
                hasCities: true,
                latitude: '-14.6957808',
                longitude: '15.0976293'
            },
            {
                id: 222,
                name: 'Luanda Province',
                state_code: 'LUA',
                hasCities: true,
                latitude: '-9.51803445',
                longitude: '13.53567602042315'
            },
            {
                id: 223,
                name: 'Lunda Norte Province',
                state_code: 'LNO',
                hasCities: true,
                latitude: '-8.5088253',
                longitude: '19.7538618'
            },
            {
                id: 220,
                name: 'Lunda Sul Province',
                state_code: 'LSU',
                hasCities: true,
                latitude: '-10.1473779',
                longitude: '20.9907756'
            },
            {
                id: 227,
                name: 'Malanje Province',
                state_code: 'MAL',
                hasCities: true,
                latitude: '-9.535332',
                longitude: '16.9364293'
            },
            {
                id: 219,
                name: 'Moxico Province',
                state_code: 'MOX',
                hasCities: true,
                latitude: '-12.7287195',
                longitude: '21.2737637'
            },
            {
                id: 224,
                name: 'Uíge Province',
                state_code: 'UIG',
                hasCities: true,
                latitude: '-6.9516802',
                longitude: '15.4799164'
            },
            {
                id: 214,
                name: 'Zaire Province',
                state_code: 'ZAI',
                hasCities: true,
                latitude: '-6.6925131',
                longitude: '13.5293029'
            }
        ]
    },
    { id: 8, states: [] },
    { id: 9, states: [] },
    {
        id: 10,
        states: [
            {
                id: 3708,
                name: 'Barbuda',
                state_code: '10',
                hasCities: true,
                latitude: '17.6148748',
                longitude: '-61.85437614537078'
            },
            {
                id: 3703,
                name: 'Redonda',
                state_code: '11',
                hasCities: false,
                latitude: '17.0244844',
                longitude: '-62.29362256990399'
            },
            {
                id: 3709,
                name: 'Saint George Parish',
                state_code: '03',
                hasCities: true
            },
            {
                id: 3706,
                name: 'Saint John Parish',
                state_code: '04',
                hasCities: true
            },
            {
                id: 3707,
                name: 'Saint Mary Parish',
                state_code: '05',
                hasCities: true
            },
            {
                id: 3705,
                name: 'Saint Paul Parish',
                state_code: '06',
                hasCities: true
            },
            {
                id: 3704,
                name: 'Saint Peter Parish',
                state_code: '07',
                hasCities: true
            },
            {
                id: 3710,
                name: 'Saint Philip Parish',
                state_code: '08',
                hasCities: false
            }
        ]
    },
    {
        id: 11,
        states: [
            {
                id: 3656,
                name: 'Buenos Aires',
                state_code: 'B',
                hasCities: true,
                latitude: '-37.14984035',
                longitude: '-60.1319456430117'
            },
            {
                id: 3647,
                name: 'Catamarca',
                state_code: 'K',
                hasCities: true,
                latitude: '-27.1910825',
                longitude: '-67.105374'
            },
            {
                id: 3640,
                name: 'Chaco',
                state_code: 'H',
                hasCities: true,
                latitude: '-26.3829647',
                longitude: '-60.8816092'
            },
            {
                id: 3651,
                name: 'Chubut',
                state_code: 'U',
                hasCities: true,
                latitude: '-43.7128356',
                longitude: '-68.7461817'
            },
            {
                id: 4880,
                name: 'Ciudad Autónoma de Buenos Aires',
                state_code: 'C',
                hasCities: false,
                latitude: '-34.61612315',
                longitude: '-58.435620572580476'
            },
            {
                id: 3642,
                name: 'Córdoba',
                state_code: 'X',
                hasCities: true,
                latitude: '-32.0967361',
                longitude: '-63.7940923'
            },
            {
                id: 3638,
                name: 'Corrientes',
                state_code: 'W',
                hasCities: true,
                latitude: '-28.99565115',
                longitude: '-57.81245796667342'
            },
            {
                id: 3654,
                name: 'Entre Ríos',
                state_code: 'E',
                hasCities: true,
                latitude: '-31.6252842',
                longitude: '-59.3539578'
            },
            {
                id: 3652,
                name: 'Formosa',
                state_code: 'P',
                hasCities: true,
                latitude: '-24.5955306',
                longitude: '-60.4289718'
            },
            {
                id: 3645,
                name: 'Jujuy',
                state_code: 'Y',
                hasCities: true,
                latitude: '-23.3161458',
                longitude: '-65.7595288'
            },
            {
                id: 3655,
                name: 'La Pampa',
                state_code: 'L',
                hasCities: true,
                latitude: '-37.2314643',
                longitude: '-65.3972948'
            },
            {
                id: 3653,
                name: 'La Rioja',
                state_code: 'F',
                hasCities: true,
                latitude: '-29.9729781',
                longitude: '-67.0487944'
            },
            {
                id: 3646,
                name: 'Mendoza',
                state_code: 'M',
                hasCities: true,
                latitude: '-34.787093049999996',
                longitude: '-68.43818677312292'
            },
            {
                id: 3644,
                name: 'Misiones',
                state_code: 'N',
                hasCities: true,
                latitude: '-26.737224',
                longitude: '-54.4315257'
            },
            {
                id: 3648,
                name: 'Neuquén',
                state_code: 'Q',
                hasCities: true,
                latitude: '-38.3695057',
                longitude: '-69.832275'
            },
            {
                id: 3639,
                name: 'Río Negro',
                state_code: 'R',
                hasCities: true,
                latitude: '-40.4811973',
                longitude: '-67.6145911'
            },
            {
                id: 3643,
                name: 'Salta',
                state_code: 'A',
                hasCities: true,
                latitude: '-25.1076701',
                longitude: '-64.3494964'
            },
            {
                id: 3634,
                name: 'San Juan',
                state_code: 'J',
                hasCities: true,
                latitude: '-30.7054363',
                longitude: '-69.1988222'
            },
            {
                id: 3636,
                name: 'San Luis',
                state_code: 'D',
                hasCities: true,
                latitude: '-33.2762202',
                longitude: '-65.9515546'
            },
            {
                id: 3649,
                name: 'Santa Cruz',
                state_code: 'Z',
                hasCities: true,
                latitude: '-48.5693327',
                longitude: '-70.1606767'
            },
            {
                id: 3641,
                name: 'Santa Fe',
                state_code: 'S',
                hasCities: true,
                latitude: '-30.3154739',
                longitude: '-61.1645076'
            },
            {
                id: 3635,
                name: 'Santiago del Estero',
                state_code: 'G',
                hasCities: true,
                latitude: '-27.6431016',
                longitude: '-63.5408542'
            },
            {
                id: 3650,
                name: 'Tierra del Fuego',
                state_code: 'V',
                hasCities: true,
                latitude: '-54.4071064',
                longitude: '-67.8974895'
            },
            {
                id: 3637,
                name: 'Tucumán',
                state_code: 'T',
                hasCities: true,
                latitude: '-26.5643582',
                longitude: '-64.882397'
            }
        ]
    },
    {
        id: 12,
        states: [
            {
                id: 2023,
                name: 'Aragatsotn Region',
                state_code: 'AG',
                hasCities: true
            },
            {
                id: 2024,
                name: 'Ararat Province',
                state_code: 'AR',
                hasCities: true,
                latitude: '40.0053589',
                longitude: '44.7315157'
            },
            {
                id: 2026,
                name: 'Armavir Region',
                state_code: 'AV',
                hasCities: true
            },
            {
                id: 2028,
                name: 'Gegharkunik Province',
                state_code: 'GR',
                hasCities: true,
                latitude: '40.3030726',
                longitude: '45.375739'
            },
            {
                id: 2033,
                name: 'Kotayk Region',
                state_code: 'KT',
                hasCities: true
            },
            {
                id: 2029,
                name: 'Lori Region',
                state_code: 'LO',
                hasCities: true
            },
            {
                id: 2031,
                name: 'Shirak Region',
                state_code: 'SH',
                hasCities: true
            },
            {
                id: 2027,
                name: 'Syunik Province',
                state_code: 'SU',
                hasCities: true,
                latitude: '39.3281408',
                longitude: '46.1530296'
            },
            {
                id: 2032,
                name: 'Tavush Region',
                state_code: 'TV',
                hasCities: true
            },
            {
                id: 2025,
                name: 'Vayots Dzor Region',
                state_code: 'VD',
                hasCities: true
            },
            {
                id: 2030,
                name: 'Yerevan',
                state_code: 'ER',
                hasCities: true,
                latitude: '40.1777112',
                longitude: '44.5126233'
            }
        ]
    },
    { id: 13, states: [] },
    {
        id: 14,
        states: [
            {
                id: 3907,
                name: 'Australian Capital Territory',
                state_code: 'ACT',
                hasCities: true,
                latitude: '-35.4883502',
                longitude: '149.0026942'
            },
            {
                id: 3909,
                name: 'New South Wales',
                state_code: 'NSW',
                hasCities: true,
                latitude: '-31.8759835',
                longitude: '147.2869493'
            },
            {
                id: 3910,
                name: 'Northern Territory',
                state_code: 'NT',
                hasCities: true,
                latitude: '-19.8516101',
                longitude: '133.2303375'
            },
            {
                id: 3905,
                name: 'Queensland',
                state_code: 'QLD',
                hasCities: true,
                latitude: '-22.1646782',
                longitude: '144.5844903'
            },
            {
                id: 3904,
                name: 'South Australia',
                state_code: 'SA',
                hasCities: true,
                latitude: '-30.5343665',
                longitude: '135.6301212'
            },
            {
                id: 3908,
                name: 'Tasmania',
                state_code: 'TAS',
                hasCities: true,
                latitude: '-42.035067',
                longitude: '146.6366887'
            },
            {
                id: 3903,
                name: 'Victoria',
                state_code: 'VIC',
                hasCities: true,
                latitude: '-36.5986096',
                longitude: '144.6780052'
            },
            {
                id: 3906,
                name: 'Western Australia',
                state_code: 'WA',
                hasCities: true,
                latitude: '-25.2303005',
                longitude: '121.0187246'
            }
        ]
    },
    {
        id: 15,
        states: [
            {
                id: 2062,
                name: 'Burgenland',
                state_code: '1',
                hasCities: true,
                latitude: '47.5000001',
                longitude: '16.4166666'
            },
            {
                id: 2057,
                name: 'Carinthia',
                state_code: '2',
                hasCities: true,
                latitude: '46.7500001',
                longitude: '13.8333333'
            },
            {
                id: 2065,
                name: 'Lower Austria',
                state_code: '3',
                hasCities: true,
                latitude: '48.2817813',
                longitude: '15.7632457'
            },
            {
                id: 2061,
                name: 'Salzburg',
                state_code: '5',
                hasCities: true,
                latitude: '47.4166667',
                longitude: '13.25'
            },
            {
                id: 2059,
                name: 'Styria',
                state_code: '6',
                hasCities: true,
                latitude: '47.2500001',
                longitude: '15.1666665'
            },
            {
                id: 2064,
                name: 'Tyrol',
                state_code: '7',
                hasCities: true,
                latitude: '47.223193',
                longitude: '11.5261028'
            },
            {
                id: 2058,
                name: 'Upper Austria',
                state_code: '4',
                hasCities: true,
                latitude: '48.25',
                longitude: '14.0'
            },
            {
                id: 2060,
                name: 'Vienna',
                state_code: '9',
                hasCities: true,
                latitude: '48.2083537',
                longitude: '16.3725042'
            },
            {
                id: 2063,
                name: 'Vorarlberg',
                state_code: '8',
                hasCities: true,
                latitude: '47.25',
                longitude: '9.9166667'
            }
        ]
    },
    {
        id: 16,
        states: [
            {
                id: 540,
                name: 'Absheron District',
                state_code: 'ABS',
                hasCities: true
            },
            {
                id: 559,
                name: 'Agdam District',
                state_code: 'AGM',
                hasCities: true
            },
            {
                id: 553,
                name: 'Agdash District',
                state_code: 'AGS',
                hasCities: true
            },
            {
                id: 577,
                name: 'Aghjabadi District',
                state_code: 'AGC',
                hasCities: true
            },
            {
                id: 543,
                name: 'Agstafa District',
                state_code: 'AGA',
                hasCities: true
            },
            {
                id: 547,
                name: 'Agsu District',
                state_code: 'AGU',
                hasCities: true
            },
            {
                id: 528,
                name: 'Astara District',
                state_code: 'AST',
                hasCities: true
            },
            {
                id: 575,
                name: 'Babek District',
                state_code: 'BAB',
                hasCities: false
            },
            {
                id: 552,
                name: 'Baku',
                state_code: 'BA',
                hasCities: true,
                latitude: '40.3698536',
                longitude: '49.953885176184734'
            },
            {
                id: 560,
                name: 'Balakan District',
                state_code: 'BAL',
                hasCities: true
            },
            {
                id: 569,
                name: 'Barda District',
                state_code: 'BAR',
                hasCities: true
            },
            {
                id: 554,
                name: 'Beylagan District',
                state_code: 'BEY',
                hasCities: true
            },
            {
                id: 532,
                name: 'Bilasuvar District',
                state_code: 'BIL',
                hasCities: true
            },
            {
                id: 561,
                name: 'Dashkasan District',
                state_code: 'DAS',
                hasCities: true
            },
            {
                id: 527,
                name: 'Fizuli District',
                state_code: 'FUZ',
                hasCities: true
            },
            {
                id: 585,
                name: 'Ganja',
                state_code: 'GA',
                hasCities: true,
                latitude: '40.4117051',
                longitude: '46.1372844'
            },
            {
                id: 589,
                name: 'Gədəbəy',
                state_code: 'GAD',
                hasCities: true,
                latitude: '40.6143568',
                longitude: '45.8175292'
            },
            {
                id: 573,
                name: 'Gobustan District',
                state_code: 'QOB',
                hasCities: true
            },
            {
                id: 551,
                name: 'Goranboy District',
                state_code: 'GOR',
                hasCities: true
            },
            { id: 531, name: 'Goychay', state_code: 'GOY', hasCities: true },
            {
                id: 574,
                name: 'Goygol District',
                state_code: 'GYG',
                hasCities: true
            },
            {
                id: 571,
                name: 'Hajigabul District',
                state_code: 'HAC',
                hasCities: true
            },
            {
                id: 544,
                name: 'Imishli District',
                state_code: 'IMI',
                hasCities: true
            },
            {
                id: 564,
                name: 'Ismailli District',
                state_code: 'ISM',
                hasCities: true
            },
            {
                id: 570,
                name: 'Jabrayil District',
                state_code: 'CAB',
                hasCities: true
            },
            {
                id: 578,
                name: 'Jalilabad District',
                state_code: 'CAL',
                hasCities: true
            },
            {
                id: 572,
                name: 'Julfa District',
                state_code: 'CUL',
                hasCities: false
            },
            {
                id: 525,
                name: 'Kalbajar District',
                state_code: 'KAL',
                hasCities: true
            },
            {
                id: 567,
                name: 'Kangarli District',
                state_code: 'KAN',
                hasCities: false
            },
            {
                id: 590,
                name: 'Khachmaz District',
                state_code: 'XAC',
                hasCities: true
            },
            {
                id: 537,
                name: 'Khizi District',
                state_code: 'XIZ',
                hasCities: true
            },
            {
                id: 524,
                name: 'Khojali District',
                state_code: 'XCI',
                hasCities: true
            },
            {
                id: 549,
                name: 'Kurdamir District',
                state_code: 'KUR',
                hasCities: true
            },
            {
                id: 541,
                name: 'Lachin District',
                state_code: 'LAC',
                hasCities: true
            },
            {
                id: 587,
                name: 'Lankaran',
                state_code: 'LAN',
                hasCities: false,
                latitude: '38.919020450000005',
                longitude: '48.737364874353986'
            },
            {
                id: 558,
                name: 'Lankaran District',
                state_code: 'LA',
                hasCities: true
            },
            {
                id: 546,
                name: 'Lerik District',
                state_code: 'LER',
                hasCities: true
            },
            { id: 568, name: 'Martuni', state_code: 'XVD', hasCities: true },
            {
                id: 555,
                name: 'Masally District',
                state_code: 'MAS',
                hasCities: true
            },
            {
                id: 580,
                name: 'Mingachevir',
                state_code: 'MI',
                hasCities: true,
                latitude: '40.920632850000004',
                longitude: '46.75710073946399'
            },
            {
                id: 562,
                name: 'Nakhchivan Autonomous Republic',
                state_code: 'NX',
                hasCities: true,
                latitude: '39.3194099',
                longitude: '45.519028184088405'
            },
            {
                id: 530,
                name: 'Neftchala District',
                state_code: 'NEF',
                hasCities: true
            },
            {
                id: 556,
                name: 'Oghuz District',
                state_code: 'OGU',
                hasCities: true
            },
            {
                id: 534,
                name: 'Ordubad District',
                state_code: 'ORD',
                hasCities: false
            },
            {
                id: 542,
                name: 'Qabala District',
                state_code: 'QAB',
                hasCities: true
            },
            {
                id: 526,
                name: 'Qakh District',
                state_code: 'QAX',
                hasCities: true
            },
            {
                id: 521,
                name: 'Qazakh District',
                state_code: 'QAZ',
                hasCities: true
            },
            {
                id: 563,
                name: 'Quba District',
                state_code: 'QBA',
                hasCities: true
            },
            {
                id: 548,
                name: 'Qubadli District',
                state_code: 'QBI',
                hasCities: true
            },
            {
                id: 588,
                name: 'Qusar District',
                state_code: 'QUS',
                hasCities: true
            },
            {
                id: 557,
                name: 'Saatly District',
                state_code: 'SAT',
                hasCities: true
            },
            {
                id: 565,
                name: 'Sabirabad District',
                state_code: 'SAB',
                hasCities: true
            },
            {
                id: 522,
                name: 'Sadarak District',
                state_code: 'SAD',
                hasCities: false
            },
            {
                id: 545,
                name: 'Salyan District',
                state_code: 'SAL',
                hasCities: true
            },
            {
                id: 536,
                name: 'Samukh District',
                state_code: 'SMX',
                hasCities: true
            },
            {
                id: 591,
                name: 'Shabran District',
                state_code: 'SBN',
                hasCities: true
            },
            {
                id: 579,
                name: 'Shahbuz District',
                state_code: 'SAH',
                hasCities: false
            },
            { id: 518, name: 'Shaki', state_code: 'SA', hasCities: true },
            {
                id: 586,
                name: 'Shaki District',
                state_code: 'SAK',
                hasCities: true
            },
            {
                id: 529,
                name: 'Shamakhi District',
                state_code: 'SMI',
                hasCities: true
            },
            {
                id: 583,
                name: 'Shamkir District',
                state_code: 'SKR',
                hasCities: true
            },
            {
                id: 535,
                name: 'Sharur District',
                state_code: 'SAR',
                hasCities: false
            },
            {
                id: 520,
                name: 'Shirvan',
                state_code: 'SR',
                hasCities: true,
                latitude: '39.947542',
                longitude: '48.9034893'
            },
            {
                id: 592,
                name: 'Shusha District',
                state_code: 'SUS',
                hasCities: true
            },
            {
                id: 584,
                name: 'Siazan District',
                state_code: 'SIY',
                hasCities: true
            },
            {
                id: 582,
                name: 'Sumqayit',
                state_code: 'SM',
                hasCities: true,
                latitude: '40.6026817',
                longitude: '49.687863'
            },
            {
                id: 519,
                name: 'Tartar District',
                state_code: 'TAR',
                hasCities: true
            },
            {
                id: 533,
                name: 'Tovuz District',
                state_code: 'TOV',
                hasCities: true
            },
            {
                id: 539,
                name: 'Ujar District',
                state_code: 'UCA',
                hasCities: true
            },
            {
                id: 550,
                name: 'Yardymli District',
                state_code: 'YAR',
                hasCities: true
            },
            { id: 538, name: 'Yevlakh', state_code: 'YE', hasCities: true },
            {
                id: 523,
                name: 'Yevlakh District',
                state_code: 'YEV',
                hasCities: true
            },
            {
                id: 581,
                name: 'Zangilan District',
                state_code: 'ZAN',
                hasCities: true
            },
            {
                id: 566,
                name: 'Zaqatala District',
                state_code: 'ZAQ',
                hasCities: true
            },
            {
                id: 576,
                name: 'Zardab District',
                state_code: 'ZAR',
                hasCities: true
            }
        ]
    },
    {
        id: 18,
        states: [
            {
                id: 1992,
                name: 'Capital',
                state_code: '13',
                hasCities: true,
                latitude: '26.4243233',
                longitude: '50.47472512345479'
            },
            { id: 1996, name: 'Central', state_code: '16', hasCities: true },
            {
                id: 1995,
                name: 'Muharraq',
                state_code: '15',
                hasCities: true,
                latitude: '26.413466149999998',
                longitude: '50.67972870771858'
            },
            {
                id: 1994,
                name: 'Northern',
                state_code: '17',
                hasCities: false
            },
            { id: 1993, name: 'Southern', state_code: '14', hasCities: true }
        ]
    },
    {
        id: 19,
        states: [
            {
                id: 796,
                name: 'Bagerhat District',
                state_code: '05',
                hasCities: false
            },
            { id: 802, name: 'Bahadia', state_code: '33', hasCities: false },
            {
                id: 752,
                name: 'Bandarban District',
                state_code: '01',
                hasCities: false
            },
            {
                id: 784,
                name: 'Barguna District',
                state_code: '02',
                hasCities: false
            },
            {
                id: 818,
                name: 'Barisal District',
                state_code: '06',
                hasCities: true
            },
            {
                id: 807,
                name: 'Barisal Division',
                state_code: 'A',
                hasCities: false,
                latitude: '22.4934035',
                longitude: '90.3548015'
            },
            {
                id: 756,
                name: 'Bhola District',
                state_code: '07',
                hasCities: false
            },
            {
                id: 797,
                name: 'Bogra District',
                state_code: '03',
                hasCities: false
            },
            {
                id: 810,
                name: 'Brahmanbaria District',
                state_code: '04',
                hasCities: false
            },
            {
                id: 768,
                name: 'Chandpur District',
                state_code: '09',
                hasCities: false
            },
            {
                id: 761,
                name: 'Chapai Nawabganj District',
                state_code: '45',
                hasCities: false
            },
            {
                id: 785,
                name: 'Chittagong District',
                state_code: '10',
                hasCities: false
            },
            {
                id: 803,
                name: 'Chittagong Division',
                state_code: 'B',
                hasCities: true,
                latitude: '22.6800466',
                longitude: '91.8839938'
            },
            {
                id: 788,
                name: 'Chuadanga District',
                state_code: '12',
                hasCities: false
            },
            {
                id: 763,
                name: 'Comilla District',
                state_code: '08',
                hasCities: false
            },
            {
                id: 751,
                name: "Cox's Bazar District",
                state_code: '11',
                hasCities: false
            },
            {
                id: 771,
                name: 'Dhaka District',
                state_code: '13',
                hasCities: true
            },
            {
                id: 760,
                name: 'Dhaka Division',
                state_code: 'C',
                hasCities: false,
                latitude: '23.9456166',
                longitude: '90.2526382'
            },
            {
                id: 783,
                name: 'Dinajpur District',
                state_code: '14',
                hasCities: false
            },
            {
                id: 762,
                name: 'Faridpur District',
                state_code: '15',
                hasCities: false
            },
            {
                id: 816,
                name: 'Feni District',
                state_code: '16',
                hasCities: false
            },
            {
                id: 795,
                name: 'Gaibandha District',
                state_code: '19',
                hasCities: false
            },
            {
                id: 798,
                name: 'Gazipur District',
                state_code: '18',
                hasCities: false
            },
            {
                id: 792,
                name: 'Gopalganj District',
                state_code: '17',
                hasCities: false
            },
            {
                id: 805,
                name: 'Habiganj District',
                state_code: '20',
                hasCities: false
            },
            {
                id: 808,
                name: 'Jamalpur District',
                state_code: '21',
                hasCities: false
            },
            {
                id: 757,
                name: 'Jessore District',
                state_code: '22',
                hasCities: false
            },
            {
                id: 778,
                name: 'Jhalokati District',
                state_code: '25',
                hasCities: false
            },
            {
                id: 789,
                name: 'Jhenaidah District',
                state_code: '23',
                hasCities: false
            },
            {
                id: 806,
                name: 'Joypurhat District',
                state_code: '24',
                hasCities: false
            },
            {
                id: 786,
                name: 'Khagrachari District',
                state_code: '29',
                hasCities: false
            },
            {
                id: 811,
                name: 'Khulna District',
                state_code: '27',
                hasCities: true
            },
            {
                id: 775,
                name: 'Khulna Division',
                state_code: 'D',
                hasCities: false,
                latitude: '22.9372087',
                longitude: '89.2852741'
            },
            {
                id: 779,
                name: 'Kishoreganj District',
                state_code: '26',
                hasCities: false
            },
            {
                id: 793,
                name: 'Kurigram District',
                state_code: '28',
                hasCities: false
            },
            {
                id: 774,
                name: 'Kushtia District',
                state_code: '30',
                hasCities: false
            },
            {
                id: 819,
                name: 'Lakshmipur District',
                state_code: '31',
                hasCities: false
            },
            {
                id: 780,
                name: 'Lalmonirhat District',
                state_code: '32',
                hasCities: false
            },
            {
                id: 817,
                name: 'Madaripur District',
                state_code: '36',
                hasCities: false
            },
            {
                id: 776,
                name: 'Meherpur District',
                state_code: '39',
                hasCities: false
            },
            {
                id: 794,
                name: 'Moulvibazar District',
                state_code: '38',
                hasCities: false
            },
            {
                id: 790,
                name: 'Munshiganj District',
                state_code: '35',
                hasCities: false
            },
            {
                id: 766,
                name: 'Mymensingh District',
                state_code: '34',
                hasCities: true
            },
            {
                id: 758,
                name: 'Mymensingh Division',
                state_code: 'H',
                hasCities: false,
                latitude: '24.8889305',
                longitude: '90.3845187'
            },
            {
                id: 814,
                name: 'Naogaon District',
                state_code: '48',
                hasCities: false
            },
            {
                id: 769,
                name: 'Narail District',
                state_code: '43',
                hasCities: false
            },
            {
                id: 770,
                name: 'Narayanganj District',
                state_code: '40',
                hasCities: false
            },
            {
                id: 787,
                name: 'Natore District',
                state_code: '44',
                hasCities: false
            },
            {
                id: 764,
                name: 'Netrokona District',
                state_code: '41',
                hasCities: false
            },
            {
                id: 772,
                name: 'Nilphamari District',
                state_code: '46',
                hasCities: false
            },
            {
                id: 815,
                name: 'Noakhali District',
                state_code: '47',
                hasCities: false
            },
            {
                id: 754,
                name: 'Pabna District',
                state_code: '49',
                hasCities: false
            },
            {
                id: 800,
                name: 'Panchagarh District',
                state_code: '52',
                hasCities: false
            },
            {
                id: 777,
                name: 'Patuakhali District',
                state_code: '51',
                hasCities: false
            },
            {
                id: 791,
                name: 'Pirojpur District',
                state_code: '50',
                hasCities: false
            },
            {
                id: 773,
                name: 'Rajbari District',
                state_code: '53',
                hasCities: false
            },
            {
                id: 813,
                name: 'Rajshahi District',
                state_code: '54',
                hasCities: true
            },
            {
                id: 753,
                name: 'Rajshahi Division',
                state_code: 'E',
                hasCities: false,
                latitude: '24.6285432',
                longitude: '89.0376862'
            },
            {
                id: 809,
                name: 'Rangamati Hill District',
                state_code: '56',
                hasCities: false
            },
            {
                id: 759,
                name: 'Rangpur District',
                state_code: '55',
                hasCities: true
            },
            {
                id: 750,
                name: 'Rangpur Division',
                state_code: 'F',
                hasCities: false,
                latitude: '25.6376135',
                longitude: '89.0826381'
            },
            {
                id: 799,
                name: 'Satkhira District',
                state_code: '58',
                hasCities: false
            },
            {
                id: 801,
                name: 'Shariatpur District',
                state_code: '62',
                hasCities: false
            },
            {
                id: 755,
                name: 'Sherpur District',
                state_code: '57',
                hasCities: false
            },
            {
                id: 781,
                name: 'Sirajganj District',
                state_code: '59',
                hasCities: false
            },
            {
                id: 812,
                name: 'Sunamganj District',
                state_code: '61',
                hasCities: false
            },
            {
                id: 767,
                name: 'Sylhet District',
                state_code: '60',
                hasCities: true
            },
            {
                id: 765,
                name: 'Sylhet Division',
                state_code: 'G',
                hasCities: false,
                latitude: '24.7358854',
                longitude: '91.6852476'
            },
            {
                id: 782,
                name: 'Tangail District',
                state_code: '63',
                hasCities: false,
                latitude: '24.26262565',
                longitude: '89.9210825173373'
            },
            {
                id: 804,
                name: 'Thakurgaon District',
                state_code: '64',
                hasCities: false
            }
        ]
    },
    {
        id: 20,
        states: [
            {
                id: 1228,
                name: 'Christ Church',
                state_code: '01',
                hasCities: true
            },
            {
                id: 1229,
                name: 'Saint Andrew',
                state_code: '02',
                hasCities: true
            },
            {
                id: 1226,
                name: 'Saint George',
                state_code: '03',
                hasCities: false
            },
            {
                id: 1224,
                name: 'Saint James',
                state_code: '04',
                hasCities: true
            },
            {
                id: 1227,
                name: 'Saint John',
                state_code: '05',
                hasCities: false
            },
            {
                id: 1223,
                name: 'Saint Joseph',
                state_code: '06',
                hasCities: true
            },
            {
                id: 1221,
                name: 'Saint Lucy',
                state_code: '07',
                hasCities: false
            },
            {
                id: 1230,
                name: 'Saint Michael',
                state_code: '08',
                hasCities: true
            },
            {
                id: 1222,
                name: 'Saint Peter',
                state_code: '09',
                hasCities: true
            },
            {
                id: 1220,
                name: 'Saint Philip',
                state_code: '10',
                hasCities: true
            },
            {
                id: 1225,
                name: 'Saint Thomas',
                state_code: '11',
                hasCities: false
            }
        ]
    },
    {
        id: 21,
        states: [
            {
                id: 2959,
                name: 'Brest Region',
                state_code: 'BR',
                hasCities: true,
                latitude: '52.4121685',
                longitude: '25.2547709'
            },
            {
                id: 2955,
                name: 'Gomel Region',
                state_code: 'HO',
                hasCities: true,
                latitude: '52.3128262',
                longitude: '29.5418527'
            },
            {
                id: 2956,
                name: 'Grodno Region',
                state_code: 'HR',
                hasCities: true,
                latitude: '53.7021118',
                longitude: '25.0711803'
            },
            {
                id: 2958,
                name: 'Minsk',
                state_code: 'HM',
                hasCities: true,
                latitude: '53.9024716',
                longitude: '27.5618225'
            },
            {
                id: 2957,
                name: 'Minsk Region',
                state_code: 'MI',
                hasCities: true,
                latitude: '53.6099039',
                longitude: '27.5910208'
            },
            {
                id: 2954,
                name: 'Mogilev Region',
                state_code: 'MA',
                hasCities: true,
                latitude: '53.7254147',
                longitude: '30.3863145'
            },
            {
                id: 2960,
                name: 'Vitebsk Region',
                state_code: 'VI',
                hasCities: true,
                latitude: '55.2381972',
                longitude: '28.7742203'
            }
        ]
    },
    {
        id: 22,
        states: [
            {
                id: 1381,
                name: 'Antwerp',
                state_code: 'VAN',
                hasCities: false,
                latitude: '51.24773665',
                longitude: '4.776534056048172'
            },
            {
                id: 1376,
                name: 'Brussels-Capital Region',
                state_code: 'BRU',
                hasCities: true,
                latitude: '50.83879505',
                longitude: '4.375304132256188'
            },
            {
                id: 1377,
                name: 'East Flanders',
                state_code: 'VOV',
                hasCities: false,
                latitude: '51.0375423',
                longitude: '3.8117830113324556'
            },
            {
                id: 1373,
                name: 'Flanders',
                state_code: 'VLG',
                hasCities: true,
                latitude: '51.096246199999996',
                longitude: '4.178629103169916'
            },
            {
                id: 1374,
                name: 'Flemish Brabant',
                state_code: 'VBR',
                hasCities: false,
                latitude: '50.8686516',
                longitude: '4.7886237984620905'
            },
            {
                id: 1375,
                name: 'Hainaut',
                state_code: 'WHT',
                hasCities: false,
                latitude: '50.36192',
                longitude: '4.125216975993737'
            },
            {
                id: 1384,
                name: 'Liège',
                state_code: 'WLG',
                hasCities: false,
                latitude: '50.47081585',
                longitude: '5.773545903524977'
            },
            {
                id: 1372,
                name: 'Limburg',
                state_code: 'VLI',
                hasCities: false,
                latitude: '50.9977937',
                longitude: '5.445357520264672'
            },
            {
                id: 1379,
                name: 'Luxembourg',
                state_code: 'WLX',
                hasCities: false,
                latitude: '49.96379985',
                longitude: '5.439803941614714'
            },
            {
                id: 1378,
                name: 'Namur',
                state_code: 'WNA',
                hasCities: false,
                latitude: '50.21692965',
                longitude: '4.801161997672262'
            },
            {
                id: 1380,
                name: 'Wallonia',
                state_code: 'WAL',
                hasCities: true,
                latitude: '50.154540049999994',
                longitude: '5.399359762971196'
            },
            {
                id: 1382,
                name: 'Walloon Brabant',
                state_code: 'WBR',
                hasCities: false,
                latitude: '50.6663106',
                longitude: '4.5500074156703025'
            },
            {
                id: 1383,
                name: 'West Flanders',
                state_code: 'VWV',
                hasCities: false,
                latitude: '51.04047465',
                longitude: '2.9994213387887116'
            }
        ]
    },
    {
        id: 23,
        states: [
            {
                id: 264,
                name: 'Belize District',
                state_code: 'BZ',
                hasCities: true,
                latitude: '17.28318125',
                longitude: '-87.93820085335867'
            },
            {
                id: 269,
                name: 'Cayo District',
                state_code: 'CY',
                hasCities: true,
                latitude: '16.94978965',
                longitude: '-88.89406460190608'
            },
            {
                id: 266,
                name: 'Corozal District',
                state_code: 'CZL',
                hasCities: true,
                latitude: '18.227632399999997',
                longitude: '-88.29212566651148'
            },
            {
                id: 268,
                name: 'Orange Walk District',
                state_code: 'OW',
                hasCities: true,
                latitude: '17.7831833',
                longitude: '-88.8620282875666'
            },
            {
                id: 265,
                name: 'Stann Creek District',
                state_code: 'SC',
                hasCities: true,
                latitude: '16.747584',
                longitude: '-88.34317192500001'
            },
            {
                id: 267,
                name: 'Toledo District',
                state_code: 'TOL',
                hasCities: true,
                latitude: '16.2802675',
                longitude: '-88.55405264612399'
            }
        ]
    },
    {
        id: 24,
        states: [
            {
                id: 3077,
                name: 'Alibori Department',
                state_code: 'AL',
                hasCities: true,
                latitude: '11.4649482',
                longitude: '2.7938798'
            },
            {
                id: 3076,
                name: 'Atakora Department',
                state_code: 'AK',
                hasCities: true,
                latitude: '10.7160515',
                longitude: '1.5331527'
            },
            {
                id: 3079,
                name: 'Atlantique Department',
                state_code: 'AQ',
                hasCities: true,
                latitude: '6.540829',
                longitude: '2.223095'
            },
            {
                id: 3078,
                name: 'Borgou Department',
                state_code: 'BO',
                hasCities: true,
                latitude: '9.7097453',
                longitude: '2.7422648'
            },
            {
                id: 3070,
                name: 'Collines Department',
                state_code: 'CO',
                hasCities: true,
                latitude: '8.1085479',
                longitude: '2.1853101'
            },
            {
                id: 3072,
                name: 'Donga Department',
                state_code: 'DO',
                hasCities: true,
                latitude: '9.2679806',
                longitude: '1.7170684'
            },
            {
                id: 3071,
                name: 'Kouffo Department',
                state_code: 'KO',
                hasCities: true,
                latitude: '7.1312662',
                longitude: '1.7567394'
            },
            {
                id: 3081,
                name: 'Littoral Department',
                state_code: 'LI',
                hasCities: true,
                latitude: '6.3663195',
                longitude: '2.4170608'
            },
            {
                id: 3075,
                name: 'Mono Department',
                state_code: 'MO',
                hasCities: true,
                latitude: '6.457624',
                longitude: '1.867408'
            },
            {
                id: 3080,
                name: 'Ouémé Department',
                state_code: 'OU',
                hasCities: true,
                latitude: '6.6013531',
                longitude: '2.550566'
            },
            {
                id: 3074,
                name: 'Plateau Department',
                state_code: 'PL',
                hasCities: true,
                latitude: '7.1002602',
                longitude: '2.6409144'
            },
            {
                id: 3073,
                name: 'Zou Department',
                state_code: 'ZO',
                hasCities: true,
                latitude: '7.2834335',
                longitude: '2.1227604'
            }
        ]
    },
    {
        id: 25,
        states: [
            {
                id: 4860,
                name: 'Devonshire Parish',
                state_code: 'DEV',
                hasCities: false
            },
            {
                id: 4861,
                name: 'Hamilton Parish',
                state_code: 'HA',
                hasCities: false
            },
            {
                id: 4863,
                name: 'Paget Parish',
                state_code: 'PAG',
                hasCities: false
            },
            {
                id: 4864,
                name: 'Pembroke Parish',
                state_code: 'PEM',
                hasCities: false
            },
            {
                id: 4866,
                name: "Saint George's Parish",
                state_code: 'SGE',
                hasCities: false
            },
            {
                id: 4867,
                name: 'Sandys Parish',
                state_code: 'SAN',
                hasCities: false
            },
            {
                id: 4868,
                name: "Smith's Parish,",
                state_code: 'SMI',
                hasCities: false
            },
            {
                id: 4869,
                name: 'Southampton Parish',
                state_code: 'SOU',
                hasCities: false
            },
            {
                id: 4870,
                name: 'Warwick Parish',
                state_code: 'WAR',
                hasCities: false
            }
        ]
    },
    {
        id: 26,
        states: [
            {
                id: 240,
                name: 'Bumthang District',
                state_code: '33',
                hasCities: true,
                latitude: '27.707913249999997',
                longitude: '90.76974352912633'
            },
            {
                id: 239,
                name: 'Chukha District',
                state_code: '12',
                hasCities: true,
                latitude: '26.943123',
                longitude: '89.3770528'
            },
            {
                id: 238,
                name: 'Dagana District',
                state_code: '22',
                hasCities: true,
                latitude: '27.0711389',
                longitude: '89.820104'
            },
            {
                id: 229,
                name: 'Gasa District',
                state_code: 'GA',
                hasCities: true,
                latitude: '27.9190875',
                longitude: '89.7875318'
            },
            {
                id: 232,
                name: 'Haa District',
                state_code: '13',
                hasCities: true,
                latitude: '27.3596658',
                longitude: '89.2357556'
            },
            {
                id: 234,
                name: 'Lhuntse District',
                state_code: '44',
                hasCities: true,
                latitude: '27.7287448',
                longitude: '91.13636238901876'
            },
            {
                id: 242,
                name: 'Mongar District',
                state_code: '42',
                hasCities: true,
                latitude: '27.2065089',
                longitude: '91.0900363'
            },
            {
                id: 237,
                name: 'Paro District',
                state_code: '11',
                hasCities: true,
                latitude: '27.4646365',
                longitude: '89.3183409'
            },
            {
                id: 244,
                name: 'Pemagatshel District',
                state_code: '43',
                hasCities: true,
                latitude: '27.0030415',
                longitude: '91.3677054'
            },
            {
                id: 235,
                name: 'Punakha District',
                state_code: '23',
                hasCities: true,
                latitude: '27.6685526',
                longitude: '89.7089548'
            },
            {
                id: 243,
                name: 'Samdrup Jongkhar District',
                state_code: '45',
                hasCities: true,
                latitude: '26.8751197',
                longitude: '91.5511211'
            },
            {
                id: 246,
                name: 'Samtse District',
                state_code: '14',
                hasCities: true,
                latitude: '27.0352532',
                longitude: '89.0147344'
            },
            {
                id: 247,
                name: 'Sarpang District',
                state_code: '31',
                hasCities: true,
                latitude: '26.9863897',
                longitude: '90.3800673'
            },
            {
                id: 241,
                name: 'Thimphu District',
                state_code: '15',
                hasCities: true,
                latitude: '27.5583211',
                longitude: '89.5524789'
            },
            {
                id: 236,
                name: 'Trashigang District',
                state_code: '41',
                hasCities: true,
                latitude: '27.2843778',
                longitude: '91.5742509'
            },
            {
                id: 245,
                name: 'Trongsa District',
                state_code: '32',
                hasCities: false,
                latitude: '27.4982491',
                longitude: '90.4691469'
            },
            {
                id: 230,
                name: 'Tsirang District',
                state_code: '21',
                hasCities: true,
                latitude: '26.933333',
                longitude: '90.1'
            },
            {
                id: 231,
                name: 'Wangdue Phodrang District',
                state_code: '24',
                hasCities: true,
                latitude: '27.544634',
                longitude: '89.955581'
            },
            {
                id: 233,
                name: 'Zhemgang District',
                state_code: '34',
                hasCities: true,
                latitude: '27.08211485',
                longitude: '90.84089839206902'
            }
        ]
    },
    {
        id: 27,
        states: [
            {
                id: 3375,
                name: 'Beni Department',
                state_code: 'B',
                hasCities: true
            },
            {
                id: 3382,
                name: 'Chuquisaca Department',
                state_code: 'H',
                hasCities: true
            },
            {
                id: 3381,
                name: 'Cochabamba Department',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 3380,
                name: 'La Paz Department',
                state_code: 'L',
                hasCities: true
            },
            {
                id: 3376,
                name: 'Oruro Department',
                state_code: 'O',
                hasCities: true
            },
            {
                id: 3379,
                name: 'Pando Department',
                state_code: 'N',
                hasCities: true,
                latitude: '-11.183333',
                longitude: '-67.183333'
            },
            {
                id: 3383,
                name: 'Potosí Department',
                state_code: 'P',
                hasCities: true,
                latitude: '-20.666667',
                longitude: '-66.666667'
            },
            {
                id: 3377,
                name: 'Santa Cruz Department',
                state_code: 'S',
                hasCities: true,
                latitude: '-17.333333',
                longitude: '-61.5'
            },
            {
                id: 3378,
                name: 'Tarija Department',
                state_code: 'T',
                hasCities: true
            }
        ]
    },
    {
        id: 155,
        states: [
            { id: 5086, name: 'Bonaire', state_code: 'BQ1', hasCities: true },
            { id: 5087, name: 'Saba', state_code: 'BQ2', hasCities: false },
            {
                id: 5088,
                name: 'Sint Eustatius',
                state_code: 'BQ3',
                hasCities: false
            }
        ]
    },
    {
        id: 28,
        states: [
            {
                id: 472,
                name: 'Bosnian Podrinje Canton',
                state_code: '05',
                hasCities: false
            },
            {
                id: 460,
                name: 'Brčko District',
                state_code: 'BRC',
                hasCities: true,
                latitude: '44.84375945',
                longitude: '18.79841088405394'
            },
            {
                id: 471,
                name: 'Canton 10',
                state_code: '10',
                hasCities: false
            },
            {
                id: 462,
                name: 'Central Bosnia Canton',
                state_code: '06',
                hasCities: false
            },
            {
                id: 467,
                name: 'Federation of Bosnia and Herzegovina',
                state_code: 'BIH',
                hasCities: true,
                latitude: '43.91674105',
                longitude: '17.548207214822682'
            },
            {
                id: 463,
                name: 'Herzegovina-Neretva Canton',
                state_code: '07',
                hasCities: false
            },
            {
                id: 464,
                name: 'Posavina Canton',
                state_code: '02',
                hasCities: false
            },
            {
                id: 470,
                name: 'Republika Srpska',
                state_code: 'SRP',
                hasCities: true,
                latitude: '44.669577200000006',
                longitude: '17.365715484504605'
            },
            {
                id: 466,
                name: 'Sarajevo Canton',
                state_code: '09',
                hasCities: false
            },
            {
                id: 461,
                name: 'Tuzla Canton',
                state_code: '03',
                hasCities: false
            },
            {
                id: 465,
                name: 'Una-Sana Canton',
                state_code: '01',
                hasCities: false
            },
            {
                id: 469,
                name: 'West Herzegovina Canton',
                state_code: '08',
                hasCities: false
            },
            {
                id: 468,
                name: 'Zenica-Doboj Canton',
                state_code: '04',
                hasCities: false
            }
        ]
    },
    {
        id: 29,
        states: [
            {
                id: 3067,
                name: 'Central District',
                state_code: 'CE',
                hasCities: true,
                latitude: '-21.4790187',
                longitude: '26.2154174'
            },
            {
                id: 3061,
                name: 'Ghanzi District',
                state_code: 'GH',
                hasCities: true,
                latitude: '-22.145794',
                longitude: '22.7610828'
            },
            {
                id: 3066,
                name: 'Kgalagadi District',
                state_code: 'KG',
                hasCities: true,
                latitude: '-24.8490576',
                longitude: '21.7883349'
            },
            {
                id: 3062,
                name: 'Kgatleng District',
                state_code: 'KL',
                hasCities: true,
                latitude: '-24.134085',
                longitude: '26.41772458295927'
            },
            {
                id: 3069,
                name: 'Kweneng District',
                state_code: 'KW',
                hasCities: true,
                latitude: '-23.9028101',
                longitude: '24.9214122'
            },
            {
                id: 3060,
                name: 'Ngamiland',
                state_code: 'NG',
                hasCities: false
            },
            {
                id: 3068,
                name: 'North-East District',
                state_code: 'NE',
                hasCities: true,
                latitude: '-21.0244816',
                longitude: '27.5147504'
            },
            {
                id: 3065,
                name: 'North-West District',
                state_code: 'NW',
                hasCities: true,
                latitude: '-19.3893529',
                longitude: '23.267951'
            },
            {
                id: 3064,
                name: 'South-East District',
                state_code: 'SE',
                hasCities: true,
                latitude: '-24.62994925',
                longitude: '26.045475779882622'
            },
            {
                id: 3063,
                name: 'Southern District',
                state_code: 'SO',
                hasCities: true,
                latitude: '-24.7998688',
                longitude: '24.5800692'
            }
        ]
    },
    { id: 30, states: [] },
    {
        id: 31,
        states: [
            {
                id: 2012,
                name: 'Acre',
                state_code: 'AC',
                hasCities: true,
                latitude: '-9.0478679',
                longitude: '-70.5264976'
            },
            {
                id: 2007,
                name: 'Alagoas',
                state_code: 'AL',
                hasCities: true,
                latitude: '-9.6611661',
                longitude: '-36.6502426'
            },
            {
                id: 1999,
                name: 'Amapá',
                state_code: 'AP',
                hasCities: true,
                latitude: '1.3545442',
                longitude: '-51.9161977'
            },
            {
                id: 2004,
                name: 'Amazonas',
                state_code: 'AM',
                hasCities: true,
                latitude: '-3.3260273',
                longitude: '-60.6439924'
            },
            {
                id: 2002,
                name: 'Bahia',
                state_code: 'BA',
                hasCities: true,
                latitude: '-12.285251',
                longitude: '-41.9294776'
            },
            {
                id: 2016,
                name: 'Ceará',
                state_code: 'CE',
                hasCities: true,
                latitude: '-5.3264703',
                longitude: '-39.7156073'
            },
            {
                id: 2017,
                name: 'Distrito Federal',
                state_code: 'DF',
                hasCities: true,
                latitude: '-15.7754462',
                longitude: '-47.7970891'
            },
            {
                id: 2018,
                name: 'Espírito Santo',
                state_code: 'ES',
                hasCities: true,
                latitude: '-19.5687682',
                longitude: '-40.1721991'
            },
            {
                id: 2000,
                name: 'Goiás',
                state_code: 'GO',
                hasCities: true,
                latitude: '-15.9323662',
                longitude: '-50.1392928'
            },
            {
                id: 2015,
                name: 'Maranhão',
                state_code: 'MA',
                hasCities: true,
                latitude: '-5.2085503',
                longitude: '-45.3930262'
            },
            {
                id: 2011,
                name: 'Mato Grosso',
                state_code: 'MT',
                hasCities: true,
                latitude: '-12.2115009',
                longitude: '-55.5716547'
            },
            {
                id: 2010,
                name: 'Mato Grosso do Sul',
                state_code: 'MS',
                hasCities: true,
                latitude: '-19.5852564',
                longitude: '-54.4794731'
            },
            {
                id: 1998,
                name: 'Minas Gerais',
                state_code: 'MG',
                hasCities: true,
                latitude: '-18.5264844',
                longitude: '-44.1588654'
            },
            {
                id: 2009,
                name: 'Pará',
                state_code: 'PA',
                hasCities: true,
                latitude: '-4.7493933',
                longitude: '-52.8973006'
            },
            {
                id: 2005,
                name: 'Paraíba',
                state_code: 'PB',
                hasCities: true,
                latitude: '-7.1219366',
                longitude: '-36.7246845'
            },
            {
                id: 2022,
                name: 'Paraná',
                state_code: 'PR',
                hasCities: true,
                latitude: '-24.4842187',
                longitude: '-51.8148872'
            },
            {
                id: 2006,
                name: 'Pernambuco',
                state_code: 'PE',
                hasCities: true,
                latitude: '-8.4116316',
                longitude: '-37.5919699'
            },
            {
                id: 2008,
                name: 'Piauí',
                state_code: 'PI',
                hasCities: true,
                latitude: '-7.6992782',
                longitude: '-42.5043787'
            },
            {
                id: 1997,
                name: 'Rio de Janeiro',
                state_code: 'RJ',
                hasCities: true,
                latitude: '-22.2752762',
                longitude: '-42.419415'
            },
            {
                id: 2019,
                name: 'Rio Grande do Norte',
                state_code: 'RN',
                hasCities: true,
                latitude: '-5.6781175',
                longitude: '-36.4781776'
            },
            {
                id: 2001,
                name: 'Rio Grande do Sul',
                state_code: 'RS',
                hasCities: true,
                latitude: '-29.8425284',
                longitude: '-53.7680577'
            },
            {
                id: 2013,
                name: 'Rondônia',
                state_code: 'RO',
                hasCities: true,
                latitude: '-10.943145',
                longitude: '-62.8277863'
            },
            {
                id: 4858,
                name: 'Roraima',
                state_code: 'RR',
                hasCities: true,
                latitude: '2.135138',
                longitude: '-61.3631922'
            },
            {
                id: 2014,
                name: 'Santa Catarina',
                state_code: 'SC',
                hasCities: true,
                latitude: '-27.0628367',
                longitude: '-51.114965'
            },
            {
                id: 2021,
                name: 'São Paulo',
                state_code: 'SP',
                hasCities: true,
                latitude: '-22.0702705',
                longitude: '-48.4333875'
            },
            {
                id: 2003,
                name: 'Sergipe',
                state_code: 'SE',
                hasCities: true,
                latitude: '-10.6743911',
                longitude: '-37.3773519'
            },
            {
                id: 2020,
                name: 'Tocantins',
                state_code: 'TO',
                hasCities: true,
                latitude: '-10.8855129',
                longitude: '-48.3716912'
            }
        ]
    },
    { id: 32, states: [] },
    {
        id: 33,
        states: [
            {
                id: 1217,
                name: 'Belait District',
                state_code: 'BE',
                hasCities: true,
                latitude: '4.43499385',
                longitude: '114.49465242052787'
            },
            {
                id: 1216,
                name: 'Brunei-Muara District',
                state_code: 'BM',
                hasCities: true,
                latitude: '4.9752098',
                longitude: '114.93676633062489'
            },
            {
                id: 1218,
                name: 'Temburong District',
                state_code: 'TE',
                hasCities: true,
                latitude: '4.629184',
                longitude: '115.163440819921'
            },
            {
                id: 1219,
                name: 'Tutong District',
                state_code: 'TU',
                hasCities: true,
                latitude: '4.682681',
                longitude: '114.6562706290643'
            }
        ]
    },
    {
        id: 34,
        states: [
            {
                id: 4699,
                name: 'Blagoevgrad Province',
                state_code: '01',
                hasCities: true
            },
            {
                id: 4715,
                name: 'Burgas Province',
                state_code: '02',
                hasCities: true
            },
            {
                id: 4718,
                name: 'Dobrich Province',
                state_code: '08',
                hasCities: true
            },
            {
                id: 4693,
                name: 'Gabrovo Province',
                state_code: '07',
                hasCities: true
            },
            {
                id: 4704,
                name: 'Haskovo Province',
                state_code: '26',
                hasCities: true
            },
            {
                id: 4702,
                name: 'Kardzhali Province',
                state_code: '09',
                hasCities: true
            },
            {
                id: 4703,
                name: 'Kyustendil Province',
                state_code: '10',
                hasCities: true
            },
            {
                id: 4710,
                name: 'Lovech Province',
                state_code: '11',
                hasCities: true
            },
            {
                id: 4696,
                name: 'Montana Province',
                state_code: '12',
                hasCities: true
            },
            {
                id: 4712,
                name: 'Pazardzhik Province',
                state_code: '13',
                hasCities: true
            },
            {
                id: 4695,
                name: 'Pernik Province',
                state_code: '14',
                hasCities: true
            },
            {
                id: 4706,
                name: 'Pleven Province',
                state_code: '15',
                hasCities: true
            },
            {
                id: 4701,
                name: 'Plovdiv Province',
                state_code: '16',
                hasCities: true
            },
            {
                id: 4698,
                name: 'Razgrad Province',
                state_code: '17',
                hasCities: true
            },
            {
                id: 4713,
                name: 'Ruse Province',
                state_code: '18',
                hasCities: true
            },
            {
                id: 4882,
                name: 'Shumen',
                state_code: '27',
                hasCities: true,
                latitude: '43.30881875',
                longitude: '27.019726110054684'
            },
            {
                id: 4708,
                name: 'Silistra Province',
                state_code: '19',
                hasCities: true
            },
            {
                id: 4700,
                name: 'Sliven Province',
                state_code: '20',
                hasCities: true
            },
            {
                id: 4694,
                name: 'Smolyan Province',
                state_code: '21',
                hasCities: true
            },
            {
                id: 4705,
                name: 'Sofia City Province',
                state_code: '22',
                hasCities: true
            },
            {
                id: 4719,
                name: 'Sofia Province',
                state_code: '23',
                hasCities: true
            },
            {
                id: 4707,
                name: 'Stara Zagora Province',
                state_code: '24',
                hasCities: true
            },
            {
                id: 4714,
                name: 'Targovishte Province',
                state_code: '25',
                hasCities: true
            },
            {
                id: 4717,
                name: 'Varna Province',
                state_code: '03',
                hasCities: true
            },
            {
                id: 4709,
                name: 'Veliko Tarnovo Province',
                state_code: '04',
                hasCities: true
            },
            {
                id: 4697,
                name: 'Vidin Province',
                state_code: '05',
                hasCities: true
            },
            {
                id: 4711,
                name: 'Vratsa Province',
                state_code: '06',
                hasCities: true
            },
            {
                id: 4716,
                name: 'Yambol Province',
                state_code: '28',
                hasCities: true
            }
        ]
    },
    {
        id: 35,
        states: [
            {
                id: 3160,
                name: 'Balé Province',
                state_code: 'BAL',
                hasCities: false
            },
            {
                id: 3155,
                name: 'Bam Province',
                state_code: 'BAM',
                hasCities: false
            },
            {
                id: 3120,
                name: 'Banwa Province',
                state_code: 'BAN',
                hasCities: false
            },
            {
                id: 3152,
                name: 'Bazèga Province',
                state_code: 'BAZ',
                hasCities: false
            },
            {
                id: 3138,
                name: 'Boucle du Mouhoun Region',
                state_code: '01',
                hasCities: true,
                latitude: '12.4777805',
                longitude: '-3.5879571310124456'
            },
            {
                id: 3121,
                name: 'Bougouriba Province',
                state_code: 'BGR',
                hasCities: false
            },
            {
                id: 3131,
                name: 'Boulgou',
                state_code: 'BLG',
                hasCities: false,
                latitude: '11.7884199',
                longitude: '-0.554037'
            },
            {
                id: 3153,
                name: 'Cascades Region',
                state_code: '02',
                hasCities: true,
                latitude: '10.30718125',
                longitude: '-4.435189320350396'
            },
            {
                id: 3136,
                name: 'Centre',
                state_code: '03',
                hasCities: true,
                latitude: '12.36732',
                longitude: '-1.5430869129979032'
            },
            {
                id: 3162,
                name: 'Centre-Est Region',
                state_code: '04',
                hasCities: true,
                latitude: '11.734933000000002',
                longitude: '-0.2921055677472593'
            },
            {
                id: 3127,
                name: 'Centre-Nord Region',
                state_code: '05',
                hasCities: true,
                latitude: '13.238710000000001',
                longitude: '-1.0349831514084509'
            },
            {
                id: 3115,
                name: 'Centre-Ouest Region',
                state_code: '06',
                hasCities: true,
                latitude: '11.9067933',
                longitude: '-2.3044800659164646'
            },
            {
                id: 3149,
                name: 'Centre-Sud Region',
                state_code: '07',
                hasCities: true,
                latitude: '11.5833646',
                longitude: '-1.0556300580745341'
            },
            {
                id: 3167,
                name: 'Comoé Province',
                state_code: 'COM',
                hasCities: false
            },
            {
                id: 3158,
                name: 'Est Region',
                state_code: '08',
                hasCities: true,
                latitude: '12.255555',
                longitude: '1.0095763618883151'
            },
            {
                id: 3148,
                name: 'Ganzourgou Province',
                state_code: 'GAN',
                hasCities: false
            },
            {
                id: 3122,
                name: 'Gnagna Province',
                state_code: 'GNA',
                hasCities: false
            },
            {
                id: 3143,
                name: 'Gourma Province',
                state_code: 'GOU',
                hasCities: false
            },
            {
                id: 3165,
                name: 'Hauts-Bassins Region',
                state_code: '09',
                hasCities: true,
                latitude: '11.389027500000001',
                longitude: '-4.041364986476256'
            },
            {
                id: 3129,
                name: 'Houet Province',
                state_code: 'HOU',
                hasCities: false
            },
            {
                id: 3135,
                name: 'Ioba Province',
                state_code: 'IOB',
                hasCities: false
            },
            {
                id: 3168,
                name: 'Kadiogo Province',
                state_code: 'KAD',
                hasCities: false
            },
            {
                id: 3112,
                name: 'Kénédougou Province',
                state_code: 'KEN',
                hasCities: false
            },
            {
                id: 3132,
                name: 'Komondjari Province',
                state_code: 'KMD',
                hasCities: false
            },
            {
                id: 3157,
                name: 'Kompienga Province',
                state_code: 'KMP',
                hasCities: false
            },
            {
                id: 3146,
                name: 'Kossi Province',
                state_code: 'KOS',
                hasCities: false
            },
            {
                id: 3133,
                name: 'Koulpélogo Province',
                state_code: 'KOP',
                hasCities: false
            },
            {
                id: 3161,
                name: 'Kouritenga Province',
                state_code: 'KOT',
                hasCities: false
            },
            {
                id: 3147,
                name: 'Kourwéogo Province',
                state_code: 'KOW',
                hasCities: false
            },
            {
                id: 3159,
                name: 'Léraba Province',
                state_code: 'LER',
                hasCities: false
            },
            {
                id: 3151,
                name: 'Loroum Province',
                state_code: 'LOR',
                hasCities: false
            },
            {
                id: 3123,
                name: 'Mouhoun',
                state_code: 'MOU',
                hasCities: false,
                latitude: '11.9493245',
                longitude: '-3.9822539'
            },
            {
                id: 3116,
                name: 'Nahouri Province',
                state_code: 'NAO',
                hasCities: false
            },
            {
                id: 3113,
                name: 'Namentenga Province',
                state_code: 'NAM',
                hasCities: false
            },
            {
                id: 3142,
                name: 'Nayala Province',
                state_code: 'NAY',
                hasCities: false
            },
            {
                id: 3164,
                name: 'Nord Region, Burkina Faso',
                state_code: '10',
                hasCities: true
            },
            {
                id: 3156,
                name: 'Noumbiel Province',
                state_code: 'NOU',
                hasCities: false
            },
            {
                id: 3141,
                name: 'Oubritenga Province',
                state_code: 'OUB',
                hasCities: false
            },
            {
                id: 3144,
                name: 'Oudalan Province',
                state_code: 'OUD',
                hasCities: false
            },
            {
                id: 3117,
                name: 'Passoré Province',
                state_code: 'PAS',
                hasCities: false
            },
            {
                id: 3125,
                name: 'Plateau-Central Region',
                state_code: '11',
                hasCities: true,
                latitude: '12.40414',
                longitude: '-0.8864160224616928'
            },
            {
                id: 3163,
                name: 'Poni Province',
                state_code: 'PON',
                hasCities: false
            },
            {
                id: 3114,
                name: 'Sahel Region',
                state_code: '12',
                hasCities: true,
                latitude: '14.0279165',
                longitude: '-0.7717775666263393'
            },
            {
                id: 3154,
                name: 'Sanguié Province',
                state_code: 'SNG',
                hasCities: false
            },
            {
                id: 3126,
                name: 'Sanmatenga Province',
                state_code: 'SMT',
                hasCities: false
            },
            {
                id: 3139,
                name: 'Séno Province',
                state_code: 'SEN',
                hasCities: false
            },
            {
                id: 3119,
                name: 'Sissili Province',
                state_code: 'SIS',
                hasCities: false
            },
            {
                id: 3166,
                name: 'Soum Province',
                state_code: 'SOM',
                hasCities: false
            },
            {
                id: 3137,
                name: 'Sourou Province',
                state_code: 'SOR',
                hasCities: false
            },
            {
                id: 3140,
                name: 'Sud-Ouest Region',
                state_code: '13',
                hasCities: true,
                latitude: '10.38692085',
                longitude: '-3.283188627811005'
            },
            {
                id: 3128,
                name: 'Tapoa Province',
                state_code: 'TAP',
                hasCities: false
            },
            {
                id: 3134,
                name: 'Tuy Province',
                state_code: 'TUI',
                hasCities: false
            },
            {
                id: 3124,
                name: 'Yagha Province',
                state_code: 'YAG',
                hasCities: false
            },
            {
                id: 3150,
                name: 'Yatenga Province',
                state_code: 'YAT',
                hasCities: false
            },
            {
                id: 3145,
                name: 'Ziro Province',
                state_code: 'ZIR',
                hasCities: false
            },
            {
                id: 3130,
                name: 'Zondoma Province',
                state_code: 'ZON',
                hasCities: false
            },
            {
                id: 3118,
                name: 'Zoundwéogo Province',
                state_code: 'ZOU',
                hasCities: false
            }
        ]
    },
    {
        id: 36,
        states: [
            {
                id: 3196,
                name: 'Bubanza Province',
                state_code: 'BB',
                hasCities: true
            },
            {
                id: 3198,
                name: 'Bujumbura Mairie Province',
                state_code: 'BM',
                hasCities: true
            },
            {
                id: 3200,
                name: 'Bujumbura Rural Province',
                state_code: 'BL',
                hasCities: false,
                latitude: '-3.4759817',
                longitude: '29.4535702'
            },
            {
                id: 3202,
                name: 'Bururi Province',
                state_code: 'BR',
                hasCities: true,
                latitude: '-3.8581592',
                longitude: '29.584379'
            },
            {
                id: 3201,
                name: 'Cankuzo Province',
                state_code: 'CA',
                hasCities: true
            },
            {
                id: 3190,
                name: 'Cibitoke Province',
                state_code: 'CI',
                hasCities: true
            },
            {
                id: 3197,
                name: 'Gitega Province',
                state_code: 'GI',
                hasCities: true,
                latitude: '-3.5382336',
                longitude: '29.910701'
            },
            {
                id: 3194,
                name: 'Karuzi Province',
                state_code: 'KR',
                hasCities: true,
                latitude: '-3.1255377',
                longitude: '30.0978347'
            },
            {
                id: 3192,
                name: 'Kayanza Province',
                state_code: 'KY',
                hasCities: true
            },
            {
                id: 3195,
                name: 'Kirundo Province',
                state_code: 'KI',
                hasCities: true
            },
            {
                id: 3188,
                name: 'Makamba Province',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 3193,
                name: 'Muramvya Province',
                state_code: 'MU',
                hasCities: true,
                latitude: '-3.2751181',
                longitude: '29.6307855'
            },
            {
                id: 3186,
                name: 'Muyinga Province',
                state_code: 'MY',
                hasCities: true
            },
            {
                id: 3187,
                name: 'Mwaro Province',
                state_code: 'MW',
                hasCities: true,
                latitude: '-3.4650043',
                longitude: '29.6708508'
            },
            {
                id: 3199,
                name: 'Ngozi Province',
                state_code: 'NG',
                hasCities: true
            },
            {
                id: 3185,
                name: 'Rumonge Province',
                state_code: 'RM',
                hasCities: true
            },
            {
                id: 3189,
                name: 'Rutana Province',
                state_code: 'RT',
                hasCities: true,
                latitude: '-3.8618714',
                longitude: '30.0676979'
            },
            {
                id: 3191,
                name: 'Ruyigi Province',
                state_code: 'RY',
                hasCities: true,
                latitude: '-3.4573515500000003',
                longitude: '30.348830297112265'
            }
        ]
    },
    {
        id: 37,
        states: [
            {
                id: 3984,
                name: 'Banteay Meanchey',
                state_code: '1',
                hasCities: true,
                latitude: '13.7989147',
                longitude: '102.8862666'
            },
            {
                id: 3976,
                name: 'Battambang',
                state_code: '2',
                hasCities: true,
                latitude: '12.9256791',
                longitude: '103.23171364274523'
            },
            {
                id: 3991,
                name: 'Kampong Cham',
                state_code: '3',
                hasCities: true,
                latitude: '12.1174857',
                longitude: '105.20800220742942'
            },
            {
                id: 3979,
                name: 'Kampong Chhnang',
                state_code: '4',
                hasCities: true,
                latitude: '12.1382025',
                longitude: '104.3354098'
            },
            {
                id: 3988,
                name: 'Kampong Speu',
                state_code: '5',
                hasCities: true,
                latitude: '11.57753675',
                longitude: '104.27140233242656'
            },
            {
                id: 5070,
                name: 'Kampong Thom',
                state_code: '6',
                hasCities: false,
                latitude: '12.6687923',
                longitude: '104.8879197'
            },
            {
                id: 3981,
                name: 'Kampot',
                state_code: '7',
                hasCities: true,
                latitude: '10.6314754',
                longitude: '104.132637'
            },
            {
                id: 3983,
                name: 'Kandal',
                state_code: '8',
                hasCities: true,
                latitude: '11.396262499999999',
                longitude: '105.02078685074581'
            },
            {
                id: 3978,
                name: 'Kep',
                state_code: '23',
                hasCities: true,
                latitude: '10.402153949999999',
                longitude: '104.26506181616313'
            },
            {
                id: 3982,
                name: 'Koh Kong',
                state_code: '9',
                hasCities: true,
                latitude: '11.6813417',
                longitude: '103.0258043'
            },
            {
                id: 3986,
                name: 'Kratie',
                state_code: '10',
                hasCities: true,
                latitude: '12.678301699999999',
                longitude: '106.05817329824376'
            },
            {
                id: 3985,
                name: 'Mondulkiri',
                state_code: '11',
                hasCities: true,
                latitude: '12.7396075',
                longitude: '107.00879873640628'
            },
            {
                id: 3987,
                name: 'Oddar Meanchey',
                state_code: '22',
                hasCities: true,
                latitude: '14.1585631',
                longitude: '103.78279595655918'
            },
            {
                id: 3980,
                name: 'Pailin',
                state_code: '24',
                hasCities: true,
                latitude: '12.89053285',
                longitude: '102.62946042446026'
            },
            {
                id: 3994,
                name: 'Phnom Penh',
                state_code: '12',
                hasCities: true,
                latitude: '11.5730391',
                longitude: '104.857807'
            },
            {
                id: 3973,
                name: 'Preah Vihear',
                state_code: '13',
                hasCities: true,
                latitude: '13.746298150000001',
                longitude: '104.97403002709669'
            },
            {
                id: 3974,
                name: 'Prey Veng',
                state_code: '14',
                hasCities: true,
                latitude: '11.365959700000001',
                longitude: '105.45572772976189'
            },
            {
                id: 3977,
                name: 'Pursat',
                state_code: '15',
                hasCities: true,
                latitude: '12.4662592',
                longitude: '103.7426829518918'
            },
            {
                id: 3990,
                name: 'Ratanakiri',
                state_code: '16',
                hasCities: true,
                latitude: '13.9312399',
                longitude: '107.03910880702057'
            },
            {
                id: 3992,
                name: 'Siem Reap',
                state_code: '17',
                hasCities: true,
                latitude: '13.314962',
                longitude: '103.805433'
            },
            {
                id: 3989,
                name: 'Sihanoukville',
                state_code: '18',
                hasCities: true,
                latitude: '10.7321989',
                longitude: '103.7595806'
            },
            {
                id: 3993,
                name: 'Stung Treng',
                state_code: '19',
                hasCities: true,
                latitude: '13.852468',
                longitude: '106.0889848986395'
            },
            {
                id: 3972,
                name: 'Svay Rieng',
                state_code: '20',
                hasCities: true,
                latitude: '11.19500815',
                longitude: '105.79679668507217'
            },
            {
                id: 3975,
                name: 'Takeo',
                state_code: '21',
                hasCities: true,
                latitude: '10.93539205',
                longitude: '104.78988300047047'
            }
        ]
    },
    {
        id: 38,
        states: [
            {
                id: 2663,
                name: 'Adamawa',
                state_code: 'AD',
                hasCities: true,
                latitude: '6.8496708',
                longitude: '13.2163222'
            },
            {
                id: 2660,
                name: 'Centre',
                state_code: 'CE',
                hasCities: true,
                latitude: '4.686267',
                longitude: '11.9414512'
            },
            {
                id: 2661,
                name: 'East',
                state_code: 'ES',
                hasCities: true,
                latitude: '3.9894393',
                longitude: '14.178373'
            },
            {
                id: 2656,
                name: 'Far North',
                state_code: 'EN',
                hasCities: true,
                latitude: '10.6377186',
                longitude: '14.2738156'
            },
            {
                id: 2662,
                name: 'Littoral',
                state_code: 'LT',
                hasCities: true,
                latitude: '4.203033',
                longitude: '10.0563057'
            },
            {
                id: 2665,
                name: 'North',
                state_code: 'NO',
                hasCities: true,
                latitude: '8.7712794',
                longitude: '13.7803627'
            },
            {
                id: 2657,
                name: 'Northwest',
                state_code: 'NW',
                hasCities: true,
                latitude: '6.3775255',
                longitude: '10.3864171'
            },
            {
                id: 2659,
                name: 'South',
                state_code: 'SU',
                hasCities: true,
                latitude: '2.7312374',
                longitude: '11.6254622'
            },
            {
                id: 2658,
                name: 'Southwest',
                state_code: 'SW',
                hasCities: true,
                latitude: '5.0577606',
                longitude: '9.2289407'
            },
            {
                id: 2664,
                name: 'West',
                state_code: 'OU',
                hasCities: true,
                latitude: '5.53563825',
                longitude: '10.582882586016343'
            }
        ]
    },
    {
        id: 39,
        states: [
            {
                id: 872,
                name: 'Alberta',
                state_code: 'AB',
                hasCities: true,
                latitude: '55.001251',
                longitude: '-115.002136'
            },
            {
                id: 875,
                name: 'British Columbia',
                state_code: 'BC',
                hasCities: true,
                latitude: '55.001251',
                longitude: '-125.002441'
            },
            {
                id: 867,
                name: 'Manitoba',
                state_code: 'MB',
                hasCities: true,
                latitude: '55.001251',
                longitude: '-97.001038'
            },
            {
                id: 868,
                name: 'New Brunswick',
                state_code: 'NB',
                hasCities: true,
                latitude: '46.500283',
                longitude: '-66.750183'
            },
            {
                id: 877,
                name: 'Newfoundland and Labrador',
                state_code: 'NL',
                hasCities: true,
                latitude: '53.8217327',
                longitude: '-61.2295532'
            },
            {
                id: 878,
                name: 'Northwest Territories',
                state_code: 'NT',
                hasCities: true,
                latitude: '65.0000004',
                longitude: '-118.0'
            },
            {
                id: 874,
                name: 'Nova Scotia',
                state_code: 'NS',
                hasCities: true,
                latitude: '45.1960403',
                longitude: '-63.1653789'
            },
            {
                id: 876,
                name: 'Nunavut',
                state_code: 'NU',
                hasCities: true,
                latitude: '65.0377727',
                longitude: '-92.5540791'
            },
            {
                id: 866,
                name: 'Ontario',
                state_code: 'ON',
                hasCities: true,
                latitude: '50.000678',
                longitude: '-86.000977'
            },
            {
                id: 871,
                name: 'Prince Edward Island',
                state_code: 'PE',
                hasCities: true,
                latitude: '46.3355508',
                longitude: '-63.1466676'
            },
            {
                id: 873,
                name: 'Quebec',
                state_code: 'QC',
                hasCities: true,
                latitude: '52.4760892',
                longitude: '-71.8258668'
            },
            {
                id: 870,
                name: 'Saskatchewan',
                state_code: 'SK',
                hasCities: true,
                latitude: '55.5321257',
                longitude: '-106.141224'
            },
            {
                id: 869,
                name: 'Yukon',
                state_code: 'YT',
                hasCities: true,
                latitude: '63.000147',
                longitude: '-136.002502'
            }
        ]
    },
    {
        id: 40,
        states: [
            {
                id: 2994,
                name: 'Barlavento Islands',
                state_code: 'B',
                hasCities: false,
                latitude: '17.05552855',
                longitude: '-25.172304911363636'
            },
            {
                id: 2999,
                name: 'Boa Vista',
                state_code: 'BV',
                hasCities: true,
                latitude: '16.099508999999998',
                longitude: '-22.800941096303617'
            },
            {
                id: 2996,
                name: 'Brava',
                state_code: 'BR',
                hasCities: true,
                latitude: '14.85194265',
                longitude: '-24.70869390903308'
            },
            {
                id: 2991,
                name: 'Maio Municipality',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 2987,
                name: 'Mosteiros',
                state_code: 'MO',
                hasCities: true
            },
            { id: 2997, name: 'Paul', state_code: 'PA', hasCities: true },
            {
                id: 2989,
                name: 'Porto Novo',
                state_code: 'PN',
                hasCities: true,
                latitude: '17.018492549999998',
                longitude: '-25.081616357643885'
            },
            { id: 2988, name: 'Praia', state_code: 'PR', hasCities: true },
            {
                id: 2982,
                name: 'Ribeira Brava Municipality',
                state_code: 'RB',
                hasCities: true
            },
            {
                id: 3002,
                name: 'Ribeira Grande',
                state_code: 'RG',
                hasCities: true,
                latitude: '17.1809419',
                longitude: '-25.0734479'
            },
            {
                id: 2984,
                name: 'Ribeira Grande de Santiago',
                state_code: 'RS',
                hasCities: true
            },
            {
                id: 2998,
                name: 'Sal',
                state_code: 'SL',
                hasCities: true,
                latitude: '16.720455649999998',
                longitude: '-22.938676127026316'
            },
            {
                id: 2985,
                name: 'Santa Catarina',
                state_code: 'CA',
                hasCities: true
            },
            {
                id: 2995,
                name: 'Santa Catarina do Fogo',
                state_code: 'CF',
                hasCities: true
            },
            {
                id: 3004,
                name: 'Santa Cruz',
                state_code: 'CR',
                hasCities: true
            },
            {
                id: 2986,
                name: 'São Domingos',
                state_code: 'SD',
                hasCities: true,
                latitude: '15.0271971',
                longitude: '-23.4894907'
            },
            {
                id: 3000,
                name: 'São Filipe',
                state_code: 'SF',
                hasCities: true,
                latitude: '14.9562832',
                longitude: '-23.5100843'
            },
            {
                id: 2993,
                name: 'São Lourenço dos Órgãos',
                state_code: 'SO',
                hasCities: true
            },
            {
                id: 2990,
                name: 'São Miguel',
                state_code: 'SM',
                hasCities: true
            },
            {
                id: 3001,
                name: 'São Vicente',
                state_code: 'SV',
                hasCities: true,
                latitude: '16.84944115',
                longitude: '-24.971879177747315'
            },
            {
                id: 2992,
                name: 'Sotavento Islands',
                state_code: 'S',
                hasCities: false,
                latitude: '15.1200758',
                longitude: '-23.634818134026133'
            },
            {
                id: 2983,
                name: 'Tarrafal',
                state_code: 'TA',
                hasCities: true,
                latitude: '16.9687633',
                longitude: '-25.2969331'
            },
            {
                id: 3003,
                name: 'Tarrafal de São Nicolau',
                state_code: 'TS',
                hasCities: true
            }
        ]
    },
    { id: 41, states: [] },
    {
        id: 42,
        states: [
            {
                id: 1259,
                name: 'Bamingui-Bangoran Prefecture',
                state_code: 'BB',
                hasCities: true
            },
            {
                id: 1262,
                name: 'Bangui',
                state_code: 'BGF',
                hasCities: true,
                latitude: '4.3635118',
                longitude: '18.5835913'
            },
            {
                id: 1264,
                name: 'Basse-Kotto Prefecture',
                state_code: 'BK',
                hasCities: true
            },
            {
                id: 1258,
                name: 'Haut-Mbomou Prefecture',
                state_code: 'HM',
                hasCities: true
            },
            {
                id: 1268,
                name: 'Haute-Kotto Prefecture',
                state_code: 'HK',
                hasCities: true
            },
            {
                id: 1263,
                name: 'Kémo Prefecture',
                state_code: 'KG',
                hasCities: true,
                latitude: '5.9480074',
                longitude: '19.2158871'
            },
            {
                id: 1256,
                name: 'Lobaye Prefecture',
                state_code: 'LB',
                hasCities: true
            },
            {
                id: 1257,
                name: 'Mambéré-Kadéï',
                state_code: 'HS',
                hasCities: true,
                latitude: '4.5662762',
                longitude: '15.8671403'
            },
            {
                id: 1266,
                name: 'Mbomou Prefecture',
                state_code: 'MB',
                hasCities: true
            },
            {
                id: 1253,
                name: 'Nana-Grébizi Economic Prefecture',
                state_code: 'KB',
                hasCities: true
            },
            {
                id: 1260,
                name: 'Nana-Mambéré Prefecture',
                state_code: 'NM',
                hasCities: true,
                latitude: '5.2231625',
                longitude: '15.3517922'
            },
            {
                id: 1255,
                name: "Ombella-M'Poko Prefecture",
                state_code: 'MP',
                hasCities: true
            },
            {
                id: 1265,
                name: 'Ouaka Prefecture',
                state_code: 'UK',
                hasCities: true
            },
            {
                id: 1254,
                name: 'Ouham Prefecture',
                state_code: 'AC',
                hasCities: true,
                latitude: '6.7057282',
                longitude: '16.1443202'
            },
            {
                id: 1267,
                name: 'Ouham-Pendé Prefecture',
                state_code: 'OP',
                hasCities: true,
                latitude: '6.7057282',
                longitude: '16.1443202'
            },
            {
                id: 1252,
                name: 'Sangha-Mbaéré',
                state_code: 'SE',
                hasCities: true,
                latitude: '3.6754895',
                longitude: '16.3246915'
            },
            {
                id: 1261,
                name: 'Vakaga Prefecture',
                state_code: 'VK',
                hasCities: true,
                latitude: '9.8250502',
                longitude: '22.376363'
            }
        ]
    },
    {
        id: 43,
        states: [
            {
                id: 3583,
                name: 'Bahr el Gazel',
                state_code: 'BG',
                hasCities: true,
                latitude: '14.4682468',
                longitude: '16.9416836'
            },
            {
                id: 3590,
                name: 'Batha',
                state_code: 'BA',
                hasCities: true,
                latitude: '13.8367731',
                longitude: '18.9649806'
            },
            {
                id: 3574,
                name: 'Borkou',
                state_code: 'BO',
                hasCities: true,
                latitude: '17.2658129',
                longitude: '18.3695288'
            },
            {
                id: 5114,
                name: 'Chari-Baguirmi',
                state_code: 'CB',
                hasCities: true,
                latitude: '11.3345348',
                longitude: '16.2884311'
            },
            {
                id: 3575,
                name: 'Ennedi-Est',
                state_code: 'EE',
                hasCities: false,
                latitude: '17.6219737',
                longitude: '23.3133676'
            },
            {
                id: 3584,
                name: 'Ennedi-Ouest',
                state_code: 'EO',
                hasCities: true,
                latitude: '18.1636803',
                longitude: '21.5082709'
            },
            {
                id: 3576,
                name: 'Guéra',
                state_code: 'GR',
                hasCities: true,
                latitude: '11.6753817',
                longitude: '18.4910031'
            },
            {
                id: 3573,
                name: 'Hadjer-Lamis',
                state_code: 'HL',
                hasCities: true,
                latitude: '12.6903906',
                longitude: '16.3352648'
            },
            {
                id: 3588,
                name: 'Kanem',
                state_code: 'KA',
                hasCities: true,
                latitude: '15.2264398',
                longitude: '15.3151191'
            },
            {
                id: 3577,
                name: 'Lac',
                state_code: 'LC',
                hasCities: true,
                latitude: '13.5820827',
                longitude: '14.3788329'
            },
            {
                id: 3585,
                name: 'Logone Occidental',
                state_code: 'LO',
                hasCities: true,
                latitude: '8.7795637',
                longitude: '15.9126749'
            },
            {
                id: 3591,
                name: 'Logone Oriental',
                state_code: 'LR',
                hasCities: true,
                latitude: '8.2047152',
                longitude: '16.470181'
            },
            {
                id: 3589,
                name: 'Mandoul',
                state_code: 'MA',
                hasCities: true,
                latitude: '8.727509999999999',
                longitude: '17.58417712733185'
            },
            {
                id: 3580,
                name: 'Mayo-Kebbi Est',
                state_code: 'ME',
                hasCities: true,
                latitude: '10.126618',
                longitude: '15.818345'
            },
            {
                id: 3571,
                name: 'Mayo-Kebbi Ouest',
                state_code: 'MO',
                hasCities: true,
                latitude: '9.2640383',
                longitude: '14.7151598'
            },
            {
                id: 3570,
                name: 'Moyen-Chari',
                state_code: 'MC',
                hasCities: true,
                latitude: '9.4407768',
                longitude: '18.8160927'
            },
            {
                id: 3586,
                name: "N'Djamena",
                state_code: 'ND',
                hasCities: true,
                latitude: '12.1191543',
                longitude: '15.0502758'
            },
            {
                id: 3582,
                name: 'Ouaddaï',
                state_code: 'OD',
                hasCities: true,
                latitude: '13.4613569',
                longitude: '21.288445'
            },
            {
                id: 3592,
                name: 'Salamat',
                state_code: 'SA',
                hasCities: true,
                latitude: '10.7575596',
                longitude: '20.6934116'
            },
            {
                id: 3572,
                name: 'Sila',
                state_code: 'SI',
                hasCities: true,
                latitude: '12.11786',
                longitude: '21.4458848'
            },
            {
                id: 3579,
                name: 'Tandjilé',
                state_code: 'TA',
                hasCities: true,
                latitude: '9.5713051',
                longitude: '16.5294956'
            },
            {
                id: 3587,
                name: 'Tibesti',
                state_code: 'TI',
                hasCities: true,
                latitude: '21.2438074',
                longitude: '17.753176663955628'
            },
            {
                id: 3581,
                name: 'Wadi Fira',
                state_code: 'WF',
                hasCities: true,
                latitude: '15.0191449',
                longitude: '21.467319'
            }
        ]
    },
    {
        id: 44,
        states: [
            {
                id: 2828,
                name: 'Aisén del General Carlos Ibañez del Campo',
                state_code: 'AI',
                hasCities: true,
                latitude: '-46.4711556',
                longitude: '-73.5206714'
            },
            {
                id: 2832,
                name: 'Antofagasta',
                state_code: 'AN',
                hasCities: true,
                latitude: '-23.6041314',
                longitude: '-69.0842783'
            },
            {
                id: 2829,
                name: 'Arica y Parinacota',
                state_code: 'AP',
                hasCities: true,
                latitude: '-18.5713496',
                longitude: '-69.7884774'
            },
            {
                id: 2823,
                name: 'Atacama',
                state_code: 'AT',
                hasCities: true,
                latitude: '-24.5563029',
                longitude: '-69.4226479'
            },
            {
                id: 2827,
                name: 'Biobío',
                state_code: 'BI',
                hasCities: true,
                latitude: '-37.3391407',
                longitude: '-72.4106825'
            },
            {
                id: 2825,
                name: 'Coquimbo',
                state_code: 'CO',
                hasCities: true,
                latitude: '-30.7546652',
                longitude: '-70.9005536'
            },
            {
                id: 2826,
                name: 'La Araucanía',
                state_code: 'AR',
                hasCities: true,
                latitude: '-38.6678955',
                longitude: '-72.2610066'
            },
            {
                id: 2838,
                name: "Libertador General Bernardo O'Higgins",
                state_code: 'LI',
                hasCities: true,
                latitude: '-34.534538',
                longitude: '-71.0354822'
            },
            {
                id: 2835,
                name: 'Los Lagos',
                state_code: 'LL',
                hasCities: true,
                latitude: '-42.300844',
                longitude: '-73.105387'
            },
            {
                id: 2834,
                name: 'Los Ríos',
                state_code: 'LR',
                hasCities: true,
                latitude: '-39.9742747',
                longitude: '-72.6677006'
            },
            {
                id: 2836,
                name: 'Magallanes y de la Antártica Chilena',
                state_code: 'MA',
                hasCities: true,
                latitude: '-53.3527518',
                longitude: '-71.5547782'
            },
            {
                id: 2833,
                name: 'Maule',
                state_code: 'ML',
                hasCities: true,
                latitude: '-35.5972284',
                longitude: '-71.48868'
            },
            {
                id: 2831,
                name: 'Ñuble',
                state_code: 'NB',
                hasCities: true,
                latitude: '-36.6331577',
                longitude: '-71.9384821'
            },
            {
                id: 2824,
                name: 'Región Metropolitana de Santiago',
                state_code: 'RM',
                hasCities: true,
                latitude: '-33.5739341',
                longitude: '-70.6205518'
            },
            {
                id: 2837,
                name: 'Tarapacá',
                state_code: 'TA',
                hasCities: true,
                latitude: '-20.1636672',
                longitude: '-69.5463448'
            },
            {
                id: 2830,
                name: 'Valparaíso',
                state_code: 'VS',
                hasCities: true,
                latitude: '-32.5976089',
                longitude: '-70.8529753'
            }
        ]
    },
    {
        id: 45,
        states: [
            {
                id: 2251,
                name: 'Anhui',
                state_code: 'AH',
                hasCities: true,
                latitude: '32.0',
                longitude: '117.0'
            },
            {
                id: 2257,
                name: 'Beijing',
                state_code: 'BJ',
                hasCities: true,
                latitude: '40.190632',
                longitude: '116.412144'
            },
            {
                id: 2271,
                name: 'Chongqing',
                state_code: 'CQ',
                hasCities: true,
                latitude: '30.05518',
                longitude: '107.8748712'
            },
            {
                id: 2248,
                name: 'Fujian',
                state_code: 'FJ',
                hasCities: true,
                latitude: '26.193218',
                longitude: '118.2208721'
            },
            {
                id: 2275,
                name: 'Gansu',
                state_code: 'GS',
                hasCities: true,
                latitude: '38.0000001',
                longitude: '101.9999999'
            },
            {
                id: 2279,
                name: 'Guangdong',
                state_code: 'GD',
                hasCities: true,
                latitude: '23.1357694',
                longitude: '113.1982688'
            },
            {
                id: 2278,
                name: 'Guangxi Zhuang',
                state_code: 'GX',
                hasCities: true,
                latitude: '24.0',
                longitude: '109.0'
            },
            {
                id: 2261,
                name: 'Guizhou',
                state_code: 'GZ',
                hasCities: true,
                latitude: '27.0',
                longitude: '107.0'
            },
            {
                id: 2273,
                name: 'Hainan',
                state_code: 'HI',
                hasCities: true,
                latitude: '19.2000001',
                longitude: '109.5999999'
            },
            {
                id: 2280,
                name: 'Hebei',
                state_code: 'HE',
                hasCities: true,
                latitude: '39.0000001',
                longitude: '116.0'
            },
            {
                id: 2265,
                name: 'Heilongjiang',
                state_code: 'HL',
                hasCities: true,
                latitude: '48.0000047',
                longitude: '127.999992'
            },
            {
                id: 2259,
                name: 'Henan',
                state_code: 'HA',
                hasCities: true,
                latitude: '34.0000001',
                longitude: '113.9999999'
            },
            {
                id: 2267,
                name: 'Hong Kong SAR',
                state_code: 'HK',
                hasCities: false,
                latitude: '22.350627',
                longitude: '114.1849161'
            },
            {
                id: 2274,
                name: 'Hubei',
                state_code: 'HB',
                hasCities: true,
                latitude: '31.15305035',
                longitude: '112.88064226239663'
            },
            {
                id: 2258,
                name: 'Hunan',
                state_code: 'HN',
                hasCities: true,
                latitude: '27.6662087',
                longitude: '111.7487063'
            },
            {
                id: 2269,
                name: 'Inner Mongolia',
                state_code: 'NM',
                hasCities: true,
                latitude: '43.2443242',
                longitude: '114.3251664'
            },
            {
                id: 2250,
                name: 'Jiangsu',
                state_code: 'JS',
                hasCities: true,
                latitude: '33.0000001',
                longitude: '119.9999999'
            },
            {
                id: 2256,
                name: 'Jiangxi',
                state_code: 'JX',
                hasCities: true,
                latitude: '28.0',
                longitude: '116.0'
            },
            {
                id: 2253,
                name: 'Jilin',
                state_code: 'JL',
                hasCities: true,
                latitude: '43.582583400000004',
                longitude: '126.12661770729827'
            },
            {
                id: 2268,
                name: 'Liaoning',
                state_code: 'LN',
                hasCities: true,
                latitude: '41.2374106',
                longitude: '122.9955469'
            },
            {
                id: 2266,
                name: 'Macau SAR',
                state_code: 'MO',
                hasCities: false
            },
            {
                id: 2262,
                name: 'Ningxia Huizu',
                state_code: 'NX',
                hasCities: true,
                latitude: '37.0000001',
                longitude: '105.9999999'
            },
            {
                id: 2270,
                name: 'Qinghai',
                state_code: 'QH',
                hasCities: true,
                latitude: '35.40709525',
                longitude: '95.95211573241954'
            },
            {
                id: 2272,
                name: 'Shaanxi',
                state_code: 'SN',
                hasCities: true,
                latitude: '35.5895959',
                longitude: '109.3013107'
            },
            {
                id: 2252,
                name: 'Shandong',
                state_code: 'SD',
                hasCities: true,
                latitude: '36.398987',
                longitude: '118.5055691'
            },
            {
                id: 2249,
                name: 'Shanghai',
                state_code: 'SH',
                hasCities: true,
                latitude: '31.2312707',
                longitude: '121.4700152'
            },
            {
                id: 2254,
                name: 'Shanxi',
                state_code: 'SX',
                hasCities: true,
                latitude: '37.0',
                longitude: '112.0'
            },
            {
                id: 2277,
                name: 'Sichuan',
                state_code: 'SC',
                hasCities: true,
                latitude: '30.5000001',
                longitude: '102.4999999'
            },
            {
                id: 2255,
                name: 'Taiwan',
                state_code: 'TW',
                hasCities: true,
                latitude: '38.9131087',
                longitude: '113.5236167'
            },
            {
                id: 2276,
                name: 'Tianjin',
                state_code: 'TJ',
                hasCities: true,
                latitude: '39.3032619',
                longitude: '117.4163641'
            },
            {
                id: 2263,
                name: 'Xinjiang',
                state_code: 'XJ',
                hasCities: true,
                latitude: '42.4804953',
                longitude: '85.4633464'
            },
            {
                id: 2264,
                name: 'Xizang',
                state_code: 'XZ',
                hasCities: true,
                latitude: '29.8556443',
                longitude: '90.8749807'
            },
            {
                id: 2260,
                name: 'Yunnan',
                state_code: 'YN',
                hasCities: true,
                latitude: '25.0',
                longitude: '102.0'
            },
            {
                id: 2247,
                name: 'Zhejiang',
                state_code: 'ZJ',
                hasCities: true,
                latitude: '29.0000001',
                longitude: '119.9999999'
            }
        ]
    },
    { id: 46, states: [] },
    { id: 47, states: [] },
    {
        id: 48,
        states: [
            {
                id: 2895,
                name: 'Amazonas',
                state_code: 'AMA',
                hasCities: true,
                latitude: '-1.305299',
                longitude: '-71.4659212'
            },
            {
                id: 2890,
                name: 'Antioquia',
                state_code: 'ANT',
                hasCities: true,
                latitude: '7.0000085',
                longitude: '-75.5000086'
            },
            {
                id: 2881,
                name: 'Arauca',
                state_code: 'ARA',
                hasCities: true,
                latitude: '6.6666755',
                longitude: '-71.0000086'
            },
            {
                id: 2900,
                name: 'Archipiélago de San Andrés, Providencia y Santa Catalina',
                state_code: 'SAP',
                hasCities: true,
                latitude: '13.35311655',
                longitude: '-81.37498889457396'
            },
            {
                id: 2880,
                name: 'Atlántico',
                state_code: 'ATL',
                hasCities: true,
                latitude: '10.6773422',
                longitude: '-74.9718666'
            },
            {
                id: 4921,
                name: 'Bogotá D.C.',
                state_code: 'DC',
                hasCities: true,
                latitude: '4.2834715',
                longitude: '-74.17536060737828'
            },
            {
                id: 2893,
                name: 'Bolívar',
                state_code: 'BOL',
                hasCities: true,
                latitude: '9.3660477',
                longitude: '-74.8023636'
            },
            {
                id: 2903,
                name: 'Boyacá',
                state_code: 'BOY',
                hasCities: true,
                latitude: '5.6278979',
                longitude: '-72.8268617'
            },
            {
                id: 2887,
                name: 'Caldas',
                state_code: 'CAL',
                hasCities: true,
                latitude: '5.3302514',
                longitude: '-75.2873471'
            },
            {
                id: 2891,
                name: 'Caquetá',
                state_code: 'CAQ',
                hasCities: true,
                latitude: '1.1153385',
                longitude: '-74.1056838'
            },
            {
                id: 2892,
                name: 'Casanare',
                state_code: 'CAS',
                hasCities: true,
                latitude: '5.5000085',
                longitude: '-71.5000086'
            },
            {
                id: 2884,
                name: 'Cauca',
                state_code: 'CAU',
                hasCities: true,
                latitude: '2.715645',
                longitude: '-76.662665'
            },
            {
                id: 2899,
                name: 'Cesar',
                state_code: 'CES',
                hasCities: true,
                latitude: '9.3333415',
                longitude: '-73.5000086'
            },
            {
                id: 2876,
                name: 'Chocó',
                state_code: 'CHO',
                hasCities: true,
                latitude: '6.0000085',
                longitude: '-77.0000086'
            },
            {
                id: 2898,
                name: 'Córdoba',
                state_code: 'COR',
                hasCities: true,
                latitude: '8.3344713',
                longitude: '-75.6666238'
            },
            {
                id: 2875,
                name: 'Cundinamarca',
                state_code: 'CUN',
                hasCities: true,
                latitude: '5.1096596',
                longitude: '-74.0995854'
            },
            {
                id: 2882,
                name: 'Guainía',
                state_code: 'GUA',
                hasCities: true,
                latitude: '2.5000086',
                longitude: '-69.0000086'
            },
            {
                id: 2888,
                name: 'Guaviare',
                state_code: 'GUV',
                hasCities: true,
                latitude: '1.7899197999999998',
                longitude: '-72.37617840546258'
            },
            {
                id: 4871,
                name: 'Huila',
                state_code: 'HUI',
                hasCities: true,
                latitude: '2.4738993',
                longitude: '-75.5900113'
            },
            {
                id: 2889,
                name: 'La Guajira',
                state_code: 'LAG',
                hasCities: true,
                latitude: '11.4354118',
                longitude: '-72.9002161'
            },
            {
                id: 2886,
                name: 'Magdalena',
                state_code: 'MAG',
                hasCities: true,
                latitude: '10.5808075',
                longitude: '-74.0685669'
            },
            {
                id: 2878,
                name: 'Meta',
                state_code: 'MET',
                hasCities: true,
                latitude: '3.5000086',
                longitude: '-73.0000086'
            },
            {
                id: 2897,
                name: 'Nariño',
                state_code: 'NAR',
                hasCities: true,
                latitude: '1.5842268',
                longitude: '-77.8585766'
            },
            {
                id: 2877,
                name: 'Norte de Santander',
                state_code: 'NSA',
                hasCities: true,
                latitude: '8.4417924',
                longitude: '-73.0492505'
            },
            {
                id: 2896,
                name: 'Putumayo',
                state_code: 'PUT',
                hasCities: true,
                latitude: '0.5000086',
                longitude: '-76.0000086'
            },
            {
                id: 2874,
                name: 'Quindío',
                state_code: 'QUI',
                hasCities: true,
                latitude: '4.4028313',
                longitude: '-75.7025795'
            },
            {
                id: 2879,
                name: 'Risaralda',
                state_code: 'RIS',
                hasCities: true,
                latitude: '5.2102948',
                longitude: '-75.9842236'
            },
            {
                id: 2901,
                name: 'Santander',
                state_code: 'SAN',
                hasCities: true,
                latitude: '7.0000085',
                longitude: '-73.2500086'
            },
            {
                id: 2902,
                name: 'Sucre',
                state_code: 'SUC',
                hasCities: true,
                latitude: '9.0',
                longitude: '-75.0'
            },
            {
                id: 2883,
                name: 'Tolima',
                state_code: 'TOL',
                hasCities: true,
                latitude: '4.0355786',
                longitude: '-75.2086642'
            },
            {
                id: 2904,
                name: 'Valle del Cauca',
                state_code: 'VAC',
                hasCities: true,
                latitude: '3.6984053',
                longitude: '-76.5501996'
            },
            {
                id: 2885,
                name: 'Vaupés',
                state_code: 'VAU',
                hasCities: true,
                latitude: '0.42281235',
                longitude: '-70.94683718027875'
            },
            {
                id: 2894,
                name: 'Vichada',
                state_code: 'VID',
                hasCities: true,
                latitude: '4.8686613',
                longitude: '-69.3736658'
            }
        ]
    },
    {
        id: 49,
        states: [
            {
                id: 2821,
                name: 'Anjouan',
                state_code: 'A',
                hasCities: true,
                latitude: '-12.226568050000001',
                longitude: '44.41070486098224'
            },
            {
                id: 2822,
                name: 'Grande Comore',
                state_code: 'G',
                hasCities: true,
                latitude: '-11.65256875',
                longitude: '43.33097059591782'
            },
            {
                id: 2820,
                name: 'Mohéli',
                state_code: 'M',
                hasCities: true,
                latitude: '-12.32045735',
                longitude: '43.720431326729724'
            }
        ]
    },
    {
        id: 50,
        states: [
            {
                id: 2866,
                name: 'Bouenza Department',
                state_code: '11',
                hasCities: true,
                latitude: '-4.2868653',
                longitude: '13.3972129'
            },
            {
                id: 2870,
                name: 'Brazzaville',
                state_code: 'BZV',
                hasCities: true,
                latitude: '-4.2307153',
                longitude: '15.3082702'
            },
            {
                id: 2864,
                name: 'Cuvette Department',
                state_code: '8',
                hasCities: true,
                latitude: '-0.4936855',
                longitude: '16.1602013'
            },
            {
                id: 2869,
                name: 'Cuvette-Ouest Department',
                state_code: '15',
                hasCities: true,
                latitude: '0.280252',
                longitude: '14.5292599'
            },
            {
                id: 2867,
                name: 'Kouilou Department',
                state_code: '5',
                hasCities: false,
                latitude: '-4.1960964',
                longitude: '11.9104388'
            },
            {
                id: 2868,
                name: 'Lékoumou Department',
                state_code: '2',
                hasCities: true,
                latitude: '-3.2315605',
                longitude: '13.5211721'
            },
            {
                id: 2865,
                name: 'Likouala Department',
                state_code: '7',
                hasCities: true,
                latitude: '1.6788828',
                longitude: '17.4747723'
            },
            {
                id: 2872,
                name: 'Niari Department',
                state_code: '9',
                hasCities: true,
                latitude: '-2.9077055',
                longitude: '12.3298313'
            },
            {
                id: 2862,
                name: 'Plateaux Department',
                state_code: '14',
                hasCities: true,
                latitude: '-2.1709644',
                longitude: '15.2286129'
            },
            {
                id: 2863,
                name: 'Pointe-Noire',
                state_code: '16',
                hasCities: true,
                latitude: '-4.8270628',
                longitude: '12.0260584'
            },
            {
                id: 2873,
                name: 'Pool Department',
                state_code: '12',
                hasCities: true,
                latitude: '-3.7298545',
                longitude: '15.053872'
            },
            {
                id: 2871,
                name: 'Sangha Department',
                state_code: '13',
                hasCities: true
            }
        ]
    },
    { id: 52, states: [] },
    {
        id: 53,
        states: [
            {
                id: 1215,
                name: 'Alajuela Province',
                state_code: 'A',
                hasCities: true,
                latitude: '10.45233165',
                longitude: '-84.46632842680263'
            },
            {
                id: 1209,
                name: 'Guanacaste Province',
                state_code: 'G',
                hasCities: true
            },
            {
                id: 1212,
                name: 'Heredia Province',
                state_code: 'H',
                hasCities: true,
                latitude: '10.376781300000001',
                longitude: '-84.01397213865732'
            },
            {
                id: 1213,
                name: 'Limón Province',
                state_code: 'L',
                hasCities: true,
                latitude: '10.099908899999999',
                longitude: '-83.34318729447185'
            },
            {
                id: 1211,
                name: 'Provincia de Cartago',
                state_code: 'C',
                hasCities: true,
                latitude: '9.8159326',
                longitude: '-83.69428210490865'
            },
            {
                id: 1210,
                name: 'Puntarenas Province',
                state_code: 'P',
                hasCities: true,
                latitude: '9.09532795',
                longitude: '-84.20030379242806'
            },
            {
                id: 1214,
                name: 'San José Province',
                state_code: 'SJ',
                hasCities: true,
                latitude: '9.6313549',
                longitude: '-84.06729722484822'
            }
        ]
    },
    {
        id: 54,
        states: [
            { id: 2634, name: 'Abidjan', state_code: 'AB', hasCities: true },
            { id: 2626, name: 'Agnéby', state_code: '16', hasCities: false },
            {
                id: 2636,
                name: 'Bafing Region',
                state_code: '17',
                hasCities: false
            },
            {
                id: 2643,
                name: 'Bas-Sassandra District',
                state_code: 'BS',
                hasCities: true
            },
            {
                id: 2635,
                name: 'Bas-Sassandra Region',
                state_code: '09',
                hasCities: false
            },
            {
                id: 2654,
                name: 'Comoé District',
                state_code: 'CM',
                hasCities: true
            },
            {
                id: 2644,
                name: 'Denguélé District',
                state_code: 'DN',
                hasCities: true
            },
            {
                id: 2642,
                name: 'Denguélé Region',
                state_code: '10',
                hasCities: false
            },
            {
                id: 2645,
                name: 'Dix-Huit Montagnes',
                state_code: '06',
                hasCities: true
            },
            {
                id: 2633,
                name: 'Fromager',
                state_code: '18',
                hasCities: false
            },
            {
                id: 2651,
                name: 'Gôh-Djiboua District',
                state_code: 'GD',
                hasCities: true
            },
            {
                id: 2638,
                name: 'Haut-Sassandra',
                state_code: '02',
                hasCities: false
            },
            {
                id: 2632,
                name: 'Lacs District',
                state_code: 'LC',
                hasCities: false
            },
            {
                id: 2640,
                name: 'Lacs Region',
                state_code: '07',
                hasCities: true
            },
            {
                id: 2627,
                name: 'Lagunes District',
                state_code: 'LG',
                hasCities: false
            },
            {
                id: 2639,
                name: 'Lagunes region',
                state_code: '01',
                hasCities: true
            },
            {
                id: 2631,
                name: 'Marahoué Region',
                state_code: '12',
                hasCities: false
            },
            {
                id: 2629,
                name: 'Montagnes District',
                state_code: 'MG',
                hasCities: false
            },
            {
                id: 2646,
                name: 'Moyen-Cavally',
                state_code: '19',
                hasCities: false
            },
            {
                id: 2630,
                name: 'Moyen-Comoé',
                state_code: '05',
                hasCities: false
            },
            {
                id: 2655,
                name: "N'zi-Comoé",
                state_code: '11',
                hasCities: false
            },
            {
                id: 2648,
                name: 'Sassandra-Marahoué District',
                state_code: 'SM',
                hasCities: true
            },
            {
                id: 2625,
                name: 'Savanes Region',
                state_code: '03',
                hasCities: false
            },
            {
                id: 2628,
                name: 'Sud-Bandama',
                state_code: '15',
                hasCities: false
            },
            {
                id: 2652,
                name: 'Sud-Comoé',
                state_code: '13',
                hasCities: false
            },
            {
                id: 2637,
                name: 'Vallée du Bandama District',
                state_code: 'VB',
                hasCities: false
            },
            {
                id: 2647,
                name: 'Vallée du Bandama Region',
                state_code: '04',
                hasCities: true
            },
            {
                id: 2650,
                name: 'Woroba District',
                state_code: 'WR',
                hasCities: true
            },
            {
                id: 2649,
                name: 'Worodougou',
                state_code: '14',
                hasCities: false
            },
            {
                id: 2653,
                name: 'Yamoussoukro',
                state_code: 'YM',
                hasCities: false
            },
            {
                id: 2641,
                name: 'Zanzan Region',
                state_code: 'ZZ',
                hasCities: true
            }
        ]
    },
    {
        id: 55,
        states: [
            {
                id: 734,
                name: 'Bjelovar-Bilogora',
                state_code: '07',
                hasCities: true
            },
            {
                id: 737,
                name: 'Brod-Posavina',
                state_code: '12',
                hasCities: true
            },
            {
                id: 728,
                name: 'Dubrovnik-Neretva',
                state_code: '19',
                hasCities: true
            },
            {
                id: 743,
                name: 'Istria',
                state_code: '18',
                hasCities: true,
                latitude: '45.193434499999995',
                longitude: '13.915053587355306'
            },
            {
                id: 5069,
                name: 'Karlovac',
                state_code: '04',
                hasCities: false,
                latitude: '46.0603617',
                longitude: '16.6887509'
            },
            {
                id: 742,
                name: 'Koprivnica-Križevci',
                state_code: '06',
                hasCities: true
            },
            {
                id: 729,
                name: 'Krapina-Zagorje',
                state_code: '02',
                hasCities: true
            },
            { id: 731, name: 'Lika-Senj', state_code: '09', hasCities: true },
            { id: 726, name: 'Međimurje', state_code: '20', hasCities: true },
            {
                id: 740,
                name: 'Osijek-Baranja',
                state_code: '14',
                hasCities: true
            },
            {
                id: 724,
                name: 'Požega-Slavonia',
                state_code: '11',
                hasCities: true
            },
            {
                id: 735,
                name: 'Primorje-Gorski Kotar',
                state_code: '08',
                hasCities: true
            },
            {
                id: 730,
                name: 'Šibenik-Knin',
                state_code: '15',
                hasCities: true
            },
            {
                id: 733,
                name: 'Sisak-Moslavina',
                state_code: '03',
                hasCities: true
            },
            {
                id: 725,
                name: 'Split-Dalmatia',
                state_code: '17',
                hasCities: true
            },
            {
                id: 739,
                name: 'Varaždin',
                state_code: '05',
                hasCities: true,
                latitude: '46.308979699999995',
                longitude: '16.3226412685206'
            },
            {
                id: 732,
                name: 'Virovitica-Podravina',
                state_code: '10',
                hasCities: true
            },
            {
                id: 741,
                name: 'Vukovar-Syrmia',
                state_code: '16',
                hasCities: true
            },
            {
                id: 727,
                name: 'Zadar',
                state_code: '13',
                hasCities: true,
                latitude: '44.1178297',
                longitude: '15.228611017614924'
            },
            {
                id: 736,
                name: 'Zagreb',
                state_code: '01',
                hasCities: true,
                latitude: '45.7913722',
                longitude: '16.011544777793343'
            },
            {
                id: 738,
                name: 'Zagreb',
                state_code: '21',
                hasCities: true,
                latitude: '45.7913722',
                longitude: '16.011544777793343'
            }
        ]
    },
    {
        id: 56,
        states: [
            {
                id: 283,
                name: 'Artemisa Province',
                state_code: '15',
                hasCities: true
            },
            {
                id: 286,
                name: 'Camagüey Province',
                state_code: '09',
                hasCities: true
            },
            {
                id: 282,
                name: 'Ciego de Ávila Province',
                state_code: '08',
                hasCities: true
            },
            {
                id: 287,
                name: 'Cienfuegos Province',
                state_code: '06',
                hasCities: true
            },
            {
                id: 275,
                name: 'Granma Province',
                state_code: '12',
                hasCities: true
            },
            {
                id: 285,
                name: 'Guantánamo Province',
                state_code: '14',
                hasCities: true
            },
            {
                id: 272,
                name: 'Havana Province',
                state_code: '03',
                hasCities: true
            },
            {
                id: 279,
                name: 'Holguín Province',
                state_code: '11',
                hasCities: true
            },
            {
                id: 278,
                name: 'Isla de la Juventud',
                state_code: '99',
                hasCities: true
            },
            {
                id: 281,
                name: 'Las Tunas Province',
                state_code: '10',
                hasCities: true
            },
            {
                id: 284,
                name: 'Matanzas Province',
                state_code: '04',
                hasCities: true
            },
            {
                id: 276,
                name: 'Mayabeque Province',
                state_code: '16',
                hasCities: true
            },
            {
                id: 277,
                name: 'Pinar del Río Province',
                state_code: '01',
                hasCities: true
            },
            {
                id: 274,
                name: 'Sancti Spíritus Province',
                state_code: '07',
                hasCities: true
            },
            {
                id: 273,
                name: 'Santiago de Cuba Province',
                state_code: '13',
                hasCities: true
            },
            {
                id: 280,
                name: 'Villa Clara Province',
                state_code: '05',
                hasCities: true
            }
        ]
    },
    { id: 249, states: [] },
    {
        id: 57,
        states: [
            {
                id: 749,
                name: 'Famagusta District (Mağusa)',
                state_code: '04',
                hasCities: true
            },
            {
                id: 744,
                name: 'Kyrenia District (Keryneia)',
                state_code: '06',
                hasCities: true
            },
            {
                id: 747,
                name: 'Larnaca District (Larnaka)',
                state_code: '03',
                hasCities: true
            },
            {
                id: 748,
                name: 'Limassol District (Leymasun)',
                state_code: '02',
                hasCities: true
            },
            {
                id: 745,
                name: 'Nicosia District (Lefkoşa)',
                state_code: '01',
                hasCities: true
            },
            {
                id: 746,
                name: 'Paphos District (Pafos)',
                state_code: '05',
                hasCities: true
            }
        ]
    },
    {
        id: 58,
        states: [
            {
                id: 4627,
                name: 'Benešov',
                state_code: '201',
                hasCities: false
            },
            { id: 4620, name: 'Beroun', state_code: '202', hasCities: false },
            {
                id: 4615,
                name: 'Blansko',
                state_code: '641',
                hasCities: false
            },
            {
                id: 4542,
                name: 'Břeclav',
                state_code: '644',
                hasCities: false
            },
            {
                id: 4568,
                name: 'Brno-město',
                state_code: '642',
                hasCities: false
            },
            {
                id: 4545,
                name: 'Brno-venkov',
                state_code: '643',
                hasCities: false
            },
            {
                id: 4644,
                name: 'Bruntál',
                state_code: '801',
                hasCities: false
            },
            {
                id: 4633,
                name: 'Česká Lípa',
                state_code: '511',
                hasCities: false
            },
            {
                id: 4556,
                name: 'České Budějovice',
                state_code: '311',
                hasCities: false
            },
            {
                id: 4543,
                name: 'Český Krumlov',
                state_code: '312',
                hasCities: false
            },
            { id: 4573, name: 'Cheb', state_code: '411', hasCities: false },
            {
                id: 4553,
                name: 'Chomutov',
                state_code: '422',
                hasCities: false
            },
            {
                id: 4634,
                name: 'Chrudim',
                state_code: '531',
                hasCities: false
            },
            { id: 4609, name: 'Děčín', state_code: '421', hasCities: false },
            {
                id: 4641,
                name: 'Domažlice',
                state_code: '321',
                hasCities: false
            },
            {
                id: 4559,
                name: 'Frýdek-Místek',
                state_code: '802',
                hasCities: false
            },
            {
                id: 4611,
                name: 'Havlíčkův Brod',
                state_code: '631',
                hasCities: false
            },
            {
                id: 4561,
                name: 'Hodonín',
                state_code: '645',
                hasCities: false
            },
            {
                id: 4580,
                name: 'Hradec Králové',
                state_code: '521',
                hasCities: false
            },
            {
                id: 4612,
                name: 'Jablonec nad Nisou',
                state_code: '512',
                hasCities: false
            },
            {
                id: 4625,
                name: 'Jeseník',
                state_code: '711',
                hasCities: false
            },
            { id: 4640, name: 'Jičín', state_code: '522', hasCities: false },
            {
                id: 4613,
                name: 'Jihlava',
                state_code: '632',
                hasCities: false
            },
            {
                id: 4639,
                name: 'Jihočeský kraj',
                state_code: '31',
                hasCities: true
            },
            {
                id: 4602,
                name: 'Jihomoravský kraj',
                state_code: '64',
                hasCities: true
            },
            {
                id: 4624,
                name: 'Jindřichův Hradec',
                state_code: '313',
                hasCities: false
            },
            {
                id: 4581,
                name: 'Karlovarský kraj',
                state_code: '41',
                hasCities: true
            },
            {
                id: 4604,
                name: 'Karlovy Vary',
                state_code: '412',
                hasCities: false
            },
            {
                id: 4586,
                name: 'Karviná',
                state_code: '803',
                hasCities: false
            },
            { id: 4631, name: 'Kladno', state_code: '203', hasCities: false },
            {
                id: 4591,
                name: 'Klatovy',
                state_code: '322',
                hasCities: false
            },
            { id: 4618, name: 'Kolín', state_code: '204', hasCities: false },
            {
                id: 4575,
                name: 'Kraj Vysočina',
                state_code: '63',
                hasCities: true
            },
            {
                id: 4614,
                name: 'Královéhradecký kraj',
                state_code: '52',
                hasCities: true
            },
            {
                id: 4593,
                name: 'Kroměříž',
                state_code: '721',
                hasCities: false
            },
            {
                id: 4923,
                name: 'Kutná Hora',
                state_code: '205',
                hasCities: false
            },
            {
                id: 4590,
                name: 'Liberec',
                state_code: '513',
                hasCities: false
            },
            {
                id: 4601,
                name: 'Liberecký kraj',
                state_code: '51',
                hasCities: true
            },
            {
                id: 4605,
                name: 'Litoměřice',
                state_code: '423',
                hasCities: false
            },
            { id: 4617, name: 'Louny', state_code: '424', hasCities: false },
            { id: 4638, name: 'Mělník', state_code: '206', hasCities: false },
            {
                id: 4643,
                name: 'Mladá Boleslav',
                state_code: '207',
                hasCities: false
            },
            {
                id: 4600,
                name: 'Moravskoslezský kraj',
                state_code: '80',
                hasCities: true
            },
            { id: 4629, name: 'Most', state_code: '425', hasCities: false },
            { id: 4550, name: 'Náchod', state_code: '523', hasCities: false },
            {
                id: 4548,
                name: 'Nový Jičín',
                state_code: '804',
                hasCities: false
            },
            {
                id: 4582,
                name: 'Nymburk',
                state_code: '208',
                hasCities: false
            },
            {
                id: 4574,
                name: 'Olomouc',
                state_code: '712',
                hasCities: false
            },
            {
                id: 4589,
                name: 'Olomoucký kraj',
                state_code: '71',
                hasCities: true
            },
            { id: 4623, name: 'Opava', state_code: '805', hasCities: false },
            {
                id: 4584,
                name: 'Ostrava-město',
                state_code: '806',
                hasCities: false
            },
            {
                id: 4547,
                name: 'Pardubice',
                state_code: '532',
                hasCities: false
            },
            {
                id: 4588,
                name: 'Pardubický kraj',
                state_code: '53',
                hasCities: true
            },
            {
                id: 4645,
                name: 'Pelhřimov',
                state_code: '633',
                hasCities: false
            },
            { id: 4560, name: 'Písek', state_code: '314', hasCities: false },
            {
                id: 4608,
                name: 'Plzeň-jih',
                state_code: '324',
                hasCities: true
            },
            {
                id: 4544,
                name: 'Plzeň-město',
                state_code: '323',
                hasCities: false
            },
            {
                id: 4564,
                name: 'Plzeň-sever',
                state_code: '325',
                hasCities: false
            },
            {
                id: 4607,
                name: 'Plzeňský kraj',
                state_code: '32',
                hasCities: false
            },
            {
                id: 4578,
                name: 'Prachatice',
                state_code: '315',
                hasCities: false
            },
            {
                id: 4606,
                name: 'Praha-východ',
                state_code: '209',
                hasCities: false
            },
            {
                id: 4619,
                name: 'Praha-západ',
                state_code: '20A',
                hasCities: false
            },
            {
                id: 4598,
                name: 'Praha, Hlavní město',
                state_code: '10',
                hasCities: true
            },
            { id: 4626, name: 'Přerov', state_code: '714', hasCities: false },
            {
                id: 4546,
                name: 'Příbram',
                state_code: '20B',
                hasCities: false
            },
            {
                id: 4551,
                name: 'Prostějov',
                state_code: '713',
                hasCities: false
            },
            {
                id: 4558,
                name: 'Rakovník',
                state_code: '20C',
                hasCities: false
            },
            {
                id: 4583,
                name: 'Rokycany',
                state_code: '326',
                hasCities: false
            },
            {
                id: 4636,
                name: 'Rychnov nad Kněžnou',
                state_code: '524',
                hasCities: false
            },
            { id: 4596, name: 'Semily', state_code: '514', hasCities: false },
            {
                id: 4595,
                name: 'Sokolov',
                state_code: '413',
                hasCities: false
            },
            {
                id: 4628,
                name: 'Strakonice',
                state_code: '316',
                hasCities: false
            },
            {
                id: 4554,
                name: 'Středočeský kraj',
                state_code: '20',
                hasCities: true
            },
            {
                id: 4642,
                name: 'Šumperk',
                state_code: '715',
                hasCities: false
            },
            {
                id: 4571,
                name: 'Svitavy',
                state_code: '533',
                hasCities: false
            },
            { id: 4565, name: 'Tábor', state_code: '317', hasCities: false },
            { id: 4646, name: 'Tachov', state_code: '327', hasCities: false },
            {
                id: 4621,
                name: 'Teplice',
                state_code: '426',
                hasCities: false
            },
            { id: 4597, name: 'Třebíč', state_code: '634', hasCities: false },
            {
                id: 4579,
                name: 'Trutnov',
                state_code: '525',
                hasCities: false
            },
            {
                id: 4592,
                name: 'Uherské Hradiště',
                state_code: '722',
                hasCities: false
            },
            {
                id: 4576,
                name: 'Ústecký kraj',
                state_code: '42',
                hasCities: true
            },
            {
                id: 4599,
                name: 'Ústí nad Labem',
                state_code: '427',
                hasCities: false
            },
            {
                id: 4647,
                name: 'Ústí nad Orlicí',
                state_code: '534',
                hasCities: false
            },
            { id: 4572, name: 'Vsetín', state_code: '723', hasCities: false },
            { id: 4622, name: 'Vyškov', state_code: '646', hasCities: false },
            {
                id: 4648,
                name: 'Žďár nad Sázavou',
                state_code: '635',
                hasCities: false
            },
            { id: 4563, name: 'Zlín', state_code: '724', hasCities: true },
            {
                id: 4552,
                name: 'Zlínský kraj',
                state_code: '72',
                hasCities: false
            },
            { id: 4630, name: 'Znojmo', state_code: '647', hasCities: false }
        ]
    },
    {
        id: 51,
        states: [
            { id: 2753, name: 'Bas-Uélé', state_code: 'BU', hasCities: true },
            { id: 2744, name: 'Équateur', state_code: 'EQ', hasCities: true },
            {
                id: 2750,
                name: 'Haut-Katanga',
                state_code: 'HK',
                hasCities: true
            },
            {
                id: 2758,
                name: 'Haut-Lomami',
                state_code: 'HL',
                hasCities: true
            },
            {
                id: 2734,
                name: 'Haut-Uélé',
                state_code: 'HU',
                hasCities: true
            },
            { id: 2751, name: 'Ituri', state_code: 'IT', hasCities: true },
            { id: 2757, name: 'Kasaï', state_code: 'KS', hasCities: true },
            {
                id: 2742,
                name: 'Kasaï Central',
                state_code: 'KC',
                hasCities: false
            },
            {
                id: 2735,
                name: 'Kasaï Oriental',
                state_code: 'KE',
                hasCities: true
            },
            { id: 2741, name: 'Kinshasa', state_code: 'KN', hasCities: true },
            {
                id: 2746,
                name: 'Kongo Central',
                state_code: 'BC',
                hasCities: true
            },
            { id: 2740, name: 'Kwango', state_code: 'KG', hasCities: true },
            { id: 2759, name: 'Kwilu', state_code: 'KL', hasCities: true },
            { id: 2747, name: 'Lomami', state_code: 'LO', hasCities: true },
            { id: 4953, name: 'Lualaba', state_code: 'LU', hasCities: false },
            {
                id: 2755,
                name: 'Mai-Ndombe',
                state_code: 'MN',
                hasCities: true
            },
            { id: 2745, name: 'Maniema', state_code: 'MA', hasCities: true },
            { id: 2752, name: 'Mongala', state_code: 'MO', hasCities: true },
            {
                id: 2749,
                name: 'Nord-Kivu',
                state_code: 'NK',
                hasCities: true
            },
            {
                id: 2739,
                name: 'Nord-Ubangi',
                state_code: 'NU',
                hasCities: true
            },
            { id: 2743, name: 'Sankuru', state_code: 'SA', hasCities: true },
            { id: 2738, name: 'Sud-Kivu', state_code: 'SK', hasCities: true },
            {
                id: 2748,
                name: 'Sud-Ubangi',
                state_code: 'SU',
                hasCities: true
            },
            {
                id: 2733,
                name: 'Tanganyika',
                state_code: 'TA',
                hasCities: true
            },
            { id: 2756, name: 'Tshopo', state_code: 'TO', hasCities: true },
            { id: 2732, name: 'Tshuapa', state_code: 'TU', hasCities: true }
        ]
    },
    {
        id: 59,
        states: [
            {
                id: 1530,
                name: 'Capital Region of Denmark',
                state_code: '84',
                hasCities: true
            },
            {
                id: 1531,
                name: 'Central Denmark Region',
                state_code: '82',
                hasCities: true
            },
            {
                id: 1532,
                name: 'North Denmark Region',
                state_code: '81',
                hasCities: true
            },
            {
                id: 1529,
                name: 'Region of Southern Denmark',
                state_code: '83',
                hasCities: true
            },
            {
                id: 1528,
                name: 'Region Zealand',
                state_code: '85',
                hasCities: true
            }
        ]
    },
    {
        id: 60,
        states: [
            {
                id: 2933,
                name: 'Ali Sabieh Region',
                state_code: 'AS',
                hasCities: true
            },
            {
                id: 2932,
                name: 'Arta Region',
                state_code: 'AR',
                hasCities: true
            },
            {
                id: 2930,
                name: 'Dikhil Region',
                state_code: 'DI',
                hasCities: true
            },
            { id: 2929, name: 'Djibouti', state_code: 'DJ', hasCities: true },
            {
                id: 2928,
                name: 'Obock Region',
                state_code: 'OB',
                hasCities: true
            },
            {
                id: 2931,
                name: 'Tadjourah Region',
                state_code: 'TA',
                hasCities: true
            }
        ]
    },
    {
        id: 61,
        states: [
            {
                id: 4082,
                name: 'Saint Andrew Parish',
                state_code: '02',
                hasCities: true
            },
            {
                id: 4078,
                name: 'Saint David Parish',
                state_code: '03',
                hasCities: true
            },
            {
                id: 4079,
                name: 'Saint George Parish',
                state_code: '04',
                hasCities: true
            },
            {
                id: 4076,
                name: 'Saint John Parish',
                state_code: '05',
                hasCities: true
            },
            {
                id: 4085,
                name: 'Saint Joseph Parish',
                state_code: '06',
                hasCities: true
            },
            {
                id: 4083,
                name: 'Saint Luke Parish',
                state_code: '07',
                hasCities: true
            },
            {
                id: 4077,
                name: 'Saint Mark Parish',
                state_code: '08',
                hasCities: true
            },
            {
                id: 4080,
                name: 'Saint Patrick Parish',
                state_code: '09',
                hasCities: true
            },
            {
                id: 4084,
                name: 'Saint Paul Parish',
                state_code: '10',
                hasCities: true
            },
            {
                id: 4081,
                name: 'Saint Peter Parish',
                state_code: '11',
                hasCities: true
            }
        ]
    },
    {
        id: 62,
        states: [
            {
                id: 4114,
                name: 'Azua Province',
                state_code: '02',
                hasCities: true
            },
            {
                id: 4105,
                name: 'Baoruco Province',
                state_code: '03',
                hasCities: true
            },
            {
                id: 4090,
                name: 'Barahona Province',
                state_code: '04',
                hasCities: true
            },
            {
                id: 4107,
                name: 'Dajabón Province',
                state_code: '05',
                hasCities: true
            },
            {
                id: 4095,
                name: 'Distrito Nacional',
                state_code: '01',
                hasCities: true
            },
            {
                id: 4113,
                name: 'Duarte Province',
                state_code: '06',
                hasCities: true
            },
            {
                id: 4086,
                name: 'El Seibo Province',
                state_code: '08',
                hasCities: true
            },
            {
                id: 4102,
                name: 'Espaillat Province',
                state_code: '09',
                hasCities: true
            },
            {
                id: 4106,
                name: 'Hato Mayor Province',
                state_code: '30',
                hasCities: true
            },
            {
                id: 4089,
                name: 'Hermanas Mirabal Province',
                state_code: '19',
                hasCities: true
            },
            {
                id: 4097,
                name: 'Independencia',
                state_code: '10',
                hasCities: true
            },
            {
                id: 4109,
                name: 'La Altagracia Province',
                state_code: '11',
                hasCities: true
            },
            {
                id: 4087,
                name: 'La Romana Province',
                state_code: '12',
                hasCities: true
            },
            {
                id: 4116,
                name: 'La Vega Province',
                state_code: '13',
                hasCities: true
            },
            {
                id: 4094,
                name: 'María Trinidad Sánchez Province',
                state_code: '14',
                hasCities: true
            },
            {
                id: 4099,
                name: 'Monseñor Nouel Province',
                state_code: '28',
                hasCities: true
            },
            {
                id: 4115,
                name: 'Monte Cristi Province',
                state_code: '15',
                hasCities: true
            },
            {
                id: 4111,
                name: 'Monte Plata Province',
                state_code: '29',
                hasCities: true
            },
            {
                id: 4101,
                name: 'Pedernales Province',
                state_code: '16',
                hasCities: true
            },
            {
                id: 4096,
                name: 'Peravia Province',
                state_code: '17',
                hasCities: true
            },
            {
                id: 4092,
                name: 'Puerto Plata Province',
                state_code: '18',
                hasCities: true
            },
            {
                id: 4103,
                name: 'Samaná Province',
                state_code: '20',
                hasCities: true
            },
            {
                id: 4091,
                name: 'San Cristóbal Province',
                state_code: '21',
                hasCities: true
            },
            {
                id: 4112,
                name: 'San José de Ocoa Province',
                state_code: '31',
                hasCities: true
            },
            {
                id: 4098,
                name: 'San Juan Province',
                state_code: '22',
                hasCities: true
            },
            {
                id: 4110,
                name: 'San Pedro de Macorís',
                state_code: '23',
                hasCities: true
            },
            {
                id: 4088,
                name: 'Sánchez Ramírez Province',
                state_code: '24',
                hasCities: true
            },
            {
                id: 4108,
                name: 'Santiago Province',
                state_code: '25',
                hasCities: true
            },
            {
                id: 4100,
                name: 'Santiago Rodríguez Province',
                state_code: '26',
                hasCities: true
            },
            {
                id: 4093,
                name: 'Santo Domingo Province',
                state_code: '32',
                hasCities: true
            },
            {
                id: 4104,
                name: 'Valverde Province',
                state_code: '27',
                hasCities: true
            }
        ]
    },
    {
        id: 63,
        states: [
            {
                id: 4520,
                name: 'Aileu municipality',
                state_code: 'AL',
                hasCities: true
            },
            {
                id: 4518,
                name: 'Ainaro Municipality',
                state_code: 'AN',
                hasCities: true
            },
            {
                id: 4521,
                name: 'Baucau Municipality',
                state_code: 'BA',
                hasCities: true
            },
            {
                id: 4525,
                name: 'Bobonaro Municipality',
                state_code: 'BO',
                hasCities: true
            },
            {
                id: 4522,
                name: 'Cova Lima Municipality',
                state_code: 'CO',
                hasCities: true
            },
            {
                id: 4524,
                name: 'Dili municipality',
                state_code: 'DI',
                hasCities: true
            },
            {
                id: 4516,
                name: 'Ermera District',
                state_code: 'ER',
                hasCities: true
            },
            {
                id: 4523,
                name: 'Lautém Municipality',
                state_code: 'LA',
                hasCities: true
            },
            {
                id: 4515,
                name: 'Liquiçá Municipality',
                state_code: 'LI',
                hasCities: true
            },
            {
                id: 4517,
                name: 'Manatuto District',
                state_code: 'MT',
                hasCities: true
            },
            {
                id: 4519,
                name: 'Manufahi Municipality',
                state_code: 'MF',
                hasCities: true
            },
            {
                id: 4514,
                name: 'Viqueque Municipality',
                state_code: 'VI',
                hasCities: true
            }
        ]
    },
    {
        id: 64,
        states: [
            { id: 2923, name: 'Azuay', state_code: 'A', hasCities: true },
            { id: 2920, name: 'Bolívar', state_code: 'B', hasCities: true },
            { id: 2917, name: 'Cañar', state_code: 'F', hasCities: true },
            { id: 2915, name: 'Carchi', state_code: 'C', hasCities: true },
            {
                id: 2925,
                name: 'Chimborazo',
                state_code: 'H',
                hasCities: true
            },
            { id: 2921, name: 'Cotopaxi', state_code: 'X', hasCities: true },
            { id: 2924, name: 'El Oro', state_code: 'O', hasCities: true },
            {
                id: 2922,
                name: 'Esmeraldas',
                state_code: 'E',
                hasCities: true
            },
            { id: 2905, name: 'Galápagos', state_code: 'W', hasCities: true },
            { id: 2914, name: 'Guayas', state_code: 'G', hasCities: true },
            { id: 2911, name: 'Imbabura', state_code: 'I', hasCities: true },
            { id: 5068, name: 'Loja', state_code: 'L', hasCities: true },
            { id: 2910, name: 'Los Ríos', state_code: 'R', hasCities: true },
            { id: 2913, name: 'Manabí', state_code: 'M', hasCities: true },
            {
                id: 2918,
                name: 'Morona-Santiago',
                state_code: 'S',
                hasCities: true
            },
            { id: 2916, name: 'Napo', state_code: 'N', hasCities: true },
            { id: 2926, name: 'Orellana', state_code: 'D', hasCities: true },
            { id: 2907, name: 'Pastaza', state_code: 'Y', hasCities: true },
            { id: 2927, name: 'Pichincha', state_code: 'P', hasCities: true },
            {
                id: 2912,
                name: 'Santa Elena',
                state_code: 'SE',
                hasCities: true
            },
            {
                id: 2919,
                name: 'Santo Domingo de los Tsáchilas',
                state_code: 'SD',
                hasCities: true
            },
            { id: 2906, name: 'Sucumbíos', state_code: 'U', hasCities: true },
            {
                id: 2908,
                name: 'Tungurahua',
                state_code: 'T',
                hasCities: true
            },
            {
                id: 2909,
                name: 'Zamora Chinchipe',
                state_code: 'Z',
                hasCities: true
            }
        ]
    },
    {
        id: 65,
        states: [
            {
                id: 3235,
                name: 'Alexandria',
                state_code: 'ALX',
                hasCities: true
            },
            { id: 3225, name: 'Aswan', state_code: 'ASN', hasCities: true },
            { id: 3236, name: 'Asyut', state_code: 'AST', hasCities: true },
            { id: 3241, name: 'Beheira', state_code: 'BH', hasCities: true },
            {
                id: 3230,
                name: 'Beni Suef',
                state_code: 'BNS',
                hasCities: true
            },
            { id: 3223, name: 'Cairo', state_code: 'C', hasCities: true },
            { id: 3245, name: 'Dakahlia', state_code: 'DK', hasCities: true },
            { id: 3224, name: 'Damietta', state_code: 'DT', hasCities: true },
            { id: 3238, name: 'Faiyum', state_code: 'FYM', hasCities: true },
            { id: 3234, name: 'Gharbia', state_code: 'GH', hasCities: true },
            { id: 3239, name: 'Giza', state_code: 'GZ', hasCities: true },
            { id: 3244, name: 'Ismailia', state_code: 'IS', hasCities: true },
            {
                id: 3222,
                name: 'Kafr el-Sheikh',
                state_code: 'KFS',
                hasCities: true
            },
            { id: 3242, name: 'Luxor', state_code: 'LX', hasCities: true },
            { id: 3231, name: 'Matrouh', state_code: 'MT', hasCities: true },
            { id: 3243, name: 'Minya', state_code: 'MN', hasCities: true },
            { id: 3228, name: 'Monufia', state_code: 'MNF', hasCities: true },
            {
                id: 3246,
                name: 'New Valley',
                state_code: 'WAD',
                hasCities: true
            },
            {
                id: 3227,
                name: 'North Sinai',
                state_code: 'SIN',
                hasCities: true
            },
            {
                id: 3229,
                name: 'Port Said',
                state_code: 'PTS',
                hasCities: true
            },
            { id: 3232, name: 'Qalyubia', state_code: 'KB', hasCities: true },
            { id: 3247, name: 'Qena', state_code: 'KN', hasCities: true },
            { id: 3240, name: 'Red Sea', state_code: 'BA', hasCities: true },
            { id: 5067, name: 'Sharqia', state_code: 'SHR', hasCities: true },
            { id: 3226, name: 'Sohag', state_code: 'SHG', hasCities: true },
            {
                id: 3237,
                name: 'South Sinai',
                state_code: 'JS',
                hasCities: true
            },
            { id: 3233, name: 'Suez', state_code: 'SUZ', hasCities: true }
        ]
    },
    {
        id: 66,
        states: [
            {
                id: 4139,
                name: 'Ahuachapán Department',
                state_code: 'AH',
                hasCities: true
            },
            {
                id: 4132,
                name: 'Cabañas Department',
                state_code: 'CA',
                hasCities: true
            },
            {
                id: 4131,
                name: 'Chalatenango Department',
                state_code: 'CH',
                hasCities: true
            },
            {
                id: 4137,
                name: 'Cuscatlán Department',
                state_code: 'CU',
                hasCities: true
            },
            {
                id: 4134,
                name: 'La Libertad Department',
                state_code: 'LI',
                hasCities: true
            },
            {
                id: 4136,
                name: 'La Paz Department',
                state_code: 'PA',
                hasCities: true
            },
            {
                id: 4138,
                name: 'La Unión Department',
                state_code: 'UN',
                hasCities: true
            },
            {
                id: 4130,
                name: 'Morazán Department',
                state_code: 'MO',
                hasCities: true
            },
            {
                id: 4135,
                name: 'San Miguel Department',
                state_code: 'SM',
                hasCities: true
            },
            {
                id: 4133,
                name: 'San Salvador Department',
                state_code: 'SS',
                hasCities: true
            },
            {
                id: 4127,
                name: 'San Vicente Department',
                state_code: 'SV',
                hasCities: true
            },
            {
                id: 4128,
                name: 'Santa Ana Department',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 4140,
                name: 'Sonsonate Department',
                state_code: 'SO',
                hasCities: true
            },
            {
                id: 4129,
                name: 'Usulután Department',
                state_code: 'US',
                hasCities: true
            }
        ]
    },
    {
        id: 67,
        states: [
            {
                id: 3444,
                name: 'Annobón Province',
                state_code: 'AN',
                hasCities: true
            },
            {
                id: 3446,
                name: 'Bioko Norte Province',
                state_code: 'BN',
                hasCities: true
            },
            {
                id: 3443,
                name: 'Bioko Sur Province',
                state_code: 'BS',
                hasCities: true
            },
            {
                id: 3445,
                name: 'Centro Sur Province',
                state_code: 'CS',
                hasCities: true
            },
            {
                id: 3442,
                name: 'Insular Region',
                state_code: 'I',
                hasCities: false
            },
            {
                id: 3439,
                name: 'Kié-Ntem Province',
                state_code: 'KN',
                hasCities: true
            },
            {
                id: 3441,
                name: 'Litoral Province',
                state_code: 'LI',
                hasCities: true
            },
            { id: 3438, name: 'Río Muni', state_code: 'C', hasCities: false },
            {
                id: 3440,
                name: 'Wele-Nzas Province',
                state_code: 'WN',
                hasCities: true
            }
        ]
    },
    {
        id: 68,
        states: [
            {
                id: 3425,
                name: 'Anseba Region',
                state_code: 'AN',
                hasCities: true
            },
            {
                id: 3427,
                name: 'Debub Region',
                state_code: 'DU',
                hasCities: true
            },
            {
                id: 3428,
                name: 'Gash-Barka Region',
                state_code: 'GB',
                hasCities: true
            },
            {
                id: 3426,
                name: 'Maekel Region',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 3424,
                name: 'Northern Red Sea Region',
                state_code: 'SK',
                hasCities: true
            },
            {
                id: 3429,
                name: 'Southern Red Sea Region',
                state_code: 'DK',
                hasCities: true
            }
        ]
    },
    {
        id: 69,
        states: [
            {
                id: 3567,
                name: 'Harju County',
                state_code: '37',
                hasCities: true
            },
            {
                id: 3555,
                name: 'Hiiu County',
                state_code: '39',
                hasCities: true
            },
            {
                id: 3569,
                name: 'Ida-Viru County',
                state_code: '44',
                hasCities: true
            },
            {
                id: 3566,
                name: 'Järva County',
                state_code: '51',
                hasCities: true
            },
            {
                id: 3565,
                name: 'Jõgeva County',
                state_code: '49',
                hasCities: true
            },
            {
                id: 3568,
                name: 'Lääne County',
                state_code: '57',
                hasCities: true
            },
            {
                id: 3564,
                name: 'Lääne-Viru County',
                state_code: '59',
                hasCities: true
            },
            {
                id: 3562,
                name: 'Pärnu County',
                state_code: '67',
                hasCities: true
            },
            {
                id: 3563,
                name: 'Põlva County',
                state_code: '65',
                hasCities: true
            },
            {
                id: 3559,
                name: 'Rapla County',
                state_code: '70',
                hasCities: true
            },
            {
                id: 3561,
                name: 'Saare County',
                state_code: '74',
                hasCities: true
            },
            {
                id: 3557,
                name: 'Tartu County',
                state_code: '78',
                hasCities: true
            },
            {
                id: 3558,
                name: 'Valga County',
                state_code: '82',
                hasCities: true
            },
            {
                id: 3556,
                name: 'Viljandi County',
                state_code: '84',
                hasCities: true
            },
            {
                id: 3560,
                name: 'Võru County',
                state_code: '86',
                hasCities: true
            }
        ]
    },
    {
        id: 70,
        states: [
            {
                id: 11,
                name: 'Addis Ababa',
                state_code: 'AA',
                hasCities: true
            },
            { id: 6, name: 'Afar Region', state_code: 'AF', hasCities: true },
            {
                id: 3,
                name: 'Amhara Region',
                state_code: 'AM',
                hasCities: true
            },
            {
                id: 9,
                name: 'Benishangul-Gumuz Region',
                state_code: 'BE',
                hasCities: true
            },
            { id: 8, name: 'Dire Dawa', state_code: 'DD', hasCities: true },
            {
                id: 10,
                name: 'Gambela Region',
                state_code: 'GA',
                hasCities: true
            },
            {
                id: 7,
                name: 'Harari Region',
                state_code: 'HA',
                hasCities: true
            },
            {
                id: 5,
                name: 'Oromia Region',
                state_code: 'OR',
                hasCities: true
            },
            {
                id: 2,
                name: 'Somali Region',
                state_code: 'SO',
                hasCities: true
            },
            {
                id: 1,
                name: "Southern Nations, Nationalities, and Peoples' Region",
                state_code: 'SN',
                hasCities: true
            },
            {
                id: 4,
                name: 'Tigray Region',
                state_code: 'TI',
                hasCities: true
            }
        ]
    },
    { id: 71, states: [] },
    { id: 72, states: [] },
    {
        id: 73,
        states: [
            { id: 1917, name: 'Ba', state_code: '01', hasCities: false },
            { id: 1930, name: 'Bua', state_code: '02', hasCities: false },
            {
                id: 1924,
                name: 'Cakaudrove',
                state_code: '03',
                hasCities: false
            },
            {
                id: 1929,
                name: 'Central Division',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 1932,
                name: 'Eastern Division',
                state_code: 'E',
                hasCities: true
            },
            { id: 1934, name: 'Kadavu', state_code: '04', hasCities: false },
            { id: 1933, name: 'Lau', state_code: '05', hasCities: false },
            {
                id: 1916,
                name: 'Lomaiviti',
                state_code: '06',
                hasCities: false
            },
            { id: 1922, name: 'Macuata', state_code: '07', hasCities: false },
            {
                id: 1919,
                name: 'Nadroga-Navosa',
                state_code: '08',
                hasCities: false
            },
            {
                id: 1927,
                name: 'Naitasiri',
                state_code: '09',
                hasCities: false
            },
            { id: 1928, name: 'Namosi', state_code: '10', hasCities: false },
            {
                id: 1921,
                name: 'Northern Division',
                state_code: 'N',
                hasCities: true
            },
            { id: 1926, name: 'Ra', state_code: '11', hasCities: false },
            { id: 1920, name: 'Rewa', state_code: '12', hasCities: false },
            { id: 1931, name: 'Rotuma', state_code: 'R', hasCities: false },
            { id: 1925, name: 'Serua', state_code: '13', hasCities: false },
            { id: 1918, name: 'Tailevu', state_code: '14', hasCities: false },
            {
                id: 1923,
                name: 'Western Division',
                state_code: 'W',
                hasCities: true
            }
        ]
    },
    {
        id: 74,
        states: [
            {
                id: 1509,
                name: 'Åland Islands',
                state_code: '01',
                hasCities: false
            },
            {
                id: 1511,
                name: 'Central Finland',
                state_code: '08',
                hasCities: true
            },
            {
                id: 1494,
                name: 'Central Ostrobothnia',
                state_code: '07',
                hasCities: true
            },
            {
                id: 1507,
                name: 'Finland Proper',
                state_code: '19',
                hasCities: true
            },
            { id: 1496, name: 'Kainuu', state_code: '05', hasCities: true },
            {
                id: 1512,
                name: 'Kymenlaakso',
                state_code: '09',
                hasCities: true
            },
            { id: 1500, name: 'Lapland', state_code: '10', hasCities: true },
            {
                id: 1504,
                name: 'North Karelia',
                state_code: '13',
                hasCities: true
            },
            {
                id: 1505,
                name: 'Northern Ostrobothnia',
                state_code: '14',
                hasCities: true
            },
            {
                id: 1503,
                name: 'Northern Savonia',
                state_code: '15',
                hasCities: false
            },
            {
                id: 1508,
                name: 'Ostrobothnia',
                state_code: '12',
                hasCities: true
            },
            {
                id: 1502,
                name: 'Päijänne Tavastia',
                state_code: '16',
                hasCities: true
            },
            {
                id: 1506,
                name: 'Pirkanmaa',
                state_code: '11',
                hasCities: true
            },
            {
                id: 1501,
                name: 'Satakunta',
                state_code: '17',
                hasCities: true
            },
            {
                id: 1497,
                name: 'South Karelia',
                state_code: '02',
                hasCities: true
            },
            {
                id: 1498,
                name: 'Southern Ostrobothnia',
                state_code: '03',
                hasCities: true
            },
            {
                id: 1495,
                name: 'Southern Savonia',
                state_code: '04',
                hasCities: true
            },
            {
                id: 1493,
                name: 'Tavastia Proper',
                state_code: '06',
                hasCities: true
            },
            { id: 1510, name: 'Uusimaa', state_code: '18', hasCities: true }
        ]
    },
    {
        id: 75,
        states: [
            { id: 4967, name: 'Ain', state_code: '01', hasCities: false },
            { id: 4968, name: 'Aisne', state_code: '02', hasCities: false },
            { id: 4969, name: 'Allier', state_code: '03', hasCities: false },
            {
                id: 4970,
                name: 'Alpes-de-Haute-Provence',
                state_code: '04',
                hasCities: false
            },
            {
                id: 4972,
                name: 'Alpes-Maritimes',
                state_code: '06',
                hasCities: false
            },
            { id: 4811, name: 'Alsace', state_code: '6AE', hasCities: false },
            { id: 4973, name: 'Ardèche', state_code: '07', hasCities: false },
            {
                id: 4974,
                name: 'Ardennes',
                state_code: '08',
                hasCities: false
            },
            { id: 4975, name: 'Ariège', state_code: '09', hasCities: false },
            { id: 4976, name: 'Aube', state_code: '10', hasCities: false },
            { id: 4977, name: 'Aude', state_code: '11', hasCities: false },
            {
                id: 4798,
                name: 'Auvergne-Rhône-Alpes',
                state_code: 'ARA',
                hasCities: true
            },
            { id: 4978, name: 'Aveyron', state_code: '12', hasCities: false },
            {
                id: 5035,
                name: 'Bas-Rhin',
                state_code: '67',
                hasCities: false
            },
            {
                id: 4979,
                name: 'Bouches-du-Rhône',
                state_code: '13',
                hasCities: false
            },
            {
                id: 4825,
                name: 'Bourgogne-Franche-Comté',
                state_code: 'BFC',
                hasCities: true
            },
            {
                id: 4807,
                name: 'Bretagne',
                state_code: 'BRE',
                hasCities: true
            },
            {
                id: 4981,
                name: 'Calvados',
                state_code: '14',
                hasCities: false
            },
            { id: 4982, name: 'Cantal', state_code: '15', hasCities: false },
            {
                id: 4818,
                name: 'Centre-Val de Loire',
                state_code: 'CVL',
                hasCities: true
            },
            {
                id: 4983,
                name: 'Charente',
                state_code: '16',
                hasCities: false
            },
            {
                id: 4984,
                name: 'Charente-Maritime',
                state_code: '17',
                hasCities: false
            },
            { id: 4985, name: 'Cher', state_code: '18', hasCities: false },
            {
                id: 5064,
                name: 'Clipperton',
                state_code: 'CP',
                hasCities: false
            },
            { id: 4986, name: 'Corrèze', state_code: '19', hasCities: false },
            { id: 4806, name: 'Corse', state_code: '20R', hasCities: true },
            {
                id: 4996,
                name: 'Corse-du-Sud',
                state_code: '2A',
                hasCities: false
            },
            {
                id: 4987,
                name: "Côte-d'Or",
                state_code: '21',
                hasCities: false
            },
            {
                id: 4988,
                name: "Côtes-d'Armor",
                state_code: '22',
                hasCities: false
            },
            { id: 4989, name: 'Creuse', state_code: '23', hasCities: false },
            {
                id: 5047,
                name: 'Deux-Sèvres',
                state_code: '79',
                hasCities: false
            },
            {
                id: 4990,
                name: 'Dordogne',
                state_code: '24',
                hasCities: false
            },
            { id: 4991, name: 'Doubs', state_code: '25', hasCities: false },
            { id: 4992, name: 'Drôme', state_code: '26', hasCities: false },
            { id: 5059, name: 'Essonne', state_code: '91', hasCities: false },
            { id: 4993, name: 'Eure', state_code: '27', hasCities: false },
            {
                id: 4994,
                name: 'Eure-et-Loir',
                state_code: '28',
                hasCities: false
            },
            {
                id: 4995,
                name: 'Finistère',
                state_code: '29',
                hasCities: false
            },
            {
                id: 4822,
                name: 'French Guiana',
                state_code: '973',
                hasCities: false
            },
            {
                id: 4824,
                name: 'French Polynesia',
                state_code: 'PF',
                hasCities: false
            },
            {
                id: 5065,
                name: 'French Southern and Antarctic Lands',
                state_code: 'TF',
                hasCities: false
            },
            { id: 4998, name: 'Gard', state_code: '30', hasCities: false },
            { id: 5000, name: 'Gers', state_code: '32', hasCities: false },
            { id: 5001, name: 'Gironde', state_code: '33', hasCities: false },
            {
                id: 4820,
                name: 'Grand-Est',
                state_code: 'GES',
                hasCities: true
            },
            {
                id: 4829,
                name: 'Guadeloupe',
                state_code: '971',
                hasCities: false
            },
            {
                id: 5036,
                name: 'Haut-Rhin',
                state_code: '68',
                hasCities: false
            },
            {
                id: 4997,
                name: 'Haute-Corse',
                state_code: '2B',
                hasCities: false
            },
            {
                id: 4999,
                name: 'Haute-Garonne',
                state_code: '31',
                hasCities: false
            },
            {
                id: 5011,
                name: 'Haute-Loire',
                state_code: '43',
                hasCities: false
            },
            {
                id: 5020,
                name: 'Haute-Marne',
                state_code: '52',
                hasCities: false
            },
            {
                id: 5039,
                name: 'Haute-Saône',
                state_code: '70',
                hasCities: false
            },
            {
                id: 5043,
                name: 'Haute-Savoie',
                state_code: '74',
                hasCities: false
            },
            {
                id: 5055,
                name: 'Haute-Vienne',
                state_code: '87',
                hasCities: false
            },
            {
                id: 4971,
                name: 'Hautes-Alpes',
                state_code: '05',
                hasCities: false
            },
            {
                id: 5033,
                name: 'Hautes-Pyrénées',
                state_code: '65',
                hasCities: false
            },
            {
                id: 4828,
                name: 'Hauts-de-France',
                state_code: 'HDF',
                hasCities: true
            },
            {
                id: 5060,
                name: 'Hauts-de-Seine',
                state_code: '92',
                hasCities: false
            },
            { id: 5002, name: 'Hérault', state_code: '34', hasCities: false },
            {
                id: 4796,
                name: 'Île-de-France',
                state_code: 'IDF',
                hasCities: true
            },
            {
                id: 5003,
                name: 'Ille-et-Vilaine',
                state_code: '35',
                hasCities: false
            },
            { id: 5004, name: 'Indre', state_code: '36', hasCities: false },
            {
                id: 5005,
                name: 'Indre-et-Loire',
                state_code: '37',
                hasCities: false
            },
            { id: 5006, name: 'Isère', state_code: '38', hasCities: false },
            { id: 5007, name: 'Jura', state_code: '39', hasCities: false },
            {
                id: 4823,
                name: 'La Réunion',
                state_code: '974',
                hasCities: false
            },
            { id: 5008, name: 'Landes', state_code: '40', hasCities: false },
            {
                id: 5009,
                name: 'Loir-et-Cher',
                state_code: '41',
                hasCities: false
            },
            { id: 5010, name: 'Loire', state_code: '42', hasCities: false },
            {
                id: 5012,
                name: 'Loire-Atlantique',
                state_code: '44',
                hasCities: false
            },
            { id: 5013, name: 'Loiret', state_code: '45', hasCities: false },
            { id: 5014, name: 'Lot', state_code: '46', hasCities: false },
            {
                id: 5015,
                name: 'Lot-et-Garonne',
                state_code: '47',
                hasCities: false
            },
            { id: 5016, name: 'Lozère', state_code: '48', hasCities: false },
            {
                id: 5017,
                name: 'Maine-et-Loire',
                state_code: '49',
                hasCities: false
            },
            { id: 5018, name: 'Manche', state_code: '50', hasCities: false },
            { id: 5019, name: 'Marne', state_code: '51', hasCities: false },
            {
                id: 4827,
                name: 'Martinique',
                state_code: '972',
                hasCities: false
            },
            { id: 5021, name: 'Mayenne', state_code: '53', hasCities: false },
            {
                id: 4797,
                name: 'Mayotte',
                state_code: '976',
                hasCities: false
            },
            {
                id: 5038,
                name: 'Métropole de Lyon',
                state_code: '69M',
                hasCities: false
            },
            {
                id: 5022,
                name: 'Meurthe-et-Moselle',
                state_code: '54',
                hasCities: false
            },
            { id: 5023, name: 'Meuse', state_code: '55', hasCities: false },
            {
                id: 5024,
                name: 'Morbihan',
                state_code: '56',
                hasCities: false
            },
            { id: 5025, name: 'Moselle', state_code: '57', hasCities: false },
            { id: 5026, name: 'Nièvre', state_code: '58', hasCities: false },
            { id: 5027, name: 'Nord', state_code: '59', hasCities: false },
            {
                id: 4804,
                name: 'Normandie',
                state_code: 'NOR',
                hasCities: true
            },
            {
                id: 4795,
                name: 'Nouvelle-Aquitaine',
                state_code: 'NAQ',
                hasCities: true
            },
            {
                id: 4799,
                name: 'Occitanie',
                state_code: 'OCC',
                hasCities: true
            },
            { id: 5028, name: 'Oise', state_code: '60', hasCities: false },
            { id: 5029, name: 'Orne', state_code: '61', hasCities: false },
            { id: 4816, name: 'Paris', state_code: '75C', hasCities: false },
            {
                id: 5030,
                name: 'Pas-de-Calais',
                state_code: '62',
                hasCities: false
            },
            {
                id: 4802,
                name: 'Pays-de-la-Loire',
                state_code: 'PDL',
                hasCities: true
            },
            {
                id: 4812,
                name: 'Provence-Alpes-Côte-d’Azur',
                state_code: 'PAC',
                hasCities: true
            },
            {
                id: 5031,
                name: 'Puy-de-Dôme',
                state_code: '63',
                hasCities: false
            },
            {
                id: 5032,
                name: 'Pyrénées-Atlantiques',
                state_code: '64',
                hasCities: false
            },
            {
                id: 5034,
                name: 'Pyrénées-Orientales',
                state_code: '66',
                hasCities: false
            },
            { id: 5037, name: 'Rhône', state_code: '69', hasCities: false },
            {
                id: 4821,
                name: 'Saint Pierre and Miquelon',
                state_code: 'PM',
                hasCities: false
            },
            {
                id: 4794,
                name: 'Saint-Barthélemy',
                state_code: 'BL',
                hasCities: false
            },
            {
                id: 4809,
                name: 'Saint-Martin',
                state_code: 'MF',
                hasCities: false
            },
            {
                id: 5040,
                name: 'Saône-et-Loire',
                state_code: '71',
                hasCities: false
            },
            { id: 5041, name: 'Sarthe', state_code: '72', hasCities: false },
            { id: 5042, name: 'Savoie', state_code: '73', hasCities: false },
            {
                id: 5045,
                name: 'Seine-et-Marne',
                state_code: '77',
                hasCities: false
            },
            {
                id: 5044,
                name: 'Seine-Maritime',
                state_code: '76',
                hasCities: false
            },
            {
                id: 5061,
                name: 'Seine-Saint-Denis',
                state_code: '93',
                hasCities: false
            },
            { id: 5048, name: 'Somme', state_code: '80', hasCities: false },
            { id: 5049, name: 'Tarn', state_code: '81', hasCities: false },
            {
                id: 5050,
                name: 'Tarn-et-Garonne',
                state_code: '82',
                hasCities: false
            },
            {
                id: 5058,
                name: 'Territoire de Belfort',
                state_code: '90',
                hasCities: false
            },
            {
                id: 5063,
                name: "Val-d'Oise",
                state_code: '95',
                hasCities: false
            },
            {
                id: 5062,
                name: 'Val-de-Marne',
                state_code: '94',
                hasCities: false
            },
            { id: 5051, name: 'Var', state_code: '83', hasCities: false },
            {
                id: 5052,
                name: 'Vaucluse',
                state_code: '84',
                hasCities: false
            },
            { id: 5053, name: 'Vendée', state_code: '85', hasCities: false },
            { id: 5054, name: 'Vienne', state_code: '86', hasCities: false },
            { id: 5056, name: 'Vosges', state_code: '88', hasCities: false },
            {
                id: 4810,
                name: 'Wallis and Futuna',
                state_code: 'WF',
                hasCities: false
            },
            { id: 5057, name: 'Yonne', state_code: '89', hasCities: false },
            { id: 5046, name: 'Yvelines', state_code: '78', hasCities: false }
        ]
    },
    { id: 76, states: [] },
    { id: 77, states: [] },
    { id: 78, states: [] },
    {
        id: 79,
        states: [
            {
                id: 2727,
                name: 'Estuaire Province',
                state_code: '1',
                hasCities: true
            },
            {
                id: 2726,
                name: 'Haut-Ogooué Province',
                state_code: '2',
                hasCities: true
            },
            {
                id: 2730,
                name: 'Moyen-Ogooué Province',
                state_code: '3',
                hasCities: true
            },
            {
                id: 2731,
                name: 'Ngounié Province',
                state_code: '4',
                hasCities: true
            },
            {
                id: 2725,
                name: 'Nyanga Province',
                state_code: '5',
                hasCities: true
            },
            {
                id: 2724,
                name: 'Ogooué-Ivindo Province',
                state_code: '6',
                hasCities: true
            },
            {
                id: 2729,
                name: 'Ogooué-Lolo Province',
                state_code: '7',
                hasCities: true
            },
            {
                id: 2728,
                name: 'Ogooué-Maritime Province',
                state_code: '8',
                hasCities: true
            },
            {
                id: 2723,
                name: 'Woleu-Ntem Province',
                state_code: '9',
                hasCities: true
            }
        ]
    },
    {
        id: 80,
        states: [
            { id: 2666, name: 'Banjul', state_code: 'B', hasCities: true },
            {
                id: 2669,
                name: 'Central River Division',
                state_code: 'M',
                hasCities: true
            },
            {
                id: 2670,
                name: 'Lower River Division',
                state_code: 'L',
                hasCities: true
            },
            {
                id: 2671,
                name: 'North Bank Division',
                state_code: 'N',
                hasCities: true
            },
            {
                id: 2668,
                name: 'Upper River Division',
                state_code: 'U',
                hasCities: true
            },
            {
                id: 2667,
                name: 'West Coast Division',
                state_code: 'W',
                hasCities: true
            }
        ]
    },
    {
        id: 81,
        states: [
            { id: 900, name: 'Adjara', state_code: 'AJ', hasCities: true },
            {
                id: 901,
                name: 'Autonomous Republic of Abkhazia',
                state_code: 'AB',
                hasCities: true
            },
            { id: 907, name: 'Guria', state_code: 'GU', hasCities: true },
            { id: 905, name: 'Imereti', state_code: 'IM', hasCities: true },
            { id: 910, name: 'Kakheti', state_code: 'KA', hasCities: true },
            {
                id: 897,
                name: 'Khelvachauri Municipality',
                state_code: '29',
                hasCities: false
            },
            {
                id: 904,
                name: 'Kvemo Kartli',
                state_code: 'KK',
                hasCities: true
            },
            {
                id: 902,
                name: 'Mtskheta-Mtianeti',
                state_code: 'MM',
                hasCities: true
            },
            {
                id: 909,
                name: 'Racha-Lechkhumi and Kvemo Svaneti',
                state_code: 'RL',
                hasCities: true
            },
            {
                id: 908,
                name: 'Samegrelo-Zemo Svaneti',
                state_code: 'SZ',
                hasCities: true
            },
            {
                id: 906,
                name: 'Samtskhe-Javakheti',
                state_code: 'SJ',
                hasCities: true
            },
            {
                id: 898,
                name: 'Senaki Municipality',
                state_code: '50',
                hasCities: false
            },
            {
                id: 903,
                name: 'Shida Kartli',
                state_code: 'SK',
                hasCities: true
            },
            { id: 899, name: 'Tbilisi', state_code: 'TB', hasCities: true }
        ]
    },
    {
        id: 82,
        states: [
            {
                id: 3006,
                name: 'Baden-Württemberg',
                state_code: 'BW',
                hasCities: true
            },
            { id: 3009, name: 'Bavaria', state_code: 'BY', hasCities: true },
            { id: 3010, name: 'Berlin', state_code: 'BE', hasCities: true },
            {
                id: 3013,
                name: 'Brandenburg',
                state_code: 'BB',
                hasCities: true
            },
            { id: 3014, name: 'Bremen', state_code: 'HB', hasCities: true },
            { id: 3016, name: 'Hamburg', state_code: 'HH', hasCities: true },
            { id: 3018, name: 'Hesse', state_code: 'HE', hasCities: true },
            {
                id: 3008,
                name: 'Lower Saxony',
                state_code: 'NI',
                hasCities: true
            },
            {
                id: 3007,
                name: 'Mecklenburg-Vorpommern',
                state_code: 'MV',
                hasCities: true
            },
            {
                id: 3017,
                name: 'North Rhine-Westphalia',
                state_code: 'NW',
                hasCities: true
            },
            {
                id: 3019,
                name: 'Rhineland-Palatinate',
                state_code: 'RP',
                hasCities: true
            },
            { id: 3020, name: 'Saarland', state_code: 'SL', hasCities: true },
            { id: 3021, name: 'Saxony', state_code: 'SN', hasCities: true },
            {
                id: 3011,
                name: 'Saxony-Anhalt',
                state_code: 'ST',
                hasCities: true
            },
            {
                id: 3005,
                name: 'Schleswig-Holstein',
                state_code: 'SH',
                hasCities: true
            },
            { id: 3015, name: 'Thuringia', state_code: 'TH', hasCities: true }
        ]
    },
    {
        id: 83,
        states: [
            { id: 53, name: 'Ahafo', state_code: 'AF', hasCities: true },
            { id: 48, name: 'Ashanti', state_code: 'AH', hasCities: true },
            { id: 4959, name: 'Bono', state_code: 'BO', hasCities: true },
            {
                id: 4958,
                name: 'Bono East',
                state_code: 'BE',
                hasCities: true
            },
            { id: 52, name: 'Central', state_code: 'CP', hasCities: true },
            { id: 50, name: 'Eastern', state_code: 'EP', hasCities: true },
            {
                id: 54,
                name: 'Greater Accra',
                state_code: 'AA',
                hasCities: true
            },
            {
                id: 4960,
                name: 'North East',
                state_code: 'NE',
                hasCities: true
            },
            { id: 51, name: 'Northern', state_code: 'NP', hasCities: true },
            { id: 4961, name: 'Oti', state_code: 'OT', hasCities: true },
            { id: 4962, name: 'Savannah', state_code: 'SV', hasCities: true },
            { id: 55, name: 'Upper East', state_code: 'UE', hasCities: true },
            { id: 57, name: 'Upper West', state_code: 'UW', hasCities: true },
            { id: 56, name: 'Volta', state_code: 'TV', hasCities: true },
            { id: 49, name: 'Western', state_code: 'WP', hasCities: true },
            {
                id: 4963,
                name: 'Western North',
                state_code: 'WN',
                hasCities: true
            }
        ]
    },
    { id: 84, states: [] },
    {
        id: 85,
        states: [
            {
                id: 2116,
                name: 'Achaea Regional Unit',
                state_code: '13',
                hasCities: false
            },
            {
                id: 2123,
                name: 'Aetolia-Acarnania Regional Unit',
                state_code: '01',
                hasCities: false
            },
            {
                id: 2098,
                name: 'Arcadia Prefecture',
                state_code: '12',
                hasCities: false
            },
            {
                id: 2105,
                name: 'Argolis Regional Unit',
                state_code: '11',
                hasCities: false
            },
            {
                id: 2122,
                name: 'Attica Region',
                state_code: 'I',
                hasCities: true
            },
            {
                id: 2126,
                name: 'Boeotia Regional Unit',
                state_code: '03',
                hasCities: false
            },
            {
                id: 2128,
                name: 'Central Greece Region',
                state_code: 'H',
                hasCities: true
            },
            {
                id: 2125,
                name: 'Central Macedonia',
                state_code: 'B',
                hasCities: true
            },
            {
                id: 2115,
                name: 'Chania Regional Unit',
                state_code: '94',
                hasCities: false
            },
            {
                id: 2124,
                name: 'Corfu Prefecture',
                state_code: '22',
                hasCities: true
            },
            {
                id: 2129,
                name: 'Corinthia Regional Unit',
                state_code: '15',
                hasCities: false
            },
            {
                id: 2109,
                name: 'Crete Region',
                state_code: 'M',
                hasCities: true
            },
            {
                id: 2130,
                name: 'Drama Regional Unit',
                state_code: '52',
                hasCities: false
            },
            {
                id: 2120,
                name: 'East Attica Regional Unit',
                state_code: 'A2',
                hasCities: true
            },
            {
                id: 2117,
                name: 'East Macedonia and Thrace',
                state_code: 'A',
                hasCities: false
            },
            {
                id: 2110,
                name: 'Epirus Region',
                state_code: 'D',
                hasCities: true
            },
            { id: 2101, name: 'Euboea', state_code: '04', hasCities: false },
            {
                id: 2102,
                name: 'Grevena Prefecture',
                state_code: '51',
                hasCities: false
            },
            {
                id: 2099,
                name: 'Imathia Regional Unit',
                state_code: '53',
                hasCities: false
            },
            {
                id: 2113,
                name: 'Ioannina Regional Unit',
                state_code: '33',
                hasCities: false
            },
            {
                id: 2131,
                name: 'Ionian Islands Region',
                state_code: 'F',
                hasCities: true
            },
            {
                id: 2095,
                name: 'Karditsa Regional Unit',
                state_code: '41',
                hasCities: false
            },
            {
                id: 2100,
                name: 'Kastoria Regional Unit',
                state_code: '56',
                hasCities: false
            },
            {
                id: 2127,
                name: 'Kefalonia Prefecture',
                state_code: '23',
                hasCities: true
            },
            {
                id: 2111,
                name: 'Kilkis Regional Unit',
                state_code: '57',
                hasCities: false
            },
            {
                id: 2112,
                name: 'Kozani Prefecture',
                state_code: '58',
                hasCities: false
            },
            { id: 2106, name: 'Laconia', state_code: '16', hasCities: false },
            {
                id: 2132,
                name: 'Larissa Prefecture',
                state_code: '42',
                hasCities: false
            },
            {
                id: 2104,
                name: 'Lefkada Regional Unit',
                state_code: '24',
                hasCities: true
            },
            {
                id: 2107,
                name: 'Pella Regional Unit',
                state_code: '59',
                hasCities: false
            },
            {
                id: 2119,
                name: 'Peloponnese Region',
                state_code: 'J',
                hasCities: true
            },
            {
                id: 2114,
                name: 'Phthiotis Prefecture',
                state_code: '06',
                hasCities: false
            },
            {
                id: 2103,
                name: 'Preveza Prefecture',
                state_code: '34',
                hasCities: false
            },
            {
                id: 2121,
                name: 'Serres Prefecture',
                state_code: '62',
                hasCities: false
            },
            {
                id: 2118,
                name: 'South Aegean',
                state_code: 'L',
                hasCities: true
            },
            {
                id: 2097,
                name: 'Thessaloniki Regional Unit',
                state_code: '54',
                hasCities: false
            },
            {
                id: 2096,
                name: 'West Greece Region',
                state_code: 'G',
                hasCities: true
            },
            {
                id: 2108,
                name: 'West Macedonia Region',
                state_code: 'C',
                hasCities: true
            }
        ]
    },
    { id: 86, states: [] },
    {
        id: 87,
        states: [
            {
                id: 3867,
                name: 'Carriacou and Petite Martinique',
                state_code: '10',
                hasCities: true
            },
            {
                id: 3865,
                name: 'Saint Andrew Parish',
                state_code: '01',
                hasCities: true
            },
            {
                id: 3869,
                name: 'Saint David Parish',
                state_code: '02',
                hasCities: true
            },
            {
                id: 3864,
                name: 'Saint George Parish',
                state_code: '03',
                hasCities: true
            },
            {
                id: 3868,
                name: 'Saint John Parish',
                state_code: '04',
                hasCities: true
            },
            {
                id: 3866,
                name: 'Saint Mark Parish',
                state_code: '05',
                hasCities: true
            },
            {
                id: 3863,
                name: 'Saint Patrick Parish',
                state_code: '06',
                hasCities: true
            }
        ]
    },
    { id: 88, states: [] },
    { id: 89, states: [] },
    {
        id: 90,
        states: [
            {
                id: 3671,
                name: 'Alta Verapaz Department',
                state_code: 'AV',
                hasCities: true
            },
            {
                id: 3674,
                name: 'Baja Verapaz Department',
                state_code: 'BV',
                hasCities: true
            },
            {
                id: 3675,
                name: 'Chimaltenango Department',
                state_code: 'CM',
                hasCities: true
            },
            {
                id: 3666,
                name: 'Chiquimula Department',
                state_code: 'CQ',
                hasCities: true
            },
            {
                id: 3662,
                name: 'El Progreso Department',
                state_code: 'PR',
                hasCities: true
            },
            {
                id: 3677,
                name: 'Escuintla Department',
                state_code: 'ES',
                hasCities: true
            },
            {
                id: 3672,
                name: 'Guatemala Department',
                state_code: 'GU',
                hasCities: true
            },
            {
                id: 3670,
                name: 'Huehuetenango Department',
                state_code: 'HU',
                hasCities: true
            },
            {
                id: 3659,
                name: 'Izabal Department',
                state_code: 'IZ',
                hasCities: true
            },
            {
                id: 3658,
                name: 'Jalapa Department',
                state_code: 'JA',
                hasCities: true
            },
            {
                id: 3673,
                name: 'Jutiapa Department',
                state_code: 'JU',
                hasCities: true
            },
            {
                id: 3669,
                name: 'Petén Department',
                state_code: 'PE',
                hasCities: true
            },
            {
                id: 3668,
                name: 'Quetzaltenango Department',
                state_code: 'QZ',
                hasCities: true
            },
            {
                id: 3657,
                name: 'Quiché Department',
                state_code: 'QC',
                hasCities: true
            },
            {
                id: 3664,
                name: 'Retalhuleu Department',
                state_code: 'RE',
                hasCities: true
            },
            {
                id: 3676,
                name: 'Sacatepéquez Department',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 3667,
                name: 'San Marcos Department',
                state_code: 'SM',
                hasCities: true
            },
            {
                id: 3665,
                name: 'Santa Rosa Department',
                state_code: 'SR',
                hasCities: true
            },
            {
                id: 3661,
                name: 'Sololá Department',
                state_code: 'SO',
                hasCities: true
            },
            {
                id: 3660,
                name: 'Suchitepéquez Department',
                state_code: 'SU',
                hasCities: true
            },
            {
                id: 3663,
                name: 'Totonicapán Department',
                state_code: 'TO',
                hasCities: true
            }
        ]
    },
    { id: 91, states: [] },
    {
        id: 92,
        states: [
            {
                id: 2672,
                name: 'Beyla Prefecture',
                state_code: 'BE',
                hasCities: false
            },
            {
                id: 2699,
                name: 'Boffa Prefecture',
                state_code: 'BF',
                hasCities: false
            },
            {
                id: 2709,
                name: 'Boké Prefecture',
                state_code: 'BK',
                hasCities: false
            },
            {
                id: 2676,
                name: 'Boké Region',
                state_code: 'B',
                hasCities: true
            },
            { id: 2686, name: 'Conakry', state_code: 'C', hasCities: true },
            {
                id: 2705,
                name: 'Coyah Prefecture',
                state_code: 'CO',
                hasCities: false
            },
            {
                id: 2679,
                name: 'Dabola Prefecture',
                state_code: 'DB',
                hasCities: false
            },
            {
                id: 2706,
                name: 'Dalaba Prefecture',
                state_code: 'DL',
                hasCities: false
            },
            {
                id: 2688,
                name: 'Dinguiraye Prefecture',
                state_code: 'DI',
                hasCities: false
            },
            {
                id: 2681,
                name: 'Dubréka Prefecture',
                state_code: 'DU',
                hasCities: false
            },
            {
                id: 2682,
                name: 'Faranah Prefecture',
                state_code: 'FA',
                hasCities: false
            },
            {
                id: 2683,
                name: 'Forécariah Prefecture',
                state_code: 'FO',
                hasCities: false
            },
            {
                id: 2675,
                name: 'Fria Prefecture',
                state_code: 'FR',
                hasCities: false
            },
            {
                id: 2685,
                name: 'Gaoual Prefecture',
                state_code: 'GA',
                hasCities: false
            },
            {
                id: 2711,
                name: 'Guéckédou Prefecture',
                state_code: 'GU',
                hasCities: false
            },
            {
                id: 2704,
                name: 'Kankan Prefecture',
                state_code: 'KA',
                hasCities: false
            },
            {
                id: 2697,
                name: 'Kankan Region',
                state_code: 'K',
                hasCities: true
            },
            {
                id: 2710,
                name: 'Kérouané Prefecture',
                state_code: 'KE',
                hasCities: false
            },
            {
                id: 2693,
                name: 'Kindia Prefecture',
                state_code: 'KD',
                hasCities: false
            },
            {
                id: 2701,
                name: 'Kindia Region',
                state_code: 'D',
                hasCities: true
            },
            {
                id: 2691,
                name: 'Kissidougou Prefecture',
                state_code: 'KS',
                hasCities: false
            },
            {
                id: 2692,
                name: 'Koubia Prefecture',
                state_code: 'KB',
                hasCities: false
            },
            {
                id: 2703,
                name: 'Koundara Prefecture',
                state_code: 'KN',
                hasCities: false
            },
            {
                id: 2695,
                name: 'Kouroussa Prefecture',
                state_code: 'KO',
                hasCities: false
            },
            {
                id: 2680,
                name: 'Labé Prefecture',
                state_code: 'LA',
                hasCities: false
            },
            {
                id: 2677,
                name: 'Labé Region',
                state_code: 'L',
                hasCities: true
            },
            {
                id: 2690,
                name: 'Lélouma Prefecture',
                state_code: 'LE',
                hasCities: false
            },
            {
                id: 2708,
                name: 'Lola Prefecture',
                state_code: 'LO',
                hasCities: false
            },
            {
                id: 2702,
                name: 'Macenta Prefecture',
                state_code: 'MC',
                hasCities: false
            },
            {
                id: 2700,
                name: 'Mali Prefecture',
                state_code: 'ML',
                hasCities: false
            },
            {
                id: 2689,
                name: 'Mamou Prefecture',
                state_code: 'MM',
                hasCities: false
            },
            {
                id: 2698,
                name: 'Mamou Region',
                state_code: 'M',
                hasCities: true
            },
            {
                id: 2673,
                name: 'Mandiana Prefecture',
                state_code: 'MD',
                hasCities: false
            },
            {
                id: 2678,
                name: 'Nzérékoré Prefecture',
                state_code: 'NZ',
                hasCities: false
            },
            {
                id: 2684,
                name: 'Nzérékoré Region',
                state_code: 'N',
                hasCities: true
            },
            {
                id: 2694,
                name: 'Pita Prefecture',
                state_code: 'PI',
                hasCities: false
            },
            {
                id: 2707,
                name: 'Siguiri Prefecture',
                state_code: 'SI',
                hasCities: false
            },
            {
                id: 2687,
                name: 'Télimélé Prefecture',
                state_code: 'TE',
                hasCities: false
            },
            {
                id: 2696,
                name: 'Tougué Prefecture',
                state_code: 'TO',
                hasCities: false
            },
            {
                id: 2674,
                name: 'Yomou Prefecture',
                state_code: 'YO',
                hasCities: false
            }
        ]
    },
    {
        id: 93,
        states: [
            { id: 2720, name: 'Bafatá', state_code: 'BA', hasCities: true },
            {
                id: 2714,
                name: 'Biombo Region',
                state_code: 'BM',
                hasCities: true
            },
            {
                id: 2722,
                name: 'Bolama Region',
                state_code: 'BL',
                hasCities: true
            },
            {
                id: 2713,
                name: 'Cacheu Region',
                state_code: 'CA',
                hasCities: true
            },
            {
                id: 2719,
                name: 'Gabú Region',
                state_code: 'GA',
                hasCities: true
            },
            {
                id: 2721,
                name: 'Leste Province',
                state_code: 'L',
                hasCities: false
            },
            {
                id: 2717,
                name: 'Norte Province',
                state_code: 'N',
                hasCities: false
            },
            {
                id: 2718,
                name: 'Oio Region',
                state_code: 'OI',
                hasCities: true
            },
            {
                id: 2715,
                name: 'Quinara Region',
                state_code: 'QU',
                hasCities: true
            },
            {
                id: 2716,
                name: 'Sul Province',
                state_code: 'S',
                hasCities: false
            },
            {
                id: 2712,
                name: 'Tombali Region',
                state_code: 'TO',
                hasCities: true
            }
        ]
    },
    {
        id: 94,
        states: [
            {
                id: 2764,
                name: 'Barima-Waini',
                state_code: 'BA',
                hasCities: true
            },
            {
                id: 2760,
                name: 'Cuyuni-Mazaruni',
                state_code: 'CU',
                hasCities: true
            },
            {
                id: 2767,
                name: 'Demerara-Mahaica',
                state_code: 'DE',
                hasCities: true
            },
            {
                id: 2766,
                name: 'East Berbice-Corentyne',
                state_code: 'EB',
                hasCities: true
            },
            {
                id: 2768,
                name: 'Essequibo Islands-West Demerara',
                state_code: 'ES',
                hasCities: true
            },
            {
                id: 2762,
                name: 'Mahaica-Berbice',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 2765,
                name: 'Pomeroon-Supenaam',
                state_code: 'PM',
                hasCities: true
            },
            {
                id: 2761,
                name: 'Potaro-Siparuni',
                state_code: 'PT',
                hasCities: true
            },
            {
                id: 2763,
                name: 'Upper Demerara-Berbice',
                state_code: 'UD',
                hasCities: true
            },
            {
                id: 2769,
                name: 'Upper Takutu-Upper Essequibo',
                state_code: 'UT',
                hasCities: true
            }
        ]
    },
    {
        id: 95,
        states: [
            {
                id: 4123,
                name: 'Artibonite',
                state_code: 'AR',
                hasCities: true
            },
            { id: 4125, name: 'Centre', state_code: 'CE', hasCities: true },
            {
                id: 4119,
                name: "Grand'Anse",
                state_code: 'GA',
                hasCities: true
            },
            { id: 4118, name: 'Nippes', state_code: 'NI', hasCities: true },
            { id: 4117, name: 'Nord', state_code: 'ND', hasCities: true },
            { id: 4121, name: 'Nord-Est', state_code: 'NE', hasCities: true },
            {
                id: 4126,
                name: 'Nord-Ouest',
                state_code: 'NO',
                hasCities: true
            },
            { id: 4120, name: 'Ouest', state_code: 'OU', hasCities: true },
            { id: 4122, name: 'Sud', state_code: 'SD', hasCities: true },
            { id: 4124, name: 'Sud-Est', state_code: 'SE', hasCities: true }
        ]
    },
    { id: 96, states: [] },
    {
        id: 97,
        states: [
            {
                id: 4047,
                name: 'Atlántida Department',
                state_code: 'AT',
                hasCities: true
            },
            {
                id: 4045,
                name: 'Bay Islands Department',
                state_code: 'IB',
                hasCities: true
            },
            {
                id: 4041,
                name: 'Choluteca Department',
                state_code: 'CH',
                hasCities: true
            },
            {
                id: 4051,
                name: 'Colón Department',
                state_code: 'CL',
                hasCities: true
            },
            {
                id: 4042,
                name: 'Comayagua Department',
                state_code: 'CM',
                hasCities: true
            },
            {
                id: 4049,
                name: 'Copán Department',
                state_code: 'CP',
                hasCities: true
            },
            {
                id: 4046,
                name: 'Cortés Department',
                state_code: 'CR',
                hasCities: true
            },
            {
                id: 4043,
                name: 'El Paraíso Department',
                state_code: 'EP',
                hasCities: true
            },
            {
                id: 4052,
                name: 'Francisco Morazán Department',
                state_code: 'FM',
                hasCities: true
            },
            {
                id: 4048,
                name: 'Gracias a Dios Department',
                state_code: 'GD',
                hasCities: true
            },
            {
                id: 4044,
                name: 'Intibucá Department',
                state_code: 'IN',
                hasCities: true
            },
            {
                id: 4058,
                name: 'La Paz Department',
                state_code: 'LP',
                hasCities: true
            },
            {
                id: 4054,
                name: 'Lempira Department',
                state_code: 'LE',
                hasCities: true
            },
            {
                id: 4056,
                name: 'Ocotepeque Department',
                state_code: 'OC',
                hasCities: true
            },
            {
                id: 4050,
                name: 'Olancho Department',
                state_code: 'OL',
                hasCities: true
            },
            {
                id: 4053,
                name: 'Santa Bárbara Department',
                state_code: 'SB',
                hasCities: true
            },
            {
                id: 4055,
                name: 'Valle Department',
                state_code: 'VA',
                hasCities: true
            },
            {
                id: 4057,
                name: 'Yoro Department',
                state_code: 'YO',
                hasCities: true
            }
        ]
    },
    {
        id: 98,
        states: [
            {
                id: 4889,
                name: 'Central and Western District',
                state_code: 'HCW',
                hasCities: false
            },
            {
                id: 4891,
                name: 'Eastern',
                state_code: 'HEA',
                hasCities: false
            },
            {
                id: 4888,
                name: 'Islands District',
                state_code: 'NIS',
                hasCities: false
            },
            {
                id: 4895,
                name: 'Kowloon City',
                state_code: 'KKC',
                hasCities: false
            },
            {
                id: 4898,
                name: 'Kwai Tsing',
                state_code: 'NKT',
                hasCities: false
            },
            {
                id: 4897,
                name: 'Kwun Tong',
                state_code: 'KKT',
                hasCities: false
            },
            { id: 4900, name: 'North', state_code: 'NNO', hasCities: false },
            {
                id: 4887,
                name: 'Sai Kung District',
                state_code: 'NSK',
                hasCities: false
            },
            {
                id: 4901,
                name: 'Sha Tin',
                state_code: 'NST',
                hasCities: false
            },
            {
                id: 4894,
                name: 'Sham Shui Po',
                state_code: 'KSS',
                hasCities: false
            },
            {
                id: 4892,
                name: 'Southern',
                state_code: 'HSO',
                hasCities: false
            },
            {
                id: 4885,
                name: 'Tai Po District',
                state_code: 'NTP',
                hasCities: false
            },
            {
                id: 4884,
                name: 'Tsuen Wan District',
                state_code: 'NTW',
                hasCities: false
            },
            {
                id: 4899,
                name: 'Tuen Mun',
                state_code: 'NTM',
                hasCities: false
            },
            {
                id: 4890,
                name: 'Wan Chai',
                state_code: 'HWC',
                hasCities: false
            },
            {
                id: 4896,
                name: 'Wong Tai Sin',
                state_code: 'KWT',
                hasCities: false
            },
            {
                id: 4893,
                name: 'Yau Tsim Mong',
                state_code: 'KYT',
                hasCities: false
            },
            {
                id: 4883,
                name: 'Yuen Long District',
                state_code: 'NYL',
                hasCities: false
            }
        ]
    },
    {
        id: 99,
        states: [
            {
                id: 1048,
                name: 'Bács-Kiskun',
                state_code: 'BK',
                hasCities: true
            },
            { id: 1055, name: 'Baranya', state_code: 'BA', hasCities: true },
            { id: 1060, name: 'Békés', state_code: 'BE', hasCities: true },
            {
                id: 1036,
                name: 'Békéscsaba',
                state_code: 'BC',
                hasCities: false
            },
            {
                id: 1058,
                name: 'Borsod-Abaúj-Zemplén',
                state_code: 'BZ',
                hasCities: true
            },
            { id: 1064, name: 'Budapest', state_code: 'BU', hasCities: true },
            {
                id: 1031,
                name: 'Csongrád County',
                state_code: 'CS',
                hasCities: true
            },
            {
                id: 1032,
                name: 'Debrecen',
                state_code: 'DE',
                hasCities: false
            },
            {
                id: 1049,
                name: 'Dunaújváros',
                state_code: 'DU',
                hasCities: false
            },
            { id: 1037, name: 'Eger', state_code: 'EG', hasCities: false },
            { id: 1028, name: 'Érd', state_code: 'ER', hasCities: false },
            {
                id: 1044,
                name: 'Fejér County',
                state_code: 'FE',
                hasCities: true
            },
            { id: 1041, name: 'Győr', state_code: 'GY', hasCities: false },
            {
                id: 1042,
                name: 'Győr-Moson-Sopron County',
                state_code: 'GS',
                hasCities: true
            },
            {
                id: 1063,
                name: 'Hajdú-Bihar County',
                state_code: 'HB',
                hasCities: true
            },
            {
                id: 1040,
                name: 'Heves County',
                state_code: 'HE',
                hasCities: true
            },
            {
                id: 1027,
                name: 'Hódmezővásárhely',
                state_code: 'HV',
                hasCities: false
            },
            {
                id: 1043,
                name: 'Jász-Nagykun-Szolnok County',
                state_code: 'JN',
                hasCities: true
            },
            {
                id: 1067,
                name: 'Kaposvár',
                state_code: 'KV',
                hasCities: false
            },
            {
                id: 1056,
                name: 'Kecskemét',
                state_code: 'KM',
                hasCities: false
            },
            {
                id: 5085,
                name: 'Komárom-Esztergom',
                state_code: 'KE',
                hasCities: true
            },
            { id: 1065, name: 'Miskolc', state_code: 'MI', hasCities: false },
            {
                id: 1030,
                name: 'Nagykanizsa',
                state_code: 'NK',
                hasCities: false
            },
            {
                id: 1051,
                name: 'Nógrád County',
                state_code: 'NO',
                hasCities: true
            },
            {
                id: 1034,
                name: 'Nyíregyháza',
                state_code: 'NY',
                hasCities: false
            },
            { id: 1053, name: 'Pécs', state_code: 'PS', hasCities: false },
            {
                id: 1059,
                name: 'Pest County',
                state_code: 'PE',
                hasCities: true
            },
            {
                id: 1068,
                name: 'Salgótarján',
                state_code: 'ST',
                hasCities: false
            },
            {
                id: 1035,
                name: 'Somogy County',
                state_code: 'SO',
                hasCities: true
            },
            { id: 1057, name: 'Sopron', state_code: 'SN', hasCities: false },
            {
                id: 1045,
                name: 'Szabolcs-Szatmár-Bereg County',
                state_code: 'SZ',
                hasCities: true
            },
            { id: 1029, name: 'Szeged', state_code: 'SD', hasCities: false },
            {
                id: 1033,
                name: 'Székesfehérvár',
                state_code: 'SF',
                hasCities: false
            },
            {
                id: 1061,
                name: 'Szekszárd',
                state_code: 'SS',
                hasCities: false
            },
            { id: 1047, name: 'Szolnok', state_code: 'SK', hasCities: false },
            {
                id: 1052,
                name: 'Szombathely',
                state_code: 'SH',
                hasCities: false
            },
            {
                id: 1066,
                name: 'Tatabánya',
                state_code: 'TB',
                hasCities: false
            },
            {
                id: 1038,
                name: 'Tolna County',
                state_code: 'TO',
                hasCities: true
            },
            {
                id: 1039,
                name: 'Vas County',
                state_code: 'VA',
                hasCities: true
            },
            {
                id: 1062,
                name: 'Veszprém',
                state_code: 'VM',
                hasCities: false
            },
            {
                id: 1054,
                name: 'Veszprém County',
                state_code: 'VE',
                hasCities: true
            },
            {
                id: 1046,
                name: 'Zala County',
                state_code: 'ZA',
                hasCities: true
            },
            {
                id: 1050,
                name: 'Zalaegerszeg',
                state_code: 'ZE',
                hasCities: false
            }
        ]
    },
    {
        id: 100,
        states: [
            {
                id: 3431,
                name: 'Capital Region',
                state_code: '1',
                hasCities: true
            },
            {
                id: 3433,
                name: 'Eastern Region',
                state_code: '7',
                hasCities: true
            },
            {
                id: 3437,
                name: 'Northeastern Region',
                state_code: '6',
                hasCities: true
            },
            {
                id: 3435,
                name: 'Northwestern Region',
                state_code: '5',
                hasCities: true
            },
            {
                id: 3430,
                name: 'Southern Peninsula Region',
                state_code: '2',
                hasCities: true
            },
            {
                id: 3434,
                name: 'Southern Region',
                state_code: '8',
                hasCities: true
            },
            {
                id: 3436,
                name: 'Western Region',
                state_code: '3',
                hasCities: true
            },
            { id: 3432, name: 'Westfjords', state_code: '4', hasCities: true }
        ]
    },
    {
        id: 101,
        states: [
            {
                id: 4023,
                name: 'Andaman and Nicobar Islands',
                state_code: 'AN',
                hasCities: true
            },
            {
                id: 4017,
                name: 'Andhra Pradesh',
                state_code: 'AP',
                hasCities: true
            },
            {
                id: 4024,
                name: 'Arunachal Pradesh',
                state_code: 'AR',
                hasCities: true
            },
            { id: 4027, name: 'Assam', state_code: 'AS', hasCities: true },
            { id: 4037, name: 'Bihar', state_code: 'BR', hasCities: true },
            {
                id: 4031,
                name: 'Chandigarh',
                state_code: 'CH',
                hasCities: true
            },
            {
                id: 4040,
                name: 'Chhattisgarh',
                state_code: 'CT',
                hasCities: true
            },
            {
                id: 4033,
                name: 'Dadra and Nagar Haveli and Daman and Diu',
                state_code: 'DH',
                hasCities: true
            },
            { id: 4021, name: 'Delhi', state_code: 'DL', hasCities: true },
            { id: 4009, name: 'Goa', state_code: 'GA', hasCities: true },
            { id: 4030, name: 'Gujarat', state_code: 'GJ', hasCities: true },
            { id: 4007, name: 'Haryana', state_code: 'HR', hasCities: true },
            {
                id: 4020,
                name: 'Himachal Pradesh',
                state_code: 'HP',
                hasCities: true
            },
            {
                id: 4029,
                name: 'Jammu and Kashmir',
                state_code: 'JK',
                hasCities: true
            },
            {
                id: 4025,
                name: 'Jharkhand',
                state_code: 'JH',
                hasCities: true
            },
            {
                id: 4026,
                name: 'Karnataka',
                state_code: 'KA',
                hasCities: true
            },
            { id: 4028, name: 'Kerala', state_code: 'KL', hasCities: true },
            { id: 4852, name: 'Ladakh', state_code: 'LA', hasCities: true },
            {
                id: 4019,
                name: 'Lakshadweep',
                state_code: 'LD',
                hasCities: true
            },
            {
                id: 4039,
                name: 'Madhya Pradesh',
                state_code: 'MP',
                hasCities: true
            },
            {
                id: 4008,
                name: 'Maharashtra',
                state_code: 'MH',
                hasCities: true
            },
            { id: 4010, name: 'Manipur', state_code: 'MN', hasCities: true },
            {
                id: 4006,
                name: 'Meghalaya',
                state_code: 'ML',
                hasCities: true
            },
            { id: 4036, name: 'Mizoram', state_code: 'MZ', hasCities: true },
            { id: 4018, name: 'Nagaland', state_code: 'NL', hasCities: true },
            { id: 4013, name: 'Odisha', state_code: 'OR', hasCities: true },
            {
                id: 4011,
                name: 'Puducherry',
                state_code: 'PY',
                hasCities: true
            },
            { id: 4015, name: 'Punjab', state_code: 'PB', hasCities: true },
            {
                id: 4014,
                name: 'Rajasthan',
                state_code: 'RJ',
                hasCities: true
            },
            { id: 4034, name: 'Sikkim', state_code: 'SK', hasCities: true },
            {
                id: 4035,
                name: 'Tamil Nadu',
                state_code: 'TN',
                hasCities: true
            },
            {
                id: 4012,
                name: 'Telangana',
                state_code: 'TG',
                hasCities: true
            },
            { id: 4038, name: 'Tripura', state_code: 'TR', hasCities: true },
            {
                id: 4022,
                name: 'Uttar Pradesh',
                state_code: 'UP',
                hasCities: true
            },
            {
                id: 4016,
                name: 'Uttarakhand',
                state_code: 'UT',
                hasCities: true
            },
            {
                id: 4853,
                name: 'West Bengal',
                state_code: 'WB',
                hasCities: true
            }
        ]
    },
    {
        id: 102,
        states: [
            { id: 1822, name: 'Aceh', state_code: 'AC', hasCities: true },
            { id: 1826, name: 'Bali', state_code: 'BA', hasCities: true },
            { id: 1810, name: 'Banten', state_code: 'BT', hasCities: true },
            { id: 1793, name: 'Bengkulu', state_code: 'BE', hasCities: true },
            {
                id: 1829,
                name: 'DI Yogyakarta',
                state_code: 'YO',
                hasCities: true
            },
            {
                id: 1805,
                name: 'DKI Jakarta',
                state_code: 'JK',
                hasCities: true
            },
            {
                id: 1812,
                name: 'Gorontalo',
                state_code: 'GO',
                hasCities: true
            },
            { id: 1815, name: 'Jambi', state_code: 'JA', hasCities: true },
            {
                id: 1825,
                name: 'Jawa Barat',
                state_code: 'JB',
                hasCities: true
            },
            {
                id: 1802,
                name: 'Jawa Tengah',
                state_code: 'JT',
                hasCities: true
            },
            {
                id: 1827,
                name: 'Jawa Timur',
                state_code: 'JI',
                hasCities: true
            },
            {
                id: 1806,
                name: 'Kalimantan Barat',
                state_code: 'KB',
                hasCities: true
            },
            {
                id: 1819,
                name: 'Kalimantan Selatan',
                state_code: 'KS',
                hasCities: true
            },
            {
                id: 1794,
                name: 'Kalimantan Tengah',
                state_code: 'KT',
                hasCities: true
            },
            {
                id: 1804,
                name: 'Kalimantan Timur',
                state_code: 'KI',
                hasCities: true
            },
            {
                id: 1824,
                name: 'Kalimantan Utara',
                state_code: 'KU',
                hasCities: true
            },
            {
                id: 1820,
                name: 'Kepulauan Bangka Belitung',
                state_code: 'BB',
                hasCities: true
            },
            {
                id: 1807,
                name: 'Kepulauan Riau',
                state_code: 'KR',
                hasCities: true
            },
            { id: 1811, name: 'Lampung', state_code: 'LA', hasCities: true },
            { id: 1800, name: 'Maluku', state_code: 'MA', hasCities: true },
            {
                id: 1801,
                name: 'Maluku Utara',
                state_code: 'MU',
                hasCities: true
            },
            {
                id: 1814,
                name: 'Nusa Tenggara Barat',
                state_code: 'NB',
                hasCities: true
            },
            {
                id: 1818,
                name: 'Nusa Tenggara Timur',
                state_code: 'NT',
                hasCities: true
            },
            { id: 1798, name: 'Papua', state_code: 'PA', hasCities: true },
            {
                id: 1799,
                name: 'Papua Barat',
                state_code: 'PB',
                hasCities: true
            },
            { id: 1809, name: 'Riau', state_code: 'RI', hasCities: true },
            {
                id: 1817,
                name: 'Sulawesi Barat',
                state_code: 'SR',
                hasCities: true
            },
            {
                id: 1795,
                name: 'Sulawesi Selatan',
                state_code: 'SN',
                hasCities: true
            },
            {
                id: 1813,
                name: 'Sulawesi Tengah',
                state_code: 'ST',
                hasCities: true
            },
            {
                id: 1796,
                name: 'Sulawesi Tenggara',
                state_code: 'SG',
                hasCities: true
            },
            {
                id: 1808,
                name: 'Sulawesi Utara',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 1828,
                name: 'Sumatera Barat',
                state_code: 'SB',
                hasCities: true
            },
            {
                id: 1816,
                name: 'Sumatera Selatan',
                state_code: 'SS',
                hasCities: true
            },
            {
                id: 1792,
                name: 'Sumatera Utara',
                state_code: 'SU',
                hasCities: true
            }
        ]
    },
    {
        id: 103,
        states: [
            { id: 3929, name: 'Alborz', state_code: '30', hasCities: true },
            { id: 3934, name: 'Ardabil', state_code: '24', hasCities: true },
            { id: 3932, name: 'Bushehr', state_code: '18', hasCities: true },
            {
                id: 3921,
                name: 'Chaharmahal and Bakhtiari',
                state_code: '14',
                hasCities: true
            },
            {
                id: 3944,
                name: 'East Azerbaijan',
                state_code: '03',
                hasCities: true
            },
            { id: 3939, name: 'Fars', state_code: '07', hasCities: true },
            { id: 3920, name: 'Gilan', state_code: '01', hasCities: true },
            { id: 3933, name: 'Golestan', state_code: '27', hasCities: true },
            { id: 4920, name: 'Hamadan', state_code: '13', hasCities: true },
            {
                id: 3937,
                name: 'Hormozgan',
                state_code: '22',
                hasCities: true
            },
            { id: 3918, name: 'Ilam', state_code: '16', hasCities: true },
            { id: 3923, name: 'Isfahan', state_code: '10', hasCities: true },
            { id: 3943, name: 'Kerman', state_code: '08', hasCities: true },
            {
                id: 3919,
                name: 'Kermanshah',
                state_code: '05',
                hasCities: true
            },
            {
                id: 3917,
                name: 'Khuzestan',
                state_code: '06',
                hasCities: true
            },
            {
                id: 3926,
                name: 'Kohgiluyeh and Boyer-Ahmad',
                state_code: '17',
                hasCities: true
            },
            {
                id: 3935,
                name: 'Kurdistan',
                state_code: '12',
                hasCities: true
            },
            { id: 3928, name: 'Lorestan', state_code: '15', hasCities: true },
            { id: 3916, name: 'Markazi', state_code: '00', hasCities: true },
            {
                id: 3938,
                name: 'Mazandaran',
                state_code: '02',
                hasCities: true
            },
            {
                id: 3942,
                name: 'North Khorasan',
                state_code: '28',
                hasCities: true
            },
            { id: 3941, name: 'Qazvin', state_code: '26', hasCities: true },
            { id: 3922, name: 'Qom', state_code: '25', hasCities: true },
            {
                id: 3927,
                name: 'Razavi Khorasan',
                state_code: '09',
                hasCities: true
            },
            { id: 3940, name: 'Semnan', state_code: '20', hasCities: true },
            {
                id: 3931,
                name: 'Sistan and Baluchestan',
                state_code: '11',
                hasCities: true
            },
            {
                id: 3930,
                name: 'South Khorasan',
                state_code: '29',
                hasCities: true
            },
            { id: 3945, name: 'Tehran', state_code: '23', hasCities: true },
            {
                id: 3924,
                name: 'West Azarbaijan',
                state_code: '04',
                hasCities: true
            },
            { id: 3936, name: 'Yazd', state_code: '21', hasCities: true },
            { id: 3925, name: 'Zanjan', state_code: '19', hasCities: true }
        ]
    },
    {
        id: 104,
        states: [
            { id: 3964, name: 'Al Anbar', state_code: 'AN', hasCities: true },
            {
                id: 3958,
                name: 'Al Muthanna',
                state_code: 'MU',
                hasCities: true
            },
            {
                id: 3956,
                name: 'Al-Qādisiyyah',
                state_code: 'QA',
                hasCities: true
            },
            { id: 3955, name: 'Babylon', state_code: 'BB', hasCities: true },
            { id: 3959, name: 'Baghdad', state_code: 'BG', hasCities: true },
            { id: 3960, name: 'Basra', state_code: 'BA', hasCities: true },
            { id: 3954, name: 'Dhi Qar', state_code: 'DQ', hasCities: true },
            { id: 3965, name: 'Diyala', state_code: 'DI', hasCities: true },
            { id: 3967, name: 'Dohuk', state_code: 'DA', hasCities: true },
            { id: 3968, name: 'Erbil', state_code: 'AR', hasCities: true },
            { id: 3957, name: 'Karbala', state_code: 'KA', hasCities: true },
            { id: 3971, name: 'Kirkuk', state_code: 'KI', hasCities: true },
            { id: 3966, name: 'Maysan', state_code: 'MA', hasCities: true },
            { id: 3962, name: 'Najaf', state_code: 'NA', hasCities: true },
            { id: 3963, name: 'Nineveh', state_code: 'NI', hasCities: true },
            { id: 3961, name: 'Saladin', state_code: 'SD', hasCities: true },
            {
                id: 3969,
                name: 'Sulaymaniyah',
                state_code: 'SU',
                hasCities: true
            },
            { id: 3970, name: 'Wasit', state_code: 'WA', hasCities: true }
        ]
    },
    {
        id: 105,
        states: [
            { id: 1095, name: 'Carlow', state_code: 'CW', hasCities: false },
            { id: 1088, name: 'Cavan', state_code: 'CN', hasCities: false },
            { id: 1091, name: 'Clare', state_code: 'CE', hasCities: false },
            { id: 1087, name: 'Connacht', state_code: 'C', hasCities: true },
            { id: 1074, name: 'Cork', state_code: 'CO', hasCities: false },
            { id: 1071, name: 'Donegal', state_code: 'DL', hasCities: false },
            { id: 1072, name: 'Dublin', state_code: 'D', hasCities: false },
            { id: 1079, name: 'Galway', state_code: 'G', hasCities: false },
            { id: 1077, name: 'Kerry', state_code: 'KY', hasCities: false },
            { id: 1082, name: 'Kildare', state_code: 'KE', hasCities: false },
            {
                id: 1090,
                name: 'Kilkenny',
                state_code: 'KK',
                hasCities: false
            },
            { id: 1096, name: 'Laois', state_code: 'LS', hasCities: false },
            { id: 1073, name: 'Leinster', state_code: 'L', hasCities: true },
            {
                id: 1094,
                name: 'Limerick',
                state_code: 'LK',
                hasCities: false
            },
            {
                id: 1076,
                name: 'Longford',
                state_code: 'LD',
                hasCities: false
            },
            { id: 1083, name: 'Louth', state_code: 'LH', hasCities: false },
            { id: 1084, name: 'Mayo', state_code: 'MO', hasCities: false },
            { id: 1092, name: 'Meath', state_code: 'MH', hasCities: false },
            {
                id: 1075,
                name: 'Monaghan',
                state_code: 'MN',
                hasCities: false
            },
            { id: 1080, name: 'Munster', state_code: 'M', hasCities: true },
            { id: 1078, name: 'Offaly', state_code: 'OY', hasCities: false },
            {
                id: 1081,
                name: 'Roscommon',
                state_code: 'RN',
                hasCities: false
            },
            { id: 1070, name: 'Sligo', state_code: 'SO', hasCities: false },
            {
                id: 1069,
                name: 'Tipperary',
                state_code: 'TA',
                hasCities: false
            },
            { id: 1086, name: 'Ulster', state_code: 'U', hasCities: true },
            {
                id: 1089,
                name: 'Waterford',
                state_code: 'WD',
                hasCities: false
            },
            {
                id: 1097,
                name: 'Westmeath',
                state_code: 'WH',
                hasCities: false
            },
            { id: 1093, name: 'Wexford', state_code: 'WX', hasCities: false },
            { id: 1085, name: 'Wicklow', state_code: 'WW', hasCities: false }
        ]
    },
    {
        id: 106,
        states: [
            {
                id: 1367,
                name: 'Central District',
                state_code: 'M',
                hasCities: true
            },
            {
                id: 1369,
                name: 'Haifa District',
                state_code: 'HA',
                hasCities: true
            },
            {
                id: 1370,
                name: 'Jerusalem District',
                state_code: 'JM',
                hasCities: true
            },
            {
                id: 1366,
                name: 'Northern District',
                state_code: 'Z',
                hasCities: true
            },
            {
                id: 1368,
                name: 'Southern District',
                state_code: 'D',
                hasCities: true
            },
            {
                id: 1371,
                name: 'Tel Aviv District',
                state_code: 'TA',
                hasCities: true
            }
        ]
    },
    {
        id: 107,
        states: [
            { id: 1679, name: 'Abruzzo', state_code: '65', hasCities: true },
            {
                id: 1727,
                name: 'Agrigento',
                state_code: 'AG',
                hasCities: false
            },
            {
                id: 1783,
                name: 'Alessandria',
                state_code: 'AL',
                hasCities: false
            },
            { id: 1672, name: 'Ancona', state_code: 'AN', hasCities: false },
            {
                id: 1716,
                name: 'Aosta Valley',
                state_code: '23',
                hasCities: true
            },
            { id: 1688, name: 'Apulia', state_code: '75', hasCities: true },
            {
                id: 1681,
                name: 'Ascoli Piceno',
                state_code: 'AP',
                hasCities: false
            },
            { id: 1780, name: 'Asti', state_code: 'AT', hasCities: false },
            {
                id: 1692,
                name: 'Avellino',
                state_code: 'AV',
                hasCities: false
            },
            {
                id: 1686,
                name: 'Barletta-Andria-Trani',
                state_code: 'BT',
                hasCities: true
            },
            {
                id: 1706,
                name: 'Basilicata',
                state_code: '77',
                hasCities: true
            },
            { id: 1689, name: 'Belluno', state_code: 'BL', hasCities: false },
            {
                id: 1701,
                name: 'Benevento',
                state_code: 'BN',
                hasCities: false
            },
            { id: 1704, name: 'Bergamo', state_code: 'BG', hasCities: false },
            { id: 1778, name: 'Biella', state_code: 'BI', hasCities: false },
            { id: 1717, name: 'Brescia', state_code: 'BS', hasCities: false },
            {
                id: 1714,
                name: 'Brindisi',
                state_code: 'BR',
                hasCities: false
            },
            { id: 1703, name: 'Calabria', state_code: '78', hasCities: true },
            {
                id: 1718,
                name: 'Caltanissetta',
                state_code: 'CL',
                hasCities: false
            },
            { id: 1669, name: 'Campania', state_code: '72', hasCities: true },
            {
                id: 1721,
                name: 'Campobasso',
                state_code: 'CB',
                hasCities: false
            },
            { id: 1731, name: 'Caserta', state_code: 'CE', hasCities: false },
            {
                id: 1728,
                name: 'Catanzaro',
                state_code: 'CZ',
                hasCities: false
            },
            { id: 1739, name: 'Chieti', state_code: 'CH', hasCities: false },
            { id: 1740, name: 'Como', state_code: 'CO', hasCities: false },
            { id: 1742, name: 'Cosenza', state_code: 'CS', hasCities: false },
            { id: 1751, name: 'Cremona', state_code: 'CR', hasCities: false },
            { id: 1754, name: 'Crotone', state_code: 'KR', hasCities: false },
            { id: 1775, name: 'Cuneo', state_code: 'CN', hasCities: false },
            {
                id: 1773,
                name: 'Emilia-Romagna',
                state_code: '45',
                hasCities: true
            },
            { id: 1723, name: 'Enna', state_code: 'EN', hasCities: false },
            { id: 1744, name: 'Fermo', state_code: 'FM', hasCities: false },
            { id: 1746, name: 'Ferrara', state_code: 'FE', hasCities: false },
            { id: 1771, name: 'Foggia', state_code: 'FG', hasCities: false },
            {
                id: 1779,
                name: 'Forlì-Cesena',
                state_code: 'FC',
                hasCities: false
            },
            {
                id: 1756,
                name: 'Friuli–Venezia Giulia',
                state_code: '36',
                hasCities: true
            },
            {
                id: 1776,
                name: 'Frosinone',
                state_code: 'FR',
                hasCities: false
            },
            { id: 1777, name: 'Gorizia', state_code: 'GO', hasCities: false },
            {
                id: 1787,
                name: 'Grosseto',
                state_code: 'GR',
                hasCities: false
            },
            { id: 1788, name: 'Imperia', state_code: 'IM', hasCities: false },
            { id: 1789, name: 'Isernia', state_code: 'IS', hasCities: false },
            {
                id: 1781,
                name: "L'Aquila",
                state_code: 'AQ',
                hasCities: false
            },
            {
                id: 1791,
                name: 'La Spezia',
                state_code: 'SP',
                hasCities: false
            },
            { id: 1674, name: 'Latina', state_code: 'LT', hasCities: false },
            { id: 1678, name: 'Lazio', state_code: '62', hasCities: true },
            { id: 1675, name: 'Lecce', state_code: 'LE', hasCities: false },
            { id: 1677, name: 'Lecco', state_code: 'LC', hasCities: false },
            { id: 1768, name: 'Liguria', state_code: '42', hasCities: true },
            { id: 1745, name: 'Livorno', state_code: 'LI', hasCities: false },
            { id: 1747, name: 'Lodi', state_code: 'LO', hasCities: false },
            { id: 1705, name: 'Lombardy', state_code: '25', hasCities: true },
            { id: 1749, name: 'Lucca', state_code: 'LU', hasCities: false },
            {
                id: 1750,
                name: 'Macerata',
                state_code: 'MC',
                hasCities: false
            },
            { id: 1758, name: 'Mantua', state_code: 'MN', hasCities: false },
            { id: 1670, name: 'Marche', state_code: '57', hasCities: true },
            {
                id: 1759,
                name: 'Massa and Carrara',
                state_code: 'MS',
                hasCities: false
            },
            { id: 1760, name: 'Matera', state_code: 'MT', hasCities: false },
            {
                id: 1761,
                name: 'Medio Campidano',
                state_code: 'VS',
                hasCities: false
            },
            { id: 1757, name: 'Modena', state_code: 'MO', hasCities: false },
            { id: 1695, name: 'Molise', state_code: '67', hasCities: true },
            {
                id: 1769,
                name: 'Monza and Brianza',
                state_code: 'MB',
                hasCities: false
            },
            { id: 1774, name: 'Novara', state_code: 'NO', hasCities: false },
            { id: 1790, name: 'Nuoro', state_code: 'NU', hasCities: false },
            {
                id: 1786,
                name: 'Oristano',
                state_code: 'OR',
                hasCities: false
            },
            { id: 1665, name: 'Padua', state_code: 'PD', hasCities: false },
            { id: 1668, name: 'Palermo', state_code: 'PA', hasCities: false },
            { id: 1666, name: 'Parma', state_code: 'PR', hasCities: false },
            { id: 1676, name: 'Pavia', state_code: 'PV', hasCities: false },
            { id: 1691, name: 'Perugia', state_code: 'PG', hasCities: false },
            {
                id: 1693,
                name: 'Pesaro and Urbino',
                state_code: 'PU',
                hasCities: false
            },
            { id: 1694, name: 'Pescara', state_code: 'PE', hasCities: false },
            {
                id: 1696,
                name: 'Piacenza',
                state_code: 'PC',
                hasCities: false
            },
            { id: 1702, name: 'Piedmont', state_code: '21', hasCities: true },
            { id: 1685, name: 'Pisa', state_code: 'PI', hasCities: false },
            { id: 1687, name: 'Pistoia', state_code: 'PT', hasCities: false },
            {
                id: 1690,
                name: 'Pordenone',
                state_code: 'PN',
                hasCities: false
            },
            { id: 1697, name: 'Potenza', state_code: 'PZ', hasCities: false },
            { id: 1700, name: 'Prato', state_code: 'PO', hasCities: false },
            { id: 1729, name: 'Ragusa', state_code: 'RG', hasCities: false },
            { id: 1707, name: 'Ravenna', state_code: 'RA', hasCities: true },
            {
                id: 1708,
                name: 'Reggio Emilia',
                state_code: 'RE',
                hasCities: false
            },
            { id: 1712, name: 'Rieti', state_code: 'RI', hasCities: false },
            { id: 1713, name: 'Rimini', state_code: 'RN', hasCities: false },
            { id: 1719, name: 'Rovigo', state_code: 'RO', hasCities: false },
            { id: 1720, name: 'Salerno', state_code: 'SA', hasCities: false },
            { id: 1715, name: 'Sardinia', state_code: '88', hasCities: true },
            { id: 1722, name: 'Sassari', state_code: 'SS', hasCities: false },
            { id: 1732, name: 'Savona', state_code: 'SV', hasCities: false },
            { id: 1709, name: 'Sicily', state_code: '82', hasCities: true },
            { id: 1734, name: 'Siena', state_code: 'SI', hasCities: false },
            {
                id: 1667,
                name: 'Siracusa',
                state_code: 'SR',
                hasCities: false
            },
            { id: 1741, name: 'Sondrio', state_code: 'SO', hasCities: false },
            {
                id: 1730,
                name: 'South Sardinia',
                state_code: 'SU',
                hasCities: false
            },
            { id: 1743, name: 'Taranto', state_code: 'TA', hasCities: false },
            { id: 1752, name: 'Teramo', state_code: 'TE', hasCities: false },
            { id: 1755, name: 'Terni', state_code: 'TR', hasCities: false },
            { id: 1733, name: 'Trapani', state_code: 'TP', hasCities: false },
            {
                id: 1725,
                name: 'Trentino-South Tyrol',
                state_code: '32',
                hasCities: true
            },
            { id: 1762, name: 'Treviso', state_code: 'TV', hasCities: false },
            { id: 1763, name: 'Trieste', state_code: 'TS', hasCities: false },
            { id: 1664, name: 'Tuscany', state_code: '52', hasCities: true },
            { id: 1764, name: 'Udine', state_code: 'UD', hasCities: false },
            { id: 1683, name: 'Umbria', state_code: '55', hasCities: true },
            { id: 1765, name: 'Varese', state_code: 'VA', hasCities: false },
            { id: 1753, name: 'Veneto', state_code: '34', hasCities: true },
            {
                id: 1726,
                name: 'Verbano-Cusio-Ossola',
                state_code: 'VB',
                hasCities: false
            },
            {
                id: 1785,
                name: 'Vercelli',
                state_code: 'VC',
                hasCities: false
            },
            { id: 1736, name: 'Verona', state_code: 'VR', hasCities: false },
            {
                id: 1737,
                name: 'Vibo Valentia',
                state_code: 'VV',
                hasCities: false
            },
            { id: 1738, name: 'Vicenza', state_code: 'VI', hasCities: false },
            { id: 1735, name: 'Viterbo', state_code: 'VT', hasCities: false }
        ]
    },
    {
        id: 108,
        states: [
            {
                id: 3753,
                name: 'Clarendon Parish',
                state_code: '13',
                hasCities: true
            },
            {
                id: 3749,
                name: 'Hanover Parish',
                state_code: '09',
                hasCities: true
            },
            {
                id: 3748,
                name: 'Kingston Parish',
                state_code: '01',
                hasCities: true
            },
            {
                id: 3754,
                name: 'Manchester Parish',
                state_code: '12',
                hasCities: true
            },
            {
                id: 3752,
                name: 'Portland Parish',
                state_code: '04',
                hasCities: true
            },
            {
                id: 3751,
                name: 'Saint Andrew',
                state_code: '02',
                hasCities: true
            },
            {
                id: 3744,
                name: 'Saint Ann Parish',
                state_code: '06',
                hasCities: true
            },
            {
                id: 3746,
                name: 'Saint Catherine Parish',
                state_code: '14',
                hasCities: true
            },
            {
                id: 3743,
                name: 'Saint Elizabeth Parish',
                state_code: '11',
                hasCities: true
            },
            {
                id: 3745,
                name: 'Saint James Parish',
                state_code: '08',
                hasCities: true
            },
            {
                id: 3747,
                name: 'Saint Mary Parish',
                state_code: '05',
                hasCities: true
            },
            {
                id: 3750,
                name: 'Saint Thomas Parish',
                state_code: '03',
                hasCities: true
            },
            {
                id: 3755,
                name: 'Trelawny Parish',
                state_code: '07',
                hasCities: true
            },
            {
                id: 3742,
                name: 'Westmoreland Parish',
                state_code: '10',
                hasCities: true
            }
        ]
    },
    {
        id: 109,
        states: [
            {
                id: 827,
                name: 'Aichi Prefecture',
                state_code: '23',
                hasCities: true
            },
            {
                id: 829,
                name: 'Akita Prefecture',
                state_code: '05',
                hasCities: true
            },
            {
                id: 839,
                name: 'Aomori Prefecture',
                state_code: '02',
                hasCities: true
            },
            {
                id: 821,
                name: 'Chiba Prefecture',
                state_code: '12',
                hasCities: true
            },
            {
                id: 865,
                name: 'Ehime Prefecture',
                state_code: '38',
                hasCities: true
            },
            {
                id: 848,
                name: 'Fukui Prefecture',
                state_code: '18',
                hasCities: true
            },
            {
                id: 861,
                name: 'Fukuoka Prefecture',
                state_code: '40',
                hasCities: true
            },
            {
                id: 847,
                name: 'Fukushima Prefecture',
                state_code: '07',
                hasCities: true
            },
            {
                id: 858,
                name: 'Gifu Prefecture',
                state_code: '21',
                hasCities: true
            },
            {
                id: 862,
                name: 'Gunma Prefecture',
                state_code: '10',
                hasCities: true
            },
            {
                id: 828,
                name: 'Hiroshima Prefecture',
                state_code: '34',
                hasCities: true
            },
            {
                id: 832,
                name: 'Hokkaidō Prefecture',
                state_code: '01',
                hasCities: true
            },
            {
                id: 831,
                name: 'Hyōgo Prefecture',
                state_code: '28',
                hasCities: true
            },
            {
                id: 851,
                name: 'Ibaraki Prefecture',
                state_code: '08',
                hasCities: true
            },
            {
                id: 830,
                name: 'Ishikawa Prefecture',
                state_code: '17',
                hasCities: true
            },
            {
                id: 856,
                name: 'Iwate Prefecture',
                state_code: '03',
                hasCities: true
            },
            {
                id: 864,
                name: 'Kagawa Prefecture',
                state_code: '37',
                hasCities: true
            },
            {
                id: 840,
                name: 'Kagoshima Prefecture',
                state_code: '46',
                hasCities: true
            },
            {
                id: 842,
                name: 'Kanagawa Prefecture',
                state_code: '14',
                hasCities: true
            },
            {
                id: 4924,
                name: 'Kōchi Prefecture',
                state_code: '39',
                hasCities: true
            },
            {
                id: 846,
                name: 'Kumamoto Prefecture',
                state_code: '43',
                hasCities: true
            },
            {
                id: 834,
                name: 'Kyōto Prefecture',
                state_code: '26',
                hasCities: true
            },
            {
                id: 833,
                name: 'Mie Prefecture',
                state_code: '24',
                hasCities: true
            },
            {
                id: 857,
                name: 'Miyagi Prefecture',
                state_code: '04',
                hasCities: true
            },
            {
                id: 855,
                name: 'Miyazaki Prefecture',
                state_code: '45',
                hasCities: true
            },
            {
                id: 843,
                name: 'Nagano Prefecture',
                state_code: '20',
                hasCities: true
            },
            {
                id: 849,
                name: 'Nagasaki Prefecture',
                state_code: '42',
                hasCities: true
            },
            {
                id: 824,
                name: 'Nara Prefecture',
                state_code: '29',
                hasCities: true
            },
            {
                id: 841,
                name: 'Niigata Prefecture',
                state_code: '15',
                hasCities: true
            },
            {
                id: 822,
                name: 'Ōita Prefecture',
                state_code: '44',
                hasCities: true
            },
            {
                id: 820,
                name: 'Okayama Prefecture',
                state_code: '33',
                hasCities: true
            },
            {
                id: 853,
                name: 'Okinawa Prefecture',
                state_code: '47',
                hasCities: true
            },
            {
                id: 859,
                name: 'Ōsaka Prefecture',
                state_code: '27',
                hasCities: true
            },
            {
                id: 863,
                name: 'Saga Prefecture',
                state_code: '41',
                hasCities: true
            },
            {
                id: 860,
                name: 'Saitama Prefecture',
                state_code: '11',
                hasCities: true
            },
            {
                id: 845,
                name: 'Shiga Prefecture',
                state_code: '25',
                hasCities: true
            },
            {
                id: 826,
                name: 'Shimane Prefecture',
                state_code: '32',
                hasCities: true
            },
            {
                id: 825,
                name: 'Shizuoka Prefecture',
                state_code: '22',
                hasCities: true
            },
            {
                id: 854,
                name: 'Tochigi Prefecture',
                state_code: '09',
                hasCities: true
            },
            {
                id: 836,
                name: 'Tokushima Prefecture',
                state_code: '36',
                hasCities: true
            },
            { id: 823, name: 'Tokyo', state_code: '13', hasCities: true },
            {
                id: 850,
                name: 'Tottori Prefecture',
                state_code: '31',
                hasCities: true
            },
            {
                id: 838,
                name: 'Toyama Prefecture',
                state_code: '16',
                hasCities: true
            },
            {
                id: 844,
                name: 'Wakayama Prefecture',
                state_code: '30',
                hasCities: true
            },
            {
                id: 837,
                name: 'Yamagata Prefecture',
                state_code: '06',
                hasCities: true
            },
            {
                id: 835,
                name: 'Yamaguchi Prefecture',
                state_code: '35',
                hasCities: true
            },
            {
                id: 852,
                name: 'Yamanashi Prefecture',
                state_code: '19',
                hasCities: true
            }
        ]
    },
    { id: 110, states: [] },
    {
        id: 111,
        states: [
            { id: 963, name: 'Ajloun', state_code: 'AJ', hasCities: true },
            { id: 965, name: 'Amman', state_code: 'AM', hasCities: true },
            { id: 959, name: 'Aqaba', state_code: 'AQ', hasCities: true },
            { id: 961, name: 'Balqa', state_code: 'BA', hasCities: true },
            { id: 960, name: 'Irbid', state_code: 'IR', hasCities: true },
            { id: 966, name: 'Jerash', state_code: 'JA', hasCities: true },
            { id: 956, name: 'Karak', state_code: 'KA', hasCities: true },
            { id: 964, name: "Ma'an", state_code: 'MN', hasCities: true },
            { id: 958, name: 'Madaba', state_code: 'MD', hasCities: true },
            { id: 962, name: 'Mafraq', state_code: 'MA', hasCities: true },
            { id: 957, name: 'Tafilah', state_code: 'AT', hasCities: true },
            { id: 967, name: 'Zarqa', state_code: 'AZ', hasCities: true }
        ]
    },
    {
        id: 112,
        states: [
            {
                id: 145,
                name: 'Akmola Region',
                state_code: 'AKM',
                hasCities: true
            },
            {
                id: 151,
                name: 'Aktobe Region',
                state_code: 'AKT',
                hasCities: true
            },
            { id: 152, name: 'Almaty', state_code: 'ALA', hasCities: true },
            {
                id: 143,
                name: 'Almaty Region',
                state_code: 'ALM',
                hasCities: true
            },
            {
                id: 153,
                name: 'Atyrau Region',
                state_code: 'ATY',
                hasCities: true
            },
            { id: 155, name: 'Baikonur', state_code: 'BAY', hasCities: true },
            {
                id: 154,
                name: 'East Kazakhstan Region',
                state_code: 'VOS',
                hasCities: true
            },
            {
                id: 147,
                name: 'Jambyl Region',
                state_code: 'ZHA',
                hasCities: true
            },
            {
                id: 150,
                name: 'Karaganda Region',
                state_code: 'KAR',
                hasCities: true
            },
            {
                id: 157,
                name: 'Kostanay Region',
                state_code: 'KUS',
                hasCities: true
            },
            {
                id: 142,
                name: 'Kyzylorda Region',
                state_code: 'KZY',
                hasCities: true
            },
            {
                id: 141,
                name: 'Mangystau Region',
                state_code: 'MAN',
                hasCities: true
            },
            {
                id: 144,
                name: 'North Kazakhstan Region',
                state_code: 'SEV',
                hasCities: true
            },
            {
                id: 156,
                name: 'Nur-Sultan',
                state_code: 'AST',
                hasCities: true
            },
            {
                id: 146,
                name: 'Pavlodar Region',
                state_code: 'PAV',
                hasCities: true
            },
            {
                id: 149,
                name: 'Turkestan Region',
                state_code: 'YUZ',
                hasCities: true
            },
            {
                id: 148,
                name: 'West Kazakhstan Province',
                state_code: 'ZAP',
                hasCities: true
            }
        ]
    },
    {
        id: 113,
        states: [
            { id: 181, name: 'Baringo', state_code: '01', hasCities: true },
            { id: 210, name: 'Bomet', state_code: '02', hasCities: true },
            { id: 168, name: 'Bungoma', state_code: '03', hasCities: true },
            { id: 161, name: 'Busia', state_code: '04', hasCities: true },
            {
                id: 201,
                name: 'Elgeyo-Marakwet',
                state_code: '05',
                hasCities: false
            },
            { id: 163, name: 'Embu', state_code: '06', hasCities: true },
            { id: 196, name: 'Garissa', state_code: '07', hasCities: true },
            { id: 195, name: 'Homa Bay', state_code: '08', hasCities: true },
            { id: 170, name: 'Isiolo', state_code: '09', hasCities: true },
            { id: 197, name: 'Kajiado', state_code: '10', hasCities: true },
            { id: 158, name: 'Kakamega', state_code: '11', hasCities: true },
            { id: 193, name: 'Kericho', state_code: '12', hasCities: true },
            { id: 199, name: 'Kiambu', state_code: '13', hasCities: true },
            { id: 174, name: 'Kilifi', state_code: '14', hasCities: true },
            { id: 167, name: 'Kirinyaga', state_code: '15', hasCities: true },
            { id: 159, name: 'Kisii', state_code: '16', hasCities: true },
            { id: 171, name: 'Kisumu', state_code: '17', hasCities: true },
            { id: 211, name: 'Kitui', state_code: '18', hasCities: true },
            { id: 173, name: 'Kwale', state_code: '19', hasCities: true },
            { id: 164, name: 'Laikipia', state_code: '20', hasCities: true },
            { id: 166, name: 'Lamu', state_code: '21', hasCities: true },
            { id: 184, name: 'Machakos', state_code: '22', hasCities: true },
            { id: 188, name: 'Makueni', state_code: '23', hasCities: true },
            { id: 187, name: 'Mandera', state_code: '24', hasCities: true },
            { id: 194, name: 'Marsabit', state_code: '25', hasCities: true },
            { id: 198, name: 'Meru', state_code: '26', hasCities: true },
            { id: 190, name: 'Migori', state_code: '27', hasCities: true },
            { id: 200, name: 'Mombasa', state_code: '28', hasCities: true },
            { id: 178, name: "Murang'a", state_code: '29', hasCities: true },
            {
                id: 191,
                name: 'Nairobi City',
                state_code: '30',
                hasCities: true
            },
            { id: 203, name: 'Nakuru', state_code: '31', hasCities: true },
            { id: 165, name: 'Nandi', state_code: '32', hasCities: true },
            { id: 175, name: 'Narok', state_code: '33', hasCities: true },
            { id: 209, name: 'Nyamira', state_code: '34', hasCities: true },
            { id: 192, name: 'Nyandarua', state_code: '35', hasCities: true },
            { id: 180, name: 'Nyeri', state_code: '36', hasCities: true },
            { id: 207, name: 'Samburu', state_code: '37', hasCities: true },
            { id: 186, name: 'Siaya', state_code: '38', hasCities: true },
            {
                id: 176,
                name: 'Taita–Taveta',
                state_code: '39',
                hasCities: false
            },
            {
                id: 205,
                name: 'Tana River',
                state_code: '40',
                hasCities: true
            },
            {
                id: 185,
                name: 'Tharaka-Nithi',
                state_code: '41',
                hasCities: true
            },
            {
                id: 183,
                name: 'Trans Nzoia',
                state_code: '42',
                hasCities: true
            },
            { id: 206, name: 'Turkana', state_code: '43', hasCities: true },
            {
                id: 169,
                name: 'Uasin Gishu',
                state_code: '44',
                hasCities: true
            },
            { id: 202, name: 'Vihiga', state_code: '45', hasCities: false },
            { id: 182, name: 'Wajir', state_code: '46', hasCities: true },
            { id: 208, name: 'West Pokot', state_code: '47', hasCities: true }
        ]
    },
    {
        id: 114,
        states: [
            {
                id: 1831,
                name: 'Gilbert Islands',
                state_code: 'G',
                hasCities: true
            },
            {
                id: 1832,
                name: 'Line Islands',
                state_code: 'L',
                hasCities: true
            },
            {
                id: 1830,
                name: 'Phoenix Islands',
                state_code: 'P',
                hasCities: true
            }
        ]
    },
    {
        id: 248,
        states: [
            {
                id: 4876,
                name: 'Đakovica District (Gjakove)',
                state_code: 'XDG',
                hasCities: false
            },
            {
                id: 4877,
                name: 'Gjilan District',
                state_code: 'XGJ',
                hasCities: false
            },
            {
                id: 4878,
                name: 'Kosovska Mitrovica District',
                state_code: 'XKM',
                hasCities: false
            },
            {
                id: 3738,
                name: 'Peć District',
                state_code: 'XPE',
                hasCities: false
            },
            {
                id: 4879,
                name: 'Pristina (Priştine)',
                state_code: 'XPI',
                hasCities: false
            },
            {
                id: 3723,
                name: 'Prizren District',
                state_code: 'XPR',
                hasCities: false
            },
            {
                id: 4874,
                name: 'Uroševac District (Ferizaj)',
                state_code: 'XUF',
                hasCities: false
            }
        ]
    },
    {
        id: 117,
        states: [
            { id: 977, name: 'Al Ahmadi', state_code: 'AH', hasCities: true },
            {
                id: 975,
                name: 'Al Farwaniyah',
                state_code: 'FA',
                hasCities: true
            },
            { id: 972, name: 'Al Jahra', state_code: 'JA', hasCities: true },
            { id: 976, name: 'Capital', state_code: 'KU', hasCities: true },
            { id: 973, name: 'Hawalli', state_code: 'HA', hasCities: true },
            {
                id: 974,
                name: 'Mubarak Al-Kabeer',
                state_code: 'MU',
                hasCities: true
            }
        ]
    },
    {
        id: 118,
        states: [
            {
                id: 998,
                name: 'Batken Region',
                state_code: 'B',
                hasCities: true
            },
            { id: 1001, name: 'Bishkek', state_code: 'GB', hasCities: true },
            {
                id: 1004,
                name: 'Chuy Region',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 1002,
                name: 'Issyk-Kul Region',
                state_code: 'Y',
                hasCities: true
            },
            {
                id: 1000,
                name: 'Jalal-Abad Region',
                state_code: 'J',
                hasCities: true
            },
            {
                id: 999,
                name: 'Naryn Region',
                state_code: 'N',
                hasCities: true
            },
            { id: 1003, name: 'Osh', state_code: 'GO', hasCities: false },
            {
                id: 1005,
                name: 'Osh Region',
                state_code: 'O',
                hasCities: true
            },
            {
                id: 997,
                name: 'Talas Region',
                state_code: 'T',
                hasCities: true
            }
        ]
    },
    {
        id: 119,
        states: [
            {
                id: 982,
                name: 'Attapeu Province',
                state_code: 'AT',
                hasCities: true
            },
            {
                id: 991,
                name: 'Bokeo Province',
                state_code: 'BK',
                hasCities: true
            },
            {
                id: 985,
                name: 'Bolikhamsai Province',
                state_code: 'BL',
                hasCities: true
            },
            {
                id: 996,
                name: 'Champasak Province',
                state_code: 'CH',
                hasCities: true
            },
            {
                id: 989,
                name: 'Houaphanh Province',
                state_code: 'HO',
                hasCities: true
            },
            {
                id: 986,
                name: 'Khammouane Province',
                state_code: 'KH',
                hasCities: true
            },
            {
                id: 992,
                name: 'Luang Namtha Province',
                state_code: 'LM',
                hasCities: true
            },
            {
                id: 978,
                name: 'Luang Prabang Province',
                state_code: 'LP',
                hasCities: true
            },
            {
                id: 988,
                name: 'Oudomxay Province',
                state_code: 'OU',
                hasCities: true
            },
            {
                id: 987,
                name: 'Phongsaly Province',
                state_code: 'PH',
                hasCities: true
            },
            {
                id: 993,
                name: 'Sainyabuli Province',
                state_code: 'XA',
                hasCities: true
            },
            {
                id: 981,
                name: 'Salavan Province',
                state_code: 'SL',
                hasCities: true
            },
            {
                id: 990,
                name: 'Savannakhet Province',
                state_code: 'SV',
                hasCities: true
            },
            {
                id: 984,
                name: 'Sekong Province',
                state_code: 'XE',
                hasCities: true
            },
            {
                id: 979,
                name: 'Vientiane Prefecture',
                state_code: 'VT',
                hasCities: true
            },
            {
                id: 980,
                name: 'Vientiane Province',
                state_code: 'VI',
                hasCities: true
            },
            {
                id: 994,
                name: 'Xaisomboun',
                state_code: 'XN',
                hasCities: false
            },
            {
                id: 983,
                name: 'Xaisomboun Province',
                state_code: 'XS',
                hasCities: true
            },
            {
                id: 995,
                name: 'Xiangkhouang Province',
                state_code: 'XI',
                hasCities: true
            }
        ]
    },
    {
        id: 120,
        states: [
            {
                id: 4445,
                name: 'Aglona Municipality',
                state_code: '001',
                hasCities: true
            },
            {
                id: 4472,
                name: 'Aizkraukle Municipality',
                state_code: '002',
                hasCities: true
            },
            {
                id: 4496,
                name: 'Aizpute Municipality',
                state_code: '003',
                hasCities: true
            },
            {
                id: 4499,
                name: 'Aknīste Municipality',
                state_code: '004',
                hasCities: true
            },
            {
                id: 4484,
                name: 'Aloja Municipality',
                state_code: '005',
                hasCities: true
            },
            {
                id: 4485,
                name: 'Alsunga Municipality',
                state_code: '006',
                hasCities: true
            },
            {
                id: 4487,
                name: 'Alūksne Municipality',
                state_code: '007',
                hasCities: true
            },
            {
                id: 4497,
                name: 'Amata Municipality',
                state_code: '008',
                hasCities: false
            },
            {
                id: 4457,
                name: 'Ape Municipality',
                state_code: '009',
                hasCities: true
            },
            {
                id: 4481,
                name: 'Auce Municipality',
                state_code: '010',
                hasCities: true
            },
            {
                id: 4427,
                name: 'Babīte Municipality',
                state_code: '012',
                hasCities: true
            },
            {
                id: 4482,
                name: 'Baldone Municipality',
                state_code: '013',
                hasCities: true
            },
            {
                id: 4498,
                name: 'Baltinava Municipality',
                state_code: '014',
                hasCities: true
            },
            {
                id: 4505,
                name: 'Balvi Municipality',
                state_code: '015',
                hasCities: true
            },
            {
                id: 4465,
                name: 'Bauska Municipality',
                state_code: '016',
                hasCities: true
            },
            {
                id: 4471,
                name: 'Beverīna Municipality',
                state_code: '017',
                hasCities: true
            },
            {
                id: 4468,
                name: 'Brocēni Municipality',
                state_code: '018',
                hasCities: true
            },
            {
                id: 4411,
                name: 'Burtnieki Municipality',
                state_code: '019',
                hasCities: false
            },
            {
                id: 4454,
                name: 'Carnikava Municipality',
                state_code: '020',
                hasCities: true
            },
            {
                id: 4469,
                name: 'Cēsis Municipality',
                state_code: '022',
                hasCities: true
            },
            {
                id: 4414,
                name: 'Cesvaine Municipality',
                state_code: '021',
                hasCities: true
            },
            {
                id: 4410,
                name: 'Cibla Municipality',
                state_code: '023',
                hasCities: true
            },
            {
                id: 4504,
                name: 'Dagda Municipality',
                state_code: '024',
                hasCities: true
            },
            {
                id: 4463,
                name: 'Daugavpils',
                state_code: 'DGV',
                hasCities: false
            },
            {
                id: 4492,
                name: 'Daugavpils Municipality',
                state_code: '025',
                hasCities: true
            },
            {
                id: 4437,
                name: 'Dobele Municipality',
                state_code: '026',
                hasCities: true
            },
            {
                id: 4428,
                name: 'Dundaga Municipality',
                state_code: '027',
                hasCities: true
            },
            {
                id: 4458,
                name: 'Durbe Municipality',
                state_code: '028',
                hasCities: true
            },
            {
                id: 4448,
                name: 'Engure Municipality',
                state_code: '029',
                hasCities: true
            },
            {
                id: 4444,
                name: 'Ērgļi Municipality',
                state_code: '030',
                hasCities: true
            },
            {
                id: 4510,
                name: 'Garkalne Municipality',
                state_code: '031',
                hasCities: true
            },
            {
                id: 4470,
                name: 'Grobiņa Municipality',
                state_code: '032',
                hasCities: true
            },
            {
                id: 4400,
                name: 'Gulbene Municipality',
                state_code: '033',
                hasCities: true
            },
            {
                id: 4441,
                name: 'Iecava Municipality',
                state_code: '034',
                hasCities: true
            },
            {
                id: 4511,
                name: 'Ikšķile Municipality',
                state_code: '035',
                hasCities: true
            },
            {
                id: 4399,
                name: 'Ilūkste Municipality',
                state_code: '036',
                hasCities: true
            },
            {
                id: 4449,
                name: 'Inčukalns Municipality',
                state_code: '037',
                hasCities: true
            },
            {
                id: 4475,
                name: 'Jaunjelgava Municipality',
                state_code: '038',
                hasCities: true
            },
            {
                id: 4407,
                name: 'Jaunpiebalga Municipality',
                state_code: '039',
                hasCities: false
            },
            {
                id: 4489,
                name: 'Jaunpils Municipality',
                state_code: '040',
                hasCities: true
            },
            {
                id: 4464,
                name: 'Jēkabpils',
                state_code: 'JKB',
                hasCities: false
            },
            {
                id: 4438,
                name: 'Jēkabpils Municipality',
                state_code: '042',
                hasCities: true
            },
            { id: 4500, name: 'Jelgava', state_code: 'JEL', hasCities: true },
            {
                id: 4424,
                name: 'Jelgava Municipality',
                state_code: '041',
                hasCities: true
            },
            { id: 4446, name: 'Jūrmala', state_code: 'JUR', hasCities: true },
            {
                id: 4420,
                name: 'Kandava Municipality',
                state_code: '043',
                hasCities: true
            },
            {
                id: 4453,
                name: 'Kārsava Municipality',
                state_code: '044',
                hasCities: true
            },
            {
                id: 4412,
                name: 'Ķegums Municipality',
                state_code: '051',
                hasCities: true
            },
            {
                id: 4435,
                name: 'Ķekava Municipality',
                state_code: '052',
                hasCities: true
            },
            {
                id: 4495,
                name: 'Kocēni Municipality',
                state_code: '045',
                hasCities: true
            },
            {
                id: 4452,
                name: 'Koknese Municipality',
                state_code: '046',
                hasCities: true
            },
            {
                id: 4474,
                name: 'Krāslava Municipality',
                state_code: '047',
                hasCities: true
            },
            {
                id: 4422,
                name: 'Krimulda Municipality',
                state_code: '048',
                hasCities: false
            },
            {
                id: 4413,
                name: 'Krustpils Municipality',
                state_code: '049',
                hasCities: false
            },
            {
                id: 4490,
                name: 'Kuldīga Municipality',
                state_code: '050',
                hasCities: true
            },
            {
                id: 4512,
                name: 'Lielvārde Municipality',
                state_code: '053',
                hasCities: true
            },
            { id: 4460, name: 'Liepāja', state_code: 'LPX', hasCities: true },
            {
                id: 4488,
                name: 'Līgatne Municipality',
                state_code: '055',
                hasCities: true
            },
            {
                id: 4418,
                name: 'Limbaži Municipality',
                state_code: '054',
                hasCities: true
            },
            {
                id: 4401,
                name: 'Līvāni Municipality',
                state_code: '056',
                hasCities: true
            },
            {
                id: 4419,
                name: 'Lubāna Municipality',
                state_code: '057',
                hasCities: true
            },
            {
                id: 4501,
                name: 'Ludza Municipality',
                state_code: '058',
                hasCities: true
            },
            {
                id: 4433,
                name: 'Madona Municipality',
                state_code: '059',
                hasCities: true
            },
            {
                id: 4461,
                name: 'Mālpils Municipality',
                state_code: '061',
                hasCities: true
            },
            {
                id: 4450,
                name: 'Mārupe Municipality',
                state_code: '062',
                hasCities: true
            },
            {
                id: 4513,
                name: 'Mazsalaca Municipality',
                state_code: '060',
                hasCities: true
            },
            {
                id: 4451,
                name: 'Mērsrags Municipality',
                state_code: '063',
                hasCities: false
            },
            {
                id: 4398,
                name: 'Naukšēni Municipality',
                state_code: '064',
                hasCities: true
            },
            {
                id: 4432,
                name: 'Nereta Municipality',
                state_code: '065',
                hasCities: true
            },
            {
                id: 4436,
                name: 'Nīca Municipality',
                state_code: '066',
                hasCities: true
            },
            {
                id: 4416,
                name: 'Ogre Municipality',
                state_code: '067',
                hasCities: true
            },
            {
                id: 4417,
                name: 'Olaine Municipality',
                state_code: '068',
                hasCities: true
            },
            {
                id: 4442,
                name: 'Ozolnieki Municipality',
                state_code: '069',
                hasCities: true
            },
            {
                id: 4507,
                name: 'Pārgauja Municipality',
                state_code: '070',
                hasCities: true
            },
            {
                id: 4467,
                name: 'Pāvilosta Municipality',
                state_code: '071',
                hasCities: true
            },
            {
                id: 4405,
                name: 'Pļaviņas Municipality',
                state_code: '072',
                hasCities: true
            },
            {
                id: 4483,
                name: 'Preiļi Municipality',
                state_code: '073',
                hasCities: true
            },
            {
                id: 4429,
                name: 'Priekule Municipality',
                state_code: '074',
                hasCities: true
            },
            {
                id: 4506,
                name: 'Priekuļi Municipality',
                state_code: '075',
                hasCities: true
            },
            {
                id: 4479,
                name: 'Rauna Municipality',
                state_code: '076',
                hasCities: true
            },
            { id: 4509, name: 'Rēzekne', state_code: 'REZ', hasCities: true },
            {
                id: 4455,
                name: 'Rēzekne Municipality',
                state_code: '077',
                hasCities: false
            },
            {
                id: 4502,
                name: 'Riebiņi Municipality',
                state_code: '078',
                hasCities: true
            },
            { id: 4491, name: 'Riga', state_code: 'RIX', hasCities: true },
            {
                id: 4440,
                name: 'Roja Municipality',
                state_code: '079',
                hasCities: true
            },
            {
                id: 4493,
                name: 'Ropaži Municipality',
                state_code: '080',
                hasCities: true
            },
            {
                id: 4503,
                name: 'Rucava Municipality',
                state_code: '081',
                hasCities: true
            },
            {
                id: 4423,
                name: 'Rugāji Municipality',
                state_code: '082',
                hasCities: true
            },
            {
                id: 4426,
                name: 'Rūjiena Municipality',
                state_code: '084',
                hasCities: true
            },
            {
                id: 4404,
                name: 'Rundāle Municipality',
                state_code: '083',
                hasCities: true
            },
            {
                id: 4434,
                name: 'Sala Municipality',
                state_code: '085',
                hasCities: false
            },
            {
                id: 4396,
                name: 'Salacgrīva Municipality',
                state_code: '086',
                hasCities: true
            },
            {
                id: 4402,
                name: 'Salaspils Municipality',
                state_code: '087',
                hasCities: true
            },
            {
                id: 4439,
                name: 'Saldus Municipality',
                state_code: '088',
                hasCities: true
            },
            {
                id: 4443,
                name: 'Saulkrasti Municipality',
                state_code: '089',
                hasCities: true
            },
            {
                id: 4408,
                name: 'Sēja Municipality',
                state_code: '090',
                hasCities: true
            },
            {
                id: 4476,
                name: 'Sigulda Municipality',
                state_code: '091',
                hasCities: true
            },
            {
                id: 4415,
                name: 'Skrīveri Municipality',
                state_code: '092',
                hasCities: true
            },
            {
                id: 4447,
                name: 'Skrunda Municipality',
                state_code: '093',
                hasCities: true
            },
            {
                id: 4462,
                name: 'Smiltene Municipality',
                state_code: '094',
                hasCities: true
            },
            {
                id: 4478,
                name: 'Stopiņi Municipality',
                state_code: '095',
                hasCities: true
            },
            {
                id: 4494,
                name: 'Strenči Municipality',
                state_code: '096',
                hasCities: true
            },
            {
                id: 4459,
                name: 'Talsi Municipality',
                state_code: '097',
                hasCities: true
            },
            {
                id: 4480,
                name: 'Tērvete Municipality',
                state_code: '098',
                hasCities: true
            },
            {
                id: 4409,
                name: 'Tukums Municipality',
                state_code: '099',
                hasCities: false
            },
            {
                id: 4508,
                name: 'Vaiņode Municipality',
                state_code: '100',
                hasCities: true
            },
            {
                id: 4425,
                name: 'Valka Municipality',
                state_code: '101',
                hasCities: true
            },
            {
                id: 4473,
                name: 'Valmiera',
                state_code: 'VMR',
                hasCities: true
            },
            {
                id: 4431,
                name: 'Varakļāni Municipality',
                state_code: '102',
                hasCities: true
            },
            {
                id: 4406,
                name: 'Vārkava Municipality',
                state_code: '103',
                hasCities: true
            },
            {
                id: 4466,
                name: 'Vecpiebalga Municipality',
                state_code: '104',
                hasCities: true
            },
            {
                id: 4397,
                name: 'Vecumnieki Municipality',
                state_code: '105',
                hasCities: true
            },
            {
                id: 4421,
                name: 'Ventspils',
                state_code: 'VEN',
                hasCities: true
            },
            {
                id: 4403,
                name: 'Ventspils Municipality',
                state_code: '106',
                hasCities: true
            },
            {
                id: 4456,
                name: 'Viesīte Municipality',
                state_code: '107',
                hasCities: true
            },
            {
                id: 4477,
                name: 'Viļaka Municipality',
                state_code: '108',
                hasCities: true
            },
            {
                id: 4486,
                name: 'Viļāni Municipality',
                state_code: '109',
                hasCities: true
            },
            {
                id: 4430,
                name: 'Zilupe Municipality',
                state_code: '110',
                hasCities: true
            }
        ]
    },
    {
        id: 121,
        states: [
            { id: 2285, name: 'Akkar', state_code: 'AK', hasCities: true },
            {
                id: 2283,
                name: 'Baalbek-Hermel',
                state_code: 'BH',
                hasCities: true
            },
            { id: 2286, name: 'Beirut', state_code: 'BA', hasCities: true },
            { id: 2287, name: 'Beqaa', state_code: 'BI', hasCities: true },
            {
                id: 2282,
                name: 'Mount Lebanon',
                state_code: 'JL',
                hasCities: true
            },
            { id: 2288, name: 'Nabatieh', state_code: 'NA', hasCities: true },
            { id: 2284, name: 'North', state_code: 'AS', hasCities: true },
            { id: 2281, name: 'South', state_code: 'JA', hasCities: true }
        ]
    },
    {
        id: 122,
        states: [
            {
                id: 3030,
                name: 'Berea District',
                state_code: 'D',
                hasCities: true
            },
            {
                id: 3029,
                name: 'Butha-Buthe District',
                state_code: 'B',
                hasCities: true
            },
            {
                id: 3026,
                name: 'Leribe District',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 3022,
                name: 'Mafeteng District',
                state_code: 'E',
                hasCities: true
            },
            {
                id: 3028,
                name: 'Maseru District',
                state_code: 'A',
                hasCities: true
            },
            {
                id: 3023,
                name: "Mohale's Hoek District",
                state_code: 'F',
                hasCities: true
            },
            {
                id: 3024,
                name: 'Mokhotlong District',
                state_code: 'J',
                hasCities: true
            },
            {
                id: 3025,
                name: "Qacha's Nek District",
                state_code: 'H',
                hasCities: true
            },
            {
                id: 3027,
                name: 'Quthing District',
                state_code: 'G',
                hasCities: true
            },
            {
                id: 3031,
                name: 'Thaba-Tseka District',
                state_code: 'K',
                hasCities: true
            }
        ]
    },
    {
        id: 123,
        states: [
            {
                id: 3041,
                name: 'Bomi County',
                state_code: 'BM',
                hasCities: true
            },
            {
                id: 3034,
                name: 'Bong County',
                state_code: 'BG',
                hasCities: true
            },
            {
                id: 3044,
                name: 'Gbarpolu County',
                state_code: 'GP',
                hasCities: true
            },
            {
                id: 3040,
                name: 'Grand Bassa County',
                state_code: 'GB',
                hasCities: true
            },
            {
                id: 3036,
                name: 'Grand Cape Mount County',
                state_code: 'CM',
                hasCities: true
            },
            {
                id: 3039,
                name: 'Grand Gedeh County',
                state_code: 'GG',
                hasCities: true
            },
            {
                id: 3045,
                name: 'Grand Kru County',
                state_code: 'GK',
                hasCities: true
            },
            {
                id: 3037,
                name: 'Lofa County',
                state_code: 'LO',
                hasCities: true
            },
            {
                id: 3043,
                name: 'Margibi County',
                state_code: 'MG',
                hasCities: true
            },
            {
                id: 3042,
                name: 'Maryland County',
                state_code: 'MY',
                hasCities: true
            },
            {
                id: 3032,
                name: 'Montserrado County',
                state_code: 'MO',
                hasCities: true
            },
            { id: 3046, name: 'Nimba', state_code: 'NI', hasCities: true },
            {
                id: 3033,
                name: 'River Cess County',
                state_code: 'RI',
                hasCities: true
            },
            {
                id: 3038,
                name: 'River Gee County',
                state_code: 'RG',
                hasCities: true
            },
            {
                id: 3035,
                name: 'Sinoe County',
                state_code: 'SI',
                hasCities: true
            }
        ]
    },
    {
        id: 124,
        states: [
            {
                id: 2964,
                name: 'Al Wahat District',
                state_code: 'WA',
                hasCities: true
            },
            { id: 2981, name: 'Benghazi', state_code: 'BA', hasCities: true },
            {
                id: 2966,
                name: 'Derna District',
                state_code: 'DR',
                hasCities: true
            },
            {
                id: 2969,
                name: 'Ghat District',
                state_code: 'GT',
                hasCities: true
            },
            {
                id: 2980,
                name: 'Jabal al Akhdar',
                state_code: 'JA',
                hasCities: true
            },
            {
                id: 2974,
                name: 'Jabal al Gharbi District',
                state_code: 'JG',
                hasCities: true
            },
            { id: 2979, name: 'Jafara', state_code: 'JI', hasCities: true },
            { id: 2970, name: 'Jufra', state_code: 'JU', hasCities: true },
            {
                id: 2972,
                name: 'Kufra District',
                state_code: 'KF',
                hasCities: true
            },
            {
                id: 2968,
                name: 'Marj District',
                state_code: 'MJ',
                hasCities: true
            },
            {
                id: 2978,
                name: 'Misrata District',
                state_code: 'MI',
                hasCities: true
            },
            { id: 2961, name: 'Murqub', state_code: 'MB', hasCities: true },
            {
                id: 2967,
                name: 'Murzuq District',
                state_code: 'MQ',
                hasCities: true
            },
            {
                id: 2976,
                name: 'Nalut District',
                state_code: 'NL',
                hasCities: true
            },
            {
                id: 2962,
                name: 'Nuqat al Khams',
                state_code: 'NQ',
                hasCities: true
            },
            {
                id: 2965,
                name: 'Sabha District',
                state_code: 'SB',
                hasCities: true
            },
            {
                id: 2977,
                name: 'Sirte District',
                state_code: 'SR',
                hasCities: true
            },
            {
                id: 2971,
                name: 'Tripoli District',
                state_code: 'TB',
                hasCities: true
            },
            {
                id: 2973,
                name: 'Wadi al Hayaa District',
                state_code: 'WD',
                hasCities: true
            },
            {
                id: 2975,
                name: 'Wadi al Shatii District',
                state_code: 'WS',
                hasCities: true
            },
            {
                id: 2963,
                name: 'Zawiya District',
                state_code: 'ZA',
                hasCities: true
            }
        ]
    },
    {
        id: 125,
        states: [
            { id: 458, name: 'Balzers', state_code: '01', hasCities: true },
            { id: 451, name: 'Eschen', state_code: '02', hasCities: true },
            { id: 457, name: 'Gamprin', state_code: '03', hasCities: true },
            { id: 455, name: 'Mauren', state_code: '04', hasCities: true },
            { id: 454, name: 'Planken', state_code: '05', hasCities: true },
            { id: 453, name: 'Ruggell', state_code: '06', hasCities: true },
            { id: 450, name: 'Schaan', state_code: '07', hasCities: true },
            {
                id: 449,
                name: 'Schellenberg',
                state_code: '08',
                hasCities: true
            },
            { id: 459, name: 'Triesen', state_code: '09', hasCities: true },
            {
                id: 456,
                name: 'Triesenberg',
                state_code: '10',
                hasCities: true
            },
            { id: 452, name: 'Vaduz', state_code: '11', hasCities: true }
        ]
    },
    {
        id: 126,
        states: [
            {
                id: 1561,
                name: 'Akmenė District Municipality',
                state_code: '01',
                hasCities: false
            },
            {
                id: 1605,
                name: 'Alytus City Municipality',
                state_code: '02',
                hasCities: true
            },
            {
                id: 1574,
                name: 'Alytus County',
                state_code: 'AL',
                hasCities: false
            },
            {
                id: 1599,
                name: 'Alytus District Municipality',
                state_code: '03',
                hasCities: false
            },
            {
                id: 1603,
                name: 'Birštonas Municipality',
                state_code: '05',
                hasCities: false
            },
            {
                id: 1566,
                name: 'Biržai District Municipality',
                state_code: '06',
                hasCities: false
            },
            {
                id: 1579,
                name: 'Druskininkai municipality',
                state_code: '07',
                hasCities: false
            },
            {
                id: 1559,
                name: 'Elektrėnai municipality',
                state_code: '08',
                hasCities: false
            },
            {
                id: 1562,
                name: 'Ignalina District Municipality',
                state_code: '09',
                hasCities: false
            },
            {
                id: 1567,
                name: 'Jonava District Municipality',
                state_code: '10',
                hasCities: false
            },
            {
                id: 1581,
                name: 'Joniškis District Municipality',
                state_code: '11',
                hasCities: false
            },
            {
                id: 1555,
                name: 'Jurbarkas District Municipality',
                state_code: '12',
                hasCities: false
            },
            {
                id: 1583,
                name: 'Kaišiadorys District Municipality',
                state_code: '13',
                hasCities: false
            },
            {
                id: 1591,
                name: 'Kalvarija municipality',
                state_code: '14',
                hasCities: false
            },
            {
                id: 1580,
                name: 'Kaunas City Municipality',
                state_code: '15',
                hasCities: true
            },
            {
                id: 1556,
                name: 'Kaunas County',
                state_code: 'KU',
                hasCities: false
            },
            {
                id: 1565,
                name: 'Kaunas District Municipality',
                state_code: '16',
                hasCities: false
            },
            {
                id: 1575,
                name: 'Kazlų Rūda municipality',
                state_code: '17',
                hasCities: false
            },
            {
                id: 1584,
                name: 'Kėdainiai District Municipality',
                state_code: '18',
                hasCities: false
            },
            {
                id: 1618,
                name: 'Kelmė District Municipality',
                state_code: '19',
                hasCities: false
            },
            {
                id: 1597,
                name: 'Klaipeda City Municipality',
                state_code: '20',
                hasCities: false
            },
            {
                id: 1600,
                name: 'Klaipėda County',
                state_code: 'KL',
                hasCities: false
            },
            {
                id: 1604,
                name: 'Klaipėda District Municipality',
                state_code: '21',
                hasCities: true
            },
            {
                id: 1571,
                name: 'Kretinga District Municipality',
                state_code: '22',
                hasCities: false
            },
            {
                id: 1585,
                name: 'Kupiškis District Municipality',
                state_code: '23',
                hasCities: false
            },
            {
                id: 1611,
                name: 'Lazdijai District Municipality',
                state_code: '24',
                hasCities: false
            },
            {
                id: 1570,
                name: 'Marijampolė County',
                state_code: 'MR',
                hasCities: false
            },
            {
                id: 1610,
                name: 'Marijampolė Municipality',
                state_code: '25',
                hasCities: true
            },
            {
                id: 1557,
                name: 'Mažeikiai District Municipality',
                state_code: '26',
                hasCities: false
            },
            {
                id: 1582,
                name: 'Molėtai District Municipality',
                state_code: '27',
                hasCities: false
            },
            {
                id: 1563,
                name: 'Neringa Municipality',
                state_code: '28',
                hasCities: false
            },
            {
                id: 1612,
                name: 'Pagėgiai municipality',
                state_code: '29',
                hasCities: false
            },
            {
                id: 1595,
                name: 'Pakruojis District Municipality',
                state_code: '30',
                hasCities: false
            },
            {
                id: 1588,
                name: 'Palanga City Municipality',
                state_code: '31',
                hasCities: false
            },
            {
                id: 1589,
                name: 'Panevėžys City Municipality',
                state_code: '32',
                hasCities: false
            },
            {
                id: 1558,
                name: 'Panevėžys County',
                state_code: 'PN',
                hasCities: false
            },
            {
                id: 1614,
                name: 'Panevėžys District Municipality',
                state_code: '33',
                hasCities: true
            },
            {
                id: 1616,
                name: 'Pasvalys District Municipality',
                state_code: '34',
                hasCities: false
            },
            {
                id: 1553,
                name: 'Plungė District Municipality',
                state_code: '35',
                hasCities: false
            },
            {
                id: 1578,
                name: 'Prienai District Municipality',
                state_code: '36',
                hasCities: false
            },
            {
                id: 1568,
                name: 'Radviliškis District Municipality',
                state_code: '37',
                hasCities: false
            },
            {
                id: 1587,
                name: 'Raseiniai District Municipality',
                state_code: '38',
                hasCities: false
            },
            {
                id: 1590,
                name: 'Rietavas municipality',
                state_code: '39',
                hasCities: false
            },
            {
                id: 1615,
                name: 'Rokiškis District Municipality',
                state_code: '40',
                hasCities: false
            },
            {
                id: 1576,
                name: 'Šakiai District Municipality',
                state_code: '41',
                hasCities: false
            },
            {
                id: 1577,
                name: 'Šalčininkai District Municipality',
                state_code: '42',
                hasCities: false
            },
            {
                id: 1609,
                name: 'Šiauliai City Municipality',
                state_code: '43',
                hasCities: true
            },
            {
                id: 1586,
                name: 'Šiauliai County',
                state_code: 'SA',
                hasCities: false
            },
            {
                id: 1554,
                name: 'Šiauliai District Municipality',
                state_code: '44',
                hasCities: false
            },
            {
                id: 1613,
                name: 'Šilalė District Municipality',
                state_code: '45',
                hasCities: false
            },
            {
                id: 1607,
                name: 'Šilutė District Municipality',
                state_code: '46',
                hasCities: false
            },
            {
                id: 1594,
                name: 'Širvintos District Municipality',
                state_code: '47',
                hasCities: false
            },
            {
                id: 1617,
                name: 'Skuodas District Municipality',
                state_code: '48',
                hasCities: false
            },
            {
                id: 1560,
                name: 'Švenčionys District Municipality',
                state_code: '49',
                hasCities: false
            },
            {
                id: 1573,
                name: 'Tauragė County',
                state_code: 'TA',
                hasCities: true
            },
            {
                id: 1572,
                name: 'Tauragė District Municipality',
                state_code: '50',
                hasCities: false
            },
            {
                id: 1569,
                name: 'Telšiai County',
                state_code: 'TE',
                hasCities: false
            },
            {
                id: 1608,
                name: 'Telšiai District Municipality',
                state_code: '51',
                hasCities: true
            },
            {
                id: 1593,
                name: 'Trakai District Municipality',
                state_code: '52',
                hasCities: false
            },
            {
                id: 1596,
                name: 'Ukmergė District Municipality',
                state_code: '53',
                hasCities: false
            },
            {
                id: 1621,
                name: 'Utena County',
                state_code: 'UT',
                hasCities: true
            },
            {
                id: 1598,
                name: 'Utena District Municipality',
                state_code: '54',
                hasCities: false
            },
            {
                id: 1602,
                name: 'Varėna District Municipality',
                state_code: '55',
                hasCities: false
            },
            {
                id: 1620,
                name: 'Vilkaviškis District Municipality',
                state_code: '56',
                hasCities: false
            },
            {
                id: 1606,
                name: 'Vilnius City Municipality',
                state_code: '57',
                hasCities: true
            },
            {
                id: 1601,
                name: 'Vilnius County',
                state_code: 'VL',
                hasCities: false
            },
            {
                id: 1592,
                name: 'Vilnius District Municipality',
                state_code: '58',
                hasCities: false
            },
            {
                id: 1564,
                name: 'Visaginas Municipality',
                state_code: '59',
                hasCities: false
            },
            {
                id: 1619,
                name: 'Zarasai District Municipality',
                state_code: '60',
                hasCities: false
            }
        ]
    },
    {
        id: 127,
        states: [
            {
                id: 1518,
                name: 'Canton of Capellen',
                state_code: 'CA',
                hasCities: true
            },
            {
                id: 1521,
                name: 'Canton of Clervaux',
                state_code: 'CL',
                hasCities: true
            },
            {
                id: 1513,
                name: 'Canton of Diekirch',
                state_code: 'DI',
                hasCities: true
            },
            {
                id: 1515,
                name: 'Canton of Echternach',
                state_code: 'EC',
                hasCities: true
            },
            {
                id: 1517,
                name: 'Canton of Esch-sur-Alzette',
                state_code: 'ES',
                hasCities: true
            },
            {
                id: 1525,
                name: 'Canton of Grevenmacher',
                state_code: 'GR',
                hasCities: true
            },
            {
                id: 1527,
                name: 'Canton of Luxembourg',
                state_code: 'LU',
                hasCities: true
            },
            {
                id: 1522,
                name: 'Canton of Mersch',
                state_code: 'ME',
                hasCities: true
            },
            {
                id: 1516,
                name: 'Canton of Redange',
                state_code: 'RD',
                hasCities: true
            },
            {
                id: 1519,
                name: 'Canton of Remich',
                state_code: 'RM',
                hasCities: true
            },
            {
                id: 1523,
                name: 'Canton of Vianden',
                state_code: 'VD',
                hasCities: true
            },
            {
                id: 1526,
                name: 'Canton of Wiltz',
                state_code: 'WI',
                hasCities: true
            },
            {
                id: 1524,
                name: 'Diekirch District',
                state_code: 'D',
                hasCities: false
            },
            {
                id: 1520,
                name: 'Grevenmacher District',
                state_code: 'G',
                hasCities: false
            },
            {
                id: 1514,
                name: 'Luxembourg District',
                state_code: 'L',
                hasCities: false
            }
        ]
    },
    { id: 128, states: [] },
    {
        id: 129,
        states: [
            {
                id: 703,
                name: 'Aerodrom Municipality',
                state_code: '01',
                hasCities: false
            },
            {
                id: 656,
                name: 'Aračinovo Municipality',
                state_code: '02',
                hasCities: true
            },
            {
                id: 716,
                name: 'Berovo Municipality',
                state_code: '03',
                hasCities: true
            },
            {
                id: 679,
                name: 'Bitola Municipality',
                state_code: '04',
                hasCities: true
            },
            {
                id: 649,
                name: 'Bogdanci Municipality',
                state_code: '05',
                hasCities: true
            },
            {
                id: 721,
                name: 'Bogovinje Municipality',
                state_code: '06',
                hasCities: true
            },
            {
                id: 652,
                name: 'Bosilovo Municipality',
                state_code: '07',
                hasCities: true
            },
            {
                id: 660,
                name: 'Brvenica Municipality',
                state_code: '08',
                hasCities: true
            },
            {
                id: 694,
                name: 'Butel Municipality',
                state_code: '09',
                hasCities: true
            },
            {
                id: 704,
                name: 'Čair Municipality',
                state_code: '79',
                hasCities: true
            },
            {
                id: 676,
                name: 'Čaška Municipality',
                state_code: '80',
                hasCities: true
            },
            {
                id: 702,
                name: 'Centar Municipality',
                state_code: '77',
                hasCities: false
            },
            {
                id: 720,
                name: 'Centar Župa Municipality',
                state_code: '78',
                hasCities: true
            },
            {
                id: 644,
                name: 'Češinovo-Obleševo Municipality',
                state_code: '81',
                hasCities: true
            },
            {
                id: 715,
                name: 'Čučer-Sandevo Municipality',
                state_code: '82',
                hasCities: true
            },
            {
                id: 645,
                name: 'Debarca Municipality',
                state_code: '22',
                hasCities: true
            },
            {
                id: 695,
                name: 'Delčevo Municipality',
                state_code: '23',
                hasCities: true
            },
            {
                id: 687,
                name: 'Demir Hisar Municipality',
                state_code: '25',
                hasCities: true
            },
            {
                id: 655,
                name: 'Demir Kapija Municipality',
                state_code: '24',
                hasCities: true
            },
            {
                id: 697,
                name: 'Dojran Municipality',
                state_code: '26',
                hasCities: true
            },
            {
                id: 675,
                name: 'Dolneni Municipality',
                state_code: '27',
                hasCities: true
            },
            {
                id: 657,
                name: 'Drugovo Municipality',
                state_code: '28',
                hasCities: false
            },
            {
                id: 707,
                name: 'Gazi Baba Municipality',
                state_code: '17',
                hasCities: true
            },
            {
                id: 648,
                name: 'Gevgelija Municipality',
                state_code: '18',
                hasCities: true
            },
            {
                id: 722,
                name: 'Gjorče Petrov Municipality',
                state_code: '29',
                hasCities: true
            },
            {
                id: 693,
                name: 'Gostivar Municipality',
                state_code: '19',
                hasCities: true
            },
            {
                id: 708,
                name: 'Gradsko Municipality',
                state_code: '20',
                hasCities: true
            },
            {
                id: 684,
                name: 'Greater Skopje',
                state_code: '85',
                hasCities: true
            },
            {
                id: 690,
                name: 'Ilinden Municipality',
                state_code: '34',
                hasCities: true
            },
            {
                id: 678,
                name: 'Jegunovce Municipality',
                state_code: '35',
                hasCities: true
            },
            { id: 674, name: 'Karbinci', state_code: '37', hasCities: true },
            {
                id: 681,
                name: 'Karpoš Municipality',
                state_code: '38',
                hasCities: true
            },
            {
                id: 713,
                name: 'Kavadarci Municipality',
                state_code: '36',
                hasCities: true
            },
            {
                id: 688,
                name: 'Kičevo Municipality',
                state_code: '40',
                hasCities: true
            },
            {
                id: 686,
                name: 'Kisela Voda Municipality',
                state_code: '39',
                hasCities: true
            },
            {
                id: 723,
                name: 'Kočani Municipality',
                state_code: '42',
                hasCities: true
            },
            {
                id: 665,
                name: 'Konče Municipality',
                state_code: '41',
                hasCities: true
            },
            {
                id: 641,
                name: 'Kratovo Municipality',
                state_code: '43',
                hasCities: true
            },
            {
                id: 677,
                name: 'Kriva Palanka Municipality',
                state_code: '44',
                hasCities: true
            },
            {
                id: 647,
                name: 'Krivogaštani Municipality',
                state_code: '45',
                hasCities: true
            },
            {
                id: 714,
                name: 'Kruševo Municipality',
                state_code: '46',
                hasCities: true
            },
            {
                id: 683,
                name: 'Kumanovo Municipality',
                state_code: '47',
                hasCities: true
            },
            {
                id: 659,
                name: 'Lipkovo Municipality',
                state_code: '48',
                hasCities: true
            },
            {
                id: 705,
                name: 'Lozovo Municipality',
                state_code: '49',
                hasCities: true
            },
            {
                id: 701,
                name: 'Makedonska Kamenica Municipality',
                state_code: '51',
                hasCities: true
            },
            {
                id: 692,
                name: 'Makedonski Brod Municipality',
                state_code: '52',
                hasCities: true
            },
            {
                id: 669,
                name: 'Mavrovo and Rostuša Municipality',
                state_code: '50',
                hasCities: true
            },
            {
                id: 653,
                name: 'Mogila Municipality',
                state_code: '53',
                hasCities: true
            },
            {
                id: 664,
                name: 'Negotino Municipality',
                state_code: '54',
                hasCities: true
            },
            {
                id: 696,
                name: 'Novaci Municipality',
                state_code: '55',
                hasCities: true
            },
            {
                id: 718,
                name: 'Novo Selo Municipality',
                state_code: '56',
                hasCities: true
            },
            {
                id: 699,
                name: 'Ohrid Municipality',
                state_code: '58',
                hasCities: true
            },
            {
                id: 682,
                name: 'Oslomej Municipality',
                state_code: '57',
                hasCities: false
            },
            {
                id: 685,
                name: 'Pehčevo Municipality',
                state_code: '60',
                hasCities: true
            },
            {
                id: 698,
                name: 'Petrovec Municipality',
                state_code: '59',
                hasCities: true
            },
            {
                id: 670,
                name: 'Plasnica Municipality',
                state_code: '61',
                hasCities: true
            },
            {
                id: 666,
                name: 'Prilep Municipality',
                state_code: '62',
                hasCities: true
            },
            {
                id: 646,
                name: 'Probištip Municipality',
                state_code: '63',
                hasCities: true
            },
            {
                id: 709,
                name: 'Radoviš Municipality',
                state_code: '64',
                hasCities: true
            },
            {
                id: 717,
                name: 'Rankovce Municipality',
                state_code: '65',
                hasCities: true
            },
            {
                id: 712,
                name: 'Resen Municipality',
                state_code: '66',
                hasCities: true
            },
            {
                id: 691,
                name: 'Rosoman Municipality',
                state_code: '67',
                hasCities: true
            },
            {
                id: 667,
                name: 'Saraj Municipality',
                state_code: '68',
                hasCities: true
            },
            {
                id: 719,
                name: 'Sopište Municipality',
                state_code: '70',
                hasCities: true
            },
            {
                id: 643,
                name: 'Staro Nagoričane Municipality',
                state_code: '71',
                hasCities: true
            },
            {
                id: 661,
                name: 'Štip Municipality',
                state_code: '83',
                hasCities: true
            },
            {
                id: 700,
                name: 'Struga Municipality',
                state_code: '72',
                hasCities: true
            },
            {
                id: 710,
                name: 'Strumica Municipality',
                state_code: '73',
                hasCities: true
            },
            {
                id: 711,
                name: 'Studeničani Municipality',
                state_code: '74',
                hasCities: true
            },
            {
                id: 680,
                name: 'Šuto Orizari Municipality',
                state_code: '84',
                hasCities: true
            },
            {
                id: 640,
                name: 'Sveti Nikole Municipality',
                state_code: '69',
                hasCities: true
            },
            {
                id: 654,
                name: 'Tearce Municipality',
                state_code: '75',
                hasCities: true
            },
            {
                id: 663,
                name: 'Tetovo Municipality',
                state_code: '76',
                hasCities: true
            },
            {
                id: 671,
                name: 'Valandovo Municipality',
                state_code: '10',
                hasCities: true
            },
            {
                id: 658,
                name: 'Vasilevo Municipality',
                state_code: '11',
                hasCities: true
            },
            {
                id: 651,
                name: 'Veles Municipality',
                state_code: '13',
                hasCities: true
            },
            {
                id: 662,
                name: 'Vevčani Municipality',
                state_code: '12',
                hasCities: true
            },
            {
                id: 672,
                name: 'Vinica Municipality',
                state_code: '14',
                hasCities: true
            },
            {
                id: 650,
                name: 'Vraneštica Municipality',
                state_code: '15',
                hasCities: false
            },
            {
                id: 689,
                name: 'Vrapčište Municipality',
                state_code: '16',
                hasCities: true
            },
            {
                id: 642,
                name: 'Zajas Municipality',
                state_code: '31',
                hasCities: false
            },
            {
                id: 706,
                name: 'Zelenikovo Municipality',
                state_code: '32',
                hasCities: true
            },
            {
                id: 668,
                name: 'Želino Municipality',
                state_code: '30',
                hasCities: true
            },
            {
                id: 673,
                name: 'Zrnovci Municipality',
                state_code: '33',
                hasCities: true
            }
        ]
    },
    {
        id: 130,
        states: [
            {
                id: 2951,
                name: 'Antananarivo Province',
                state_code: 'T',
                hasCities: false
            },
            {
                id: 2950,
                name: 'Antsiranana Province',
                state_code: 'D',
                hasCities: true
            },
            {
                id: 2948,
                name: 'Fianarantsoa Province',
                state_code: 'F',
                hasCities: false
            },
            {
                id: 2953,
                name: 'Mahajanga Province',
                state_code: 'M',
                hasCities: false
            },
            {
                id: 2952,
                name: 'Toamasina Province',
                state_code: 'A',
                hasCities: false
            },
            {
                id: 2949,
                name: 'Toliara Province',
                state_code: 'U',
                hasCities: false
            }
        ]
    },
    {
        id: 131,
        states: [
            {
                id: 3096,
                name: 'Balaka District',
                state_code: 'BA',
                hasCities: false
            },
            {
                id: 3102,
                name: 'Blantyre District',
                state_code: 'BL',
                hasCities: false
            },
            {
                id: 3092,
                name: 'Central Region',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 3107,
                name: 'Chikwawa District',
                state_code: 'CK',
                hasCities: false
            },
            {
                id: 3109,
                name: 'Chiradzulu District',
                state_code: 'CR',
                hasCities: false
            },
            {
                id: 3087,
                name: 'Chitipa district',
                state_code: 'CT',
                hasCities: false
            },
            {
                id: 3097,
                name: 'Dedza District',
                state_code: 'DE',
                hasCities: false
            },
            {
                id: 3090,
                name: 'Dowa District',
                state_code: 'DO',
                hasCities: false
            },
            {
                id: 3091,
                name: 'Karonga District',
                state_code: 'KR',
                hasCities: false
            },
            {
                id: 3094,
                name: 'Kasungu District',
                state_code: 'KS',
                hasCities: false
            },
            {
                id: 3093,
                name: 'Likoma District',
                state_code: 'LK',
                hasCities: false
            },
            {
                id: 3101,
                name: 'Lilongwe District',
                state_code: 'LI',
                hasCities: false
            },
            {
                id: 3082,
                name: 'Machinga District',
                state_code: 'MH',
                hasCities: false
            },
            {
                id: 3110,
                name: 'Mangochi District',
                state_code: 'MG',
                hasCities: false
            },
            {
                id: 3099,
                name: 'Mchinji District',
                state_code: 'MC',
                hasCities: false
            },
            {
                id: 3103,
                name: 'Mulanje District',
                state_code: 'MU',
                hasCities: false
            },
            {
                id: 3084,
                name: 'Mwanza District',
                state_code: 'MW',
                hasCities: false
            },
            {
                id: 3104,
                name: 'Mzimba District',
                state_code: 'MZ',
                hasCities: false
            },
            {
                id: 3095,
                name: 'Nkhata Bay District',
                state_code: 'NB',
                hasCities: false
            },
            {
                id: 3100,
                name: 'Nkhotakota District',
                state_code: 'NK',
                hasCities: false
            },
            {
                id: 3105,
                name: 'Northern Region',
                state_code: 'N',
                hasCities: true
            },
            {
                id: 3085,
                name: 'Nsanje District',
                state_code: 'NS',
                hasCities: false
            },
            {
                id: 3088,
                name: 'Ntcheu District',
                state_code: 'NU',
                hasCities: false
            },
            {
                id: 3111,
                name: 'Ntchisi District',
                state_code: 'NI',
                hasCities: false
            },
            {
                id: 3108,
                name: 'Phalombe District',
                state_code: 'PH',
                hasCities: false
            },
            {
                id: 3089,
                name: 'Rumphi District',
                state_code: 'RU',
                hasCities: false
            },
            {
                id: 3086,
                name: 'Salima District',
                state_code: 'SA',
                hasCities: false
            },
            {
                id: 3106,
                name: 'Southern Region',
                state_code: 'S',
                hasCities: true
            },
            {
                id: 3098,
                name: 'Thyolo District',
                state_code: 'TH',
                hasCities: false
            },
            {
                id: 3083,
                name: 'Zomba District',
                state_code: 'ZO',
                hasCities: false
            }
        ]
    },
    {
        id: 132,
        states: [
            { id: 1950, name: 'Johor', state_code: '01', hasCities: true },
            { id: 1947, name: 'Kedah', state_code: '02', hasCities: true },
            { id: 1946, name: 'Kelantan', state_code: '03', hasCities: true },
            {
                id: 1949,
                name: 'Kuala Lumpur',
                state_code: '14',
                hasCities: true
            },
            { id: 1935, name: 'Labuan', state_code: '15', hasCities: true },
            { id: 1941, name: 'Malacca', state_code: '04', hasCities: true },
            {
                id: 1948,
                name: 'Negeri Sembilan',
                state_code: '05',
                hasCities: true
            },
            { id: 1940, name: 'Pahang', state_code: '06', hasCities: true },
            { id: 1939, name: 'Penang', state_code: '07', hasCities: true },
            { id: 1943, name: 'Perak', state_code: '08', hasCities: true },
            { id: 1938, name: 'Perlis', state_code: '09', hasCities: true },
            {
                id: 1945,
                name: 'Putrajaya',
                state_code: '16',
                hasCities: true
            },
            { id: 1936, name: 'Sabah', state_code: '12', hasCities: true },
            { id: 1937, name: 'Sarawak', state_code: '13', hasCities: true },
            { id: 1944, name: 'Selangor', state_code: '10', hasCities: true },
            {
                id: 1942,
                name: 'Terengganu',
                state_code: '11',
                hasCities: true
            }
        ]
    },
    {
        id: 133,
        states: [
            {
                id: 2594,
                name: 'Addu Atoll',
                state_code: '01',
                hasCities: true
            },
            {
                id: 2587,
                name: 'Alif Alif Atoll',
                state_code: '02',
                hasCities: false
            },
            {
                id: 2600,
                name: 'Alif Dhaal Atoll',
                state_code: '00',
                hasCities: false
            },
            {
                id: 2604,
                name: 'Central Province',
                state_code: 'CE',
                hasCities: false
            },
            {
                id: 2590,
                name: 'Dhaalu Atoll',
                state_code: '17',
                hasCities: true
            },
            {
                id: 2599,
                name: 'Faafu Atoll',
                state_code: '14',
                hasCities: false
            },
            {
                id: 2598,
                name: 'Gaafu Alif Atoll',
                state_code: '27',
                hasCities: true
            },
            {
                id: 2603,
                name: 'Gaafu Dhaalu Atoll',
                state_code: '28',
                hasCities: true
            },
            {
                id: 2595,
                name: 'Gnaviyani Atoll',
                state_code: '29',
                hasCities: true
            },
            {
                id: 2586,
                name: 'Haa Alif Atoll',
                state_code: '07',
                hasCities: true
            },
            {
                id: 2597,
                name: 'Haa Dhaalu Atoll',
                state_code: '23',
                hasCities: true
            },
            {
                id: 2596,
                name: 'Kaafu Atoll',
                state_code: '26',
                hasCities: true
            },
            {
                id: 2601,
                name: 'Laamu Atoll',
                state_code: '05',
                hasCities: true
            },
            {
                id: 2607,
                name: 'Lhaviyani Atoll',
                state_code: '03',
                hasCities: true
            },
            { id: 2609, name: 'Malé', state_code: 'MLE', hasCities: false },
            {
                id: 2608,
                name: 'Meemu Atoll',
                state_code: '12',
                hasCities: true
            },
            {
                id: 2592,
                name: 'Noonu Atoll',
                state_code: '25',
                hasCities: true
            },
            {
                id: 2589,
                name: 'North Central Province',
                state_code: 'NC',
                hasCities: false
            },
            {
                id: 2588,
                name: 'North Province',
                state_code: 'NO',
                hasCities: false
            },
            {
                id: 2602,
                name: 'Raa Atoll',
                state_code: '13',
                hasCities: true
            },
            {
                id: 2585,
                name: 'Shaviyani Atoll',
                state_code: '24',
                hasCities: true
            },
            {
                id: 2606,
                name: 'South Central Province',
                state_code: 'SC',
                hasCities: true
            },
            {
                id: 2605,
                name: 'South Province',
                state_code: 'SU',
                hasCities: false
            },
            {
                id: 2591,
                name: 'Thaa Atoll',
                state_code: '08',
                hasCities: true
            },
            {
                id: 2593,
                name: 'Upper South Province',
                state_code: 'US',
                hasCities: false
            },
            {
                id: 2584,
                name: 'Vaavu Atoll',
                state_code: '04',
                hasCities: true
            }
        ]
    },
    {
        id: 134,
        states: [
            { id: 253, name: 'Bamako', state_code: 'BKO', hasCities: true },
            { id: 258, name: 'Gao Region', state_code: '7', hasCities: true },
            {
                id: 252,
                name: 'Kayes Region',
                state_code: '1',
                hasCities: true
            },
            {
                id: 257,
                name: 'Kidal Region',
                state_code: '8',
                hasCities: true
            },
            {
                id: 250,
                name: 'Koulikoro Region',
                state_code: '2',
                hasCities: true
            },
            {
                id: 251,
                name: 'Ménaka Region',
                state_code: '9',
                hasCities: false
            },
            {
                id: 255,
                name: 'Mopti Region',
                state_code: '5',
                hasCities: true
            },
            {
                id: 249,
                name: 'Ségou Region',
                state_code: '4',
                hasCities: true
            },
            {
                id: 254,
                name: 'Sikasso Region',
                state_code: '3',
                hasCities: true
            },
            {
                id: 256,
                name: 'Taoudénit Region',
                state_code: '10',
                hasCities: false
            },
            {
                id: 248,
                name: 'Tombouctou Region',
                state_code: '6',
                hasCities: true
            }
        ]
    },
    {
        id: 135,
        states: [
            { id: 110, name: 'Attard', state_code: '01', hasCities: true },
            { id: 108, name: 'Balzan', state_code: '02', hasCities: true },
            { id: 107, name: 'Birgu', state_code: '03', hasCities: true },
            { id: 97, name: 'Birkirkara', state_code: '04', hasCities: true },
            { id: 88, name: 'Birżebbuġa', state_code: '05', hasCities: true },
            { id: 138, name: 'Cospicua', state_code: '06', hasCities: true },
            { id: 117, name: 'Dingli', state_code: '07', hasCities: true },
            { id: 129, name: 'Fgura', state_code: '08', hasCities: true },
            { id: 84, name: 'Floriana', state_code: '09', hasCities: true },
            { id: 134, name: 'Fontana', state_code: '10', hasCities: true },
            {
                id: 130,
                name: 'Għajnsielem',
                state_code: '13',
                hasCities: true
            },
            { id: 92, name: 'Għarb', state_code: '14', hasCities: false },
            { id: 120, name: 'Għargħur', state_code: '15', hasCities: true },
            { id: 106, name: 'Għasri', state_code: '16', hasCities: true },
            { id: 124, name: 'Għaxaq', state_code: '17', hasCities: true },
            { id: 118, name: 'Gudja', state_code: '11', hasCities: false },
            { id: 113, name: 'Gżira', state_code: '12', hasCities: true },
            { id: 105, name: 'Ħamrun', state_code: '18', hasCities: true },
            { id: 93, name: 'Iklin', state_code: '19', hasCities: true },
            { id: 99, name: 'Kalkara', state_code: '21', hasCities: true },
            { id: 91, name: 'Kerċem', state_code: '22', hasCities: true },
            { id: 82, name: 'Kirkop', state_code: '23', hasCities: true },
            { id: 126, name: 'Lija', state_code: '24', hasCities: true },
            { id: 77, name: 'Luqa', state_code: '25', hasCities: true },
            { id: 128, name: 'Marsa', state_code: '26', hasCities: true },
            {
                id: 137,
                name: 'Marsaskala',
                state_code: '27',
                hasCities: true
            },
            { id: 78, name: 'Marsaxlokk', state_code: '28', hasCities: true },
            { id: 89, name: 'Mdina', state_code: '29', hasCities: false },
            { id: 102, name: 'Mellieħa', state_code: '30', hasCities: false },
            { id: 109, name: 'Mġarr', state_code: '31', hasCities: true },
            { id: 140, name: 'Mosta', state_code: '32', hasCities: false },
            { id: 74, name: 'Mqabba', state_code: '33', hasCities: false },
            { id: 96, name: 'Msida', state_code: '34', hasCities: true },
            { id: 131, name: 'Mtarfa', state_code: '35', hasCities: false },
            { id: 132, name: 'Munxar', state_code: '36', hasCities: true },
            { id: 133, name: 'Nadur', state_code: '37', hasCities: true },
            { id: 112, name: 'Naxxar', state_code: '38', hasCities: true },
            { id: 115, name: 'Paola', state_code: '39', hasCities: true },
            { id: 125, name: 'Pembroke', state_code: '40', hasCities: true },
            { id: 127, name: 'Pietà', state_code: '41', hasCities: true },
            { id: 79, name: 'Qala', state_code: '42', hasCities: true },
            { id: 119, name: 'Qormi', state_code: '43', hasCities: true },
            { id: 111, name: 'Qrendi', state_code: '44', hasCities: true },
            { id: 83, name: 'Rabat', state_code: '46', hasCities: false },
            {
                id: 87,
                name: 'Saint Lawrence',
                state_code: '50',
                hasCities: true
            },
            { id: 75, name: 'San Ġwann', state_code: '49', hasCities: true },
            { id: 116, name: 'Sannat', state_code: '52', hasCities: true },
            {
                id: 94,
                name: 'Santa Luċija',
                state_code: '53',
                hasCities: true
            },
            {
                id: 90,
                name: 'Santa Venera',
                state_code: '54',
                hasCities: false
            },
            { id: 136, name: 'Senglea', state_code: '20', hasCities: true },
            { id: 98, name: 'Siġġiewi', state_code: '55', hasCities: true },
            { id: 104, name: 'Sliema', state_code: '56', hasCities: true },
            {
                id: 100,
                name: "St. Julian's",
                state_code: '48',
                hasCities: true
            },
            {
                id: 139,
                name: "St. Paul's Bay",
                state_code: '51',
                hasCities: true
            },
            { id: 86, name: 'Swieqi', state_code: '57', hasCities: true },
            { id: 122, name: "Ta' Xbiex", state_code: '58', hasCities: true },
            { id: 103, name: 'Tarxien', state_code: '59', hasCities: true },
            { id: 95, name: 'Valletta', state_code: '60', hasCities: true },
            { id: 101, name: 'Victoria', state_code: '45', hasCities: true },
            { id: 114, name: 'Xagħra', state_code: '61', hasCities: true },
            { id: 121, name: 'Xewkija', state_code: '62', hasCities: true },
            { id: 81, name: 'Xgħajra', state_code: '63', hasCities: true },
            { id: 123, name: 'Żabbar', state_code: '64', hasCities: true },
            {
                id: 85,
                name: 'Żebbuġ Gozo',
                state_code: '65',
                hasCities: true
            },
            {
                id: 80,
                name: 'Żebbuġ Malta',
                state_code: '66',
                hasCities: true
            },
            { id: 135, name: 'Żejtun', state_code: '67', hasCities: true },
            { id: 76, name: 'Żurrieq', state_code: '68', hasCities: true }
        ]
    },
    { id: 136, states: [] },
    {
        id: 137,
        states: [
            {
                id: 2574,
                name: 'Ralik Chain',
                state_code: 'L',
                hasCities: false
            },
            {
                id: 2573,
                name: 'Ratak Chain',
                state_code: 'T',
                hasCities: false
            }
        ]
    },
    { id: 138, states: [] },
    {
        id: 139,
        states: [
            { id: 3344, name: 'Adrar', state_code: '07', hasCities: true },
            { id: 3349, name: 'Assaba', state_code: '03', hasCities: true },
            { id: 3339, name: 'Brakna', state_code: '05', hasCities: true },
            {
                id: 3346,
                name: 'Dakhlet Nouadhibou',
                state_code: '08',
                hasCities: true
            },
            { id: 3341, name: 'Gorgol', state_code: '04', hasCities: true },
            {
                id: 3350,
                name: 'Guidimaka',
                state_code: '10',
                hasCities: true
            },
            {
                id: 3338,
                name: 'Hodh Ech Chargui',
                state_code: '01',
                hasCities: true
            },
            {
                id: 3351,
                name: 'Hodh El Gharbi',
                state_code: '02',
                hasCities: true
            },
            { id: 3342, name: 'Inchiri', state_code: '12', hasCities: true },
            {
                id: 3343,
                name: 'Nouakchott-Nord',
                state_code: '14',
                hasCities: true
            },
            {
                id: 3352,
                name: 'Nouakchott-Ouest',
                state_code: '13',
                hasCities: true
            },
            {
                id: 3347,
                name: 'Nouakchott-Sud',
                state_code: '15',
                hasCities: true
            },
            { id: 3345, name: 'Tagant', state_code: '09', hasCities: false },
            {
                id: 3340,
                name: 'Tiris Zemmour',
                state_code: '11',
                hasCities: true
            },
            { id: 3348, name: 'Trarza', state_code: '06', hasCities: true }
        ]
    },
    {
        id: 140,
        states: [
            {
                id: 3248,
                name: 'Agalega Islands',
                state_code: 'AG',
                hasCities: true
            },
            {
                id: 3259,
                name: 'Black River',
                state_code: 'BL',
                hasCities: true
            },
            { id: 3254, name: 'Flacq', state_code: 'FL', hasCities: true },
            {
                id: 3264,
                name: 'Grand Port',
                state_code: 'GP',
                hasCities: true
            },
            { id: 3253, name: 'Moka', state_code: 'MO', hasCities: true },
            {
                id: 3250,
                name: 'Pamplemousses',
                state_code: 'PA',
                hasCities: true
            },
            {
                id: 3263,
                name: 'Plaines Wilhems',
                state_code: 'PW',
                hasCities: true
            },
            {
                id: 3260,
                name: 'Port Louis',
                state_code: 'PL',
                hasCities: true
            },
            {
                id: 3261,
                name: 'Rivière du Rempart',
                state_code: 'RR',
                hasCities: true
            },
            {
                id: 3249,
                name: 'Rodrigues Island',
                state_code: 'RO',
                hasCities: true
            },
            {
                id: 3251,
                name: 'Saint Brandon Islands',
                state_code: 'CC',
                hasCities: true
            },
            { id: 3257, name: 'Savanne', state_code: 'SA', hasCities: true }
        ]
    },
    { id: 141, states: [] },
    {
        id: 142,
        states: [
            {
                id: 3456,
                name: 'Aguascalientes',
                state_code: 'AGU',
                hasCities: true
            },
            {
                id: 3457,
                name: 'Baja California',
                state_code: 'BCN',
                hasCities: true
            },
            {
                id: 3460,
                name: 'Baja California Sur',
                state_code: 'BCS',
                hasCities: true
            },
            {
                id: 3475,
                name: 'Campeche',
                state_code: 'CAM',
                hasCities: true
            },
            { id: 3451, name: 'Chiapas', state_code: 'CHP', hasCities: true },
            {
                id: 3447,
                name: 'Chihuahua',
                state_code: 'CHH',
                hasCities: true
            },
            {
                id: 3473,
                name: 'Ciudad de México',
                state_code: 'CDMX',
                hasCities: true
            },
            {
                id: 3471,
                name: 'Coahuila de Zaragoza',
                state_code: 'COA',
                hasCities: true
            },
            { id: 3472, name: 'Colima', state_code: 'COL', hasCities: true },
            { id: 3453, name: 'Durango', state_code: 'DUR', hasCities: true },
            {
                id: 3450,
                name: 'Estado de México',
                state_code: 'MEX',
                hasCities: true
            },
            {
                id: 3469,
                name: 'Guanajuato',
                state_code: 'GUA',
                hasCities: true
            },
            {
                id: 3459,
                name: 'Guerrero',
                state_code: 'GRO',
                hasCities: true
            },
            { id: 3470, name: 'Hidalgo', state_code: 'HID', hasCities: true },
            { id: 4857, name: 'Jalisco', state_code: 'JAL', hasCities: true },
            {
                id: 3474,
                name: 'Michoacán de Ocampo',
                state_code: 'MIC',
                hasCities: true
            },
            { id: 3465, name: 'Morelos', state_code: 'MOR', hasCities: true },
            { id: 3477, name: 'Nayarit', state_code: 'NAY', hasCities: true },
            {
                id: 3452,
                name: 'Nuevo León',
                state_code: 'NLE',
                hasCities: true
            },
            { id: 3448, name: 'Oaxaca', state_code: 'OAX', hasCities: true },
            { id: 3476, name: 'Puebla', state_code: 'PUE', hasCities: true },
            {
                id: 3455,
                name: 'Querétaro',
                state_code: 'QUE',
                hasCities: true
            },
            {
                id: 3467,
                name: 'Quintana Roo',
                state_code: 'ROO',
                hasCities: true
            },
            {
                id: 3461,
                name: 'San Luis Potosí',
                state_code: 'SLP',
                hasCities: true
            },
            { id: 3449, name: 'Sinaloa', state_code: 'SIN', hasCities: true },
            { id: 3468, name: 'Sonora', state_code: 'SON', hasCities: true },
            { id: 3454, name: 'Tabasco', state_code: 'TAB', hasCities: true },
            {
                id: 3463,
                name: 'Tamaulipas',
                state_code: 'TAM',
                hasCities: true
            },
            {
                id: 3458,
                name: 'Tlaxcala',
                state_code: 'TLA',
                hasCities: true
            },
            {
                id: 3464,
                name: 'Veracruz de Ignacio de la Llave',
                state_code: 'VER',
                hasCities: true
            },
            { id: 3466, name: 'Yucatán', state_code: 'YUC', hasCities: true },
            {
                id: 3462,
                name: 'Zacatecas',
                state_code: 'ZAC',
                hasCities: true
            }
        ]
    },
    {
        id: 143,
        states: [
            {
                id: 2580,
                name: 'Chuuk State',
                state_code: 'TRK',
                hasCities: true
            },
            {
                id: 2583,
                name: 'Kosrae State',
                state_code: 'KSA',
                hasCities: true
            },
            {
                id: 2581,
                name: 'Pohnpei State',
                state_code: 'PNI',
                hasCities: true
            },
            {
                id: 2582,
                name: 'Yap State',
                state_code: 'YAP',
                hasCities: true
            }
        ]
    },
    {
        id: 144,
        states: [
            {
                id: 4368,
                name: 'Anenii Noi District',
                state_code: 'AN',
                hasCities: true
            },
            {
                id: 4393,
                name: 'Bălți Municipality',
                state_code: 'BA',
                hasCities: true
            },
            {
                id: 4379,
                name: 'Basarabeasca District',
                state_code: 'BS',
                hasCities: true
            },
            {
                id: 4362,
                name: 'Bender Municipality',
                state_code: 'BD',
                hasCities: true
            },
            {
                id: 4375,
                name: 'Briceni District',
                state_code: 'BR',
                hasCities: true
            },
            {
                id: 4391,
                name: 'Cahul District',
                state_code: 'CA',
                hasCities: true
            },
            {
                id: 4366,
                name: 'Călărași District',
                state_code: 'CL',
                hasCities: true
            },
            {
                id: 4380,
                name: 'Cantemir District',
                state_code: 'CT',
                hasCities: true
            },
            {
                id: 4365,
                name: 'Căușeni District',
                state_code: 'CS',
                hasCities: true
            },
            {
                id: 4373,
                name: 'Chișinău Municipality',
                state_code: 'CU',
                hasCities: true
            },
            {
                id: 4360,
                name: 'Cimișlia District',
                state_code: 'CM',
                hasCities: true
            },
            {
                id: 4390,
                name: 'Criuleni District',
                state_code: 'CR',
                hasCities: true
            },
            {
                id: 4384,
                name: 'Dondușeni District',
                state_code: 'DO',
                hasCities: true
            },
            {
                id: 4392,
                name: 'Drochia District',
                state_code: 'DR',
                hasCities: true
            },
            {
                id: 4383,
                name: 'Dubăsari District',
                state_code: 'DU',
                hasCities: true
            },
            {
                id: 4387,
                name: 'Edineț District',
                state_code: 'ED',
                hasCities: true
            },
            {
                id: 4381,
                name: 'Fălești District',
                state_code: 'FA',
                hasCities: true
            },
            {
                id: 4370,
                name: 'Florești District',
                state_code: 'FL',
                hasCities: true
            },
            { id: 4385, name: 'Gagauzia', state_code: 'GA', hasCities: true },
            {
                id: 4367,
                name: 'Glodeni District',
                state_code: 'GL',
                hasCities: true
            },
            {
                id: 4382,
                name: 'Hîncești District',
                state_code: 'HI',
                hasCities: true
            },
            {
                id: 4369,
                name: 'Ialoveni District',
                state_code: 'IA',
                hasCities: true
            },
            {
                id: 4363,
                name: 'Nisporeni District',
                state_code: 'NI',
                hasCities: true
            },
            {
                id: 4389,
                name: 'Ocnița District',
                state_code: 'OC',
                hasCities: true
            },
            {
                id: 4361,
                name: 'Orhei District',
                state_code: 'OR',
                hasCities: true
            },
            {
                id: 4394,
                name: 'Rezina District',
                state_code: 'RE',
                hasCities: true
            },
            {
                id: 4376,
                name: 'Rîșcani District',
                state_code: 'RI',
                hasCities: true
            },
            {
                id: 4364,
                name: 'Sîngerei District',
                state_code: 'SI',
                hasCities: true
            },
            {
                id: 4388,
                name: 'Șoldănești District',
                state_code: 'SD',
                hasCities: true
            },
            {
                id: 4374,
                name: 'Soroca District',
                state_code: 'SO',
                hasCities: true
            },
            {
                id: 4378,
                name: 'Ștefan Vodă District',
                state_code: 'SV',
                hasCities: true
            },
            {
                id: 4377,
                name: 'Strășeni District',
                state_code: 'ST',
                hasCities: true
            },
            {
                id: 4372,
                name: 'Taraclia District',
                state_code: 'TA',
                hasCities: true
            },
            {
                id: 4371,
                name: 'Telenești District',
                state_code: 'TE',
                hasCities: true
            },
            {
                id: 4395,
                name: 'Transnistria autonomous territorial unit',
                state_code: 'SN',
                hasCities: true
            },
            {
                id: 4386,
                name: 'Ungheni District',
                state_code: 'UN',
                hasCities: true
            }
        ]
    },
    {
        id: 145,
        states: [
            {
                id: 4917,
                name: 'La Colle',
                state_code: 'CL',
                hasCities: false
            },
            {
                id: 4918,
                name: 'La Condamine',
                state_code: 'CO',
                hasCities: false
            },
            {
                id: 4919,
                name: 'Moneghetti',
                state_code: 'MG',
                hasCities: false
            }
        ]
    },
    {
        id: 146,
        states: [
            {
                id: 1973,
                name: 'Arkhangai Province',
                state_code: '073',
                hasCities: true
            },
            {
                id: 1969,
                name: 'Bayan-Ölgii Province',
                state_code: '071',
                hasCities: true
            },
            {
                id: 1976,
                name: 'Bayankhongor Province',
                state_code: '069',
                hasCities: true
            },
            {
                id: 1961,
                name: 'Bulgan Province',
                state_code: '067',
                hasCities: true
            },
            {
                id: 1962,
                name: 'Darkhan-Uul Province',
                state_code: '037',
                hasCities: true
            },
            {
                id: 1963,
                name: 'Dornod Province',
                state_code: '061',
                hasCities: true
            },
            {
                id: 1981,
                name: 'Dornogovi Province',
                state_code: '063',
                hasCities: false
            },
            {
                id: 1970,
                name: 'Dundgovi Province',
                state_code: '059',
                hasCities: true
            },
            {
                id: 1972,
                name: 'Govi-Altai Province',
                state_code: '065',
                hasCities: true
            },
            {
                id: 1978,
                name: 'Govisümber Province',
                state_code: '064',
                hasCities: true
            },
            {
                id: 1974,
                name: 'Khentii Province',
                state_code: '039',
                hasCities: true
            },
            {
                id: 1964,
                name: 'Khovd Province',
                state_code: '043',
                hasCities: true
            },
            {
                id: 1975,
                name: 'Khövsgöl Province',
                state_code: '041',
                hasCities: true
            },
            {
                id: 1967,
                name: 'Ömnögovi Province',
                state_code: '053',
                hasCities: true
            },
            {
                id: 1966,
                name: 'Orkhon Province',
                state_code: '035',
                hasCities: true
            },
            {
                id: 1965,
                name: 'Övörkhangai Province',
                state_code: '055',
                hasCities: true
            },
            {
                id: 1980,
                name: 'Selenge Province',
                state_code: '049',
                hasCities: true
            },
            {
                id: 1977,
                name: 'Sükhbaatar Province',
                state_code: '051',
                hasCities: true
            },
            {
                id: 1968,
                name: 'Töv Province',
                state_code: '047',
                hasCities: true
            },
            {
                id: 1971,
                name: 'Uvs Province',
                state_code: '046',
                hasCities: true
            },
            {
                id: 1979,
                name: 'Zavkhan Province',
                state_code: '057',
                hasCities: true
            }
        ]
    },
    {
        id: 147,
        states: [
            {
                id: 23,
                name: 'Andrijevica Municipality',
                state_code: '01',
                hasCities: true
            },
            {
                id: 13,
                name: 'Bar Municipality',
                state_code: '02',
                hasCities: true
            },
            {
                id: 21,
                name: 'Berane Municipality',
                state_code: '03',
                hasCities: true
            },
            {
                id: 25,
                name: 'Bijelo Polje Municipality',
                state_code: '04',
                hasCities: true
            },
            {
                id: 30,
                name: 'Budva Municipality',
                state_code: '05',
                hasCities: true
            },
            {
                id: 14,
                name: 'Danilovgrad Municipality',
                state_code: '07',
                hasCities: true
            },
            {
                id: 24,
                name: 'Gusinje Municipality',
                state_code: '22',
                hasCities: true
            },
            {
                id: 31,
                name: 'Kolašin Municipality',
                state_code: '09',
                hasCities: true
            },
            {
                id: 26,
                name: 'Kotor Municipality',
                state_code: '10',
                hasCities: true
            },
            {
                id: 22,
                name: 'Mojkovac Municipality',
                state_code: '11',
                hasCities: true
            },
            {
                id: 17,
                name: 'Nikšić Municipality',
                state_code: '12',
                hasCities: true
            },
            {
                id: 28,
                name: 'Old Royal Capital Cetinje',
                state_code: '06',
                hasCities: true
            },
            {
                id: 12,
                name: 'Petnjica Municipality',
                state_code: '23',
                hasCities: false
            },
            {
                id: 19,
                name: 'Plav Municipality',
                state_code: '13',
                hasCities: true
            },
            {
                id: 20,
                name: 'Pljevlja Municipality',
                state_code: '14',
                hasCities: true
            },
            {
                id: 16,
                name: 'Plužine Municipality',
                state_code: '15',
                hasCities: true
            },
            {
                id: 27,
                name: 'Podgorica Municipality',
                state_code: '16',
                hasCities: true
            },
            {
                id: 15,
                name: 'Rožaje Municipality',
                state_code: '17',
                hasCities: true
            },
            {
                id: 18,
                name: 'Šavnik Municipality',
                state_code: '18',
                hasCities: true
            },
            {
                id: 29,
                name: 'Tivat Municipality',
                state_code: '19',
                hasCities: true
            },
            {
                id: 33,
                name: 'Ulcinj Municipality',
                state_code: '20',
                hasCities: true
            },
            {
                id: 32,
                name: 'Žabljak Municipality',
                state_code: '21',
                hasCities: true
            }
        ]
    },
    { id: 148, states: [] },
    {
        id: 149,
        states: [
            {
                id: 4928,
                name: 'Agadir-Ida-Ou-Tanane',
                state_code: 'AGD',
                hasCities: false
            },
            {
                id: 3320,
                name: 'Al Haouz',
                state_code: 'HAO',
                hasCities: false
            },
            {
                id: 3267,
                name: 'Al Hoceïma',
                state_code: 'HOC',
                hasCities: false
            },
            {
                id: 3266,
                name: 'Aousserd (EH)',
                state_code: 'AOU',
                hasCities: false
            },
            {
                id: 3297,
                name: 'Assa-Zag (EH-partial)',
                state_code: 'ASZ',
                hasCities: true
            },
            { id: 3321, name: 'Azilal', state_code: 'AZI', hasCities: false },
            {
                id: 3272,
                name: 'Béni Mellal',
                state_code: 'BEM',
                hasCities: false
            },
            {
                id: 3278,
                name: 'Béni Mellal-Khénifra',
                state_code: '05',
                hasCities: false
            },
            {
                id: 3304,
                name: 'Benslimane',
                state_code: 'BES',
                hasCities: false
            },
            {
                id: 3285,
                name: 'Berkane',
                state_code: 'BER',
                hasCities: false
            },
            {
                id: 4929,
                name: 'Berrechid',
                state_code: 'BRR',
                hasCities: false
            },
            {
                id: 3275,
                name: 'Boujdour (EH)',
                state_code: 'BOD',
                hasCities: false
            },
            {
                id: 3270,
                name: 'Boulemane',
                state_code: 'BOM',
                hasCities: false
            },
            {
                id: 4930,
                name: 'Casablanca',
                state_code: 'CAS',
                hasCities: false
            },
            {
                id: 3303,
                name: 'Casablanca-Settat',
                state_code: '06',
                hasCities: true
            },
            {
                id: 3310,
                name: 'Chefchaouen',
                state_code: 'CHE',
                hasCities: false
            },
            {
                id: 3274,
                name: 'Chichaoua',
                state_code: 'CHI',
                hasCities: false
            },
            {
                id: 3302,
                name: 'Chtouka-Ait Baha',
                state_code: 'CHT',
                hasCities: false
            },
            {
                id: 3306,
                name: 'Dakhla-Oued Ed-Dahab (EH)',
                state_code: '12',
                hasCities: false
            },
            {
                id: 3290,
                name: 'Drâa-Tafilalet',
                state_code: '08',
                hasCities: true
            },
            {
                id: 4931,
                name: 'Driouch',
                state_code: 'DRI',
                hasCities: false
            },
            {
                id: 3291,
                name: 'El Hajeb',
                state_code: 'HAJ',
                hasCities: false
            },
            {
                id: 3280,
                name: 'El Jadida',
                state_code: 'JDI',
                hasCities: false
            },
            {
                id: 3309,
                name: 'El Kelâa des Sraghna',
                state_code: 'KES',
                hasCities: false
            },
            {
                id: 3299,
                name: 'Errachidia',
                state_code: 'ERR',
                hasCities: false
            },
            {
                id: 3292,
                name: 'Es-Semara (EH-partial)',
                state_code: 'ESM',
                hasCities: false
            },
            {
                id: 3316,
                name: 'Essaouira',
                state_code: 'ESI',
                hasCities: false
            },
            {
                id: 3300,
                name: 'Fahs-Anjra',
                state_code: 'FAH',
                hasCities: false
            },
            { id: 4932, name: 'Fès', state_code: 'FES', hasCities: false },
            {
                id: 3313,
                name: 'Fès-Meknès',
                state_code: '03',
                hasCities: true
            },
            { id: 3301, name: 'Figuig', state_code: 'FIG', hasCities: false },
            {
                id: 4933,
                name: 'Fquih Ben Salah',
                state_code: 'FQH',
                hasCities: false
            },
            {
                id: 3265,
                name: 'Guelmim',
                state_code: 'GUE',
                hasCities: false
            },
            {
                id: 3305,
                name: 'Guelmim-Oued Noun (EH-partial)',
                state_code: '10',
                hasCities: true
            },
            {
                id: 4934,
                name: 'Guercif',
                state_code: 'GUF',
                hasCities: false
            },
            { id: 3325, name: 'Ifrane', state_code: 'IFR', hasCities: false },
            {
                id: 3294,
                name: 'Inezgane-Ait Melloul',
                state_code: 'INE',
                hasCities: false
            },
            { id: 3307, name: 'Jerada', state_code: 'JRA', hasCities: false },
            { id: 3308, name: 'Kénitra', state_code: 'KEN', hasCities: true },
            {
                id: 3276,
                name: 'Khémisset',
                state_code: 'KHE',
                hasCities: false
            },
            {
                id: 3317,
                name: 'Khénifra',
                state_code: 'KHN',
                hasCities: true
            },
            {
                id: 3326,
                name: 'Khouribga',
                state_code: 'KHO',
                hasCities: false
            },
            {
                id: 3271,
                name: "L'Oriental",
                state_code: '02',
                hasCities: true
            },
            {
                id: 3293,
                name: 'Laâyoune (EH)',
                state_code: 'LAA',
                hasCities: false
            },
            {
                id: 3298,
                name: 'Laâyoune-Sakia El Hamra (EH-partial)',
                state_code: '11',
                hasCities: true
            },
            {
                id: 3268,
                name: 'Larache',
                state_code: 'LAR',
                hasCities: false
            },
            {
                id: 4936,
                name: 'M’diq-Fnideq',
                state_code: 'MDF',
                hasCities: false
            },
            {
                id: 4935,
                name: 'Marrakech',
                state_code: 'MAR',
                hasCities: false
            },
            {
                id: 3288,
                name: 'Marrakesh-Safi',
                state_code: '07',
                hasCities: false
            },
            {
                id: 3284,
                name: 'Médiouna',
                state_code: 'MED',
                hasCities: false
            },
            { id: 4937, name: 'Meknès', state_code: 'MEK', hasCities: false },
            { id: 4938, name: 'Midelt', state_code: 'MID', hasCities: false },
            {
                id: 4939,
                name: 'Mohammadia',
                state_code: 'MOH',
                hasCities: false
            },
            {
                id: 3315,
                name: 'Moulay Yacoub',
                state_code: 'MOU',
                hasCities: false
            },
            { id: 3281, name: 'Nador', state_code: 'NAD', hasCities: false },
            {
                id: 3287,
                name: 'Nouaceur',
                state_code: 'NOU',
                hasCities: false
            },
            {
                id: 3269,
                name: 'Ouarzazate',
                state_code: 'OUA',
                hasCities: false
            },
            {
                id: 3319,
                name: 'Oued Ed-Dahab (EH)',
                state_code: 'OUD',
                hasCities: true
            },
            {
                id: 4941,
                name: 'Ouezzane',
                state_code: 'OUZ',
                hasCities: false
            },
            {
                id: 4940,
                name: 'Oujda-Angad',
                state_code: 'OUJ',
                hasCities: false
            },
            { id: 4942, name: 'Rabat', state_code: 'RAB', hasCities: false },
            {
                id: 4927,
                name: 'Rabat-Salé-Kénitra',
                state_code: '04',
                hasCities: false
            },
            {
                id: 4943,
                name: 'Rehamna',
                state_code: 'REH',
                hasCities: false
            },
            { id: 3311, name: 'Safi', state_code: 'SAF', hasCities: true },
            { id: 4944, name: 'Salé', state_code: 'SAL', hasCities: false },
            { id: 3289, name: 'Sefrou', state_code: 'SEF', hasCities: false },
            { id: 3282, name: 'Settat', state_code: 'SET', hasCities: false },
            {
                id: 4945,
                name: 'Sidi Bennour',
                state_code: 'SIB',
                hasCities: false
            },
            {
                id: 4946,
                name: 'Sidi Ifni',
                state_code: 'SIF',
                hasCities: false
            },
            {
                id: 3279,
                name: 'Sidi Kacem',
                state_code: 'SIK',
                hasCities: false
            },
            {
                id: 4952,
                name: 'Sidi Slimane',
                state_code: 'SIL',
                hasCities: false
            },
            {
                id: 4947,
                name: 'Skhirate-Témara',
                state_code: 'SKH',
                hasCities: false
            },
            {
                id: 3295,
                name: 'Souss-Massa',
                state_code: '09',
                hasCities: false
            },
            {
                id: 3286,
                name: 'Tan-Tan (EH-partial)',
                state_code: 'TNT',
                hasCities: false
            },
            {
                id: 4950,
                name: 'Tanger-Assilah',
                state_code: 'TNG',
                hasCities: false
            },
            {
                id: 3324,
                name: 'Tanger-Tétouan-Al Hoceïma',
                state_code: '01',
                hasCities: true
            },
            {
                id: 3323,
                name: 'Taounate',
                state_code: 'TAO',
                hasCities: false
            },
            {
                id: 3322,
                name: 'Taourirt',
                state_code: 'TAI',
                hasCities: false
            },
            {
                id: 4948,
                name: 'Tarfaya (EH-partial)',
                state_code: 'TAF',
                hasCities: false
            },
            {
                id: 3314,
                name: 'Taroudannt',
                state_code: 'TAR',
                hasCities: false
            },
            { id: 3312, name: 'Tata', state_code: 'TAT', hasCities: false },
            { id: 3296, name: 'Taza', state_code: 'TAZ', hasCities: false },
            {
                id: 3318,
                name: 'Tétouan',
                state_code: 'TET',
                hasCities: false
            },
            {
                id: 4949,
                name: 'Tinghir',
                state_code: 'TIN',
                hasCities: false
            },
            { id: 3277, name: 'Tiznit', state_code: 'TIZ', hasCities: false },
            {
                id: 4951,
                name: 'Youssoufia',
                state_code: 'YUS',
                hasCities: false
            },
            { id: 3283, name: 'Zagora', state_code: 'ZAG', hasCities: false }
        ]
    },
    {
        id: 150,
        states: [
            {
                id: 3327,
                name: 'Cabo Delgado Province',
                state_code: 'P',
                hasCities: true
            },
            {
                id: 3329,
                name: 'Gaza Province',
                state_code: 'G',
                hasCities: true
            },
            {
                id: 3330,
                name: 'Inhambane Province',
                state_code: 'I',
                hasCities: true
            },
            {
                id: 3337,
                name: 'Manica Province',
                state_code: 'B',
                hasCities: true
            },
            { id: 3335, name: 'Maputo', state_code: 'MPM', hasCities: true },
            {
                id: 3332,
                name: 'Maputo Province',
                state_code: 'L',
                hasCities: true
            },
            {
                id: 3336,
                name: 'Nampula Province',
                state_code: 'N',
                hasCities: true
            },
            {
                id: 3333,
                name: 'Niassa Province',
                state_code: 'A',
                hasCities: true
            },
            {
                id: 3331,
                name: 'Sofala Province',
                state_code: 'S',
                hasCities: true
            },
            {
                id: 3334,
                name: 'Tete Province',
                state_code: 'T',
                hasCities: true
            },
            {
                id: 3328,
                name: 'Zambezia Province',
                state_code: 'Q',
                hasCities: true
            }
        ]
    },
    {
        id: 151,
        states: [
            {
                id: 2142,
                name: 'Ayeyarwady Region',
                state_code: '07',
                hasCities: true
            },
            { id: 2141, name: 'Bago', state_code: '02', hasCities: true },
            {
                id: 2137,
                name: 'Chin State',
                state_code: '14',
                hasCities: true
            },
            {
                id: 2143,
                name: 'Kachin State',
                state_code: '11',
                hasCities: true
            },
            {
                id: 2144,
                name: 'Kayah State',
                state_code: '12',
                hasCities: true
            },
            {
                id: 2133,
                name: 'Kayin State',
                state_code: '13',
                hasCities: true
            },
            {
                id: 2136,
                name: 'Magway Region',
                state_code: '03',
                hasCities: true
            },
            {
                id: 2134,
                name: 'Mandalay Region',
                state_code: '04',
                hasCities: true
            },
            {
                id: 2147,
                name: 'Mon State',
                state_code: '15',
                hasCities: true
            },
            {
                id: 2146,
                name: 'Naypyidaw Union Territory',
                state_code: '18',
                hasCities: true
            },
            {
                id: 2138,
                name: 'Rakhine State',
                state_code: '16',
                hasCities: true
            },
            {
                id: 2145,
                name: 'Sagaing Region',
                state_code: '01',
                hasCities: true
            },
            {
                id: 2139,
                name: 'Shan State',
                state_code: '17',
                hasCities: true
            },
            {
                id: 2140,
                name: 'Tanintharyi Region',
                state_code: '05',
                hasCities: true
            },
            {
                id: 2135,
                name: 'Yangon Region',
                state_code: '06',
                hasCities: true
            }
        ]
    },
    {
        id: 152,
        states: [
            {
                id: 43,
                name: 'Erongo Region',
                state_code: 'ER',
                hasCities: true
            },
            {
                id: 38,
                name: 'Hardap Region',
                state_code: 'HA',
                hasCities: true
            },
            {
                id: 45,
                name: 'Karas Region',
                state_code: 'KA',
                hasCities: true
            },
            {
                id: 36,
                name: 'Kavango East Region',
                state_code: 'KE',
                hasCities: true
            },
            {
                id: 35,
                name: 'Kavango West Region',
                state_code: 'KW',
                hasCities: false
            },
            {
                id: 44,
                name: 'Khomas Region',
                state_code: 'KH',
                hasCities: true
            },
            {
                id: 34,
                name: 'Kunene Region',
                state_code: 'KU',
                hasCities: true
            },
            {
                id: 40,
                name: 'Ohangwena Region',
                state_code: 'OW',
                hasCities: true
            },
            {
                id: 41,
                name: 'Omaheke Region',
                state_code: 'OH',
                hasCities: true
            },
            {
                id: 39,
                name: 'Omusati Region',
                state_code: 'OS',
                hasCities: true
            },
            {
                id: 37,
                name: 'Oshana Region',
                state_code: 'ON',
                hasCities: true
            },
            {
                id: 42,
                name: 'Oshikoto Region',
                state_code: 'OT',
                hasCities: true
            },
            {
                id: 46,
                name: 'Otjozondjupa Region',
                state_code: 'OD',
                hasCities: true
            },
            {
                id: 47,
                name: 'Zambezi Region',
                state_code: 'CA',
                hasCities: true
            }
        ]
    },
    {
        id: 153,
        states: [
            {
                id: 4656,
                name: 'Aiwo District',
                state_code: '01',
                hasCities: true
            },
            {
                id: 4658,
                name: 'Anabar District',
                state_code: '02',
                hasCities: true
            },
            {
                id: 4667,
                name: 'Anetan District',
                state_code: '03',
                hasCities: false
            },
            {
                id: 4663,
                name: 'Anibare District',
                state_code: '04',
                hasCities: false
            },
            {
                id: 4660,
                name: 'Baiti District',
                state_code: '05',
                hasCities: true
            },
            {
                id: 4665,
                name: 'Boe District',
                state_code: '06',
                hasCities: false
            },
            {
                id: 4662,
                name: 'Buada District',
                state_code: '07',
                hasCities: false
            },
            {
                id: 4666,
                name: 'Denigomodu District',
                state_code: '08',
                hasCities: false
            },
            {
                id: 4654,
                name: 'Ewa District',
                state_code: '09',
                hasCities: false
            },
            {
                id: 4661,
                name: 'Ijuw District',
                state_code: '10',
                hasCities: true
            },
            {
                id: 4657,
                name: 'Meneng District',
                state_code: '11',
                hasCities: true
            },
            {
                id: 4659,
                name: 'Nibok District',
                state_code: '12',
                hasCities: false
            },
            {
                id: 4655,
                name: 'Uaboe District',
                state_code: '13',
                hasCities: true
            },
            {
                id: 4664,
                name: 'Yaren District',
                state_code: '14',
                hasCities: true
            }
        ]
    },
    {
        id: 154,
        states: [
            {
                id: 2082,
                name: 'Bagmati Zone',
                state_code: 'BA',
                hasCities: false
            },
            {
                id: 2071,
                name: 'Bheri Zone',
                state_code: 'BH',
                hasCities: false
            },
            {
                id: 2073,
                name: 'Central Region',
                state_code: '1',
                hasCities: true
            },
            {
                id: 2080,
                name: 'Dhaulagiri Zone',
                state_code: 'DH',
                hasCities: false
            },
            {
                id: 2069,
                name: 'Eastern Development Region',
                state_code: '4',
                hasCities: true
            },
            {
                id: 2068,
                name: 'Far-Western Development Region',
                state_code: '5',
                hasCities: true
            },
            {
                id: 2081,
                name: 'Gandaki Zone',
                state_code: 'GA',
                hasCities: false
            },
            {
                id: 2076,
                name: 'Janakpur Zone',
                state_code: 'JA',
                hasCities: false
            },
            {
                id: 2079,
                name: 'Karnali Zone',
                state_code: 'KA',
                hasCities: false
            },
            {
                id: 2072,
                name: 'Kosi Zone',
                state_code: 'KO',
                hasCities: false
            },
            {
                id: 2074,
                name: 'Lumbini Zone',
                state_code: 'LU',
                hasCities: false
            },
            {
                id: 2083,
                name: 'Mahakali Zone',
                state_code: 'MA',
                hasCities: false
            },
            {
                id: 2070,
                name: 'Mechi Zone',
                state_code: 'ME',
                hasCities: false
            },
            {
                id: 2066,
                name: 'Mid-Western Region',
                state_code: '2',
                hasCities: true
            },
            {
                id: 2075,
                name: 'Narayani Zone',
                state_code: 'NA',
                hasCities: false
            },
            {
                id: 2077,
                name: 'Rapti Zone',
                state_code: 'RA',
                hasCities: false
            },
            {
                id: 2084,
                name: 'Sagarmatha Zone',
                state_code: 'SA',
                hasCities: false
            },
            {
                id: 2078,
                name: 'Seti Zone',
                state_code: 'SE',
                hasCities: false
            },
            {
                id: 2067,
                name: 'Western Region',
                state_code: '3',
                hasCities: true
            }
        ]
    },
    {
        id: 156,
        states: [
            { id: 2624, name: 'Bonaire', state_code: 'BQ1', hasCities: true },
            { id: 2613, name: 'Drenthe', state_code: 'DR', hasCities: true },
            {
                id: 2619,
                name: 'Flevoland',
                state_code: 'FL',
                hasCities: true
            },
            {
                id: 2622,
                name: 'Friesland',
                state_code: 'FR',
                hasCities: true
            },
            {
                id: 2611,
                name: 'Gelderland',
                state_code: 'GE',
                hasCities: true
            },
            {
                id: 2617,
                name: 'Groningen',
                state_code: 'GR',
                hasCities: true
            },
            { id: 2615, name: 'Limburg', state_code: 'LI', hasCities: true },
            {
                id: 2623,
                name: 'North Brabant',
                state_code: 'NB',
                hasCities: true
            },
            {
                id: 2612,
                name: 'North Holland',
                state_code: 'NH',
                hasCities: true
            },
            {
                id: 2618,
                name: 'Overijssel',
                state_code: 'OV',
                hasCities: true
            },
            { id: 2621, name: 'Saba', state_code: 'BQ2', hasCities: false },
            {
                id: 2616,
                name: 'Sint Eustatius',
                state_code: 'BQ3',
                hasCities: false
            },
            {
                id: 2614,
                name: 'South Holland',
                state_code: 'ZH',
                hasCities: true
            },
            { id: 2610, name: 'Utrecht', state_code: 'UT', hasCities: true },
            { id: 2620, name: 'Zeeland', state_code: 'ZE', hasCities: true }
        ]
    },
    { id: 157, states: [] },
    {
        id: 158,
        states: [
            {
                id: 4072,
                name: 'Auckland Region',
                state_code: 'AUK',
                hasCities: true
            },
            {
                id: 4074,
                name: 'Bay of Plenty Region',
                state_code: 'BOP',
                hasCities: true
            },
            {
                id: 4066,
                name: 'Canterbury Region',
                state_code: 'CAN',
                hasCities: true
            },
            {
                id: 4067,
                name: 'Chatham Islands',
                state_code: 'CIT',
                hasCities: true
            },
            {
                id: 4068,
                name: 'Gisborne District',
                state_code: 'GIS',
                hasCities: true
            },
            {
                id: 4075,
                name: "Hawke's Bay Region",
                state_code: 'HKB',
                hasCities: true
            },
            {
                id: 4060,
                name: 'Manawatu-Wanganui Region',
                state_code: 'MWT',
                hasCities: true
            },
            {
                id: 4063,
                name: 'Marlborough Region',
                state_code: 'MBH',
                hasCities: true
            },
            {
                id: 4070,
                name: 'Nelson Region',
                state_code: 'NSN',
                hasCities: true
            },
            {
                id: 4059,
                name: 'Northland Region',
                state_code: 'NTL',
                hasCities: true
            },
            {
                id: 4062,
                name: 'Otago Region',
                state_code: 'OTA',
                hasCities: true
            },
            {
                id: 4071,
                name: 'Southland Region',
                state_code: 'STL',
                hasCities: true
            },
            {
                id: 4069,
                name: 'Taranaki Region',
                state_code: 'TKI',
                hasCities: true
            },
            {
                id: 4073,
                name: 'Tasman District',
                state_code: 'TAS',
                hasCities: true
            },
            {
                id: 4061,
                name: 'Waikato Region',
                state_code: 'WKO',
                hasCities: true
            },
            {
                id: 4065,
                name: 'Wellington Region',
                state_code: 'WGN',
                hasCities: true
            },
            {
                id: 4064,
                name: 'West Coast Region',
                state_code: 'WTC',
                hasCities: true
            }
        ]
    },
    {
        id: 159,
        states: [
            { id: 946, name: 'Boaco', state_code: 'BO', hasCities: true },
            { id: 950, name: 'Carazo', state_code: 'CA', hasCities: true },
            {
                id: 954,
                name: 'Chinandega',
                state_code: 'CI',
                hasCities: true
            },
            { id: 940, name: 'Chontales', state_code: 'CO', hasCities: true },
            { id: 945, name: 'Estelí', state_code: 'ES', hasCities: true },
            { id: 943, name: 'Granada', state_code: 'GR', hasCities: true },
            { id: 955, name: 'Jinotega', state_code: 'JI', hasCities: true },
            { id: 944, name: 'León', state_code: 'LE', hasCities: true },
            { id: 948, name: 'Madriz', state_code: 'MD', hasCities: true },
            { id: 941, name: 'Managua', state_code: 'MN', hasCities: true },
            { id: 953, name: 'Masaya', state_code: 'MS', hasCities: true },
            { id: 947, name: 'Matagalpa', state_code: 'MT', hasCities: true },
            {
                id: 951,
                name: 'North Caribbean Coast',
                state_code: 'AN',
                hasCities: true
            },
            {
                id: 4964,
                name: 'Nueva Segovia',
                state_code: 'NS',
                hasCities: true
            },
            {
                id: 949,
                name: 'Río San Juan',
                state_code: 'SJ',
                hasCities: true
            },
            { id: 942, name: 'Rivas', state_code: 'RI', hasCities: true },
            {
                id: 952,
                name: 'South Caribbean Coast',
                state_code: 'AS',
                hasCities: true
            }
        ]
    },
    {
        id: 160,
        states: [
            {
                id: 71,
                name: 'Agadez Region',
                state_code: '1',
                hasCities: true
            },
            {
                id: 72,
                name: 'Diffa Region',
                state_code: '2',
                hasCities: true
            },
            {
                id: 68,
                name: 'Dosso Region',
                state_code: '3',
                hasCities: true
            },
            {
                id: 70,
                name: 'Maradi Region',
                state_code: '4',
                hasCities: true
            },
            {
                id: 73,
                name: 'Tahoua Region',
                state_code: '5',
                hasCities: true
            },
            {
                id: 67,
                name: 'Tillabéri Region',
                state_code: '6',
                hasCities: true
            },
            {
                id: 69,
                name: 'Zinder Region',
                state_code: '7',
                hasCities: true
            }
        ]
    },
    {
        id: 161,
        states: [
            { id: 303, name: 'Abia', state_code: 'AB', hasCities: true },
            {
                id: 293,
                name: 'Abuja Federal Capital Territory',
                state_code: 'FC',
                hasCities: true
            },
            { id: 320, name: 'Adamawa', state_code: 'AD', hasCities: true },
            { id: 304, name: 'Akwa Ibom', state_code: 'AK', hasCities: true },
            { id: 315, name: 'Anambra', state_code: 'AN', hasCities: true },
            { id: 312, name: 'Bauchi', state_code: 'BA', hasCities: true },
            { id: 305, name: 'Bayelsa', state_code: 'BY', hasCities: true },
            { id: 291, name: 'Benue', state_code: 'BE', hasCities: true },
            { id: 307, name: 'Borno', state_code: 'BO', hasCities: true },
            {
                id: 314,
                name: 'Cross River',
                state_code: 'CR',
                hasCities: true
            },
            { id: 316, name: 'Delta', state_code: 'DE', hasCities: true },
            { id: 311, name: 'Ebonyi', state_code: 'EB', hasCities: true },
            { id: 318, name: 'Edo', state_code: 'ED', hasCities: true },
            { id: 309, name: 'Ekiti', state_code: 'EK', hasCities: true },
            { id: 289, name: 'Enugu', state_code: 'EN', hasCities: true },
            { id: 310, name: 'Gombe', state_code: 'GO', hasCities: true },
            { id: 308, name: 'Imo', state_code: 'IM', hasCities: true },
            { id: 288, name: 'Jigawa', state_code: 'JI', hasCities: true },
            { id: 294, name: 'Kaduna', state_code: 'KD', hasCities: true },
            { id: 300, name: 'Kano', state_code: 'KN', hasCities: true },
            { id: 313, name: 'Katsina', state_code: 'KT', hasCities: true },
            { id: 290, name: 'Kebbi', state_code: 'KE', hasCities: true },
            { id: 298, name: 'Kogi', state_code: 'KO', hasCities: true },
            { id: 295, name: 'Kwara', state_code: 'KW', hasCities: true },
            { id: 306, name: 'Lagos', state_code: 'LA', hasCities: true },
            { id: 301, name: 'Nasarawa', state_code: 'NA', hasCities: true },
            { id: 317, name: 'Niger', state_code: 'NI', hasCities: true },
            { id: 323, name: 'Ogun', state_code: 'OG', hasCities: true },
            { id: 321, name: 'Ondo', state_code: 'ON', hasCities: true },
            { id: 322, name: 'Osun', state_code: 'OS', hasCities: true },
            { id: 296, name: 'Oyo', state_code: 'OY', hasCities: true },
            { id: 302, name: 'Plateau', state_code: 'PL', hasCities: true },
            { id: 4926, name: 'Rivers', state_code: 'RI', hasCities: true },
            { id: 292, name: 'Sokoto', state_code: 'SO', hasCities: true },
            { id: 319, name: 'Taraba', state_code: 'TA', hasCities: true },
            { id: 297, name: 'Yobe', state_code: 'YO', hasCities: true },
            { id: 299, name: 'Zamfara', state_code: 'ZA', hasCities: true }
        ]
    },
    { id: 162, states: [] },
    { id: 163, states: [] },
    {
        id: 115,
        states: [
            {
                id: 3998,
                name: 'Chagang Province',
                state_code: '04',
                hasCities: true
            },
            {
                id: 3999,
                name: 'Kangwon Province',
                state_code: '07',
                hasCities: true
            },
            {
                id: 3995,
                name: 'North Hamgyong Province',
                state_code: '09',
                hasCities: true
            },
            {
                id: 4004,
                name: 'North Hwanghae Province',
                state_code: '06',
                hasCities: true
            },
            {
                id: 4002,
                name: 'North Pyongan Province',
                state_code: '03',
                hasCities: true
            },
            {
                id: 4005,
                name: 'Pyongyang',
                state_code: '01',
                hasCities: true
            },
            { id: 4001, name: 'Rason', state_code: '13', hasCities: true },
            {
                id: 3996,
                name: 'Ryanggang Province',
                state_code: '10',
                hasCities: true
            },
            {
                id: 4000,
                name: 'South Hamgyong Province',
                state_code: '08',
                hasCities: true
            },
            {
                id: 4003,
                name: 'South Hwanghae Province',
                state_code: '05',
                hasCities: true
            },
            {
                id: 3997,
                name: 'South Pyongan Province',
                state_code: '02',
                hasCities: true
            }
        ]
    },
    { id: 164, states: [] },
    {
        id: 165,
        states: [
            { id: 1014, name: 'Agder', state_code: '42', hasCities: true },
            { id: 1012, name: 'Akershus', state_code: '32', hasCities: true },
            { id: 1016, name: 'Buskerud', state_code: '33', hasCities: true },
            {
                id: 1009,
                name: 'Innlandet',
                state_code: '34',
                hasCities: true
            },
            {
                id: 1026,
                name: 'Jan Mayen',
                state_code: '22',
                hasCities: false
            },
            {
                id: 1020,
                name: 'Møre og Romsdal',
                state_code: '15',
                hasCities: true
            },
            { id: 1025, name: 'Nordland', state_code: '18', hasCities: true },
            { id: 1007, name: 'Oslo', state_code: '03', hasCities: true },
            { id: 1011, name: 'Østfold', state_code: '31', hasCities: true },
            { id: 1021, name: 'Rogaland', state_code: '11', hasCities: true },
            {
                id: 1013,
                name: 'Svalbard',
                state_code: '21',
                hasCities: false
            },
            {
                id: 1015,
                name: 'Troms og Finnmark',
                state_code: '54',
                hasCities: true
            },
            {
                id: 1006,
                name: 'Trøndelag',
                state_code: '50',
                hasCities: true
            },
            {
                id: 1024,
                name: 'Vestfold og Telemark',
                state_code: '38',
                hasCities: true
            },
            { id: 1018, name: 'Vestland', state_code: '46', hasCities: true }
        ]
    },
    {
        id: 166,
        states: [
            {
                id: 3058,
                name: 'Ad Dakhiliyah',
                state_code: 'DA',
                hasCities: true
            },
            {
                id: 3047,
                name: 'Ad Dhahirah',
                state_code: 'ZA',
                hasCities: true
            },
            {
                id: 3048,
                name: 'Al Batinah North',
                state_code: 'BS',
                hasCities: true
            },
            {
                id: 3050,
                name: 'Al Batinah Region',
                state_code: 'BA',
                hasCities: true
            },
            {
                id: 3049,
                name: 'Al Batinah South',
                state_code: 'BJ',
                hasCities: false
            },
            {
                id: 3059,
                name: 'Al Buraimi',
                state_code: 'BU',
                hasCities: true
            },
            { id: 3056, name: 'Al Wusta', state_code: 'WU', hasCities: true },
            {
                id: 3053,
                name: 'Ash Sharqiyah North',
                state_code: 'SS',
                hasCities: false
            },
            {
                id: 3051,
                name: 'Ash Sharqiyah Region',
                state_code: 'SH',
                hasCities: true
            },
            {
                id: 3054,
                name: 'Ash Sharqiyah South',
                state_code: 'SJ',
                hasCities: false
            },
            { id: 3057, name: 'Dhofar', state_code: 'ZU', hasCities: true },
            { id: 3052, name: 'Musandam', state_code: 'MU', hasCities: true },
            { id: 3055, name: 'Muscat', state_code: 'MA', hasCities: true }
        ]
    },
    {
        id: 167,
        states: [
            {
                id: 3172,
                name: 'Azad Kashmir',
                state_code: 'JK',
                hasCities: true
            },
            {
                id: 3174,
                name: 'Balochistan',
                state_code: 'BA',
                hasCities: true
            },
            {
                id: 3173,
                name: 'Federally Administered Tribal Areas',
                state_code: 'TA',
                hasCities: true
            },
            {
                id: 3170,
                name: 'Gilgit-Baltistan',
                state_code: 'GB',
                hasCities: true
            },
            {
                id: 3169,
                name: 'Islamabad Capital Territory',
                state_code: 'IS',
                hasCities: true
            },
            {
                id: 3171,
                name: 'Khyber Pakhtunkhwa',
                state_code: 'KP',
                hasCities: true
            },
            { id: 3176, name: 'Punjab', state_code: 'PB', hasCities: true },
            { id: 3175, name: 'Sindh', state_code: 'SD', hasCities: true }
        ]
    },
    {
        id: 168,
        states: [
            {
                id: 4540,
                name: 'Aimeliik',
                state_code: '002',
                hasCities: true
            },
            { id: 4528, name: 'Airai', state_code: '004', hasCities: true },
            { id: 4538, name: 'Angaur', state_code: '010', hasCities: true },
            {
                id: 4529,
                name: 'Hatohobei',
                state_code: '050',
                hasCities: true
            },
            {
                id: 4539,
                name: 'Kayangel',
                state_code: '100',
                hasCities: true
            },
            { id: 4532, name: 'Koror', state_code: '150', hasCities: true },
            {
                id: 4530,
                name: 'Melekeok',
                state_code: '212',
                hasCities: true
            },
            {
                id: 4537,
                name: 'Ngaraard',
                state_code: '214',
                hasCities: true
            },
            {
                id: 4533,
                name: 'Ngarchelong',
                state_code: '218',
                hasCities: true
            },
            {
                id: 4527,
                name: 'Ngardmau',
                state_code: '222',
                hasCities: true
            },
            {
                id: 4531,
                name: 'Ngatpang',
                state_code: '224',
                hasCities: false
            },
            {
                id: 4536,
                name: 'Ngchesar',
                state_code: '226',
                hasCities: true
            },
            {
                id: 4541,
                name: 'Ngeremlengui',
                state_code: '227',
                hasCities: true
            },
            { id: 4534, name: 'Ngiwal', state_code: '228', hasCities: true },
            { id: 4526, name: 'Peleliu', state_code: '350', hasCities: true },
            { id: 4535, name: 'Sonsorol', state_code: '370', hasCities: true }
        ]
    },
    {
        id: 169,
        states: [
            {
                id: 5118,
                name: 'Bethlehem',
                state_code: 'BTH',
                hasCities: false
            },
            {
                id: 5119,
                name: 'Deir El Balah',
                state_code: 'DEB',
                hasCities: false
            },
            { id: 5120, name: 'Gaza', state_code: 'GZA', hasCities: false },
            { id: 5121, name: 'Hebron', state_code: 'HBN', hasCities: false },
            { id: 5122, name: 'Jenin', state_code: 'JEN', hasCities: false },
            {
                id: 5123,
                name: 'Jericho and Al Aghwar',
                state_code: 'JRH',
                hasCities: false
            },
            {
                id: 5124,
                name: 'Jerusalem',
                state_code: 'JEM',
                hasCities: false
            },
            {
                id: 5125,
                name: 'Khan Yunis',
                state_code: 'KYS',
                hasCities: false
            },
            { id: 5126, name: 'Nablus', state_code: 'NBS', hasCities: false },
            {
                id: 5127,
                name: 'North Gaza',
                state_code: 'NGZ',
                hasCities: false
            },
            {
                id: 5128,
                name: 'Qalqilya',
                state_code: 'QQA',
                hasCities: false
            },
            { id: 5129, name: 'Rafah', state_code: 'RFH', hasCities: false },
            {
                id: 5130,
                name: 'Ramallah',
                state_code: 'RBH',
                hasCities: false
            },
            { id: 5131, name: 'Salfit', state_code: 'SLT', hasCities: false },
            { id: 5132, name: 'Tubas', state_code: 'TBS', hasCities: false },
            { id: 5133, name: 'Tulkarm', state_code: 'TKM', hasCities: false }
        ]
    },
    {
        id: 170,
        states: [
            {
                id: 1393,
                name: 'Bocas del Toro Province',
                state_code: '1',
                hasCities: true
            },
            {
                id: 1397,
                name: 'Chiriquí Province',
                state_code: '4',
                hasCities: true
            },
            {
                id: 1387,
                name: 'Coclé Province',
                state_code: '2',
                hasCities: true
            },
            {
                id: 1386,
                name: 'Colón Province',
                state_code: '3',
                hasCities: true
            },
            {
                id: 1385,
                name: 'Darién Province',
                state_code: '5',
                hasCities: true
            },
            {
                id: 1396,
                name: 'Emberá-Wounaan Comarca',
                state_code: 'EM',
                hasCities: true
            },
            {
                id: 1388,
                name: 'Guna Yala',
                state_code: 'KY',
                hasCities: true
            },
            {
                id: 1389,
                name: 'Herrera Province',
                state_code: '6',
                hasCities: true
            },
            {
                id: 1390,
                name: 'Los Santos Province',
                state_code: '7',
                hasCities: true
            },
            {
                id: 1391,
                name: 'Ngöbe-Buglé Comarca',
                state_code: 'NB',
                hasCities: true
            },
            {
                id: 1394,
                name: 'Panamá Oeste Province',
                state_code: '10',
                hasCities: true
            },
            {
                id: 1395,
                name: 'Panamá Province',
                state_code: '8',
                hasCities: true
            },
            {
                id: 1392,
                name: 'Veraguas Province',
                state_code: '9',
                hasCities: true
            }
        ]
    },
    {
        id: 171,
        states: [
            {
                id: 4831,
                name: 'Bougainville',
                state_code: 'NSB',
                hasCities: true
            },
            {
                id: 4847,
                name: 'Central Province',
                state_code: 'CPM',
                hasCities: true
            },
            {
                id: 4846,
                name: 'Chimbu Province',
                state_code: 'CPK',
                hasCities: true
            },
            {
                id: 4834,
                name: 'East New Britain',
                state_code: 'EBR',
                hasCities: true
            },
            {
                id: 4845,
                name: 'Eastern Highlands Province',
                state_code: 'EHG',
                hasCities: true
            },
            {
                id: 4848,
                name: 'Enga Province',
                state_code: 'EPW',
                hasCities: true
            },
            { id: 4839, name: 'Gulf', state_code: 'GPK', hasCities: true },
            { id: 4833, name: 'Hela', state_code: 'HLA', hasCities: true },
            {
                id: 4832,
                name: 'Jiwaka Province',
                state_code: 'JWK',
                hasCities: true
            },
            {
                id: 4843,
                name: 'Madang Province',
                state_code: 'MPM',
                hasCities: true
            },
            {
                id: 4842,
                name: 'Manus Province',
                state_code: 'MRL',
                hasCities: true
            },
            {
                id: 4849,
                name: 'Milne Bay Province',
                state_code: 'MBA',
                hasCities: true
            },
            {
                id: 4835,
                name: 'Morobe Province',
                state_code: 'MPL',
                hasCities: true
            },
            {
                id: 4841,
                name: 'New Ireland Province',
                state_code: 'NIK',
                hasCities: true
            },
            {
                id: 4838,
                name: 'Oro Province',
                state_code: 'NPP',
                hasCities: true
            },
            {
                id: 4837,
                name: 'Port Moresby',
                state_code: 'NCD',
                hasCities: true
            },
            {
                id: 4836,
                name: 'Sandaun Province',
                state_code: 'SAN',
                hasCities: true
            },
            {
                id: 4844,
                name: 'Southern Highlands Province',
                state_code: 'SHM',
                hasCities: true
            },
            {
                id: 4830,
                name: 'West New Britain Province',
                state_code: 'WBK',
                hasCities: true
            },
            {
                id: 4840,
                name: 'Western Highlands Province',
                state_code: 'WHM',
                hasCities: true
            },
            {
                id: 4850,
                name: 'Western Province',
                state_code: 'WPD',
                hasCities: true
            }
        ]
    },
    {
        id: 172,
        states: [
            {
                id: 2785,
                name: 'Alto Paraguay Department',
                state_code: '16',
                hasCities: true
            },
            {
                id: 2784,
                name: 'Alto Paraná Department',
                state_code: '10',
                hasCities: true
            },
            {
                id: 2782,
                name: 'Amambay Department',
                state_code: '13',
                hasCities: true
            },
            {
                id: 2780,
                name: 'Boquerón Department',
                state_code: '19',
                hasCities: true
            },
            { id: 2773, name: 'Caaguazú', state_code: '5', hasCities: true },
            { id: 2775, name: 'Caazapá', state_code: '6', hasCities: true },
            {
                id: 2771,
                name: 'Canindeyú',
                state_code: '14',
                hasCities: true
            },
            {
                id: 2777,
                name: 'Central Department',
                state_code: '11',
                hasCities: true
            },
            {
                id: 2779,
                name: 'Concepción Department',
                state_code: '1',
                hasCities: true
            },
            {
                id: 2783,
                name: 'Cordillera Department',
                state_code: '3',
                hasCities: true
            },
            {
                id: 2772,
                name: 'Guairá Department',
                state_code: '4',
                hasCities: true
            },
            { id: 2778, name: 'Itapúa', state_code: '7', hasCities: true },
            {
                id: 2786,
                name: 'Misiones Department',
                state_code: '8',
                hasCities: true
            },
            {
                id: 2781,
                name: 'Ñeembucú Department',
                state_code: '12',
                hasCities: true
            },
            {
                id: 2774,
                name: 'Paraguarí Department',
                state_code: '9',
                hasCities: true
            },
            {
                id: 2770,
                name: 'Presidente Hayes Department',
                state_code: '15',
                hasCities: true
            },
            {
                id: 2776,
                name: 'San Pedro Department',
                state_code: '2',
                hasCities: true
            }
        ]
    },
    {
        id: 173,
        states: [
            {
                id: 3685,
                name: 'Amazonas',
                state_code: 'AMA',
                hasCities: true
            },
            { id: 3680, name: 'Áncash', state_code: 'ANC', hasCities: true },
            {
                id: 3699,
                name: 'Apurímac',
                state_code: 'APU',
                hasCities: true
            },
            {
                id: 3681,
                name: 'Arequipa',
                state_code: 'ARE',
                hasCities: true
            },
            {
                id: 3692,
                name: 'Ayacucho',
                state_code: 'AYA',
                hasCities: true
            },
            {
                id: 3688,
                name: 'Cajamarca',
                state_code: 'CAJ',
                hasCities: true
            },
            { id: 3701, name: 'Callao', state_code: 'CAL', hasCities: true },
            { id: 3691, name: 'Cusco', state_code: 'CUS', hasCities: true },
            {
                id: 3679,
                name: 'Huancavelica',
                state_code: 'HUV',
                hasCities: true
            },
            { id: 3687, name: 'Huanuco', state_code: 'HUC', hasCities: true },
            { id: 3700, name: 'Ica', state_code: 'ICA', hasCities: true },
            { id: 3693, name: 'Junín', state_code: 'JUN', hasCities: true },
            {
                id: 3683,
                name: 'La Libertad',
                state_code: 'LAL',
                hasCities: true
            },
            {
                id: 3702,
                name: 'Lambayeque',
                state_code: 'LAM',
                hasCities: true
            },
            { id: 3695, name: 'Lima', state_code: 'LIM', hasCities: true },
            { id: 4922, name: 'Loreto', state_code: 'LOR', hasCities: true },
            {
                id: 3678,
                name: 'Madre de Dios',
                state_code: 'MDD',
                hasCities: true
            },
            {
                id: 3698,
                name: 'Moquegua',
                state_code: 'MOQ',
                hasCities: true
            },
            { id: 3686, name: 'Pasco', state_code: 'PAS', hasCities: true },
            { id: 3697, name: 'Piura', state_code: 'PIU', hasCities: true },
            { id: 3682, name: 'Puno', state_code: 'PUN', hasCities: true },
            {
                id: 3694,
                name: 'San Martín',
                state_code: 'SAM',
                hasCities: true
            },
            { id: 3696, name: 'Tacna', state_code: 'TAC', hasCities: true },
            { id: 3689, name: 'Tumbes', state_code: 'TUM', hasCities: true },
            { id: 3684, name: 'Ucayali', state_code: 'UCA', hasCities: true }
        ]
    },
    {
        id: 174,
        states: [
            { id: 1324, name: 'Abra', state_code: 'ABR', hasCities: true },
            {
                id: 1323,
                name: 'Agusan del Norte',
                state_code: 'AGN',
                hasCities: true
            },
            {
                id: 1326,
                name: 'Agusan del Sur',
                state_code: 'AGS',
                hasCities: true
            },
            { id: 1331, name: 'Aklan', state_code: 'AKL', hasCities: false },
            { id: 1337, name: 'Albay', state_code: 'ALB', hasCities: true },
            { id: 1336, name: 'Antique', state_code: 'ANT', hasCities: true },
            { id: 1334, name: 'Apayao', state_code: 'APA', hasCities: false },
            { id: 1341, name: 'Aurora', state_code: 'AUR', hasCities: false },
            {
                id: 1316,
                name: 'Autonomous Region in Muslim Mindanao',
                state_code: '14',
                hasCities: true
            },
            {
                id: 1346,
                name: 'Basilan',
                state_code: 'BAS',
                hasCities: false
            },
            { id: 1344, name: 'Bataan', state_code: 'BAN', hasCities: true },
            { id: 1352, name: 'Batanes', state_code: 'BTN', hasCities: true },
            {
                id: 1359,
                name: 'Batangas',
                state_code: 'BTG',
                hasCities: false
            },
            { id: 1363, name: 'Benguet', state_code: 'BEN', hasCities: true },
            { id: 1304, name: 'Bicol', state_code: '05', hasCities: false },
            {
                id: 1274,
                name: 'Biliran',
                state_code: 'BIL',
                hasCities: false
            },
            { id: 1272, name: 'Bohol', state_code: 'BOH', hasCities: true },
            {
                id: 1270,
                name: 'Bukidnon',
                state_code: 'BUK',
                hasCities: true
            },
            { id: 1278, name: 'Bulacan', state_code: 'BUL', hasCities: true },
            { id: 1279, name: 'Cagayan', state_code: 'CAG', hasCities: true },
            {
                id: 1342,
                name: 'Cagayan Valley',
                state_code: '02',
                hasCities: true
            },
            {
                id: 1294,
                name: 'Calabarzon',
                state_code: '40',
                hasCities: false
            },
            {
                id: 1283,
                name: 'Camarines Norte',
                state_code: 'CAN',
                hasCities: true
            },
            {
                id: 1287,
                name: 'Camarines Sur',
                state_code: 'CAS',
                hasCities: false
            },
            {
                id: 1285,
                name: 'Camiguin',
                state_code: 'CAM',
                hasCities: false
            },
            { id: 1292, name: 'Capiz', state_code: 'CAP', hasCities: false },
            { id: 1314, name: 'Caraga', state_code: '13', hasCities: true },
            {
                id: 1301,
                name: 'Catanduanes',
                state_code: 'CAT',
                hasCities: false
            },
            { id: 1307, name: 'Cavite', state_code: 'CAV', hasCities: false },
            { id: 1306, name: 'Cebu', state_code: 'CEB', hasCities: false },
            {
                id: 1345,
                name: 'Central Luzon',
                state_code: '03',
                hasCities: true
            },
            {
                id: 1308,
                name: 'Central Visayas',
                state_code: '07',
                hasCities: false
            },
            {
                id: 1311,
                name: 'Compostela Valley',
                state_code: 'COM',
                hasCities: false
            },
            {
                id: 1335,
                name: 'Cordillera Administrative',
                state_code: '15',
                hasCities: true
            },
            {
                id: 1320,
                name: 'Cotabato',
                state_code: 'NCO',
                hasCities: false
            },
            { id: 1340, name: 'Davao', state_code: '11', hasCities: true },
            {
                id: 1319,
                name: 'Davao del Norte',
                state_code: 'DAV',
                hasCities: false
            },
            {
                id: 1318,
                name: 'Davao del Sur',
                state_code: 'DAS',
                hasCities: false
            },
            {
                id: 1309,
                name: 'Davao Occidental',
                state_code: 'DVO',
                hasCities: true
            },
            {
                id: 1289,
                name: 'Davao Oriental',
                state_code: 'DAO',
                hasCities: false
            },
            {
                id: 1291,
                name: 'Dinagat Islands',
                state_code: 'DIN',
                hasCities: false
            },
            {
                id: 1290,
                name: 'Eastern Samar',
                state_code: 'EAS',
                hasCities: false
            },
            {
                id: 1322,
                name: 'Eastern Visayas',
                state_code: '08',
                hasCities: true
            },
            {
                id: 1303,
                name: 'Guimaras',
                state_code: 'GUI',
                hasCities: false
            },
            { id: 1300, name: 'Ifugao', state_code: 'IFU', hasCities: false },
            { id: 1355, name: 'Ilocos', state_code: '01', hasCities: true },
            {
                id: 1298,
                name: 'Ilocos Norte',
                state_code: 'ILN',
                hasCities: false
            },
            {
                id: 1321,
                name: 'Ilocos Sur',
                state_code: 'ILS',
                hasCities: false
            },
            { id: 1315, name: 'Iloilo', state_code: 'ILI', hasCities: false },
            {
                id: 1313,
                name: 'Isabela',
                state_code: 'ISA',
                hasCities: false
            },
            {
                id: 1312,
                name: 'Kalinga',
                state_code: 'KAL',
                hasCities: false
            },
            {
                id: 1317,
                name: 'La Union',
                state_code: 'LUN',
                hasCities: false
            },
            { id: 1328, name: 'Laguna', state_code: 'LAG', hasCities: false },
            {
                id: 1327,
                name: 'Lanao del Norte',
                state_code: 'LAN',
                hasCities: false
            },
            {
                id: 1333,
                name: 'Lanao del Sur',
                state_code: 'LAS',
                hasCities: false
            },
            { id: 1332, name: 'Leyte', state_code: 'LEY', hasCities: false },
            {
                id: 1330,
                name: 'Maguindanao',
                state_code: 'MAG',
                hasCities: false
            },
            {
                id: 1329,
                name: 'Marinduque',
                state_code: 'MAD',
                hasCities: false
            },
            {
                id: 1338,
                name: 'Masbate',
                state_code: 'MAS',
                hasCities: false
            },
            {
                id: 1347,
                name: 'Metro Manila',
                state_code: 'NCR',
                hasCities: true
            },
            {
                id: 1299,
                name: 'Mimaropa',
                state_code: '41',
                hasCities: false
            },
            {
                id: 1343,
                name: 'Misamis Occidental',
                state_code: 'MSC',
                hasCities: false
            },
            {
                id: 1348,
                name: 'Misamis Oriental',
                state_code: 'MSR',
                hasCities: false
            },
            {
                id: 1353,
                name: 'Mountain Province',
                state_code: 'MOU',
                hasCities: false
            },
            {
                id: 1351,
                name: 'Negros Occidental',
                state_code: 'NEC',
                hasCities: false
            },
            {
                id: 1350,
                name: 'Negros Oriental',
                state_code: 'NER',
                hasCities: false
            },
            {
                id: 1339,
                name: 'Northern Mindanao',
                state_code: '10',
                hasCities: false
            },
            {
                id: 1349,
                name: 'Northern Samar',
                state_code: 'NSA',
                hasCities: false
            },
            {
                id: 1360,
                name: 'Nueva Ecija',
                state_code: 'NUE',
                hasCities: false
            },
            {
                id: 1358,
                name: 'Nueva Vizcaya',
                state_code: 'NUV',
                hasCities: false
            },
            {
                id: 1356,
                name: 'Occidental Mindoro',
                state_code: 'MDC',
                hasCities: true
            },
            {
                id: 1354,
                name: 'Oriental Mindoro',
                state_code: 'MDR',
                hasCities: true
            },
            {
                id: 1361,
                name: 'Palawan',
                state_code: 'PLW',
                hasCities: false
            },
            {
                id: 1365,
                name: 'Pampanga',
                state_code: 'PAM',
                hasCities: false
            },
            {
                id: 1364,
                name: 'Pangasinan',
                state_code: 'PAN',
                hasCities: false
            },
            { id: 1275, name: 'Quezon', state_code: 'QUE', hasCities: false },
            {
                id: 1273,
                name: 'Quirino',
                state_code: 'QUI',
                hasCities: false
            },
            { id: 1271, name: 'Rizal', state_code: 'RIZ', hasCities: false },
            {
                id: 1269,
                name: 'Romblon',
                state_code: 'ROM',
                hasCities: false
            },
            {
                id: 1277,
                name: 'Sarangani',
                state_code: 'SAR',
                hasCities: false
            },
            {
                id: 1276,
                name: 'Siquijor',
                state_code: 'SIG',
                hasCities: false
            },
            {
                id: 1310,
                name: 'Soccsksargen',
                state_code: '12',
                hasCities: true
            },
            {
                id: 1281,
                name: 'Sorsogon',
                state_code: 'SOR',
                hasCities: false
            },
            {
                id: 1280,
                name: 'South Cotabato',
                state_code: 'SCO',
                hasCities: false
            },
            {
                id: 1284,
                name: 'Southern Leyte',
                state_code: 'SLE',
                hasCities: false
            },
            {
                id: 1282,
                name: 'Sultan Kudarat',
                state_code: 'SUK',
                hasCities: false
            },
            { id: 1288, name: 'Sulu', state_code: 'SLU', hasCities: false },
            {
                id: 1286,
                name: 'Surigao del Norte',
                state_code: 'SUN',
                hasCities: false
            },
            {
                id: 1296,
                name: 'Surigao del Sur',
                state_code: 'SUR',
                hasCities: false
            },
            { id: 1295, name: 'Tarlac', state_code: 'TAR', hasCities: false },
            {
                id: 1293,
                name: 'Tawi-Tawi',
                state_code: 'TAW',
                hasCities: false
            },
            {
                id: 5115,
                name: 'Western Samar',
                state_code: 'WSA',
                hasCities: false
            },
            {
                id: 1305,
                name: 'Western Visayas',
                state_code: '06',
                hasCities: false
            },
            {
                id: 1297,
                name: 'Zambales',
                state_code: 'ZMB',
                hasCities: false
            },
            {
                id: 1302,
                name: 'Zamboanga del Norte',
                state_code: 'ZAN',
                hasCities: false
            },
            {
                id: 1357,
                name: 'Zamboanga del Sur',
                state_code: 'ZAS',
                hasCities: false
            },
            {
                id: 1325,
                name: 'Zamboanga Peninsula',
                state_code: '09',
                hasCities: false
            },
            {
                id: 1362,
                name: 'Zamboanga Sibugay',
                state_code: 'ZSI',
                hasCities: true
            }
        ]
    },
    { id: 175, states: [] },
    {
        id: 176,
        states: [
            {
                id: 1634,
                name: 'Greater Poland Voivodeship',
                state_code: 'WP',
                hasCities: true
            },
            {
                id: 1625,
                name: 'Kuyavian-Pomeranian Voivodeship',
                state_code: 'KP',
                hasCities: true
            },
            {
                id: 1635,
                name: 'Lesser Poland Voivodeship',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 1629,
                name: 'Lower Silesian Voivodeship',
                state_code: 'DS',
                hasCities: true
            },
            {
                id: 1638,
                name: 'Lublin Voivodeship',
                state_code: 'LU',
                hasCities: true
            },
            {
                id: 1631,
                name: 'Lubusz Voivodeship',
                state_code: 'LB',
                hasCities: true
            },
            {
                id: 1636,
                name: 'Łódź Voivodeship',
                state_code: 'LD',
                hasCities: true
            },
            {
                id: 1637,
                name: 'Masovian Voivodeship',
                state_code: 'MZ',
                hasCities: true
            },
            {
                id: 1622,
                name: 'Opole Voivodeship',
                state_code: 'OP',
                hasCities: true
            },
            {
                id: 1626,
                name: 'Podkarpackie Voivodeship',
                state_code: 'PK',
                hasCities: true
            },
            {
                id: 1632,
                name: 'Podlaskie Voivodeship',
                state_code: 'PD',
                hasCities: true
            },
            {
                id: 1624,
                name: 'Pomeranian Voivodeship',
                state_code: 'PM',
                hasCities: true
            },
            {
                id: 1623,
                name: 'Silesian Voivodeship',
                state_code: 'SL',
                hasCities: true
            },
            {
                id: 1630,
                name: 'Świętokrzyskie Voivodeship',
                state_code: 'SK',
                hasCities: true
            },
            {
                id: 1628,
                name: 'Warmian-Masurian Voivodeship',
                state_code: 'WN',
                hasCities: true
            },
            {
                id: 1633,
                name: 'West Pomeranian Voivodeship',
                state_code: 'ZP',
                hasCities: true
            }
        ]
    },
    {
        id: 177,
        states: [
            { id: 2233, name: 'Açores', state_code: '20', hasCities: true },
            { id: 2235, name: 'Aveiro', state_code: '01', hasCities: true },
            { id: 2230, name: 'Beja', state_code: '02', hasCities: true },
            { id: 2244, name: 'Braga', state_code: '03', hasCities: true },
            { id: 2229, name: 'Bragança', state_code: '04', hasCities: true },
            {
                id: 2241,
                name: 'Castelo Branco',
                state_code: '05',
                hasCities: true
            },
            { id: 2246, name: 'Coimbra', state_code: '06', hasCities: true },
            { id: 2236, name: 'Évora', state_code: '07', hasCities: true },
            { id: 2239, name: 'Faro', state_code: '08', hasCities: true },
            { id: 4859, name: 'Guarda', state_code: '09', hasCities: true },
            { id: 2240, name: 'Leiria', state_code: '10', hasCities: true },
            { id: 2228, name: 'Lisbon', state_code: '11', hasCities: true },
            { id: 2231, name: 'Madeira', state_code: '30', hasCities: true },
            {
                id: 2232,
                name: 'Portalegre',
                state_code: '12',
                hasCities: true
            },
            { id: 2243, name: 'Porto', state_code: '13', hasCities: true },
            { id: 2238, name: 'Santarém', state_code: '14', hasCities: true },
            { id: 2242, name: 'Setúbal', state_code: '15', hasCities: true },
            {
                id: 2245,
                name: 'Viana do Castelo',
                state_code: '16',
                hasCities: true
            },
            {
                id: 2234,
                name: 'Vila Real',
                state_code: '17',
                hasCities: true
            },
            { id: 2237, name: 'Viseu', state_code: '18', hasCities: true }
        ]
    },
    {
        id: 178,
        states: [
            { id: 5081, name: 'Arecibo', state_code: 'AR', hasCities: false },
            { id: 5076, name: 'Bayamon', state_code: 'BY', hasCities: false },
            { id: 5079, name: 'Caguas', state_code: 'CG', hasCities: false },
            {
                id: 5077,
                name: 'Carolina',
                state_code: 'CL',
                hasCities: false
            },
            {
                id: 5080,
                name: 'Guaynabo',
                state_code: 'GN',
                hasCities: false
            },
            {
                id: 5083,
                name: 'Mayagüez',
                state_code: 'MG',
                hasCities: false
            },
            { id: 5078, name: 'Ponce', state_code: 'PO', hasCities: false },
            {
                id: 5075,
                name: 'San Juan',
                state_code: 'SJ',
                hasCities: false
            },
            {
                id: 5082,
                name: 'Toa Baja',
                state_code: 'TB',
                hasCities: false
            },
            {
                id: 5084,
                name: 'Trujillo Alto',
                state_code: 'TA',
                hasCities: false
            }
        ]
    },
    {
        id: 179,
        states: [
            {
                id: 3182,
                name: 'Al Daayen',
                state_code: 'ZA',
                hasCities: false
            },
            { id: 3183, name: 'Al Khor', state_code: 'KH', hasCities: true },
            {
                id: 3177,
                name: 'Al Rayyan Municipality',
                state_code: 'RA',
                hasCities: true
            },
            {
                id: 3179,
                name: 'Al Wakrah',
                state_code: 'WA',
                hasCities: true
            },
            {
                id: 3178,
                name: 'Al-Shahaniya',
                state_code: 'SH',
                hasCities: true
            },
            { id: 3181, name: 'Doha', state_code: 'DA', hasCities: true },
            {
                id: 3180,
                name: 'Madinat ash Shamal',
                state_code: 'MS',
                hasCities: true
            },
            {
                id: 3184,
                name: 'Umm Salal Municipality',
                state_code: 'US',
                hasCities: true
            }
        ]
    },
    { id: 180, states: [] },
    {
        id: 181,
        states: [
            { id: 4724, name: 'Alba', state_code: 'AB', hasCities: true },
            {
                id: 4739,
                name: 'Arad County',
                state_code: 'AR',
                hasCities: true
            },
            { id: 4722, name: 'Arges', state_code: 'AG', hasCities: true },
            {
                id: 4744,
                name: 'Bacău County',
                state_code: 'BC',
                hasCities: true
            },
            {
                id: 4723,
                name: 'Bihor County',
                state_code: 'BH',
                hasCities: true
            },
            {
                id: 4733,
                name: 'Bistrița-Năsăud County',
                state_code: 'BN',
                hasCities: true
            },
            {
                id: 4740,
                name: 'Botoșani County',
                state_code: 'BT',
                hasCities: true
            },
            { id: 4736, name: 'Braila', state_code: 'BR', hasCities: true },
            {
                id: 4759,
                name: 'Brașov County',
                state_code: 'BV',
                hasCities: true
            },
            { id: 4730, name: 'Bucharest', state_code: 'B', hasCities: true },
            {
                id: 4756,
                name: 'Buzău County',
                state_code: 'BZ',
                hasCities: true
            },
            {
                id: 4732,
                name: 'Călărași County',
                state_code: 'CL',
                hasCities: true
            },
            {
                id: 4753,
                name: 'Caraș-Severin County',
                state_code: 'CS',
                hasCities: true
            },
            {
                id: 4734,
                name: 'Cluj County',
                state_code: 'CJ',
                hasCities: true
            },
            {
                id: 4737,
                name: 'Constanța County',
                state_code: 'CT',
                hasCities: true
            },
            {
                id: 4754,
                name: 'Covasna County',
                state_code: 'CV',
                hasCities: true
            },
            {
                id: 4745,
                name: 'Dâmbovița County',
                state_code: 'DB',
                hasCities: true
            },
            {
                id: 4742,
                name: 'Dolj County',
                state_code: 'DJ',
                hasCities: true
            },
            {
                id: 4747,
                name: 'Galați County',
                state_code: 'GL',
                hasCities: true
            },
            {
                id: 4726,
                name: 'Giurgiu County',
                state_code: 'GR',
                hasCities: true
            },
            {
                id: 4750,
                name: 'Gorj County',
                state_code: 'GJ',
                hasCities: true
            },
            {
                id: 4749,
                name: 'Harghita County',
                state_code: 'HR',
                hasCities: true
            },
            {
                id: 4721,
                name: 'Hunedoara County',
                state_code: 'HD',
                hasCities: true
            },
            {
                id: 4743,
                name: 'Ialomița County',
                state_code: 'IL',
                hasCities: true
            },
            {
                id: 4735,
                name: 'Iași County',
                state_code: 'IS',
                hasCities: true
            },
            {
                id: 4725,
                name: 'Ilfov County',
                state_code: 'IF',
                hasCities: true
            },
            {
                id: 4760,
                name: 'Maramureș County',
                state_code: 'MM',
                hasCities: true
            },
            {
                id: 4751,
                name: 'Mehedinți County',
                state_code: 'MH',
                hasCities: true
            },
            {
                id: 4915,
                name: 'Mureș County',
                state_code: 'MS',
                hasCities: true
            },
            {
                id: 4731,
                name: 'Neamț County',
                state_code: 'NT',
                hasCities: true
            },
            {
                id: 4738,
                name: 'Olt County',
                state_code: 'OT',
                hasCities: true
            },
            {
                id: 4729,
                name: 'Prahova County',
                state_code: 'PH',
                hasCities: true
            },
            {
                id: 4741,
                name: 'Sălaj County',
                state_code: 'SJ',
                hasCities: true
            },
            {
                id: 4746,
                name: 'Satu Mare County',
                state_code: 'SM',
                hasCities: true
            },
            {
                id: 4755,
                name: 'Sibiu County',
                state_code: 'SB',
                hasCities: true
            },
            {
                id: 4720,
                name: 'Suceava County',
                state_code: 'SV',
                hasCities: true
            },
            {
                id: 4728,
                name: 'Teleorman County',
                state_code: 'TR',
                hasCities: true
            },
            {
                id: 4748,
                name: 'Timiș County',
                state_code: 'TM',
                hasCities: true
            },
            {
                id: 4727,
                name: 'Tulcea County',
                state_code: 'TL',
                hasCities: true
            },
            {
                id: 4757,
                name: 'Vâlcea County',
                state_code: 'VL',
                hasCities: true
            },
            {
                id: 4752,
                name: 'Vaslui County',
                state_code: 'VS',
                hasCities: true
            },
            {
                id: 4758,
                name: 'Vrancea County',
                state_code: 'VN',
                hasCities: true
            }
        ]
    },
    {
        id: 182,
        states: [
            {
                id: 1911,
                name: 'Altai Krai',
                state_code: 'ALT',
                hasCities: true
            },
            {
                id: 1876,
                name: 'Altai Republic',
                state_code: 'AL',
                hasCities: true
            },
            {
                id: 1858,
                name: 'Amur Oblast',
                state_code: 'AMU',
                hasCities: true
            },
            {
                id: 1849,
                name: 'Arkhangelsk',
                state_code: 'ARK',
                hasCities: true
            },
            {
                id: 1866,
                name: 'Astrakhan Oblast',
                state_code: 'AST',
                hasCities: true
            },
            {
                id: 1903,
                name: 'Belgorod Oblast',
                state_code: 'BEL',
                hasCities: true
            },
            {
                id: 1867,
                name: 'Bryansk Oblast',
                state_code: 'BRY',
                hasCities: true
            },
            {
                id: 1893,
                name: 'Chechen Republic',
                state_code: 'CE',
                hasCities: true
            },
            {
                id: 1845,
                name: 'Chelyabinsk Oblast',
                state_code: 'CHE',
                hasCities: true
            },
            {
                id: 1859,
                name: 'Chukotka Autonomous Okrug',
                state_code: 'CHU',
                hasCities: true
            },
            {
                id: 1914,
                name: 'Chuvash Republic',
                state_code: 'CU',
                hasCities: true
            },
            {
                id: 1880,
                name: 'Irkutsk',
                state_code: 'IRK',
                hasCities: false
            },
            {
                id: 1864,
                name: 'Ivanovo Oblast',
                state_code: 'IVA',
                hasCities: true
            },
            {
                id: 1835,
                name: 'Jewish Autonomous Oblast',
                state_code: 'YEV',
                hasCities: true
            },
            {
                id: 1892,
                name: 'Kabardino-Balkar Republic',
                state_code: 'KB',
                hasCities: true
            },
            {
                id: 1902,
                name: 'Kaliningrad',
                state_code: 'KGD',
                hasCities: true
            },
            {
                id: 1844,
                name: 'Kaluga Oblast',
                state_code: 'KLU',
                hasCities: true
            },
            {
                id: 1865,
                name: 'Kamchatka Krai',
                state_code: 'KAM',
                hasCities: true
            },
            {
                id: 1869,
                name: 'Karachay-Cherkess Republic',
                state_code: 'KC',
                hasCities: true
            },
            {
                id: 1897,
                name: 'Kemerovo Oblast',
                state_code: 'KEM',
                hasCities: true
            },
            {
                id: 1873,
                name: 'Khabarovsk Krai',
                state_code: 'KHA',
                hasCities: true
            },
            {
                id: 1838,
                name: 'Khanty-Mansi Autonomous Okrug',
                state_code: 'KHM',
                hasCities: true
            },
            {
                id: 1890,
                name: 'Kirov Oblast',
                state_code: 'KIR',
                hasCities: true
            },
            {
                id: 1899,
                name: 'Komi Republic',
                state_code: 'KO',
                hasCities: true
            },
            {
                id: 1910,
                name: 'Kostroma Oblast',
                state_code: 'KOS',
                hasCities: true
            },
            {
                id: 1891,
                name: 'Krasnodar Krai',
                state_code: 'KDA',
                hasCities: true
            },
            {
                id: 1840,
                name: 'Krasnoyarsk Krai',
                state_code: 'KYA',
                hasCities: true
            },
            {
                id: 1915,
                name: 'Kurgan Oblast',
                state_code: 'KGN',
                hasCities: true
            },
            {
                id: 1855,
                name: 'Kursk Oblast',
                state_code: 'KRS',
                hasCities: true
            },
            {
                id: 1896,
                name: 'Leningrad Oblast',
                state_code: 'LEN',
                hasCities: true
            },
            {
                id: 1889,
                name: 'Lipetsk Oblast',
                state_code: 'LIP',
                hasCities: true
            },
            {
                id: 1839,
                name: 'Magadan Oblast',
                state_code: 'MAG',
                hasCities: true
            },
            {
                id: 1870,
                name: 'Mari El Republic',
                state_code: 'ME',
                hasCities: true
            },
            { id: 1901, name: 'Moscow', state_code: 'MOW', hasCities: true },
            {
                id: 1882,
                name: 'Moscow Oblast',
                state_code: 'MOS',
                hasCities: true
            },
            {
                id: 1843,
                name: 'Murmansk Oblast',
                state_code: 'MUR',
                hasCities: true
            },
            {
                id: 1836,
                name: 'Nenets Autonomous Okrug',
                state_code: 'NEN',
                hasCities: true
            },
            {
                id: 1857,
                name: 'Nizhny Novgorod Oblast',
                state_code: 'NIZ',
                hasCities: true
            },
            {
                id: 1834,
                name: 'Novgorod Oblast',
                state_code: 'NGR',
                hasCities: true
            },
            {
                id: 1888,
                name: 'Novosibirsk',
                state_code: 'NVS',
                hasCities: true
            },
            {
                id: 1846,
                name: 'Omsk Oblast',
                state_code: 'OMS',
                hasCities: true
            },
            {
                id: 1886,
                name: 'Orenburg Oblast',
                state_code: 'ORE',
                hasCities: true
            },
            {
                id: 1908,
                name: 'Oryol Oblast',
                state_code: 'ORL',
                hasCities: true
            },
            {
                id: 1909,
                name: 'Penza Oblast',
                state_code: 'PNZ',
                hasCities: true
            },
            {
                id: 1871,
                name: 'Perm Krai',
                state_code: 'PER',
                hasCities: true
            },
            {
                id: 1833,
                name: 'Primorsky Krai',
                state_code: 'PRI',
                hasCities: true
            },
            {
                id: 1863,
                name: 'Pskov Oblast',
                state_code: 'PSK',
                hasCities: true
            },
            {
                id: 1852,
                name: 'Republic of Adygea',
                state_code: 'AD',
                hasCities: true
            },
            {
                id: 1854,
                name: 'Republic of Bashkortostan',
                state_code: 'BA',
                hasCities: true
            },
            {
                id: 1842,
                name: 'Republic of Buryatia',
                state_code: 'BU',
                hasCities: true
            },
            {
                id: 1850,
                name: 'Republic of Dagestan',
                state_code: 'DA',
                hasCities: true
            },
            {
                id: 1884,
                name: 'Republic of Ingushetia',
                state_code: 'IN',
                hasCities: true
            },
            {
                id: 1883,
                name: 'Republic of Kalmykia',
                state_code: 'KL',
                hasCities: true
            },
            {
                id: 1841,
                name: 'Republic of Karelia',
                state_code: 'KR',
                hasCities: true
            },
            {
                id: 1877,
                name: 'Republic of Khakassia',
                state_code: 'KK',
                hasCities: true
            },
            {
                id: 1898,
                name: 'Republic of Mordovia',
                state_code: 'MO',
                hasCities: true
            },
            {
                id: 1853,
                name: 'Republic of North Ossetia-Alania',
                state_code: 'SE',
                hasCities: true
            },
            {
                id: 1861,
                name: 'Republic of Tatarstan',
                state_code: 'TA',
                hasCities: true
            },
            {
                id: 1837,
                name: 'Rostov Oblast',
                state_code: 'ROS',
                hasCities: true
            },
            {
                id: 1905,
                name: 'Ryazan Oblast',
                state_code: 'RYA',
                hasCities: true
            },
            {
                id: 1879,
                name: 'Saint Petersburg',
                state_code: 'SPE',
                hasCities: true
            },
            {
                id: 1848,
                name: 'Sakha Republic',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 1875,
                name: 'Sakhalin',
                state_code: 'SAK',
                hasCities: true
            },
            {
                id: 1862,
                name: 'Samara Oblast',
                state_code: 'SAM',
                hasCities: true
            },
            {
                id: 1887,
                name: 'Saratov Oblast',
                state_code: 'SAR',
                hasCities: true
            },
            {
                id: 1912,
                name: 'Sevastopol',
                state_code: 'UA-40',
                hasCities: true
            },
            {
                id: 1885,
                name: 'Smolensk Oblast',
                state_code: 'SMO',
                hasCities: true
            },
            {
                id: 1868,
                name: 'Stavropol Krai',
                state_code: 'STA',
                hasCities: true
            },
            {
                id: 1894,
                name: 'Sverdlovsk',
                state_code: 'SVE',
                hasCities: true
            },
            {
                id: 1878,
                name: 'Tambov Oblast',
                state_code: 'TAM',
                hasCities: true
            },
            {
                id: 1872,
                name: 'Tomsk Oblast',
                state_code: 'TOM',
                hasCities: true
            },
            {
                id: 1895,
                name: 'Tula Oblast',
                state_code: 'TUL',
                hasCities: true
            },
            {
                id: 1900,
                name: 'Tuva Republic',
                state_code: 'TY',
                hasCities: true
            },
            {
                id: 1860,
                name: 'Tver Oblast',
                state_code: 'TVE',
                hasCities: true
            },
            {
                id: 1907,
                name: 'Tyumen Oblast',
                state_code: 'TYU',
                hasCities: true
            },
            {
                id: 1913,
                name: 'Udmurt Republic',
                state_code: 'UD',
                hasCities: true
            },
            {
                id: 1856,
                name: 'Ulyanovsk Oblast',
                state_code: 'ULY',
                hasCities: true
            },
            {
                id: 1881,
                name: 'Vladimir Oblast',
                state_code: 'VLA',
                hasCities: true
            },
            {
                id: 4916,
                name: 'Volgograd Oblast',
                state_code: 'VGG',
                hasCities: true
            },
            {
                id: 1874,
                name: 'Vologda Oblast',
                state_code: 'VLG',
                hasCities: true
            },
            {
                id: 1906,
                name: 'Voronezh Oblast',
                state_code: 'VOR',
                hasCities: true
            },
            {
                id: 1847,
                name: 'Yamalo-Nenets Autonomous Okrug',
                state_code: 'YAN',
                hasCities: true
            },
            {
                id: 1851,
                name: 'Yaroslavl Oblast',
                state_code: 'YAR',
                hasCities: true
            },
            {
                id: 1904,
                name: 'Zabaykalsky Krai',
                state_code: 'ZAB',
                hasCities: true
            }
        ]
    },
    {
        id: 183,
        states: [
            {
                id: 261,
                name: 'Eastern Province',
                state_code: '02',
                hasCities: true
            },
            {
                id: 262,
                name: 'Kigali district',
                state_code: '01',
                hasCities: true
            },
            {
                id: 263,
                name: 'Northern Province',
                state_code: '03',
                hasCities: true
            },
            {
                id: 259,
                name: 'Southern Province',
                state_code: '05',
                hasCities: true
            },
            {
                id: 260,
                name: 'Western Province',
                state_code: '04',
                hasCities: true
            }
        ]
    },
    { id: 184, states: [] },
    {
        id: 185,
        states: [
            {
                id: 3833,
                name: 'Christ Church Nichola Town Parish',
                state_code: '01',
                hasCities: true
            },
            { id: 3832, name: 'Nevis', state_code: 'N', hasCities: false },
            {
                id: 3836,
                name: 'Saint Anne Sandy Point Parish',
                state_code: '02',
                hasCities: true
            },
            {
                id: 3837,
                name: 'Saint George Gingerland Parish',
                state_code: '04',
                hasCities: true
            },
            {
                id: 3835,
                name: 'Saint James Windward Parish',
                state_code: '05',
                hasCities: true
            },
            {
                id: 3845,
                name: 'Saint John Capisterre Parish',
                state_code: '06',
                hasCities: true
            },
            {
                id: 3840,
                name: 'Saint John Figtree Parish',
                state_code: '07',
                hasCities: true
            },
            {
                id: 3841,
                name: 'Saint Kitts',
                state_code: 'K',
                hasCities: false
            },
            {
                id: 3844,
                name: 'Saint Mary Cayon Parish',
                state_code: '08',
                hasCities: true
            },
            {
                id: 3834,
                name: 'Saint Paul Capisterre Parish',
                state_code: '09',
                hasCities: true
            },
            {
                id: 3838,
                name: 'Saint Paul Charlestown Parish',
                state_code: '10',
                hasCities: true
            },
            {
                id: 3831,
                name: 'Saint Peter Basseterre Parish',
                state_code: '11',
                hasCities: true
            },
            {
                id: 3839,
                name: 'Saint Thomas Lowland Parish',
                state_code: '12',
                hasCities: true
            },
            {
                id: 3842,
                name: 'Saint Thomas Middle Island Parish',
                state_code: '13',
                hasCities: true
            },
            {
                id: 3843,
                name: 'Trinity Palmetto Point Parish',
                state_code: '15',
                hasCities: true
            }
        ]
    },
    {
        id: 186,
        states: [
            {
                id: 3757,
                name: 'Anse la Raye Quarter',
                state_code: '01',
                hasCities: true
            },
            { id: 3761, name: 'Canaries', state_code: '12', hasCities: true },
            {
                id: 3758,
                name: 'Castries Quarter',
                state_code: '02',
                hasCities: true
            },
            {
                id: 3760,
                name: 'Choiseul Quarter',
                state_code: '03',
                hasCities: true
            },
            {
                id: 3767,
                name: 'Dauphin Quarter',
                state_code: '04',
                hasCities: false
            },
            {
                id: 3756,
                name: 'Dennery Quarter',
                state_code: '05',
                hasCities: true
            },
            {
                id: 3766,
                name: 'Gros Islet Quarter',
                state_code: '06',
                hasCities: true
            },
            {
                id: 3759,
                name: 'Laborie Quarter',
                state_code: '07',
                hasCities: true
            },
            {
                id: 3762,
                name: 'Micoud Quarter',
                state_code: '08',
                hasCities: true
            },
            {
                id: 3765,
                name: 'Praslin Quarter',
                state_code: '09',
                hasCities: false
            },
            {
                id: 3764,
                name: 'Soufrière Quarter',
                state_code: '10',
                hasCities: true
            },
            {
                id: 3763,
                name: 'Vieux Fort Quarter',
                state_code: '11',
                hasCities: true
            }
        ]
    },
    { id: 187, states: [] },
    {
        id: 188,
        states: [
            {
                id: 3389,
                name: 'Charlotte Parish',
                state_code: '01',
                hasCities: true
            },
            {
                id: 3388,
                name: 'Grenadines Parish',
                state_code: '06',
                hasCities: true
            },
            {
                id: 3386,
                name: 'Saint Andrew Parish',
                state_code: '02',
                hasCities: true
            },
            {
                id: 3387,
                name: 'Saint David Parish',
                state_code: '03',
                hasCities: true
            },
            {
                id: 3384,
                name: 'Saint George Parish',
                state_code: '04',
                hasCities: true
            },
            {
                id: 3385,
                name: 'Saint Patrick Parish',
                state_code: '05',
                hasCities: true
            }
        ]
    },
    { id: 189, states: [] },
    { id: 190, states: [] },
    {
        id: 191,
        states: [
            { id: 4763, name: "A'ana", state_code: 'AA', hasCities: true },
            {
                id: 4761,
                name: 'Aiga-i-le-Tai',
                state_code: 'AL',
                hasCities: true
            },
            { id: 4765, name: 'Atua', state_code: 'AT', hasCities: true },
            {
                id: 4764,
                name: "Fa'asaleleaga",
                state_code: 'FA',
                hasCities: false
            },
            {
                id: 4769,
                name: "Gaga'emauga",
                state_code: 'GE',
                hasCities: false
            },
            {
                id: 4771,
                name: "Gaga'ifomauga",
                state_code: 'GI',
                hasCities: true
            },
            { id: 4767, name: 'Palauli', state_code: 'PA', hasCities: true },
            {
                id: 4762,
                name: "Satupa'itea",
                state_code: 'SA',
                hasCities: false
            },
            {
                id: 4770,
                name: 'Tuamasaga',
                state_code: 'TU',
                hasCities: true
            },
            {
                id: 4768,
                name: "Va'a-o-Fonoti",
                state_code: 'VF',
                hasCities: true
            },
            { id: 4766, name: 'Vaisigano', state_code: 'VS', hasCities: true }
        ]
    },
    {
        id: 192,
        states: [
            { id: 59, name: 'Acquaviva', state_code: '01', hasCities: true },
            {
                id: 61,
                name: 'Borgo Maggiore',
                state_code: '06',
                hasCities: true
            },
            {
                id: 60,
                name: 'Chiesanuova',
                state_code: '02',
                hasCities: true
            },
            { id: 64, name: 'Domagnano', state_code: '03', hasCities: true },
            { id: 62, name: 'Faetano', state_code: '04', hasCities: true },
            { id: 66, name: 'Fiorentino', state_code: '05', hasCities: true },
            {
                id: 63,
                name: 'Montegiardino',
                state_code: '08',
                hasCities: true
            },
            { id: 58, name: 'San Marino', state_code: '07', hasCities: true },
            { id: 65, name: 'Serravalle', state_code: '09', hasCities: true }
        ]
    },
    {
        id: 193,
        states: [
            {
                id: 270,
                name: 'Príncipe Province',
                state_code: 'P',
                hasCities: true
            },
            {
                id: 271,
                name: 'São Tomé Province',
                state_code: 'S',
                hasCities: true
            }
        ]
    },
    {
        id: 194,
        states: [
            { id: 2853, name: "'Asir", state_code: '14', hasCities: true },
            { id: 2859, name: 'Al Bahah', state_code: '11', hasCities: true },
            { id: 2857, name: 'Al Jawf', state_code: '12', hasCities: true },
            {
                id: 2851,
                name: 'Al Madinah',
                state_code: '03',
                hasCities: true
            },
            {
                id: 2861,
                name: 'Al-Qassim',
                state_code: '05',
                hasCities: true
            },
            {
                id: 2856,
                name: 'Eastern Province',
                state_code: '04',
                hasCities: true
            },
            { id: 2855, name: "Ha'il", state_code: '06', hasCities: true },
            { id: 2858, name: 'Jizan', state_code: '09', hasCities: true },
            { id: 2850, name: 'Makkah', state_code: '02', hasCities: true },
            { id: 2860, name: 'Najran', state_code: '10', hasCities: true },
            {
                id: 2854,
                name: 'Northern Borders',
                state_code: '08',
                hasCities: true
            },
            { id: 2849, name: 'Riyadh', state_code: '01', hasCities: true },
            { id: 2852, name: 'Tabuk', state_code: '07', hasCities: true }
        ]
    },
    {
        id: 195,
        states: [
            { id: 473, name: 'Dakar', state_code: 'DK', hasCities: true },
            {
                id: 480,
                name: 'Diourbel Region',
                state_code: 'DB',
                hasCities: true
            },
            { id: 479, name: 'Fatick', state_code: 'FK', hasCities: true },
            { id: 475, name: 'Kaffrine', state_code: 'KA', hasCities: true },
            { id: 483, name: 'Kaolack', state_code: 'KL', hasCities: true },
            { id: 481, name: 'Kédougou', state_code: 'KE', hasCities: true },
            { id: 474, name: 'Kolda', state_code: 'KD', hasCities: true },
            { id: 485, name: 'Louga', state_code: 'LG', hasCities: true },
            { id: 476, name: 'Matam', state_code: 'MT', hasCities: true },
            {
                id: 477,
                name: 'Saint-Louis',
                state_code: 'SL',
                hasCities: true
            },
            { id: 482, name: 'Sédhiou', state_code: 'SE', hasCities: true },
            {
                id: 486,
                name: 'Tambacounda Region',
                state_code: 'TC',
                hasCities: true
            },
            {
                id: 484,
                name: 'Thiès Region',
                state_code: 'TH',
                hasCities: true
            },
            { id: 478, name: 'Ziguinchor', state_code: 'ZG', hasCities: true }
        ]
    },
    {
        id: 196,
        states: [
            {
                id: 3728,
                name: 'Belgrade',
                state_code: '00',
                hasCities: false
            },
            {
                id: 3717,
                name: 'Bor District',
                state_code: '14',
                hasCities: false
            },
            {
                id: 3732,
                name: 'Braničevo District',
                state_code: '11',
                hasCities: false
            },
            {
                id: 3716,
                name: 'Central Banat District',
                state_code: '02',
                hasCities: true
            },
            {
                id: 3715,
                name: 'Jablanica District',
                state_code: '23',
                hasCities: false
            },
            {
                id: 3724,
                name: 'Kolubara District',
                state_code: '09',
                hasCities: false
            },
            {
                id: 3719,
                name: 'Mačva District',
                state_code: '08',
                hasCities: false
            },
            {
                id: 3727,
                name: 'Moravica District',
                state_code: '17',
                hasCities: false
            },
            {
                id: 3722,
                name: 'Nišava District',
                state_code: '20',
                hasCities: false
            },
            {
                id: 3714,
                name: 'North Bačka District',
                state_code: '01',
                hasCities: false
            },
            {
                id: 3736,
                name: 'North Banat District',
                state_code: '03',
                hasCities: false
            },
            {
                id: 3721,
                name: 'Pčinja District',
                state_code: '24',
                hasCities: false
            },
            {
                id: 3712,
                name: 'Pirot District',
                state_code: '22',
                hasCities: false
            },
            {
                id: 3741,
                name: 'Podunavlje District',
                state_code: '10',
                hasCities: false
            },
            {
                id: 3737,
                name: 'Pomoravlje District',
                state_code: '13',
                hasCities: false
            },
            {
                id: 3720,
                name: 'Rasina District',
                state_code: '19',
                hasCities: false
            },
            {
                id: 3725,
                name: 'Raška District',
                state_code: '18',
                hasCities: false
            },
            {
                id: 3711,
                name: 'South Bačka District',
                state_code: '06',
                hasCities: false
            },
            {
                id: 3713,
                name: 'South Banat District',
                state_code: '04',
                hasCities: false
            },
            {
                id: 3740,
                name: 'Srem District',
                state_code: '07',
                hasCities: false
            },
            {
                id: 3734,
                name: 'Šumadija District',
                state_code: '12',
                hasCities: false
            },
            {
                id: 3718,
                name: 'Toplica District',
                state_code: '21',
                hasCities: false
            },
            {
                id: 3733,
                name: 'Vojvodina',
                state_code: 'VO',
                hasCities: true
            },
            {
                id: 3726,
                name: 'West Bačka District',
                state_code: '05',
                hasCities: false
            },
            {
                id: 3731,
                name: 'Zaječar District',
                state_code: '15',
                hasCities: false
            },
            {
                id: 3729,
                name: 'Zlatibor District',
                state_code: '16',
                hasCities: false
            }
        ]
    },
    {
        id: 197,
        states: [
            {
                id: 513,
                name: 'Anse Boileau',
                state_code: '02',
                hasCities: true
            },
            {
                id: 502,
                name: 'Anse Royale',
                state_code: '05',
                hasCities: true
            },
            {
                id: 506,
                name: 'Anse-aux-Pins',
                state_code: '01',
                hasCities: false
            },
            { id: 508, name: 'Au Cap', state_code: '04', hasCities: false },
            {
                id: 497,
                name: 'Baie Lazare',
                state_code: '06',
                hasCities: false
            },
            {
                id: 514,
                name: 'Baie Sainte Anne',
                state_code: '07',
                hasCities: false
            },
            {
                id: 512,
                name: 'Beau Vallon',
                state_code: '08',
                hasCities: true
            },
            { id: 515, name: 'Bel Air', state_code: '09', hasCities: false },
            { id: 505, name: 'Bel Ombre', state_code: '10', hasCities: true },
            { id: 517, name: 'Cascade', state_code: '11', hasCities: true },
            { id: 503, name: 'Glacis', state_code: '12', hasCities: false },
            {
                id: 500,
                name: "Grand'Anse Mahé",
                state_code: '13',
                hasCities: false
            },
            {
                id: 504,
                name: "Grand'Anse Praslin",
                state_code: '14',
                hasCities: false
            },
            { id: 495, name: 'La Digue', state_code: '15', hasCities: false },
            {
                id: 516,
                name: 'La Rivière Anglaise',
                state_code: '16',
                hasCities: true
            },
            {
                id: 499,
                name: 'Les Mamelles',
                state_code: '24',
                hasCities: false
            },
            {
                id: 494,
                name: 'Mont Buxton',
                state_code: '17',
                hasCities: false
            },
            {
                id: 498,
                name: 'Mont Fleuri',
                state_code: '18',
                hasCities: false
            },
            {
                id: 511,
                name: 'Plaisance',
                state_code: '19',
                hasCities: false
            },
            {
                id: 510,
                name: 'Pointe La Rue',
                state_code: '20',
                hasCities: false
            },
            {
                id: 507,
                name: 'Port Glaud',
                state_code: '21',
                hasCities: true
            },
            {
                id: 501,
                name: 'Roche Caiman',
                state_code: '25',
                hasCities: false
            },
            {
                id: 496,
                name: 'Saint Louis',
                state_code: '22',
                hasCities: false
            },
            { id: 509, name: 'Takamaka', state_code: '23', hasCities: true }
        ]
    },
    {
        id: 198,
        states: [
            {
                id: 914,
                name: 'Eastern Province',
                state_code: 'E',
                hasCities: true
            },
            {
                id: 911,
                name: 'Northern Province',
                state_code: 'N',
                hasCities: true
            },
            {
                id: 912,
                name: 'Southern Province',
                state_code: 'S',
                hasCities: true
            },
            {
                id: 913,
                name: 'Western Area',
                state_code: 'W',
                hasCities: true
            }
        ]
    },
    {
        id: 199,
        states: [
            {
                id: 4651,
                name: 'Central Singapore Community Development Council',
                state_code: '01',
                hasCities: true
            },
            {
                id: 4649,
                name: 'North East Community Development Council',
                state_code: '02',
                hasCities: false
            },
            {
                id: 4653,
                name: 'North West Community Development Council',
                state_code: '03',
                hasCities: true
            },
            {
                id: 4650,
                name: 'South East Community Development Council',
                state_code: '04',
                hasCities: false
            },
            {
                id: 4652,
                name: 'South West Community Development Council',
                state_code: '05',
                hasCities: false
            }
        ]
    },
    { id: 250, states: [] },
    {
        id: 200,
        states: [
            {
                id: 4352,
                name: 'Banská Bystrica Region',
                state_code: 'BC',
                hasCities: true
            },
            {
                id: 4356,
                name: 'Bratislava Region',
                state_code: 'BL',
                hasCities: true
            },
            {
                id: 4353,
                name: 'Košice Region',
                state_code: 'KI',
                hasCities: true
            },
            {
                id: 4357,
                name: 'Nitra Region',
                state_code: 'NI',
                hasCities: true
            },
            {
                id: 4354,
                name: 'Prešov Region',
                state_code: 'PV',
                hasCities: true
            },
            {
                id: 4358,
                name: 'Trenčín Region',
                state_code: 'TC',
                hasCities: true
            },
            {
                id: 4355,
                name: 'Trnava Region',
                state_code: 'TA',
                hasCities: true
            },
            {
                id: 4359,
                name: 'Žilina Region',
                state_code: 'ZI',
                hasCities: true
            }
        ]
    },
    {
        id: 201,
        states: [
            {
                id: 4183,
                name: 'Ajdovščina Municipality',
                state_code: '001',
                hasCities: true
            },
            {
                id: 4326,
                name: 'Ankaran Municipality',
                state_code: '213',
                hasCities: true
            },
            {
                id: 4301,
                name: 'Beltinci Municipality',
                state_code: '002',
                hasCities: true
            },
            {
                id: 4166,
                name: 'Benedikt Municipality',
                state_code: '148',
                hasCities: true
            },
            {
                id: 4179,
                name: 'Bistrica ob Sotli Municipality',
                state_code: '149',
                hasCities: true
            },
            {
                id: 4202,
                name: 'Bled Municipality',
                state_code: '003',
                hasCities: true
            },
            {
                id: 4278,
                name: 'Bloke Municipality',
                state_code: '150',
                hasCities: true
            },
            {
                id: 4282,
                name: 'Bohinj Municipality',
                state_code: '004',
                hasCities: true
            },
            {
                id: 4200,
                name: 'Borovnica Municipality',
                state_code: '005',
                hasCities: true
            },
            {
                id: 4181,
                name: 'Bovec Municipality',
                state_code: '006',
                hasCities: true
            },
            {
                id: 4141,
                name: 'Braslovče Municipality',
                state_code: '151',
                hasCities: true
            },
            {
                id: 4240,
                name: 'Brda Municipality',
                state_code: '007',
                hasCities: true
            },
            {
                id: 4215,
                name: 'Brežice Municipality',
                state_code: '009',
                hasCities: true
            },
            {
                id: 4165,
                name: 'Brezovica Municipality',
                state_code: '008',
                hasCities: true
            },
            {
                id: 4147,
                name: 'Cankova Municipality',
                state_code: '152',
                hasCities: true
            },
            {
                id: 4310,
                name: 'Cerklje na Gorenjskem Municipality',
                state_code: '012',
                hasCities: true
            },
            {
                id: 4162,
                name: 'Cerknica Municipality',
                state_code: '013',
                hasCities: true
            },
            {
                id: 4178,
                name: 'Cerkno Municipality',
                state_code: '014',
                hasCities: true
            },
            {
                id: 4176,
                name: 'Cerkvenjak Municipality',
                state_code: '153',
                hasCities: true
            },
            {
                id: 4191,
                name: 'City Municipality of Celje',
                state_code: '011',
                hasCities: true
            },
            {
                id: 4236,
                name: 'City Municipality of Novo Mesto',
                state_code: '085',
                hasCities: true
            },
            {
                id: 4151,
                name: 'Črenšovci Municipality',
                state_code: '015',
                hasCities: true
            },
            {
                id: 4232,
                name: 'Črna na Koroškem Municipality',
                state_code: '016',
                hasCities: true
            },
            {
                id: 4291,
                name: 'Črnomelj Municipality',
                state_code: '017',
                hasCities: true
            },
            {
                id: 4304,
                name: 'Destrnik Municipality',
                state_code: '018',
                hasCities: true
            },
            {
                id: 4167,
                name: 'Divača Municipality',
                state_code: '019',
                hasCities: true
            },
            {
                id: 4295,
                name: 'Dobje Municipality',
                state_code: '154',
                hasCities: true
            },
            {
                id: 4216,
                name: 'Dobrepolje Municipality',
                state_code: '020',
                hasCities: true
            },
            {
                id: 4252,
                name: 'Dobrna Municipality',
                state_code: '155',
                hasCities: true
            },
            {
                id: 4308,
                name: 'Dobrova–Polhov Gradec Municipality',
                state_code: '021',
                hasCities: true
            },
            {
                id: 4189,
                name: 'Dobrovnik Municipality',
                state_code: '156',
                hasCities: true
            },
            {
                id: 4173,
                name: 'Dol pri Ljubljani Municipality',
                state_code: '022',
                hasCities: true
            },
            {
                id: 4281,
                name: 'Dolenjske Toplice Municipality',
                state_code: '157',
                hasCities: true
            },
            {
                id: 4159,
                name: 'Domžale Municipality',
                state_code: '023',
                hasCities: true
            },
            {
                id: 4290,
                name: 'Dornava Municipality',
                state_code: '024',
                hasCities: true
            },
            {
                id: 4345,
                name: 'Dravograd Municipality',
                state_code: '025',
                hasCities: true
            },
            {
                id: 4213,
                name: 'Duplek Municipality',
                state_code: '026',
                hasCities: true
            },
            {
                id: 4293,
                name: 'Gorenja Vas–Poljane Municipality',
                state_code: '027',
                hasCities: true
            },
            {
                id: 4210,
                name: 'Gorišnica Municipality',
                state_code: '028',
                hasCities: true
            },
            {
                id: 4284,
                name: 'Gorje Municipality',
                state_code: '207',
                hasCities: false
            },
            {
                id: 4343,
                name: 'Gornja Radgona Municipality',
                state_code: '029',
                hasCities: true
            },
            {
                id: 4339,
                name: 'Gornji Grad Municipality',
                state_code: '030',
                hasCities: true
            },
            {
                id: 4271,
                name: 'Gornji Petrovci Municipality',
                state_code: '031',
                hasCities: true
            },
            {
                id: 4217,
                name: 'Grad Municipality',
                state_code: '158',
                hasCities: true
            },
            {
                id: 4336,
                name: 'Grosuplje Municipality',
                state_code: '032',
                hasCities: true
            },
            {
                id: 4145,
                name: 'Hajdina Municipality',
                state_code: '159',
                hasCities: true
            },
            {
                id: 4175,
                name: 'Hoče–Slivnica Municipality',
                state_code: '160',
                hasCities: true
            },
            {
                id: 4327,
                name: 'Hodoš Municipality',
                state_code: '161',
                hasCities: true
            },
            {
                id: 4193,
                name: 'Horjul Municipality',
                state_code: '162',
                hasCities: true
            },
            {
                id: 4341,
                name: 'Hrastnik Municipality',
                state_code: '034',
                hasCities: true
            },
            {
                id: 4321,
                name: 'Hrpelje–Kozina Municipality',
                state_code: '035',
                hasCities: true
            },
            {
                id: 4152,
                name: 'Idrija Municipality',
                state_code: '036',
                hasCities: true
            },
            {
                id: 4286,
                name: 'Ig Municipality',
                state_code: '037',
                hasCities: true
            },
            {
                id: 4305,
                name: 'Ivančna Gorica Municipality',
                state_code: '039',
                hasCities: true
            },
            {
                id: 4322,
                name: 'Izola Municipality',
                state_code: '040',
                hasCities: true
            },
            {
                id: 4337,
                name: 'Jesenice Municipality',
                state_code: '041',
                hasCities: true
            },
            {
                id: 4203,
                name: 'Jezersko Municipality',
                state_code: '163',
                hasCities: true
            },
            {
                id: 4266,
                name: 'Juršinci Municipality',
                state_code: '042',
                hasCities: true
            },
            {
                id: 4180,
                name: 'Kamnik Municipality',
                state_code: '043',
                hasCities: true
            },
            {
                id: 4227,
                name: 'Kanal ob Soči Municipality',
                state_code: '044',
                hasCities: true
            },
            {
                id: 4150,
                name: 'Kidričevo Municipality',
                state_code: '045',
                hasCities: true
            },
            {
                id: 4243,
                name: 'Kobarid Municipality',
                state_code: '046',
                hasCities: true
            },
            {
                id: 4325,
                name: 'Kobilje Municipality',
                state_code: '047',
                hasCities: true
            },
            {
                id: 4335,
                name: 'Kočevje Municipality',
                state_code: '048',
                hasCities: true
            },
            {
                id: 4315,
                name: 'Komen Municipality',
                state_code: '049',
                hasCities: true
            },
            {
                id: 4283,
                name: 'Komenda Municipality',
                state_code: '164',
                hasCities: true
            },
            {
                id: 4319,
                name: 'Koper City Municipality',
                state_code: '050',
                hasCities: true
            },
            {
                id: 4254,
                name: 'Kostanjevica na Krki Municipality',
                state_code: '197',
                hasCities: false
            },
            {
                id: 4331,
                name: 'Kostel Municipality',
                state_code: '165',
                hasCities: true
            },
            {
                id: 4186,
                name: 'Kozje Municipality',
                state_code: '051',
                hasCities: true
            },
            {
                id: 4287,
                name: 'Kranj City Municipality',
                state_code: '052',
                hasCities: true
            },
            {
                id: 4340,
                name: 'Kranjska Gora Municipality',
                state_code: '053',
                hasCities: true
            },
            {
                id: 4238,
                name: 'Križevci Municipality',
                state_code: '166',
                hasCities: true
            },
            { id: 4197, name: 'Kungota', state_code: '055', hasCities: true },
            {
                id: 4211,
                name: 'Kuzma Municipality',
                state_code: '056',
                hasCities: true
            },
            {
                id: 4338,
                name: 'Laško Municipality',
                state_code: '057',
                hasCities: true
            },
            {
                id: 4142,
                name: 'Lenart Municipality',
                state_code: '058',
                hasCities: true
            },
            {
                id: 4225,
                name: 'Lendava Municipality',
                state_code: '059',
                hasCities: true
            },
            {
                id: 4347,
                name: 'Litija Municipality',
                state_code: '060',
                hasCities: true
            },
            {
                id: 4270,
                name: 'Ljubljana City Municipality',
                state_code: '061',
                hasCities: true
            },
            {
                id: 4294,
                name: 'Ljubno Municipality',
                state_code: '062',
                hasCities: true
            },
            {
                id: 4351,
                name: 'Ljutomer Municipality',
                state_code: '063',
                hasCities: true
            },
            {
                id: 4306,
                name: 'Log–Dragomer Municipality',
                state_code: '208',
                hasCities: false
            },
            {
                id: 4350,
                name: 'Logatec Municipality',
                state_code: '064',
                hasCities: true
            },
            {
                id: 4174,
                name: 'Loška Dolina Municipality',
                state_code: '065',
                hasCities: true
            },
            {
                id: 4158,
                name: 'Loški Potok Municipality',
                state_code: '066',
                hasCities: true
            },
            {
                id: 4156,
                name: 'Lovrenc na Pohorju Municipality',
                state_code: '167',
                hasCities: true
            },
            {
                id: 4219,
                name: 'Luče Municipality',
                state_code: '067',
                hasCities: true
            },
            {
                id: 4302,
                name: 'Lukovica Municipality',
                state_code: '068',
                hasCities: true
            },
            {
                id: 4157,
                name: 'Majšperk Municipality',
                state_code: '069',
                hasCities: true
            },
            {
                id: 4224,
                name: 'Makole Municipality',
                state_code: '198',
                hasCities: false
            },
            {
                id: 4242,
                name: 'Maribor City Municipality',
                state_code: '070',
                hasCities: true
            },
            {
                id: 4244,
                name: 'Markovci Municipality',
                state_code: '168',
                hasCities: true
            },
            {
                id: 4349,
                name: 'Medvode Municipality',
                state_code: '071',
                hasCities: true
            },
            {
                id: 4348,
                name: 'Mengeš Municipality',
                state_code: '072',
                hasCities: true
            },
            {
                id: 4323,
                name: 'Metlika Municipality',
                state_code: '073',
                hasCities: true
            },
            {
                id: 4265,
                name: 'Mežica Municipality',
                state_code: '074',
                hasCities: true
            },
            {
                id: 4223,
                name: 'Miklavž na Dravskem Polju Municipality',
                state_code: '169',
                hasCities: true
            },
            {
                id: 4220,
                name: 'Miren–Kostanjevica Municipality',
                state_code: '075',
                hasCities: true
            },
            {
                id: 4298,
                name: 'Mirna Municipality',
                state_code: '212',
                hasCities: false
            },
            {
                id: 4237,
                name: 'Mirna Peč Municipality',
                state_code: '170',
                hasCities: true
            },
            {
                id: 4212,
                name: 'Mislinja Municipality',
                state_code: '076',
                hasCities: true
            },
            {
                id: 4297,
                name: 'Mokronog–Trebelno Municipality',
                state_code: '199',
                hasCities: false
            },
            {
                id: 4168,
                name: 'Moravče Municipality',
                state_code: '077',
                hasCities: true
            },
            {
                id: 4218,
                name: 'Moravske Toplice Municipality',
                state_code: '078',
                hasCities: true
            },
            {
                id: 4190,
                name: 'Mozirje Municipality',
                state_code: '079',
                hasCities: true
            },
            {
                id: 4318,
                name: 'Municipality of Apače',
                state_code: '195',
                hasCities: true
            },
            {
                id: 4309,
                name: 'Municipality of Cirkulane',
                state_code: '196',
                hasCities: false
            },
            {
                id: 4344,
                name: 'Municipality of Ilirska Bistrica',
                state_code: '038',
                hasCities: true
            },
            {
                id: 4314,
                name: 'Municipality of Krško',
                state_code: '054',
                hasCities: true
            },
            {
                id: 4187,
                name: 'Municipality of Škofljica',
                state_code: '123',
                hasCities: true
            },
            {
                id: 4313,
                name: 'Murska Sobota City Municipality',
                state_code: '080',
                hasCities: true
            },
            {
                id: 4208,
                name: 'Muta Municipality',
                state_code: '081',
                hasCities: true
            },
            {
                id: 4177,
                name: 'Naklo Municipality',
                state_code: '082',
                hasCities: true
            },
            {
                id: 4329,
                name: 'Nazarje Municipality',
                state_code: '083',
                hasCities: true
            },
            {
                id: 4205,
                name: 'Nova Gorica City Municipality',
                state_code: '084',
                hasCities: true
            },
            {
                id: 4320,
                name: 'Odranci Municipality',
                state_code: '086',
                hasCities: true
            },
            {
                id: 4143,
                name: 'Oplotnica',
                state_code: '171',
                hasCities: true
            },
            {
                id: 4221,
                name: 'Ormož Municipality',
                state_code: '087',
                hasCities: true
            },
            {
                id: 4199,
                name: 'Osilnica Municipality',
                state_code: '088',
                hasCities: true
            },
            {
                id: 4172,
                name: 'Pesnica Municipality',
                state_code: '089',
                hasCities: true
            },
            {
                id: 4201,
                name: 'Piran Municipality',
                state_code: '090',
                hasCities: true
            },
            {
                id: 4184,
                name: 'Pivka Municipality',
                state_code: '091',
                hasCities: true
            },
            {
                id: 4146,
                name: 'Podčetrtek Municipality',
                state_code: '092',
                hasCities: true
            },
            {
                id: 4161,
                name: 'Podlehnik Municipality',
                state_code: '172',
                hasCities: true
            },
            {
                id: 4234,
                name: 'Podvelka Municipality',
                state_code: '093',
                hasCities: true
            },
            {
                id: 4239,
                name: 'Poljčane Municipality',
                state_code: '200',
                hasCities: false
            },
            {
                id: 4272,
                name: 'Polzela Municipality',
                state_code: '173',
                hasCities: true
            },
            {
                id: 4330,
                name: 'Postojna Municipality',
                state_code: '094',
                hasCities: true
            },
            {
                id: 4188,
                name: 'Prebold Municipality',
                state_code: '174',
                hasCities: true
            },
            {
                id: 4303,
                name: 'Preddvor Municipality',
                state_code: '095',
                hasCities: true
            },
            {
                id: 4274,
                name: 'Prevalje Municipality',
                state_code: '175',
                hasCities: true
            },
            {
                id: 4228,
                name: 'Ptuj City Municipality',
                state_code: '096',
                hasCities: true
            },
            {
                id: 4288,
                name: 'Puconci Municipality',
                state_code: '097',
                hasCities: true
            },
            {
                id: 4204,
                name: 'Rače–Fram Municipality',
                state_code: '098',
                hasCities: true
            },
            {
                id: 4195,
                name: 'Radeče Municipality',
                state_code: '099',
                hasCities: true
            },
            {
                id: 4292,
                name: 'Radenci Municipality',
                state_code: '100',
                hasCities: true
            },
            {
                id: 4275,
                name: 'Radlje ob Dravi Municipality',
                state_code: '101',
                hasCities: true
            },
            {
                id: 4231,
                name: 'Radovljica Municipality',
                state_code: '102',
                hasCities: true
            },
            {
                id: 4155,
                name: 'Ravne na Koroškem Municipality',
                state_code: '103',
                hasCities: true
            },
            {
                id: 4206,
                name: 'Razkrižje Municipality',
                state_code: '176',
                hasCities: true
            },
            {
                id: 4160,
                name: 'Rečica ob Savinji Municipality',
                state_code: '209',
                hasCities: false
            },
            {
                id: 4253,
                name: 'Renče–Vogrsko Municipality',
                state_code: '201',
                hasCities: true
            },
            {
                id: 4235,
                name: 'Ribnica Municipality',
                state_code: '104',
                hasCities: true
            },
            {
                id: 4207,
                name: 'Ribnica na Pohorju Municipality',
                state_code: '177',
                hasCities: true
            },
            {
                id: 4233,
                name: 'Rogaška Slatina Municipality',
                state_code: '106',
                hasCities: true
            },
            {
                id: 4264,
                name: 'Rogašovci Municipality',
                state_code: '105',
                hasCities: true
            },
            {
                id: 4209,
                name: 'Rogatec Municipality',
                state_code: '107',
                hasCities: true
            },
            {
                id: 4280,
                name: 'Ruše Municipality',
                state_code: '108',
                hasCities: true
            },
            {
                id: 4222,
                name: 'Šalovci Municipality',
                state_code: '033',
                hasCities: true
            },
            {
                id: 4230,
                name: 'Selnica ob Dravi Municipality',
                state_code: '178',
                hasCities: true
            },
            {
                id: 4346,
                name: 'Semič Municipality',
                state_code: '109',
                hasCities: true
            },
            {
                id: 4317,
                name: 'Šempeter–Vrtojba Municipality',
                state_code: '183',
                hasCities: true
            },
            {
                id: 4299,
                name: 'Šenčur Municipality',
                state_code: '117',
                hasCities: true
            },
            {
                id: 4324,
                name: 'Šentilj Municipality',
                state_code: '118',
                hasCities: true
            },
            {
                id: 4241,
                name: 'Šentjernej Municipality',
                state_code: '119',
                hasCities: true
            },
            {
                id: 4171,
                name: 'Šentjur Municipality',
                state_code: '120',
                hasCities: true
            },
            {
                id: 4311,
                name: 'Šentrupert Municipality',
                state_code: '211',
                hasCities: true
            },
            {
                id: 4268,
                name: 'Sevnica Municipality',
                state_code: '110',
                hasCities: true
            },
            {
                id: 4149,
                name: 'Sežana Municipality',
                state_code: '111',
                hasCities: true
            },
            {
                id: 4170,
                name: 'Škocjan Municipality',
                state_code: '121',
                hasCities: true
            },
            {
                id: 4316,
                name: 'Škofja Loka Municipality',
                state_code: '122',
                hasCities: true
            },
            {
                id: 4169,
                name: 'Slovenj Gradec City Municipality',
                state_code: '112',
                hasCities: true
            },
            {
                id: 4332,
                name: 'Slovenska Bistrica Municipality',
                state_code: '113',
                hasCities: true
            },
            {
                id: 4198,
                name: 'Slovenske Konjice Municipality',
                state_code: '114',
                hasCities: true
            },
            {
                id: 4285,
                name: 'Šmarje pri Jelšah Municipality',
                state_code: '124',
                hasCities: true
            },
            {
                id: 4289,
                name: 'Šmarješke Toplice Municipality',
                state_code: '206',
                hasCities: true
            },
            {
                id: 4296,
                name: 'Šmartno ob Paki Municipality',
                state_code: '125',
                hasCities: true
            },
            {
                id: 4279,
                name: 'Šmartno pri Litiji Municipality',
                state_code: '194',
                hasCities: true
            },
            {
                id: 4277,
                name: 'Sodražica Municipality',
                state_code: '179',
                hasCities: true
            },
            {
                id: 4261,
                name: 'Solčava Municipality',
                state_code: '180',
                hasCities: true
            },
            {
                id: 4248,
                name: 'Šoštanj Municipality',
                state_code: '126',
                hasCities: true
            },
            {
                id: 4263,
                name: 'Središče ob Dravi',
                state_code: '202',
                hasCities: true
            },
            {
                id: 4259,
                name: 'Starše Municipality',
                state_code: '115',
                hasCities: true
            },
            {
                id: 4185,
                name: 'Štore Municipality',
                state_code: '127',
                hasCities: true
            },
            {
                id: 4333,
                name: 'Straža Municipality',
                state_code: '203',
                hasCities: true
            },
            {
                id: 4164,
                name: 'Sveta Ana Municipality',
                state_code: '181',
                hasCities: true
            },
            {
                id: 4260,
                name: 'Sveta Trojica v Slovenskih Goricah Municipality',
                state_code: '204',
                hasCities: true
            },
            {
                id: 4229,
                name: 'Sveti Andraž v Slovenskih Goricah Municipality',
                state_code: '182',
                hasCities: true
            },
            {
                id: 4255,
                name: 'Sveti Jurij ob Ščavnici Municipality',
                state_code: '116',
                hasCities: false
            },
            {
                id: 4328,
                name: 'Sveti Jurij v Slovenskih Goricah Municipality',
                state_code: '210',
                hasCities: true
            },
            {
                id: 4273,
                name: 'Sveti Tomaž Municipality',
                state_code: '205',
                hasCities: true
            },
            {
                id: 4194,
                name: 'Tabor Municipality',
                state_code: '184',
                hasCities: true
            },
            {
                id: 4312,
                name: 'Tišina Municipality',
                state_code: '010',
                hasCities: true
            },
            {
                id: 4247,
                name: 'Tolmin Municipality',
                state_code: '128',
                hasCities: true
            },
            {
                id: 4246,
                name: 'Trbovlje Municipality',
                state_code: '129',
                hasCities: true
            },
            {
                id: 4214,
                name: 'Trebnje Municipality',
                state_code: '130',
                hasCities: true
            },
            {
                id: 4153,
                name: 'Trnovska Vas Municipality',
                state_code: '185',
                hasCities: true
            },
            {
                id: 4250,
                name: 'Tržič Municipality',
                state_code: '131',
                hasCities: true
            },
            {
                id: 4334,
                name: 'Trzin Municipality',
                state_code: '186',
                hasCities: true
            },
            {
                id: 4251,
                name: 'Turnišče Municipality',
                state_code: '132',
                hasCities: true
            },
            {
                id: 4267,
                name: 'Velika Polana Municipality',
                state_code: '187',
                hasCities: true
            },
            {
                id: 4144,
                name: 'Velike Lašče Municipality',
                state_code: '134',
                hasCities: true
            },
            {
                id: 4257,
                name: 'Veržej Municipality',
                state_code: '188',
                hasCities: true
            },
            {
                id: 4300,
                name: 'Videm Municipality',
                state_code: '135',
                hasCities: true
            },
            {
                id: 4196,
                name: 'Vipava Municipality',
                state_code: '136',
                hasCities: true
            },
            {
                id: 4148,
                name: 'Vitanje Municipality',
                state_code: '137',
                hasCities: true
            },
            {
                id: 4154,
                name: 'Vodice Municipality',
                state_code: '138',
                hasCities: true
            },
            {
                id: 4245,
                name: 'Vojnik Municipality',
                state_code: '139',
                hasCities: true
            },
            {
                id: 4163,
                name: 'Vransko Municipality',
                state_code: '189',
                hasCities: true
            },
            {
                id: 4262,
                name: 'Vrhnika Municipality',
                state_code: '140',
                hasCities: true
            },
            {
                id: 4226,
                name: 'Vuzenica Municipality',
                state_code: '141',
                hasCities: true
            },
            {
                id: 4269,
                name: 'Zagorje ob Savi Municipality',
                state_code: '142',
                hasCities: true
            },
            {
                id: 4258,
                name: 'Žalec Municipality',
                state_code: '190',
                hasCities: true
            },
            {
                id: 4182,
                name: 'Zavrč Municipality',
                state_code: '143',
                hasCities: true
            },
            {
                id: 4256,
                name: 'Železniki Municipality',
                state_code: '146',
                hasCities: true
            },
            {
                id: 4249,
                name: 'Žetale Municipality',
                state_code: '191',
                hasCities: true
            },
            {
                id: 4192,
                name: 'Žiri Municipality',
                state_code: '147',
                hasCities: true
            },
            {
                id: 4276,
                name: 'Žirovnica Municipality',
                state_code: '192',
                hasCities: true
            },
            {
                id: 4342,
                name: 'Zreče Municipality',
                state_code: '144',
                hasCities: true
            },
            {
                id: 4307,
                name: 'Žužemberk Municipality',
                state_code: '193',
                hasCities: true
            }
        ]
    },
    {
        id: 202,
        states: [
            {
                id: 4784,
                name: 'Central Province',
                state_code: 'CE',
                hasCities: true
            },
            {
                id: 4781,
                name: 'Choiseul Province',
                state_code: 'CH',
                hasCities: false
            },
            {
                id: 4785,
                name: 'Guadalcanal Province',
                state_code: 'GU',
                hasCities: true
            },
            { id: 4778, name: 'Honiara', state_code: 'CT', hasCities: false },
            {
                id: 4780,
                name: 'Isabel Province',
                state_code: 'IS',
                hasCities: true
            },
            {
                id: 4782,
                name: 'Makira-Ulawa Province',
                state_code: 'MK',
                hasCities: true
            },
            {
                id: 4783,
                name: 'Malaita Province',
                state_code: 'ML',
                hasCities: true
            },
            {
                id: 4787,
                name: 'Rennell and Bellona Province',
                state_code: 'RB',
                hasCities: false
            },
            {
                id: 4779,
                name: 'Temotu Province',
                state_code: 'TE',
                hasCities: true
            },
            {
                id: 4786,
                name: 'Western Province',
                state_code: 'WE',
                hasCities: true
            }
        ]
    },
    {
        id: 203,
        states: [
            {
                id: 925,
                name: 'Awdal Region',
                state_code: 'AW',
                hasCities: false
            },
            { id: 917, name: 'Bakool', state_code: 'BK', hasCities: true },
            { id: 927, name: 'Banaadir', state_code: 'BN', hasCities: true },
            { id: 930, name: 'Bari', state_code: 'BR', hasCities: true },
            { id: 926, name: 'Bay', state_code: 'BY', hasCities: true },
            { id: 918, name: 'Galguduud', state_code: 'GA', hasCities: true },
            { id: 928, name: 'Gedo', state_code: 'GE', hasCities: true },
            { id: 915, name: 'Hiran', state_code: 'HI', hasCities: true },
            {
                id: 924,
                name: 'Lower Juba',
                state_code: 'JH',
                hasCities: true
            },
            {
                id: 921,
                name: 'Lower Shebelle',
                state_code: 'SH',
                hasCities: true
            },
            {
                id: 922,
                name: 'Middle Juba',
                state_code: 'JD',
                hasCities: true
            },
            {
                id: 923,
                name: 'Middle Shebelle',
                state_code: 'SD',
                hasCities: true
            },
            { id: 916, name: 'Mudug', state_code: 'MU', hasCities: true },
            { id: 920, name: 'Nugal', state_code: 'NU', hasCities: true },
            {
                id: 919,
                name: 'Sanaag Region',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 929,
                name: 'Togdheer Region',
                state_code: 'TO',
                hasCities: true
            }
        ]
    },
    {
        id: 204,
        states: [
            {
                id: 938,
                name: 'Eastern Cape',
                state_code: 'EC',
                hasCities: true
            },
            {
                id: 932,
                name: 'Free State',
                state_code: 'FS',
                hasCities: true
            },
            { id: 936, name: 'Gauteng', state_code: 'GP', hasCities: true },
            {
                id: 935,
                name: 'KwaZulu-Natal',
                state_code: 'KZN',
                hasCities: true
            },
            { id: 933, name: 'Limpopo', state_code: 'LP', hasCities: true },
            {
                id: 937,
                name: 'Mpumalanga',
                state_code: 'MP',
                hasCities: true
            },
            {
                id: 934,
                name: 'North West',
                state_code: 'NW',
                hasCities: true
            },
            {
                id: 931,
                name: 'Northern Cape',
                state_code: 'NC',
                hasCities: true
            },
            {
                id: 939,
                name: 'Western Cape',
                state_code: 'WC',
                hasCities: true
            }
        ]
    },
    { id: 205, states: [] },
    {
        id: 116,
        states: [
            { id: 3860, name: 'Busan', state_code: '26', hasCities: true },
            { id: 3846, name: 'Daegu', state_code: '27', hasCities: true },
            { id: 3850, name: 'Daejeon', state_code: '30', hasCities: true },
            {
                id: 3862,
                name: 'Gangwon Province',
                state_code: '42',
                hasCities: true
            },
            { id: 3858, name: 'Gwangju', state_code: '29', hasCities: true },
            {
                id: 3847,
                name: 'Gyeonggi Province',
                state_code: '41',
                hasCities: true
            },
            { id: 3848, name: 'Incheon', state_code: '28', hasCities: true },
            { id: 3853, name: 'Jeju', state_code: '49', hasCities: true },
            {
                id: 3854,
                name: 'North Chungcheong Province',
                state_code: '43',
                hasCities: true
            },
            {
                id: 3855,
                name: 'North Gyeongsang Province',
                state_code: '47',
                hasCities: true
            },
            {
                id: 3851,
                name: 'North Jeolla Province',
                state_code: '45',
                hasCities: true
            },
            {
                id: 3861,
                name: 'Sejong City',
                state_code: '50',
                hasCities: true
            },
            { id: 3849, name: 'Seoul', state_code: '11', hasCities: true },
            {
                id: 3859,
                name: 'South Chungcheong Province',
                state_code: '44',
                hasCities: true
            },
            {
                id: 3857,
                name: 'South Gyeongsang Province',
                state_code: '48',
                hasCities: true
            },
            {
                id: 3856,
                name: 'South Jeolla Province',
                state_code: '46',
                hasCities: true
            },
            { id: 3852, name: 'Ulsan', state_code: '31', hasCities: true }
        ]
    },
    {
        id: 206,
        states: [
            {
                id: 2092,
                name: 'Central Equatoria',
                state_code: 'EC',
                hasCities: false
            },
            {
                id: 2093,
                name: 'Eastern Equatoria',
                state_code: 'EE',
                hasCities: false
            },
            {
                id: 2094,
                name: 'Jonglei State',
                state_code: 'JG',
                hasCities: false
            },
            { id: 2090, name: 'Lakes', state_code: 'LK', hasCities: true },
            {
                id: 2088,
                name: 'Northern Bahr el Ghazal',
                state_code: 'BN',
                hasCities: false
            },
            { id: 2085, name: 'Unity', state_code: 'UY', hasCities: false },
            {
                id: 2086,
                name: 'Upper Nile',
                state_code: 'NU',
                hasCities: false
            },
            { id: 2087, name: 'Warrap', state_code: 'WR', hasCities: false },
            {
                id: 2091,
                name: 'Western Bahr el Ghazal',
                state_code: 'BW',
                hasCities: false
            },
            {
                id: 2089,
                name: 'Western Equatoria',
                state_code: 'EW',
                hasCities: false
            }
        ]
    },
    {
        id: 207,
        states: [
            { id: 5089, name: 'A Coruña', state_code: 'C', hasCities: true },
            { id: 5109, name: 'Albacete', state_code: 'AB', hasCities: true },
            { id: 5108, name: 'Alicante', state_code: 'A', hasCities: true },
            { id: 5095, name: 'Almeria', state_code: 'AL', hasCities: true },
            { id: 5093, name: 'Araba', state_code: 'VI', hasCities: true },
            { id: 1160, name: 'Asturias', state_code: 'O', hasCities: true },
            { id: 1189, name: 'Ávila', state_code: 'AV', hasCities: true },
            { id: 5092, name: 'Badajoz', state_code: 'BA', hasCities: true },
            { id: 5102, name: 'Barcelona', state_code: 'B', hasCities: true },
            { id: 5094, name: 'Bizkaia', state_code: 'BI', hasCities: true },
            { id: 1146, name: 'Burgos', state_code: 'BU', hasCities: true },
            { id: 1190, name: 'Caceres', state_code: 'CC', hasCities: true },
            { id: 5096, name: 'Cádiz', state_code: 'CA', hasCities: true },
            { id: 1170, name: 'Cantabria', state_code: 'S', hasCities: true },
            {
                id: 5110,
                name: 'Castellón',
                state_code: 'CS',
                hasCities: true
            },
            {
                id: 5105,
                name: 'Ciudad Real',
                state_code: 'CR',
                hasCities: true
            },
            { id: 5097, name: 'Córdoba', state_code: 'CO', hasCities: true },
            { id: 5106, name: 'Cuenca', state_code: 'CU', hasCities: true },
            { id: 1191, name: 'Gipuzkoa', state_code: 'SS', hasCities: true },
            { id: 5103, name: 'Girona', state_code: 'GI', hasCities: true },
            { id: 5098, name: 'Granada', state_code: 'GR', hasCities: true },
            {
                id: 5107,
                name: 'Guadalajara',
                state_code: 'GU',
                hasCities: true
            },
            { id: 5099, name: 'Huelva', state_code: 'H', hasCities: true },
            { id: 1177, name: 'Huesca', state_code: 'HU', hasCities: true },
            {
                id: 1174,
                name: 'Islas Baleares',
                state_code: 'PM',
                hasCities: true
            },
            { id: 5100, name: 'Jaén', state_code: 'J', hasCities: true },
            { id: 1171, name: 'La Rioja', state_code: 'LO', hasCities: true },
            {
                id: 1185,
                name: 'Las Palmas',
                state_code: 'GC',
                hasCities: true
            },
            { id: 1200, name: 'Léon', state_code: 'LE', hasCities: true },
            { id: 5104, name: 'Lleida', state_code: 'L', hasCities: true },
            { id: 5090, name: 'Lugo', state_code: 'LU', hasCities: true },
            { id: 1158, name: 'Madrid', state_code: 'M', hasCities: true },
            { id: 5101, name: 'Málaga', state_code: 'MA', hasCities: true },
            { id: 1176, name: 'Murcia', state_code: 'MU', hasCities: true },
            { id: 1204, name: 'Navarra', state_code: 'NA', hasCities: true },
            { id: 5091, name: 'Ourense', state_code: 'OR', hasCities: true },
            { id: 1157, name: 'Palencia', state_code: 'P', hasCities: true },
            {
                id: 1167,
                name: 'Pontevedra',
                state_code: 'PO',
                hasCities: true
            },
            {
                id: 1147,
                name: 'Salamanca',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 5112,
                name: 'Santa Cruz de Tenerife',
                state_code: 'TF',
                hasCities: true
            },
            { id: 1192, name: 'Segovia', state_code: 'SG', hasCities: true },
            { id: 1193, name: 'Sevilla', state_code: 'SE', hasCities: true },
            { id: 1208, name: 'Soria', state_code: 'SO', hasCities: true },
            { id: 1203, name: 'Tarragona', state_code: 'T', hasCities: true },
            { id: 5111, name: 'Teruel', state_code: 'TE', hasCities: true },
            { id: 1205, name: 'Toledo', state_code: 'TO', hasCities: true },
            { id: 1175, name: 'Valencia', state_code: 'V', hasCities: true },
            {
                id: 1183,
                name: 'Valladolid',
                state_code: 'VA',
                hasCities: true
            },
            { id: 1161, name: 'Zamora', state_code: 'ZA', hasCities: true },
            { id: 5113, name: 'Zaragoza', state_code: 'Z', hasCities: true }
        ]
    },
    {
        id: 208,
        states: [
            {
                id: 2799,
                name: 'Ampara District',
                state_code: '52',
                hasCities: false
            },
            {
                id: 2816,
                name: 'Anuradhapura District',
                state_code: '71',
                hasCities: false
            },
            {
                id: 2790,
                name: 'Badulla District',
                state_code: '81',
                hasCities: false
            },
            {
                id: 2818,
                name: 'Batticaloa District',
                state_code: '51',
                hasCities: false
            },
            {
                id: 2798,
                name: 'Central Province',
                state_code: '2',
                hasCities: true
            },
            {
                id: 2815,
                name: 'Colombo District',
                state_code: '11',
                hasCities: true
            },
            {
                id: 2808,
                name: 'Eastern Province',
                state_code: '5',
                hasCities: true
            },
            {
                id: 2792,
                name: 'Galle District',
                state_code: '31',
                hasCities: false
            },
            {
                id: 2804,
                name: 'Gampaha District',
                state_code: '12',
                hasCities: false
            },
            {
                id: 2791,
                name: 'Hambantota District',
                state_code: '33',
                hasCities: false
            },
            {
                id: 2787,
                name: 'Jaffna District',
                state_code: '41',
                hasCities: false
            },
            {
                id: 2789,
                name: 'Kalutara District',
                state_code: '13',
                hasCities: false
            },
            {
                id: 2788,
                name: 'Kandy District',
                state_code: '21',
                hasCities: true
            },
            {
                id: 2797,
                name: 'Kegalle District',
                state_code: '92',
                hasCities: false
            },
            {
                id: 2793,
                name: 'Kilinochchi District',
                state_code: '42',
                hasCities: false
            },
            {
                id: 2805,
                name: 'Mannar District',
                state_code: '43',
                hasCities: false
            },
            {
                id: 2810,
                name: 'Matale District',
                state_code: '22',
                hasCities: false
            },
            {
                id: 2806,
                name: 'Matara District',
                state_code: '32',
                hasCities: false
            },
            {
                id: 2819,
                name: 'Monaragala District',
                state_code: '82',
                hasCities: false
            },
            {
                id: 2814,
                name: 'Mullaitivu District',
                state_code: '45',
                hasCities: false
            },
            {
                id: 2800,
                name: 'North Central Province',
                state_code: '7',
                hasCities: true
            },
            {
                id: 2817,
                name: 'North Western Province',
                state_code: '6',
                hasCities: true
            },
            {
                id: 2813,
                name: 'Northern Province',
                state_code: '4',
                hasCities: true
            },
            {
                id: 2794,
                name: 'Nuwara Eliya District',
                state_code: '23',
                hasCities: false
            },
            {
                id: 2812,
                name: 'Polonnaruwa District',
                state_code: '72',
                hasCities: false
            },
            {
                id: 2796,
                name: 'Puttalam District',
                state_code: '62',
                hasCities: false
            },
            {
                id: 2807,
                name: 'Ratnapura district',
                state_code: '91',
                hasCities: false
            },
            {
                id: 2803,
                name: 'Sabaragamuwa Province',
                state_code: '9',
                hasCities: true
            },
            {
                id: 2801,
                name: 'Southern Province',
                state_code: '3',
                hasCities: true
            },
            {
                id: 2795,
                name: 'Trincomalee District',
                state_code: '53',
                hasCities: false
            },
            {
                id: 2811,
                name: 'Uva Province',
                state_code: '8',
                hasCities: true
            },
            {
                id: 2809,
                name: 'Vavuniya District',
                state_code: '44',
                hasCities: false
            },
            {
                id: 2802,
                name: 'Western Province',
                state_code: '1',
                hasCities: true
            }
        ]
    },
    {
        id: 209,
        states: [
            {
                id: 885,
                name: 'Al Jazirah',
                state_code: 'GZ',
                hasCities: true
            },
            {
                id: 886,
                name: 'Al Qadarif',
                state_code: 'GD',
                hasCities: true
            },
            { id: 887, name: 'Blue Nile', state_code: 'NB', hasCities: true },
            {
                id: 896,
                name: 'Central Darfur',
                state_code: 'DC',
                hasCities: true
            },
            {
                id: 892,
                name: 'East Darfur',
                state_code: 'DE',
                hasCities: true
            },
            { id: 884, name: 'Kassala', state_code: 'KA', hasCities: true },
            { id: 881, name: 'Khartoum', state_code: 'KH', hasCities: true },
            {
                id: 890,
                name: 'North Darfur',
                state_code: 'DN',
                hasCities: true
            },
            {
                id: 893,
                name: 'North Kordofan',
                state_code: 'KN',
                hasCities: true
            },
            { id: 895, name: 'Northern', state_code: 'NO', hasCities: true },
            { id: 880, name: 'Red Sea', state_code: 'RS', hasCities: true },
            {
                id: 891,
                name: 'River Nile',
                state_code: 'NR',
                hasCities: true
            },
            { id: 882, name: 'Sennar', state_code: 'SI', hasCities: true },
            {
                id: 894,
                name: 'South Darfur',
                state_code: 'DS',
                hasCities: true
            },
            {
                id: 883,
                name: 'South Kordofan',
                state_code: 'KS',
                hasCities: true
            },
            {
                id: 888,
                name: 'West Darfur',
                state_code: 'DW',
                hasCities: true
            },
            {
                id: 889,
                name: 'West Kordofan',
                state_code: 'GK',
                hasCities: true
            },
            { id: 879, name: 'White Nile', state_code: 'NW', hasCities: true }
        ]
    },
    {
        id: 210,
        states: [
            {
                id: 2846,
                name: 'Brokopondo District',
                state_code: 'BR',
                hasCities: true
            },
            {
                id: 2839,
                name: 'Commewijne District',
                state_code: 'CM',
                hasCities: true
            },
            {
                id: 2842,
                name: 'Coronie District',
                state_code: 'CR',
                hasCities: true
            },
            {
                id: 2845,
                name: 'Marowijne District',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 2840,
                name: 'Nickerie District',
                state_code: 'NI',
                hasCities: true
            },
            {
                id: 2841,
                name: 'Para District',
                state_code: 'PR',
                hasCities: true
            },
            {
                id: 2843,
                name: 'Paramaribo District',
                state_code: 'PM',
                hasCities: true
            },
            {
                id: 2848,
                name: 'Saramacca District',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 2847,
                name: 'Sipaliwini District',
                state_code: 'SI',
                hasCities: false
            },
            {
                id: 2844,
                name: 'Wanica District',
                state_code: 'WA',
                hasCities: true
            }
        ]
    },
    { id: 211, states: [] },
    {
        id: 212,
        states: [
            {
                id: 969,
                name: 'Hhohho District',
                state_code: 'HH',
                hasCities: true
            },
            {
                id: 970,
                name: 'Lubombo District',
                state_code: 'LU',
                hasCities: true
            },
            {
                id: 968,
                name: 'Manzini District',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 971,
                name: 'Shiselweni District',
                state_code: 'SH',
                hasCities: true
            }
        ]
    },
    {
        id: 213,
        states: [
            { id: 1537, name: 'Blekinge', state_code: 'K', hasCities: true },
            {
                id: 1534,
                name: 'Dalarna County',
                state_code: 'W',
                hasCities: true
            },
            {
                id: 1533,
                name: 'Gävleborg County',
                state_code: 'X',
                hasCities: true
            },
            {
                id: 1546,
                name: 'Gotland County',
                state_code: 'I',
                hasCities: true
            },
            {
                id: 1548,
                name: 'Halland County',
                state_code: 'N',
                hasCities: true
            },
            {
                id: 1550,
                name: 'Jönköping County',
                state_code: 'F',
                hasCities: true
            },
            {
                id: 1544,
                name: 'Kalmar County',
                state_code: 'H',
                hasCities: true
            },
            {
                id: 1542,
                name: 'Kronoberg County',
                state_code: 'G',
                hasCities: true
            },
            {
                id: 1538,
                name: 'Norrbotten County',
                state_code: 'BD',
                hasCities: true
            },
            {
                id: 1539,
                name: 'Örebro County',
                state_code: 'T',
                hasCities: true
            },
            {
                id: 1536,
                name: 'Östergötland County',
                state_code: 'E',
                hasCities: true
            },
            {
                id: 1541,
                name: 'Skåne County',
                state_code: 'M',
                hasCities: true
            },
            {
                id: 1540,
                name: 'Södermanland County',
                state_code: 'D',
                hasCities: true
            },
            {
                id: 1551,
                name: 'Stockholm County',
                state_code: 'AB',
                hasCities: true
            },
            {
                id: 1545,
                name: 'Uppsala County',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 1535,
                name: 'Värmland County',
                state_code: 'S',
                hasCities: true
            },
            {
                id: 1543,
                name: 'Västerbotten County',
                state_code: 'AC',
                hasCities: true
            },
            {
                id: 1552,
                name: 'Västernorrland County',
                state_code: 'Y',
                hasCities: true
            },
            {
                id: 1549,
                name: 'Västmanland County',
                state_code: 'U',
                hasCities: true
            },
            {
                id: 1547,
                name: 'Västra Götaland County',
                state_code: 'O',
                hasCities: true
            }
        ]
    },
    {
        id: 214,
        states: [
            { id: 1639, name: 'Aargau', state_code: 'AG', hasCities: true },
            {
                id: 1655,
                name: 'Appenzell Ausserrhoden',
                state_code: 'AR',
                hasCities: true
            },
            {
                id: 1649,
                name: 'Appenzell Innerrhoden',
                state_code: 'AI',
                hasCities: true
            },
            {
                id: 1641,
                name: 'Basel-Land',
                state_code: 'BL',
                hasCities: true
            },
            {
                id: 4957,
                name: 'Basel-Stadt',
                state_code: 'BS',
                hasCities: true
            },
            { id: 1645, name: 'Bern', state_code: 'BE', hasCities: true },
            { id: 1640, name: 'Fribourg', state_code: 'FR', hasCities: true },
            { id: 1647, name: 'Geneva', state_code: 'GE', hasCities: true },
            { id: 1661, name: 'Glarus', state_code: 'GL', hasCities: true },
            {
                id: 1660,
                name: 'Graubünden',
                state_code: 'GR',
                hasCities: true
            },
            { id: 1658, name: 'Jura', state_code: 'JU', hasCities: true },
            { id: 1663, name: 'Lucerne', state_code: 'LU', hasCities: true },
            {
                id: 1659,
                name: 'Neuchâtel',
                state_code: 'NE',
                hasCities: true
            },
            {
                id: 1652,
                name: 'Nidwalden',
                state_code: 'NW',
                hasCities: true
            },
            { id: 1650, name: 'Obwalden', state_code: 'OW', hasCities: true },
            {
                id: 1654,
                name: 'Schaffhausen',
                state_code: 'SH',
                hasCities: true
            },
            { id: 1653, name: 'Schwyz', state_code: 'SZ', hasCities: true },
            {
                id: 1662,
                name: 'Solothurn',
                state_code: 'SO',
                hasCities: true
            },
            {
                id: 1644,
                name: 'St. Gallen',
                state_code: 'SG',
                hasCities: true
            },
            { id: 1657, name: 'Thurgau', state_code: 'TG', hasCities: true },
            { id: 1643, name: 'Ticino', state_code: 'TI', hasCities: true },
            { id: 1642, name: 'Uri', state_code: 'UR', hasCities: true },
            { id: 1648, name: 'Valais', state_code: 'VS', hasCities: true },
            { id: 1651, name: 'Vaud', state_code: 'VD', hasCities: true },
            { id: 1646, name: 'Zug', state_code: 'ZG', hasCities: true },
            { id: 1656, name: 'Zürich', state_code: 'ZH', hasCities: true }
        ]
    },
    {
        id: 215,
        states: [
            {
                id: 2941,
                name: 'Al-Hasakah',
                state_code: 'HA',
                hasCities: true
            },
            {
                id: 2944,
                name: 'Al-Raqqah',
                state_code: 'RA',
                hasCities: true
            },
            { id: 2946, name: 'Aleppo', state_code: 'HL', hasCities: true },
            {
                id: 2936,
                name: 'As-Suwayda',
                state_code: 'SU',
                hasCities: true
            },
            { id: 2939, name: 'Damascus', state_code: 'DI', hasCities: true },
            { id: 2945, name: 'Daraa', state_code: 'DR', hasCities: true },
            {
                id: 2937,
                name: 'Deir ez-Zor',
                state_code: 'DY',
                hasCities: true
            },
            { id: 2934, name: 'Hama', state_code: 'HM', hasCities: true },
            { id: 2942, name: 'Homs', state_code: 'HI', hasCities: true },
            { id: 2940, name: 'Idlib', state_code: 'ID', hasCities: true },
            { id: 2938, name: 'Latakia', state_code: 'LA', hasCities: true },
            { id: 2943, name: 'Quneitra', state_code: 'QU', hasCities: true },
            {
                id: 2935,
                name: 'Rif Dimashq',
                state_code: 'RD',
                hasCities: true
            },
            { id: 2947, name: 'Tartus', state_code: 'TA', hasCities: true }
        ]
    },
    {
        id: 216,
        states: [
            {
                id: 3404,
                name: 'Changhua',
                state_code: 'CHA',
                hasCities: true
            },
            { id: 3408, name: 'Chiayi', state_code: 'CYI', hasCities: true },
            { id: 3418, name: 'Chiayi', state_code: 'CYQ', hasCities: true },
            { id: 3423, name: 'Hsinchu', state_code: 'HSQ', hasCities: true },
            { id: 3417, name: 'Hsinchu', state_code: 'HSZ', hasCities: true },
            { id: 3411, name: 'Hualien', state_code: 'HUA', hasCities: true },
            {
                id: 3412,
                name: 'Kaohsiung',
                state_code: 'KHH',
                hasCities: true
            },
            {
                id: 4965,
                name: 'Keelung',
                state_code: 'KEE',
                hasCities: false
            },
            { id: 3415, name: 'Kinmen', state_code: 'KIN', hasCities: true },
            {
                id: 3420,
                name: 'Lienchiang',
                state_code: 'LIE',
                hasCities: true
            },
            { id: 3413, name: 'Miaoli', state_code: 'MIA', hasCities: true },
            { id: 3407, name: 'Nantou', state_code: 'NAN', hasCities: true },
            {
                id: 4966,
                name: 'New Taipei',
                state_code: 'NWT',
                hasCities: false
            },
            { id: 3403, name: 'Penghu', state_code: 'PEN', hasCities: true },
            {
                id: 3405,
                name: 'Pingtung',
                state_code: 'PIF',
                hasCities: true
            },
            {
                id: 3406,
                name: 'Taichung',
                state_code: 'TXG',
                hasCities: true
            },
            { id: 3421, name: 'Tainan', state_code: 'TNN', hasCities: true },
            { id: 3422, name: 'Taipei', state_code: 'TPE', hasCities: true },
            { id: 3410, name: 'Taitung', state_code: 'TTT', hasCities: true },
            { id: 3419, name: 'Taoyuan', state_code: 'TAO', hasCities: true },
            { id: 3402, name: 'Yilan', state_code: 'ILA', hasCities: true },
            { id: 3416, name: 'Yunlin', state_code: 'YUN', hasCities: true }
        ]
    },
    {
        id: 217,
        states: [
            {
                id: 3397,
                name: 'districts of Republican Subordination',
                state_code: 'RA',
                hasCities: true
            },
            {
                id: 3399,
                name: 'Gorno-Badakhshan Autonomous Province',
                state_code: 'GB',
                hasCities: true
            },
            {
                id: 3398,
                name: 'Khatlon Province',
                state_code: 'KT',
                hasCities: true
            },
            {
                id: 3400,
                name: 'Sughd Province',
                state_code: 'SU',
                hasCities: true
            }
        ]
    },
    {
        id: 218,
        states: [
            { id: 1491, name: 'Arusha', state_code: '01', hasCities: true },
            {
                id: 1490,
                name: 'Dar es Salaam',
                state_code: '02',
                hasCities: true
            },
            { id: 1466, name: 'Dodoma', state_code: '03', hasCities: true },
            { id: 1481, name: 'Geita', state_code: '27', hasCities: true },
            { id: 1489, name: 'Iringa', state_code: '04', hasCities: true },
            { id: 1465, name: 'Kagera', state_code: '05', hasCities: true },
            { id: 1482, name: 'Katavi', state_code: '28', hasCities: true },
            { id: 1478, name: 'Kigoma', state_code: '08', hasCities: true },
            {
                id: 1467,
                name: 'Kilimanjaro',
                state_code: '09',
                hasCities: true
            },
            { id: 1483, name: 'Lindi', state_code: '12', hasCities: true },
            { id: 1484, name: 'Manyara', state_code: '26', hasCities: true },
            { id: 1468, name: 'Mara', state_code: '13', hasCities: true },
            { id: 4955, name: 'Mbeya', state_code: '14', hasCities: true },
            { id: 1470, name: 'Morogoro', state_code: '16', hasCities: true },
            { id: 1476, name: 'Mtwara', state_code: '17', hasCities: true },
            { id: 1479, name: 'Mwanza', state_code: '18', hasCities: true },
            { id: 1480, name: 'Njombe', state_code: '29', hasCities: true },
            {
                id: 1488,
                name: 'Pemba North',
                state_code: '06',
                hasCities: true
            },
            {
                id: 1472,
                name: 'Pemba South',
                state_code: '10',
                hasCities: true
            },
            { id: 1485, name: 'Pwani', state_code: '19', hasCities: true },
            { id: 1477, name: 'Rukwa', state_code: '20', hasCities: true },
            { id: 1486, name: 'Ruvuma', state_code: '21', hasCities: true },
            {
                id: 1463,
                name: 'Shinyanga',
                state_code: '22',
                hasCities: true
            },
            { id: 1464, name: 'Simiyu', state_code: '30', hasCities: true },
            { id: 1474, name: 'Singida', state_code: '23', hasCities: true },
            { id: 4956, name: 'Songwe', state_code: '31', hasCities: false },
            { id: 1469, name: 'Tabora', state_code: '24', hasCities: true },
            { id: 1487, name: 'Tanga', state_code: '25', hasCities: true },
            {
                id: 1473,
                name: 'Zanzibar North',
                state_code: '07',
                hasCities: true
            },
            {
                id: 1471,
                name: 'Zanzibar South',
                state_code: '11',
                hasCities: true
            },
            {
                id: 1475,
                name: 'Zanzibar West',
                state_code: '15',
                hasCities: true
            }
        ]
    },
    {
        id: 219,
        states: [
            {
                id: 3523,
                name: 'Amnat Charoen',
                state_code: '37',
                hasCities: true
            },
            {
                id: 3519,
                name: 'Ang Thong',
                state_code: '15',
                hasCities: true
            },
            { id: 3554, name: 'Bangkok', state_code: '10', hasCities: true },
            {
                id: 3533,
                name: 'Bueng Kan',
                state_code: '38',
                hasCities: true
            },
            { id: 3534, name: 'Buri Ram', state_code: '31', hasCities: true },
            {
                id: 3552,
                name: 'Chachoengsao',
                state_code: '24',
                hasCities: true
            },
            { id: 3522, name: 'Chai Nat', state_code: '18', hasCities: true },
            {
                id: 4954,
                name: 'Chaiyaphum',
                state_code: '36',
                hasCities: true
            },
            {
                id: 3486,
                name: 'Chanthaburi',
                state_code: '22',
                hasCities: true
            },
            {
                id: 3491,
                name: 'Chiang Mai',
                state_code: '50',
                hasCities: true
            },
            {
                id: 3498,
                name: 'Chiang Rai',
                state_code: '57',
                hasCities: true
            },
            {
                id: 3513,
                name: 'Chon Buri',
                state_code: '20',
                hasCities: true
            },
            { id: 3526, name: 'Chumphon', state_code: '86', hasCities: true },
            { id: 3550, name: 'Kalasin', state_code: '46', hasCities: true },
            {
                id: 3516,
                name: 'Kamphaeng Phet',
                state_code: '62',
                hasCities: true
            },
            {
                id: 3511,
                name: 'Kanchanaburi',
                state_code: '71',
                hasCities: true
            },
            {
                id: 3485,
                name: 'Khon Kaen',
                state_code: '40',
                hasCities: true
            },
            { id: 3478, name: 'Krabi', state_code: '81', hasCities: true },
            { id: 3544, name: 'Lampang', state_code: '52', hasCities: true },
            { id: 3483, name: 'Lamphun', state_code: '51', hasCities: true },
            { id: 3509, name: 'Loei', state_code: '42', hasCities: true },
            { id: 3543, name: 'Lop Buri', state_code: '16', hasCities: true },
            {
                id: 3505,
                name: 'Mae Hong Son',
                state_code: '58',
                hasCities: true
            },
            {
                id: 3517,
                name: 'Maha Sarakham',
                state_code: '44',
                hasCities: true
            },
            { id: 3546, name: 'Mukdahan', state_code: '49', hasCities: true },
            {
                id: 3535,
                name: 'Nakhon Nayok',
                state_code: '26',
                hasCities: true
            },
            {
                id: 3503,
                name: 'Nakhon Pathom',
                state_code: '73',
                hasCities: true
            },
            {
                id: 3548,
                name: 'Nakhon Phanom',
                state_code: '48',
                hasCities: true
            },
            {
                id: 3497,
                name: 'Nakhon Ratchasima',
                state_code: '30',
                hasCities: true
            },
            {
                id: 3492,
                name: 'Nakhon Sawan',
                state_code: '60',
                hasCities: true
            },
            {
                id: 3520,
                name: 'Nakhon Si Thammarat',
                state_code: '80',
                hasCities: true
            },
            { id: 3530, name: 'Nan', state_code: '55', hasCities: true },
            {
                id: 3553,
                name: 'Narathiwat',
                state_code: '96',
                hasCities: true
            },
            {
                id: 3480,
                name: 'Nong Bua Lam Phu',
                state_code: '39',
                hasCities: true
            },
            {
                id: 3484,
                name: 'Nong Khai',
                state_code: '43',
                hasCities: true
            },
            {
                id: 3495,
                name: 'Nonthaburi',
                state_code: '12',
                hasCities: true
            },
            {
                id: 3500,
                name: 'Pathum Thani',
                state_code: '13',
                hasCities: true
            },
            { id: 3540, name: 'Pattani', state_code: '94', hasCities: true },
            { id: 3507, name: 'Pattaya', state_code: 'S', hasCities: false },
            { id: 3549, name: 'Phangnga', state_code: '82', hasCities: true },
            {
                id: 3488,
                name: 'Phatthalung',
                state_code: '93',
                hasCities: true
            },
            { id: 3538, name: 'Phayao', state_code: '56', hasCities: true },
            {
                id: 3515,
                name: 'Phetchabun',
                state_code: '67',
                hasCities: true
            },
            {
                id: 3532,
                name: 'Phetchaburi',
                state_code: '76',
                hasCities: true
            },
            { id: 3514, name: 'Phichit', state_code: '66', hasCities: true },
            {
                id: 3506,
                name: 'Phitsanulok',
                state_code: '65',
                hasCities: true
            },
            {
                id: 3494,
                name: 'Phra Nakhon Si Ayutthaya',
                state_code: '14',
                hasCities: true
            },
            { id: 3528, name: 'Phrae', state_code: '54', hasCities: true },
            { id: 3536, name: 'Phuket', state_code: '83', hasCities: true },
            {
                id: 3542,
                name: 'Prachin Buri',
                state_code: '25',
                hasCities: true
            },
            {
                id: 3508,
                name: 'Prachuap Khiri Khan',
                state_code: '77',
                hasCities: true
            },
            { id: 3479, name: 'Ranong', state_code: '85', hasCities: true },
            {
                id: 3499,
                name: 'Ratchaburi',
                state_code: '70',
                hasCities: true
            },
            { id: 3518, name: 'Rayong', state_code: '21', hasCities: true },
            { id: 3510, name: 'Roi Et', state_code: '45', hasCities: true },
            { id: 3529, name: 'Sa Kaeo', state_code: '27', hasCities: true },
            {
                id: 3501,
                name: 'Sakon Nakhon',
                state_code: '47',
                hasCities: true
            },
            {
                id: 3481,
                name: 'Samut Prakan',
                state_code: '11',
                hasCities: true
            },
            {
                id: 3504,
                name: 'Samut Sakhon',
                state_code: '74',
                hasCities: true
            },
            {
                id: 3502,
                name: 'Samut Songkhram',
                state_code: '75',
                hasCities: true
            },
            { id: 3487, name: 'Saraburi', state_code: '19', hasCities: true },
            { id: 3537, name: 'Satun', state_code: '91', hasCities: true },
            {
                id: 3547,
                name: 'Si Sa Ket',
                state_code: '33',
                hasCities: true
            },
            {
                id: 3490,
                name: 'Sing Buri',
                state_code: '17',
                hasCities: true
            },
            { id: 3539, name: 'Songkhla', state_code: '90', hasCities: true },
            {
                id: 3545,
                name: 'Sukhothai',
                state_code: '64',
                hasCities: true
            },
            {
                id: 3524,
                name: 'Suphan Buri',
                state_code: '72',
                hasCities: true
            },
            {
                id: 3482,
                name: 'Surat Thani',
                state_code: '84',
                hasCities: true
            },
            { id: 3531, name: 'Surin', state_code: '32', hasCities: true },
            { id: 3525, name: 'Tak', state_code: '63', hasCities: true },
            { id: 3541, name: 'Trang', state_code: '92', hasCities: true },
            { id: 3496, name: 'Trat', state_code: '23', hasCities: true },
            {
                id: 3512,
                name: 'Ubon Ratchathani',
                state_code: '34',
                hasCities: true
            },
            {
                id: 3527,
                name: 'Udon Thani',
                state_code: '41',
                hasCities: true
            },
            {
                id: 3551,
                name: 'Uthai Thani',
                state_code: '61',
                hasCities: true
            },
            {
                id: 3489,
                name: 'Uttaradit',
                state_code: '53',
                hasCities: true
            },
            { id: 3493, name: 'Yala', state_code: '95', hasCities: true },
            { id: 3521, name: 'Yasothon', state_code: '35', hasCities: true }
        ]
    },
    {
        id: 17,
        states: [
            { id: 3601, name: 'Acklins', state_code: 'AK', hasCities: false },
            {
                id: 3628,
                name: 'Acklins and Crooked Islands',
                state_code: 'AC',
                hasCities: false
            },
            {
                id: 3593,
                name: 'Berry Islands',
                state_code: 'BY',
                hasCities: false
            },
            { id: 3629, name: 'Bimini', state_code: 'BI', hasCities: true },
            {
                id: 3605,
                name: 'Black Point',
                state_code: 'BP',
                hasCities: false
            },
            {
                id: 3611,
                name: 'Cat Island',
                state_code: 'CI',
                hasCities: true
            },
            {
                id: 3603,
                name: 'Central Abaco',
                state_code: 'CO',
                hasCities: true
            },
            {
                id: 3631,
                name: 'Central Andros',
                state_code: 'CS',
                hasCities: false
            },
            {
                id: 3596,
                name: 'Central Eleuthera',
                state_code: 'CE',
                hasCities: false
            },
            {
                id: 3621,
                name: 'Crooked Island',
                state_code: 'CK',
                hasCities: true
            },
            {
                id: 3614,
                name: 'East Grand Bahama',
                state_code: 'EG',
                hasCities: true
            },
            { id: 3612, name: 'Exuma', state_code: 'EX', hasCities: true },
            { id: 3626, name: 'Freeport', state_code: 'FP', hasCities: true },
            {
                id: 3619,
                name: 'Fresh Creek',
                state_code: 'FC',
                hasCities: false
            },
            {
                id: 3597,
                name: "Governor's Harbour",
                state_code: 'GH',
                hasCities: false
            },
            {
                id: 3632,
                name: 'Grand Cay',
                state_code: 'GC',
                hasCities: false
            },
            {
                id: 3595,
                name: 'Green Turtle Cay',
                state_code: 'GT',
                hasCities: false
            },
            {
                id: 3613,
                name: 'Harbour Island',
                state_code: 'HI',
                hasCities: true
            },
            {
                id: 3598,
                name: 'High Rock',
                state_code: 'HR',
                hasCities: false
            },
            {
                id: 3624,
                name: 'Hope Town',
                state_code: 'HT',
                hasCities: false
            },
            { id: 3609, name: 'Inagua', state_code: 'IN', hasCities: true },
            {
                id: 3618,
                name: 'Kemps Bay',
                state_code: 'KB',
                hasCities: false
            },
            {
                id: 3610,
                name: 'Long Island',
                state_code: 'LI',
                hasCities: true
            },
            {
                id: 3625,
                name: 'Mangrove Cay',
                state_code: 'MC',
                hasCities: false
            },
            {
                id: 3604,
                name: 'Marsh Harbour',
                state_code: 'MH',
                hasCities: false
            },
            {
                id: 3633,
                name: 'Mayaguana District',
                state_code: 'MG',
                hasCities: true
            },
            {
                id: 4881,
                name: 'New Providence',
                state_code: 'NP',
                hasCities: true
            },
            {
                id: 3594,
                name: 'Nichollstown and Berry Islands',
                state_code: 'NB',
                hasCities: false
            },
            {
                id: 3616,
                name: 'North Abaco',
                state_code: 'NO',
                hasCities: true
            },
            {
                id: 3617,
                name: 'North Andros',
                state_code: 'NS',
                hasCities: true
            },
            {
                id: 3602,
                name: 'North Eleuthera',
                state_code: 'NE',
                hasCities: false
            },
            {
                id: 3615,
                name: 'Ragged Island',
                state_code: 'RI',
                hasCities: true
            },
            {
                id: 3623,
                name: 'Rock Sound',
                state_code: 'RS',
                hasCities: false
            },
            {
                id: 3600,
                name: 'Rum Cay District',
                state_code: 'RC',
                hasCities: true
            },
            {
                id: 3620,
                name: 'San Salvador and Rum Cay',
                state_code: 'SR',
                hasCities: false
            },
            {
                id: 3627,
                name: 'San Salvador Island',
                state_code: 'SS',
                hasCities: true
            },
            {
                id: 3606,
                name: 'Sandy Point',
                state_code: 'SP',
                hasCities: false
            },
            {
                id: 3608,
                name: 'South Abaco',
                state_code: 'SO',
                hasCities: false
            },
            {
                id: 3622,
                name: 'South Andros',
                state_code: 'SA',
                hasCities: false
            },
            {
                id: 3607,
                name: 'South Eleuthera',
                state_code: 'SE',
                hasCities: false
            },
            {
                id: 3630,
                name: 'Spanish Wells',
                state_code: 'SW',
                hasCities: true
            },
            {
                id: 3599,
                name: 'West Grand Bahama',
                state_code: 'WG',
                hasCities: true
            }
        ]
    },
    {
        id: 220,
        states: [
            {
                id: 2575,
                name: 'Centrale Region',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 2579,
                name: 'Kara Region',
                state_code: 'K',
                hasCities: true
            },
            { id: 2576, name: 'Maritime', state_code: 'M', hasCities: true },
            {
                id: 2577,
                name: 'Plateaux Region',
                state_code: 'P',
                hasCities: true
            },
            {
                id: 2578,
                name: 'Savanes Region',
                state_code: 'S',
                hasCities: true
            }
        ]
    },
    { id: 221, states: [] },
    {
        id: 222,
        states: [
            { id: 3913, name: 'Haʻapai', state_code: '02', hasCities: true },
            { id: 3915, name: 'ʻEua', state_code: '01', hasCities: true },
            { id: 3914, name: 'Niuas', state_code: '03', hasCities: true },
            {
                id: 3912,
                name: 'Tongatapu',
                state_code: '04',
                hasCities: true
            },
            { id: 3911, name: 'Vavaʻu', state_code: '05', hasCities: true }
        ]
    },
    {
        id: 223,
        states: [
            { id: 3362, name: 'Arima', state_code: 'ARI', hasCities: true },
            {
                id: 3366,
                name: 'Chaguanas',
                state_code: 'CHA',
                hasCities: true
            },
            {
                id: 3354,
                name: 'Couva-Tabaquite-Talparo Regional Corporation',
                state_code: 'CTT',
                hasCities: true
            },
            {
                id: 3367,
                name: 'Diego Martin Regional Corporation',
                state_code: 'DMN',
                hasCities: true
            },
            {
                id: 3355,
                name: 'Eastern Tobago',
                state_code: 'ETO',
                hasCities: true
            },
            {
                id: 3365,
                name: 'Penal-Debe Regional Corporation',
                state_code: 'PED',
                hasCities: true
            },
            {
                id: 3360,
                name: 'Point Fortin',
                state_code: 'PTF',
                hasCities: true
            },
            {
                id: 3363,
                name: 'Port of Spain',
                state_code: 'POS',
                hasCities: true
            },
            {
                id: 3368,
                name: 'Princes Town Regional Corporation',
                state_code: 'PRT',
                hasCities: true
            },
            {
                id: 3356,
                name: 'Rio Claro-Mayaro Regional Corporation',
                state_code: 'MRC',
                hasCities: false
            },
            {
                id: 3359,
                name: 'San Fernando',
                state_code: 'SFO',
                hasCities: true
            },
            {
                id: 3357,
                name: 'San Juan-Laventille Regional Corporation',
                state_code: 'SJL',
                hasCities: true
            },
            {
                id: 3361,
                name: 'Sangre Grande Regional Corporation',
                state_code: 'SGE',
                hasCities: true
            },
            {
                id: 3364,
                name: 'Siparia Regional Corporation',
                state_code: 'SIP',
                hasCities: true
            },
            {
                id: 3358,
                name: 'Tunapuna-Piarco Regional Corporation',
                state_code: 'TUP',
                hasCities: true
            },
            {
                id: 3353,
                name: 'Western Tobago',
                state_code: 'WTO',
                hasCities: true
            }
        ]
    },
    {
        id: 224,
        states: [
            { id: 2550, name: 'Ariana', state_code: '12', hasCities: true },
            {
                id: 2566,
                name: 'Ben Arous',
                state_code: '13',
                hasCities: true
            },
            { id: 2551, name: 'Bizerte', state_code: '23', hasCities: true },
            { id: 2558, name: 'Gabès', state_code: '81', hasCities: true },
            { id: 2556, name: 'Gafsa', state_code: '71', hasCities: true },
            { id: 2552, name: 'Jendouba', state_code: '32', hasCities: true },
            { id: 2564, name: 'Kairouan', state_code: '41', hasCities: true },
            {
                id: 2570,
                name: 'Kasserine',
                state_code: '42',
                hasCities: true
            },
            { id: 2572, name: 'Kassrine', state_code: '31', hasCities: true },
            { id: 2562, name: 'Kebili', state_code: '73', hasCities: true },
            { id: 2561, name: 'Kef', state_code: '33', hasCities: true },
            { id: 2568, name: 'Mahdia', state_code: '53', hasCities: true },
            { id: 2555, name: 'Manouba', state_code: '14', hasCities: true },
            { id: 2560, name: 'Medenine', state_code: '82', hasCities: true },
            { id: 2553, name: 'Monastir', state_code: '52', hasCities: true },
            { id: 5116, name: 'Nabeul', state_code: '21', hasCities: true },
            { id: 2557, name: 'Sfax', state_code: '61', hasCities: true },
            {
                id: 2567,
                name: 'Sidi Bouzid',
                state_code: '43',
                hasCities: true
            },
            { id: 2563, name: 'Siliana', state_code: '34', hasCities: true },
            { id: 2571, name: 'Sousse', state_code: '51', hasCities: true },
            {
                id: 2559,
                name: 'Tataouine',
                state_code: '83',
                hasCities: true
            },
            { id: 2569, name: 'Tozeur', state_code: '72', hasCities: true },
            { id: 2554, name: 'Tunis', state_code: '11', hasCities: true },
            { id: 2565, name: 'Zaghouan', state_code: '22', hasCities: true }
        ]
    },
    {
        id: 225,
        states: [
            { id: 2212, name: 'Adana', state_code: '01', hasCities: true },
            { id: 2155, name: 'Adıyaman', state_code: '02', hasCities: true },
            {
                id: 2179,
                name: 'Afyonkarahisar',
                state_code: '03',
                hasCities: true
            },
            { id: 2193, name: 'Ağrı', state_code: '04', hasCities: true },
            { id: 2210, name: 'Aksaray', state_code: '68', hasCities: true },
            { id: 2161, name: 'Amasya', state_code: '05', hasCities: true },
            { id: 2217, name: 'Ankara', state_code: '06', hasCities: true },
            { id: 2169, name: 'Antalya', state_code: '07', hasCities: true },
            { id: 2185, name: 'Ardahan', state_code: '75', hasCities: true },
            { id: 2191, name: 'Artvin', state_code: '08', hasCities: true },
            { id: 2187, name: 'Aydın', state_code: '09', hasCities: true },
            {
                id: 2175,
                name: 'Balıkesir',
                state_code: '10',
                hasCities: true
            },
            { id: 2148, name: 'Bartın', state_code: '74', hasCities: true },
            { id: 2194, name: 'Batman', state_code: '72', hasCities: true },
            { id: 2177, name: 'Bayburt', state_code: '69', hasCities: true },
            { id: 2221, name: 'Bilecik', state_code: '11', hasCities: true },
            { id: 2153, name: 'Bingöl', state_code: '12', hasCities: true },
            { id: 2215, name: 'Bitlis', state_code: '13', hasCities: true },
            { id: 2172, name: 'Bolu', state_code: '14', hasCities: true },
            { id: 2209, name: 'Burdur', state_code: '15', hasCities: true },
            { id: 2163, name: 'Bursa', state_code: '16', hasCities: true },
            {
                id: 2216,
                name: 'Çanakkale',
                state_code: '17',
                hasCities: true
            },
            { id: 2168, name: 'Çankırı', state_code: '18', hasCities: true },
            { id: 2173, name: 'Çorum', state_code: '19', hasCities: true },
            { id: 2157, name: 'Denizli', state_code: '20', hasCities: true },
            {
                id: 2226,
                name: 'Diyarbakır',
                state_code: '21',
                hasCities: true
            },
            { id: 2202, name: 'Düzce', state_code: '81', hasCities: true },
            { id: 2151, name: 'Edirne', state_code: '22', hasCities: true },
            { id: 2159, name: 'Elazığ', state_code: '23', hasCities: true },
            { id: 2160, name: 'Erzincan', state_code: '24', hasCities: true },
            { id: 2165, name: 'Erzurum', state_code: '25', hasCities: true },
            {
                id: 2164,
                name: 'Eskişehir',
                state_code: '26',
                hasCities: true
            },
            {
                id: 2203,
                name: 'Gaziantep',
                state_code: '27',
                hasCities: true
            },
            { id: 2186, name: 'Giresun', state_code: '28', hasCities: true },
            {
                id: 2204,
                name: 'Gümüşhane',
                state_code: '29',
                hasCities: true
            },
            { id: 2190, name: 'Hakkâri', state_code: '30', hasCities: true },
            { id: 2211, name: 'Hatay', state_code: '31', hasCities: true },
            { id: 2166, name: 'Iğdır', state_code: '76', hasCities: true },
            { id: 2222, name: 'Isparta', state_code: '32', hasCities: true },
            { id: 2170, name: 'İstanbul', state_code: '34', hasCities: true },
            { id: 2205, name: 'İzmir', state_code: '35', hasCities: true },
            {
                id: 2227,
                name: 'Kahramanmaraş',
                state_code: '46',
                hasCities: true
            },
            { id: 2223, name: 'Karabük', state_code: '78', hasCities: true },
            { id: 2184, name: 'Karaman', state_code: '70', hasCities: true },
            { id: 2208, name: 'Kars', state_code: '36', hasCities: true },
            {
                id: 2197,
                name: 'Kastamonu',
                state_code: '37',
                hasCities: true
            },
            { id: 2200, name: 'Kayseri', state_code: '38', hasCities: true },
            { id: 2154, name: 'Kilis', state_code: '79', hasCities: true },
            {
                id: 2178,
                name: 'Kırıkkale',
                state_code: '71',
                hasCities: true
            },
            {
                id: 2176,
                name: 'Kırklareli',
                state_code: '39',
                hasCities: true
            },
            { id: 2180, name: 'Kırşehir', state_code: '40', hasCities: true },
            { id: 2195, name: 'Kocaeli', state_code: '41', hasCities: true },
            { id: 2171, name: 'Konya', state_code: '42', hasCities: true },
            { id: 2149, name: 'Kütahya', state_code: '43', hasCities: true },
            { id: 2158, name: 'Malatya', state_code: '44', hasCities: true },
            { id: 2198, name: 'Manisa', state_code: '45', hasCities: true },
            { id: 2224, name: 'Mardin', state_code: '47', hasCities: true },
            { id: 2156, name: 'Mersin', state_code: '33', hasCities: true },
            { id: 2182, name: 'Muğla', state_code: '48', hasCities: true },
            { id: 2162, name: 'Muş', state_code: '49', hasCities: true },
            { id: 2196, name: 'Nevşehir', state_code: '50', hasCities: true },
            { id: 2189, name: 'Niğde', state_code: '51', hasCities: true },
            { id: 2174, name: 'Ordu', state_code: '52', hasCities: true },
            { id: 2214, name: 'Osmaniye', state_code: '80', hasCities: true },
            { id: 2219, name: 'Rize', state_code: '53', hasCities: true },
            { id: 2150, name: 'Sakarya', state_code: '54', hasCities: true },
            { id: 2220, name: 'Samsun', state_code: '55', hasCities: true },
            {
                id: 2183,
                name: 'Şanlıurfa',
                state_code: '63',
                hasCities: true
            },
            { id: 2207, name: 'Siirt', state_code: '56', hasCities: true },
            { id: 4854, name: 'Sinop', state_code: '57', hasCities: true },
            { id: 2181, name: 'Sivas', state_code: '58', hasCities: true },
            { id: 2225, name: 'Şırnak', state_code: '73', hasCities: true },
            { id: 2167, name: 'Tekirdağ', state_code: '59', hasCities: true },
            { id: 2199, name: 'Tokat', state_code: '60', hasCities: true },
            { id: 2206, name: 'Trabzon', state_code: '61', hasCities: true },
            { id: 2192, name: 'Tunceli', state_code: '62', hasCities: true },
            { id: 2201, name: 'Uşak', state_code: '64', hasCities: true },
            { id: 2152, name: 'Van', state_code: '65', hasCities: true },
            { id: 2218, name: 'Yalova', state_code: '77', hasCities: true },
            { id: 2188, name: 'Yozgat', state_code: '66', hasCities: true },
            { id: 2213, name: 'Zonguldak', state_code: '67', hasCities: true }
        ]
    },
    {
        id: 226,
        states: [
            {
                id: 3374,
                name: 'Ahal Region',
                state_code: 'A',
                hasCities: true
            },
            { id: 3371, name: 'Ashgabat', state_code: 'S', hasCities: true },
            {
                id: 3372,
                name: 'Balkan Region',
                state_code: 'B',
                hasCities: true
            },
            {
                id: 3373,
                name: 'Daşoguz Region',
                state_code: 'D',
                hasCities: true
            },
            {
                id: 3370,
                name: 'Lebap Region',
                state_code: 'L',
                hasCities: true
            },
            {
                id: 3369,
                name: 'Mary Region',
                state_code: 'M',
                hasCities: true
            }
        ]
    },
    { id: 227, states: [] },
    {
        id: 228,
        states: [
            {
                id: 3951,
                name: 'Funafuti',
                state_code: 'FUN',
                hasCities: true
            },
            {
                id: 3947,
                name: 'Nanumanga',
                state_code: 'NMG',
                hasCities: true
            },
            {
                id: 3949,
                name: 'Nanumea',
                state_code: 'NMA',
                hasCities: false
            },
            {
                id: 3946,
                name: 'Niutao Island Council',
                state_code: 'NIT',
                hasCities: true
            },
            { id: 3948, name: 'Nui', state_code: 'NUI', hasCities: true },
            {
                id: 3952,
                name: 'Nukufetau',
                state_code: 'NKF',
                hasCities: true
            },
            {
                id: 3953,
                name: 'Nukulaelae',
                state_code: 'NKL',
                hasCities: false
            },
            { id: 3950, name: 'Vaitupu', state_code: 'VAI', hasCities: true }
        ]
    },
    {
        id: 229,
        states: [
            {
                id: 329,
                name: 'Abim District',
                state_code: '314',
                hasCities: false
            },
            {
                id: 361,
                name: 'Adjumani District',
                state_code: '301',
                hasCities: false
            },
            {
                id: 392,
                name: 'Agago District',
                state_code: '322',
                hasCities: false
            },
            {
                id: 344,
                name: 'Alebtong District',
                state_code: '323',
                hasCities: false
            },
            {
                id: 416,
                name: 'Amolatar District',
                state_code: '315',
                hasCities: false
            },
            {
                id: 353,
                name: 'Amudat District',
                state_code: '324',
                hasCities: false
            },
            {
                id: 352,
                name: 'Amuria District',
                state_code: '216',
                hasCities: false
            },
            {
                id: 335,
                name: 'Amuru District',
                state_code: '316',
                hasCities: false
            },
            {
                id: 328,
                name: 'Apac District',
                state_code: '302',
                hasCities: false
            },
            {
                id: 447,
                name: 'Arua District',
                state_code: '303',
                hasCities: false
            },
            {
                id: 441,
                name: 'Budaka District',
                state_code: '217',
                hasCities: false
            },
            {
                id: 349,
                name: 'Bududa District',
                state_code: '218',
                hasCities: false
            },
            {
                id: 387,
                name: 'Bugiri District',
                state_code: '201',
                hasCities: false
            },
            {
                id: 391,
                name: 'Buhweju District',
                state_code: '420',
                hasCities: false
            },
            {
                id: 377,
                name: 'Buikwe District',
                state_code: '117',
                hasCities: false
            },
            {
                id: 343,
                name: 'Bukedea District',
                state_code: '219',
                hasCities: false
            },
            {
                id: 375,
                name: 'Bukomansimbi District',
                state_code: '118',
                hasCities: false
            },
            {
                id: 385,
                name: 'Bukwo District',
                state_code: '220',
                hasCities: false
            },
            {
                id: 428,
                name: 'Bulambuli District',
                state_code: '225',
                hasCities: false
            },
            {
                id: 389,
                name: 'Buliisa District',
                state_code: '416',
                hasCities: false
            },
            {
                id: 419,
                name: 'Bundibugyo District',
                state_code: '401',
                hasCities: false
            },
            {
                id: 381,
                name: 'Bunyangabu District',
                state_code: '430',
                hasCities: false
            },
            {
                id: 386,
                name: 'Bushenyi District',
                state_code: '402',
                hasCities: false
            },
            {
                id: 431,
                name: 'Busia District',
                state_code: '202',
                hasCities: false
            },
            {
                id: 365,
                name: 'Butaleja District',
                state_code: '221',
                hasCities: false
            },
            {
                id: 384,
                name: 'Butambala District',
                state_code: '119',
                hasCities: false
            },
            {
                id: 388,
                name: 'Butebo District',
                state_code: '233',
                hasCities: false
            },
            {
                id: 414,
                name: 'Buvuma District',
                state_code: '120',
                hasCities: false
            },
            {
                id: 380,
                name: 'Buyende District',
                state_code: '226',
                hasCities: false
            },
            {
                id: 396,
                name: 'Central Region',
                state_code: 'C',
                hasCities: true
            },
            {
                id: 341,
                name: 'Dokolo District',
                state_code: '317',
                hasCities: false
            },
            {
                id: 372,
                name: 'Eastern Region',
                state_code: 'E',
                hasCities: true
            },
            {
                id: 366,
                name: 'Gomba District',
                state_code: '121',
                hasCities: false
            },
            {
                id: 413,
                name: 'Gulu District',
                state_code: '304',
                hasCities: false
            },
            {
                id: 339,
                name: 'Ibanda District',
                state_code: '417',
                hasCities: false
            },
            {
                id: 340,
                name: 'Iganga District',
                state_code: '203',
                hasCities: false
            },
            {
                id: 383,
                name: 'Isingiro District',
                state_code: '418',
                hasCities: false
            },
            {
                id: 367,
                name: 'Jinja District',
                state_code: '204',
                hasCities: false
            },
            {
                id: 434,
                name: 'Kaabong District',
                state_code: '318',
                hasCities: false
            },
            {
                id: 426,
                name: 'Kabale District',
                state_code: '404',
                hasCities: false
            },
            {
                id: 326,
                name: 'Kabarole District',
                state_code: '405',
                hasCities: false
            },
            {
                id: 336,
                name: 'Kaberamaido District',
                state_code: '213',
                hasCities: false
            },
            {
                id: 403,
                name: 'Kagadi District',
                state_code: '427',
                hasCities: false
            },
            {
                id: 399,
                name: 'Kakumiro District',
                state_code: '428',
                hasCities: false
            },
            {
                id: 405,
                name: 'Kalangala District',
                state_code: '101',
                hasCities: false
            },
            {
                id: 398,
                name: 'Kaliro District',
                state_code: '222',
                hasCities: false
            },
            {
                id: 394,
                name: 'Kalungu District',
                state_code: '122',
                hasCities: false
            },
            {
                id: 382,
                name: 'Kampala District',
                state_code: '102',
                hasCities: false
            },
            {
                id: 334,
                name: 'Kamuli District',
                state_code: '205',
                hasCities: false
            },
            {
                id: 360,
                name: 'Kamwenge District',
                state_code: '413',
                hasCities: false
            },
            {
                id: 373,
                name: 'Kanungu District',
                state_code: '414',
                hasCities: false
            },
            {
                id: 432,
                name: 'Kapchorwa District',
                state_code: '206',
                hasCities: false
            },
            {
                id: 440,
                name: 'Kasese District',
                state_code: '406',
                hasCities: false
            },
            {
                id: 420,
                name: 'Katakwi District',
                state_code: '207',
                hasCities: false
            },
            {
                id: 368,
                name: 'Kayunga District',
                state_code: '112',
                hasCities: false
            },
            {
                id: 436,
                name: 'Kibaale District',
                state_code: '407',
                hasCities: false
            },
            {
                id: 347,
                name: 'Kiboga District',
                state_code: '103',
                hasCities: false
            },
            {
                id: 338,
                name: 'Kibuku District',
                state_code: '227',
                hasCities: false
            },
            {
                id: 355,
                name: 'Kiruhura District',
                state_code: '419',
                hasCities: false
            },
            {
                id: 346,
                name: 'Kiryandongo District',
                state_code: '421',
                hasCities: false
            },
            {
                id: 409,
                name: 'Kisoro District',
                state_code: '408',
                hasCities: false
            },
            {
                id: 348,
                name: 'Kitgum District',
                state_code: '305',
                hasCities: false
            },
            {
                id: 345,
                name: 'Koboko District',
                state_code: '319',
                hasCities: false
            },
            {
                id: 401,
                name: 'Kole District',
                state_code: '325',
                hasCities: false
            },
            {
                id: 443,
                name: 'Kotido District',
                state_code: '306',
                hasCities: false
            },
            {
                id: 425,
                name: 'Kumi District',
                state_code: '208',
                hasCities: false
            },
            {
                id: 369,
                name: 'Kween District',
                state_code: '228',
                hasCities: false
            },
            {
                id: 325,
                name: 'Kyankwanzi District',
                state_code: '123',
                hasCities: false
            },
            {
                id: 437,
                name: 'Kyegegwa District',
                state_code: '422',
                hasCities: false
            },
            {
                id: 402,
                name: 'Kyenjojo District',
                state_code: '415',
                hasCities: false
            },
            {
                id: 448,
                name: 'Kyotera District',
                state_code: '125',
                hasCities: false
            },
            {
                id: 411,
                name: 'Lamwo District',
                state_code: '326',
                hasCities: false
            },
            {
                id: 342,
                name: 'Lira District',
                state_code: '307',
                hasCities: false
            },
            {
                id: 445,
                name: 'Luuka District',
                state_code: '229',
                hasCities: false
            },
            {
                id: 433,
                name: 'Luwero District',
                state_code: '104',
                hasCities: false
            },
            {
                id: 417,
                name: 'Lwengo District',
                state_code: '124',
                hasCities: false
            },
            {
                id: 376,
                name: 'Lyantonde District',
                state_code: '114',
                hasCities: false
            },
            {
                id: 438,
                name: 'Manafwa District',
                state_code: '223',
                hasCities: false
            },
            {
                id: 421,
                name: 'Maracha District',
                state_code: '320',
                hasCities: false
            },
            {
                id: 356,
                name: 'Masaka District',
                state_code: '105',
                hasCities: false
            },
            {
                id: 354,
                name: 'Masindi District',
                state_code: '409',
                hasCities: false
            },
            {
                id: 418,
                name: 'Mayuge District',
                state_code: '214',
                hasCities: false
            },
            {
                id: 350,
                name: 'Mbale District',
                state_code: '209',
                hasCities: false
            },
            {
                id: 415,
                name: 'Mbarara District',
                state_code: '410',
                hasCities: false
            },
            {
                id: 435,
                name: 'Mitooma District',
                state_code: '423',
                hasCities: false
            },
            {
                id: 364,
                name: 'Mityana District',
                state_code: '115',
                hasCities: false
            },
            {
                id: 395,
                name: 'Moroto District',
                state_code: '308',
                hasCities: false
            },
            {
                id: 363,
                name: 'Moyo District',
                state_code: '309',
                hasCities: false
            },
            {
                id: 327,
                name: 'Mpigi District',
                state_code: '106',
                hasCities: false
            },
            {
                id: 371,
                name: 'Mubende District',
                state_code: '107',
                hasCities: false
            },
            {
                id: 410,
                name: 'Mukono District',
                state_code: '108',
                hasCities: false
            },
            {
                id: 393,
                name: 'Nakapiripirit District',
                state_code: '311',
                hasCities: false
            },
            {
                id: 423,
                name: 'Nakaseke District',
                state_code: '116',
                hasCities: false
            },
            {
                id: 406,
                name: 'Nakasongola District',
                state_code: '109',
                hasCities: false
            },
            {
                id: 351,
                name: 'Namayingo District',
                state_code: '230',
                hasCities: false
            },
            {
                id: 400,
                name: 'Namisindwa District',
                state_code: '234',
                hasCities: false
            },
            {
                id: 337,
                name: 'Namutumba District',
                state_code: '224',
                hasCities: false
            },
            {
                id: 430,
                name: 'Napak District',
                state_code: '327',
                hasCities: false
            },
            {
                id: 446,
                name: 'Nebbi District',
                state_code: '310',
                hasCities: false
            },
            {
                id: 424,
                name: 'Ngora District',
                state_code: '231',
                hasCities: false
            },
            {
                id: 332,
                name: 'Northern Region',
                state_code: 'N',
                hasCities: true
            },
            {
                id: 422,
                name: 'Ntoroko District',
                state_code: '424',
                hasCities: false
            },
            {
                id: 404,
                name: 'Ntungamo District',
                state_code: '411',
                hasCities: false
            },
            {
                id: 378,
                name: 'Nwoya District',
                state_code: '328',
                hasCities: false
            },
            {
                id: 374,
                name: 'Omoro District',
                state_code: '331',
                hasCities: false
            },
            {
                id: 390,
                name: 'Otuke District',
                state_code: '329',
                hasCities: false
            },
            {
                id: 397,
                name: 'Oyam District',
                state_code: '321',
                hasCities: false
            },
            {
                id: 408,
                name: 'Pader District',
                state_code: '312',
                hasCities: false
            },
            {
                id: 357,
                name: 'Pakwach District',
                state_code: '332',
                hasCities: false
            },
            {
                id: 412,
                name: 'Pallisa District',
                state_code: '210',
                hasCities: false
            },
            {
                id: 439,
                name: 'Rakai District',
                state_code: '110',
                hasCities: false
            },
            {
                id: 358,
                name: 'Rubanda District',
                state_code: '429',
                hasCities: false
            },
            {
                id: 442,
                name: 'Rubirizi District',
                state_code: '425',
                hasCities: false
            },
            {
                id: 331,
                name: 'Rukiga District',
                state_code: '431',
                hasCities: false
            },
            {
                id: 324,
                name: 'Rukungiri District',
                state_code: '412',
                hasCities: false
            },
            {
                id: 427,
                name: 'Sembabule District',
                state_code: '111',
                hasCities: false
            },
            {
                id: 333,
                name: 'Serere District',
                state_code: '232',
                hasCities: false
            },
            {
                id: 407,
                name: 'Sheema District',
                state_code: '426',
                hasCities: false
            },
            {
                id: 429,
                name: 'Sironko District',
                state_code: '215',
                hasCities: false
            },
            {
                id: 444,
                name: 'Soroti District',
                state_code: '211',
                hasCities: false
            },
            {
                id: 359,
                name: 'Tororo District',
                state_code: '212',
                hasCities: false
            },
            {
                id: 362,
                name: 'Wakiso District',
                state_code: '113',
                hasCities: false
            },
            {
                id: 370,
                name: 'Western Region',
                state_code: 'W',
                hasCities: true
            },
            {
                id: 330,
                name: 'Yumbe District',
                state_code: '313',
                hasCities: false
            },
            {
                id: 379,
                name: 'Zombo District',
                state_code: '330',
                hasCities: false
            }
        ]
    },
    {
        id: 230,
        states: [
            {
                id: 4689,
                name: 'Autonomous Republic of Crimea',
                state_code: '43',
                hasCities: true
            },
            {
                id: 4680,
                name: 'Cherkaska oblast',
                state_code: '71',
                hasCities: true
            },
            {
                id: 4692,
                name: 'Chernihivska oblast',
                state_code: '74',
                hasCities: true
            },
            {
                id: 4678,
                name: 'Chernivetska oblast',
                state_code: '77',
                hasCities: true
            },
            {
                id: 4675,
                name: 'Dnipropetrovska oblast',
                state_code: '12',
                hasCities: true
            },
            {
                id: 4691,
                name: 'Donetska oblast',
                state_code: '14',
                hasCities: true
            },
            {
                id: 4682,
                name: 'Ivano-Frankivska oblast',
                state_code: '26',
                hasCities: true
            },
            {
                id: 4686,
                name: 'Kharkivska oblast',
                state_code: '63',
                hasCities: true
            },
            {
                id: 4684,
                name: 'Khersonska oblast',
                state_code: '65',
                hasCities: true
            },
            {
                id: 4681,
                name: 'Khmelnytska oblast',
                state_code: '68',
                hasCities: true
            },
            {
                id: 4677,
                name: 'Kirovohradska oblast',
                state_code: '35',
                hasCities: true
            },
            { id: 4676, name: 'Kyiv', state_code: '30', hasCities: true },
            {
                id: 4671,
                name: 'Kyivska oblast',
                state_code: '32',
                hasCities: true
            },
            {
                id: 4673,
                name: 'Luhanska oblast',
                state_code: '09',
                hasCities: true
            },
            {
                id: 4672,
                name: 'Lvivska oblast',
                state_code: '46',
                hasCities: true
            },
            {
                id: 4679,
                name: 'Mykolaivska oblast',
                state_code: '48',
                hasCities: true
            },
            {
                id: 4688,
                name: 'Odeska oblast',
                state_code: '51',
                hasCities: true
            },
            {
                id: 5071,
                name: 'Poltavska oblast',
                state_code: '53',
                hasCities: true
            },
            {
                id: 4683,
                name: 'Rivnenska oblast',
                state_code: '56',
                hasCities: true
            },
            {
                id: 4685,
                name: 'Sumska oblast',
                state_code: '59',
                hasCities: true
            },
            {
                id: 4674,
                name: 'Ternopilska oblast',
                state_code: '61',
                hasCities: true
            },
            {
                id: 4669,
                name: 'Vinnytska oblast',
                state_code: '05',
                hasCities: true
            },
            {
                id: 4690,
                name: 'Volynska oblast',
                state_code: '07',
                hasCities: true
            },
            {
                id: 4670,
                name: 'Zakarpatska Oblast',
                state_code: '21',
                hasCities: true
            },
            {
                id: 4687,
                name: 'Zaporizka oblast',
                state_code: '23',
                hasCities: true
            },
            {
                id: 4668,
                name: 'Zhytomyrska oblast',
                state_code: '18',
                hasCities: true
            }
        ]
    },
    {
        id: 231,
        states: [
            {
                id: 3396,
                name: 'Abu Dhabi Emirate',
                state_code: 'AZ',
                hasCities: true
            },
            {
                id: 3395,
                name: 'Ajman Emirate',
                state_code: 'AJ',
                hasCities: true
            },
            { id: 3391, name: 'Dubai', state_code: 'DU', hasCities: true },
            { id: 3393, name: 'Fujairah', state_code: 'FU', hasCities: true },
            {
                id: 3394,
                name: 'Ras al-Khaimah',
                state_code: 'RK',
                hasCities: true
            },
            {
                id: 3390,
                name: 'Sharjah Emirate',
                state_code: 'SH',
                hasCities: true
            },
            {
                id: 3392,
                name: 'Umm al-Quwain',
                state_code: 'UQ',
                hasCities: true
            }
        ]
    },
    {
        id: 232,
        states: [
            { id: 2498, name: 'Ards', state_code: 'ARD', hasCities: false },
            {
                id: 2378,
                name: 'Ascension Island',
                state_code: 'SH-AC',
                hasCities: false
            },
            {
                id: 2363,
                name: 'Ballymena Borough',
                state_code: 'BLA',
                hasCities: false
            },
            {
                id: 2311,
                name: 'Belfast district',
                state_code: 'BFS',
                hasCities: false
            },
            {
                id: 2530,
                name: 'Blaenau Gwent County Borough',
                state_code: 'BGW',
                hasCities: false
            },
            {
                id: 2439,
                name: 'Carrickfergus Borough Council',
                state_code: 'CKF',
                hasCities: false
            },
            {
                id: 2509,
                name: 'Ceredigion',
                state_code: 'CGN',
                hasCities: false
            },
            {
                id: 2528,
                name: 'City and County of Cardiff',
                state_code: 'CRF',
                hasCities: false
            },
            {
                id: 2485,
                name: 'City of Derby',
                state_code: 'DER',
                hasCities: false
            },
            {
                id: 2359,
                name: 'City of Nottingham',
                state_code: 'NGM',
                hasCities: false
            },
            {
                id: 2297,
                name: 'City of Peterborough',
                state_code: 'PTE',
                hasCities: false
            },
            {
                id: 2514,
                name: 'City of Plymouth',
                state_code: 'PLY',
                hasCities: false
            },
            {
                id: 2294,
                name: 'City of Southampton',
                state_code: 'STH',
                hasCities: false
            },
            {
                id: 2506,
                name: 'City of Stoke-on-Trent',
                state_code: 'STE',
                hasCities: false
            },
            {
                id: 2372,
                name: 'City of Sunderland',
                state_code: 'SND',
                hasCities: false
            },
            {
                id: 2489,
                name: 'City of Wolverhampton',
                state_code: 'WLV',
                hasCities: false
            },
            {
                id: 2461,
                name: 'Coleraine Borough Council',
                state_code: 'CLR',
                hasCities: false
            },
            {
                id: 2352,
                name: 'Conwy County Borough',
                state_code: 'CWY',
                hasCities: false
            },
            {
                id: 2445,
                name: 'Cookstown District Council',
                state_code: 'CKT',
                hasCities: false
            },
            {
                id: 2449,
                name: 'Craigavon Borough Council',
                state_code: 'CGV',
                hasCities: false
            },
            {
                id: 2417,
                name: 'Derry City Council',
                state_code: 'DRY',
                hasCities: false
            },
            {
                id: 2508,
                name: 'Dungannon and South Tyrone Borough Council',
                state_code: 'DGN',
                hasCities: false
            },
            {
                id: 2531,
                name: 'Fermanagh District Council',
                state_code: 'FER',
                hasCities: false
            },
            {
                id: 2437,
                name: 'Flintshire',
                state_code: 'FLN',
                hasCities: false
            },
            {
                id: 2515,
                name: 'Larne Borough Council',
                state_code: 'LRN',
                hasCities: false
            },
            {
                id: 2382,
                name: 'Limavady Borough Council',
                state_code: 'LMV',
                hasCities: false
            },
            {
                id: 2494,
                name: 'Lisburn City Council',
                state_code: 'LSB',
                hasCities: false
            },
            {
                id: 2356,
                name: 'London Borough of Barking and Dagenham',
                state_code: 'BDG',
                hasCities: false
            },
            {
                id: 2520,
                name: 'London Borough of Barnet',
                state_code: 'BNE',
                hasCities: false
            },
            {
                id: 2307,
                name: 'London Borough of Bexley',
                state_code: 'BEX',
                hasCities: false
            },
            {
                id: 2291,
                name: 'London Borough of Brent',
                state_code: 'BEN',
                hasCities: false
            },
            {
                id: 2490,
                name: 'London Borough of Bromley',
                state_code: 'BRY',
                hasCities: false
            },
            {
                id: 2349,
                name: 'London Borough of Camden',
                state_code: 'CMD',
                hasCities: false
            },
            {
                id: 2512,
                name: 'London Borough of Croydon',
                state_code: 'CRY',
                hasCities: false
            },
            {
                id: 2532,
                name: 'London Borough of Ealing',
                state_code: 'EAL',
                hasCities: false
            },
            {
                id: 2476,
                name: 'London Borough of Enfield',
                state_code: 'ENF',
                hasCities: false
            },
            {
                id: 2411,
                name: 'London Borough of Hackney',
                state_code: 'HCK',
                hasCities: false
            },
            {
                id: 2448,
                name: 'London Borough of Hammersmith and Fulham',
                state_code: 'HMF',
                hasCities: false
            },
            {
                id: 2306,
                name: 'London Borough of Haringey',
                state_code: 'HRY',
                hasCities: false
            },
            {
                id: 2385,
                name: 'London Borough of Harrow',
                state_code: 'HRW',
                hasCities: false
            },
            {
                id: 2347,
                name: 'London Borough of Havering',
                state_code: 'HAV',
                hasCities: false
            },
            {
                id: 2376,
                name: 'London Borough of Hillingdon',
                state_code: 'HIL',
                hasCities: false
            },
            {
                id: 2380,
                name: 'London Borough of Hounslow',
                state_code: 'HNS',
                hasCities: false
            },
            {
                id: 2319,
                name: 'London Borough of Islington',
                state_code: 'ISL',
                hasCities: false
            },
            {
                id: 2396,
                name: 'London Borough of Lambeth',
                state_code: 'LBH',
                hasCities: false
            },
            {
                id: 2358,
                name: 'London Borough of Lewisham',
                state_code: 'LEW',
                hasCities: false
            },
            {
                id: 2483,
                name: 'London Borough of Merton',
                state_code: 'MRT',
                hasCities: false
            },
            {
                id: 2418,
                name: 'London Borough of Newham',
                state_code: 'NWM',
                hasCities: false
            },
            {
                id: 2397,
                name: 'London Borough of Redbridge',
                state_code: 'RDB',
                hasCities: false
            },
            {
                id: 2501,
                name: 'London Borough of Richmond upon Thames',
                state_code: 'RIC',
                hasCities: false
            },
            {
                id: 2432,
                name: 'London Borough of Southwark',
                state_code: 'SWK',
                hasCities: false
            },
            {
                id: 2313,
                name: 'London Borough of Sutton',
                state_code: 'STN',
                hasCities: false
            },
            {
                id: 2390,
                name: 'London Borough of Tower Hamlets',
                state_code: 'TWH',
                hasCities: false
            },
            {
                id: 2326,
                name: 'London Borough of Waltham Forest',
                state_code: 'WFT',
                hasCities: false
            },
            {
                id: 2434,
                name: 'London Borough of Wandsworth',
                state_code: 'WND',
                hasCities: false
            },
            {
                id: 2322,
                name: 'Magherafelt District Council',
                state_code: 'MFT',
                hasCities: false
            },
            {
                id: 2320,
                name: 'Metropolitan Borough of Wigan',
                state_code: 'WGN',
                hasCities: false
            },
            {
                id: 2348,
                name: 'Moyle District Council',
                state_code: 'MYL',
                hasCities: false
            },
            {
                id: 2351,
                name: 'Neath Port Talbot County Borough',
                state_code: 'NTL',
                hasCities: false
            },
            {
                id: 2350,
                name: 'Newry and Mourne District Council',
                state_code: 'NYM',
                hasCities: false
            },
            {
                id: 2534,
                name: 'Newry, Mourne and Down',
                state_code: 'NMD',
                hasCities: false
            },
            {
                id: 2317,
                name: 'Newtownabbey Borough Council',
                state_code: 'NTA',
                hasCities: false
            },
            {
                id: 2473,
                name: 'Norfolk',
                state_code: 'NFK',
                hasCities: false
            },
            {
                id: 2513,
                name: 'North Down Borough Council',
                state_code: 'NDN',
                hasCities: false
            },
            {
                id: 2521,
                name: 'North Tyneside',
                state_code: 'NTY',
                hasCities: false
            },
            {
                id: 2337,
                name: 'Northern Ireland',
                state_code: 'NIR',
                hasCities: true
            },
            {
                id: 2314,
                name: 'Omagh District Council',
                state_code: 'OMH',
                hasCities: false
            },
            {
                id: 2353,
                name: 'Outer Hebrides',
                state_code: 'ELS',
                hasCities: false
            },
            { id: 2441, name: 'Powys', state_code: 'POW', hasCities: false },
            {
                id: 2492,
                name: 'Royal Borough of Greenwich',
                state_code: 'GRE',
                hasCities: false
            },
            {
                id: 2368,
                name: 'Royal Borough of Kensington and Chelsea',
                state_code: 'KEC',
                hasCities: false
            },
            {
                id: 2481,
                name: 'Royal Borough of Kingston upon Thames',
                state_code: 'KTT',
                hasCities: false
            },
            {
                id: 2393,
                name: 'Strabane District Council',
                state_code: 'STB',
                hasCities: false
            },
            {
                id: 2375,
                name: 'United Kingdom',
                state_code: 'UKM',
                hasCities: false
            }
        ]
    },
    {
        id: 233,
        states: [
            { id: 1456, name: 'Alabama', state_code: 'AL', hasCities: true },
            { id: 1400, name: 'Alaska', state_code: 'AK', hasCities: true },
            {
                id: 1424,
                name: 'American Samoa',
                state_code: 'AS',
                hasCities: false
            },
            { id: 1434, name: 'Arizona', state_code: 'AZ', hasCities: true },
            { id: 1444, name: 'Arkansas', state_code: 'AR', hasCities: true },
            {
                id: 1402,
                name: 'Baker Island',
                state_code: 'UM-81',
                hasCities: false
            },
            {
                id: 1416,
                name: 'California',
                state_code: 'CA',
                hasCities: true
            },
            { id: 1450, name: 'Colorado', state_code: 'CO', hasCities: true },
            {
                id: 1435,
                name: 'Connecticut',
                state_code: 'CT',
                hasCities: true
            },
            { id: 1399, name: 'Delaware', state_code: 'DE', hasCities: true },
            {
                id: 1437,
                name: 'District of Columbia',
                state_code: 'DC',
                hasCities: true
            },
            { id: 1436, name: 'Florida', state_code: 'FL', hasCities: true },
            { id: 1455, name: 'Georgia', state_code: 'GA', hasCities: true },
            { id: 1412, name: 'Guam', state_code: 'GU', hasCities: false },
            { id: 1411, name: 'Hawaii', state_code: 'HI', hasCities: true },
            {
                id: 1398,
                name: 'Howland Island',
                state_code: 'UM-84',
                hasCities: false
            },
            { id: 1460, name: 'Idaho', state_code: 'ID', hasCities: true },
            { id: 1425, name: 'Illinois', state_code: 'IL', hasCities: true },
            { id: 1440, name: 'Indiana', state_code: 'IN', hasCities: true },
            { id: 1459, name: 'Iowa', state_code: 'IA', hasCities: true },
            {
                id: 1410,
                name: 'Jarvis Island',
                state_code: 'UM-86',
                hasCities: false
            },
            {
                id: 1428,
                name: 'Johnston Atoll',
                state_code: 'UM-67',
                hasCities: false
            },
            { id: 1406, name: 'Kansas', state_code: 'KS', hasCities: true },
            { id: 1419, name: 'Kentucky', state_code: 'KY', hasCities: true },
            {
                id: 1403,
                name: 'Kingman Reef',
                state_code: 'UM-89',
                hasCities: false
            },
            {
                id: 1457,
                name: 'Louisiana',
                state_code: 'LA',
                hasCities: true
            },
            { id: 1453, name: 'Maine', state_code: 'ME', hasCities: true },
            { id: 1401, name: 'Maryland', state_code: 'MD', hasCities: true },
            {
                id: 1433,
                name: 'Massachusetts',
                state_code: 'MA',
                hasCities: true
            },
            { id: 1426, name: 'Michigan', state_code: 'MI', hasCities: true },
            {
                id: 1438,
                name: 'Midway Atoll',
                state_code: 'UM-71',
                hasCities: false
            },
            {
                id: 1420,
                name: 'Minnesota',
                state_code: 'MN',
                hasCities: true
            },
            {
                id: 1430,
                name: 'Mississippi',
                state_code: 'MS',
                hasCities: true
            },
            { id: 1451, name: 'Missouri', state_code: 'MO', hasCities: true },
            { id: 1446, name: 'Montana', state_code: 'MT', hasCities: true },
            {
                id: 1439,
                name: 'Navassa Island',
                state_code: 'UM-76',
                hasCities: false
            },
            { id: 1408, name: 'Nebraska', state_code: 'NE', hasCities: true },
            { id: 1458, name: 'Nevada', state_code: 'NV', hasCities: true },
            {
                id: 1404,
                name: 'New Hampshire',
                state_code: 'NH',
                hasCities: true
            },
            {
                id: 1417,
                name: 'New Jersey',
                state_code: 'NJ',
                hasCities: true
            },
            {
                id: 1423,
                name: 'New Mexico',
                state_code: 'NM',
                hasCities: true
            },
            { id: 1452, name: 'New York', state_code: 'NY', hasCities: true },
            {
                id: 1447,
                name: 'North Carolina',
                state_code: 'NC',
                hasCities: true
            },
            {
                id: 1418,
                name: 'North Dakota',
                state_code: 'ND',
                hasCities: true
            },
            {
                id: 1431,
                name: 'Northern Mariana Islands',
                state_code: 'MP',
                hasCities: false
            },
            { id: 4851, name: 'Ohio', state_code: 'OH', hasCities: true },
            { id: 1421, name: 'Oklahoma', state_code: 'OK', hasCities: true },
            { id: 1415, name: 'Oregon', state_code: 'OR', hasCities: true },
            {
                id: 1448,
                name: 'Palmyra Atoll',
                state_code: 'UM-95',
                hasCities: false
            },
            {
                id: 1422,
                name: 'Pennsylvania',
                state_code: 'PA',
                hasCities: true
            },
            {
                id: 1449,
                name: 'Puerto Rico',
                state_code: 'PR',
                hasCities: true
            },
            {
                id: 1461,
                name: 'Rhode Island',
                state_code: 'RI',
                hasCities: true
            },
            {
                id: 1443,
                name: 'South Carolina',
                state_code: 'SC',
                hasCities: true
            },
            {
                id: 1445,
                name: 'South Dakota',
                state_code: 'SD',
                hasCities: true
            },
            {
                id: 1454,
                name: 'Tennessee',
                state_code: 'TN',
                hasCities: true
            },
            { id: 1407, name: 'Texas', state_code: 'TX', hasCities: true },
            {
                id: 1432,
                name: 'United States Minor Outlying Islands',
                state_code: 'UM',
                hasCities: false
            },
            {
                id: 1413,
                name: 'United States Virgin Islands',
                state_code: 'VI',
                hasCities: false
            },
            { id: 1414, name: 'Utah', state_code: 'UT', hasCities: true },
            { id: 1409, name: 'Vermont', state_code: 'VT', hasCities: true },
            { id: 1427, name: 'Virginia', state_code: 'VA', hasCities: true },
            {
                id: 1405,
                name: 'Wake Island',
                state_code: 'UM-79',
                hasCities: false
            },
            {
                id: 1462,
                name: 'Washington',
                state_code: 'WA',
                hasCities: true
            },
            {
                id: 1429,
                name: 'West Virginia',
                state_code: 'WV',
                hasCities: true
            },
            {
                id: 1441,
                name: 'Wisconsin',
                state_code: 'WI',
                hasCities: true
            },
            { id: 1442, name: 'Wyoming', state_code: 'WY', hasCities: true }
        ]
    },
    { id: 234, states: [] },
    {
        id: 235,
        states: [
            {
                id: 3205,
                name: 'Artigas Department',
                state_code: 'AR',
                hasCities: true
            },
            {
                id: 3213,
                name: 'Canelones Department',
                state_code: 'CA',
                hasCities: true
            },
            {
                id: 3211,
                name: 'Cerro Largo Department',
                state_code: 'CL',
                hasCities: true
            },
            {
                id: 3208,
                name: 'Colonia Department',
                state_code: 'CO',
                hasCities: true
            },
            {
                id: 3209,
                name: 'Durazno Department',
                state_code: 'DU',
                hasCities: true
            },
            {
                id: 3203,
                name: 'Flores Department',
                state_code: 'FS',
                hasCities: true
            },
            {
                id: 3217,
                name: 'Florida Department',
                state_code: 'FD',
                hasCities: true
            },
            {
                id: 3215,
                name: 'Lavalleja Department',
                state_code: 'LA',
                hasCities: true
            },
            {
                id: 3206,
                name: 'Maldonado Department',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 3218,
                name: 'Montevideo Department',
                state_code: 'MO',
                hasCities: true
            },
            {
                id: 3212,
                name: 'Paysandú Department',
                state_code: 'PA',
                hasCities: true
            },
            {
                id: 3210,
                name: 'Río Negro Department',
                state_code: 'RN',
                hasCities: true
            },
            {
                id: 3207,
                name: 'Rivera Department',
                state_code: 'RV',
                hasCities: true
            },
            {
                id: 3216,
                name: 'Rocha Department',
                state_code: 'RO',
                hasCities: true
            },
            {
                id: 3220,
                name: 'Salto Department',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 3204,
                name: 'San José Department',
                state_code: 'SJ',
                hasCities: true
            },
            {
                id: 3219,
                name: 'Soriano Department',
                state_code: 'SO',
                hasCities: true
            },
            {
                id: 3221,
                name: 'Tacuarembó Department',
                state_code: 'TA',
                hasCities: true
            },
            {
                id: 3214,
                name: 'Treinta y Tres Department',
                state_code: 'TT',
                hasCities: true
            }
        ]
    },
    {
        id: 236,
        states: [
            {
                id: 2540,
                name: 'Andijan Region',
                state_code: 'AN',
                hasCities: true
            },
            {
                id: 2541,
                name: 'Bukhara Region',
                state_code: 'BU',
                hasCities: true
            },
            {
                id: 2538,
                name: 'Fergana Region',
                state_code: 'FA',
                hasCities: true
            },
            {
                id: 2545,
                name: 'Jizzakh Region',
                state_code: 'JI',
                hasCities: true
            },
            {
                id: 2548,
                name: 'Karakalpakstan',
                state_code: 'QR',
                hasCities: true
            },
            {
                id: 2537,
                name: 'Namangan Region',
                state_code: 'NG',
                hasCities: true
            },
            {
                id: 2542,
                name: 'Navoiy Region',
                state_code: 'NW',
                hasCities: true
            },
            {
                id: 2543,
                name: 'Qashqadaryo Region',
                state_code: 'QA',
                hasCities: true
            },
            {
                id: 2544,
                name: 'Samarqand Region',
                state_code: 'SA',
                hasCities: true
            },
            {
                id: 2547,
                name: 'Sirdaryo Region',
                state_code: 'SI',
                hasCities: true
            },
            {
                id: 2546,
                name: 'Surxondaryo Region',
                state_code: 'SU',
                hasCities: true
            },
            { id: 2536, name: 'Tashkent', state_code: 'TK', hasCities: true },
            {
                id: 2549,
                name: 'Tashkent Region',
                state_code: 'TO',
                hasCities: true
            },
            {
                id: 2539,
                name: 'Xorazm Region',
                state_code: 'XO',
                hasCities: true
            }
        ]
    },
    {
        id: 237,
        states: [
            { id: 4775, name: 'Malampa', state_code: 'MAP', hasCities: true },
            { id: 4773, name: 'Penama', state_code: 'PAM', hasCities: false },
            { id: 4776, name: 'Sanma', state_code: 'SAM', hasCities: true },
            { id: 4774, name: 'Shefa', state_code: 'SEE', hasCities: true },
            { id: 4777, name: 'Tafea', state_code: 'TAE', hasCities: true },
            { id: 4772, name: 'Torba', state_code: 'TOB', hasCities: true }
        ]
    },
    { id: 238, states: [] },
    {
        id: 239,
        states: [
            { id: 2044, name: 'Amazonas', state_code: 'Z', hasCities: true },
            {
                id: 2050,
                name: 'Anzoátegui',
                state_code: 'B',
                hasCities: true
            },
            { id: 4856, name: 'Apure', state_code: 'C', hasCities: true },
            { id: 2047, name: 'Aragua', state_code: 'D', hasCities: true },
            { id: 2049, name: 'Barinas', state_code: 'E', hasCities: true },
            { id: 2039, name: 'Bolívar', state_code: 'F', hasCities: true },
            { id: 2040, name: 'Carabobo', state_code: 'G', hasCities: true },
            { id: 2034, name: 'Cojedes', state_code: 'H', hasCities: true },
            {
                id: 2051,
                name: 'Delta Amacuro',
                state_code: 'Y',
                hasCities: true
            },
            {
                id: 4855,
                name: 'Distrito Capital',
                state_code: 'A',
                hasCities: true
            },
            { id: 2035, name: 'Falcón', state_code: 'I', hasCities: true },
            {
                id: 2046,
                name: 'Federal Dependencies of Venezuela',
                state_code: 'W',
                hasCities: false
            },
            { id: 2045, name: 'Guárico', state_code: 'J', hasCities: true },
            { id: 2055, name: 'La Guaira', state_code: 'X', hasCities: true },
            { id: 2038, name: 'Lara', state_code: 'K', hasCities: true },
            { id: 2053, name: 'Mérida', state_code: 'L', hasCities: true },
            { id: 2037, name: 'Miranda', state_code: 'M', hasCities: true },
            { id: 2054, name: 'Monagas', state_code: 'N', hasCities: true },
            {
                id: 2052,
                name: 'Nueva Esparta',
                state_code: 'O',
                hasCities: true
            },
            {
                id: 2036,
                name: 'Portuguesa',
                state_code: 'P',
                hasCities: true
            },
            { id: 2056, name: 'Sucre', state_code: 'R', hasCities: true },
            { id: 2048, name: 'Táchira', state_code: 'S', hasCities: true },
            { id: 2043, name: 'Trujillo', state_code: 'T', hasCities: true },
            { id: 2041, name: 'Yaracuy', state_code: 'U', hasCities: true },
            { id: 2042, name: 'Zulia', state_code: 'V', hasCities: true }
        ]
    },
    {
        id: 240,
        states: [
            { id: 3794, name: 'An Giang', state_code: '44', hasCities: true },
            {
                id: 3770,
                name: 'Bà Rịa-Vũng Tàu',
                state_code: '43',
                hasCities: true
            },
            {
                id: 3815,
                name: 'Bắc Giang',
                state_code: '54',
                hasCities: true
            },
            { id: 3822, name: 'Bắc Kạn', state_code: '53', hasCities: true },
            { id: 3804, name: 'Bạc Liêu', state_code: '55', hasCities: true },
            { id: 3791, name: 'Bắc Ninh', state_code: '56', hasCities: true },
            { id: 3796, name: 'Bến Tre', state_code: '50', hasCities: true },
            {
                id: 3785,
                name: 'Bình Dương',
                state_code: '57',
                hasCities: true
            },
            {
                id: 3830,
                name: 'Bình Định',
                state_code: '31',
                hasCities: true
            },
            {
                id: 3797,
                name: 'Bình Phước',
                state_code: '58',
                hasCities: true
            },
            {
                id: 3787,
                name: 'Bình Thuận',
                state_code: '40',
                hasCities: true
            },
            { id: 3778, name: 'Cà Mau', state_code: '59', hasCities: true },
            { id: 4925, name: 'Cần Thơ', state_code: 'CT', hasCities: true },
            { id: 3782, name: 'Cao Bằng', state_code: '04', hasCities: true },
            { id: 3806, name: 'Đà Nẵng', state_code: 'DN', hasCities: true },
            { id: 3829, name: 'Đắk Lắk', state_code: '33', hasCities: true },
            { id: 3823, name: 'Đắk Nông', state_code: '72', hasCities: true },
            {
                id: 3773,
                name: 'Điện Biên',
                state_code: '71',
                hasCities: true
            },
            { id: 3821, name: 'Đồng Nai', state_code: '39', hasCities: true },
            {
                id: 3769,
                name: 'Đồng Tháp',
                state_code: '45',
                hasCities: true
            },
            { id: 3813, name: 'Gia Lai', state_code: '30', hasCities: true },
            { id: 3779, name: 'Hà Giang', state_code: '03', hasCities: true },
            { id: 3802, name: 'Hà Nam', state_code: '63', hasCities: true },
            { id: 3810, name: 'Hà Nội', state_code: 'HN', hasCities: true },
            { id: 3816, name: 'Hà Tĩnh', state_code: '23', hasCities: true },
            {
                id: 3827,
                name: 'Hải Dương',
                state_code: '61',
                hasCities: true
            },
            {
                id: 3783,
                name: 'Hải Phòng',
                state_code: 'HP',
                hasCities: true
            },
            {
                id: 3777,
                name: 'Hậu Giang',
                state_code: '73',
                hasCities: true
            },
            {
                id: 3811,
                name: 'Hồ Chí Minh',
                state_code: 'SG',
                hasCities: true
            },
            { id: 3799, name: 'Hòa Bình', state_code: '14', hasCities: true },
            { id: 3768, name: 'Hưng Yên', state_code: '66', hasCities: true },
            {
                id: 3793,
                name: 'Khánh Hòa',
                state_code: '34',
                hasCities: true
            },
            {
                id: 3800,
                name: 'Kiên Giang',
                state_code: '47',
                hasCities: true
            },
            { id: 3772, name: 'Kon Tum', state_code: '28', hasCities: true },
            { id: 3825, name: 'Lai Châu', state_code: '01', hasCities: true },
            { id: 3818, name: 'Lâm Đồng', state_code: '35', hasCities: true },
            { id: 3792, name: 'Lạng Sơn', state_code: '09', hasCities: true },
            { id: 3817, name: 'Lào Cai', state_code: '02', hasCities: true },
            { id: 3808, name: 'Long An', state_code: '41', hasCities: true },
            { id: 3789, name: 'Nam Định', state_code: '67', hasCities: true },
            { id: 3780, name: 'Nghệ An', state_code: '22', hasCities: true },
            {
                id: 3786,
                name: 'Ninh Bình',
                state_code: '18',
                hasCities: true
            },
            {
                id: 3788,
                name: 'Ninh Thuận',
                state_code: '36',
                hasCities: true
            },
            { id: 3801, name: 'Phú Thọ', state_code: '68', hasCities: true },
            { id: 3824, name: 'Phú Yên', state_code: '32', hasCities: true },
            {
                id: 3809,
                name: 'Quảng Bình',
                state_code: '24',
                hasCities: true
            },
            {
                id: 3776,
                name: 'Quảng Nam',
                state_code: '27',
                hasCities: true
            },
            {
                id: 3828,
                name: 'Quảng Ngãi',
                state_code: '29',
                hasCities: true
            },
            {
                id: 3814,
                name: 'Quảng Ninh',
                state_code: '13',
                hasCities: true
            },
            {
                id: 3803,
                name: 'Quảng Trị',
                state_code: '25',
                hasCities: true
            },
            {
                id: 3819,
                name: 'Sóc Trăng',
                state_code: '52',
                hasCities: true
            },
            { id: 3812, name: 'Sơn La', state_code: '05', hasCities: true },
            { id: 3826, name: 'Tây Ninh', state_code: '37', hasCities: true },
            {
                id: 3775,
                name: 'Thái Bình',
                state_code: '20',
                hasCities: true
            },
            {
                id: 3807,
                name: 'Thái Nguyên',
                state_code: '69',
                hasCities: true
            },
            {
                id: 3771,
                name: 'Thanh Hóa',
                state_code: '21',
                hasCities: true
            },
            {
                id: 3798,
                name: 'Thừa Thiên-Huế',
                state_code: '26',
                hasCities: true
            },
            {
                id: 3781,
                name: 'Tiền Giang',
                state_code: '46',
                hasCities: true
            },
            { id: 3805, name: 'Trà Vinh', state_code: '51', hasCities: true },
            {
                id: 3795,
                name: 'Tuyên Quang',
                state_code: '07',
                hasCities: true
            },
            {
                id: 3790,
                name: 'Vĩnh Long',
                state_code: '49',
                hasCities: true
            },
            {
                id: 3774,
                name: 'Vĩnh Phúc',
                state_code: '70',
                hasCities: true
            },
            { id: 3784, name: 'Yên Bái', state_code: '06', hasCities: true }
        ]
    },
    { id: 241, states: [] },
    {
        id: 242,
        states: [
            {
                id: 5074,
                name: 'Saint Croix',
                state_code: 'SC',
                hasCities: true
            },
            {
                id: 5073,
                name: 'Saint John',
                state_code: 'SJ',
                hasCities: true
            },
            {
                id: 5072,
                name: 'Saint Thomas',
                state_code: 'ST',
                hasCities: true
            }
        ]
    },
    { id: 243, states: [] },
    { id: 244, states: [] },
    {
        id: 245,
        states: [
            { id: 1242, name: "'Adan", state_code: 'AD', hasCities: true },
            { id: 1250, name: "'Amran", state_code: 'AM', hasCities: true },
            { id: 1237, name: 'Abyan', state_code: 'AB', hasCities: true },
            {
                id: 1240,
                name: "Al Bayda'",
                state_code: 'BA',
                hasCities: true
            },
            {
                id: 1241,
                name: 'Al Hudaydah',
                state_code: 'HU',
                hasCities: true
            },
            { id: 1243, name: 'Al Jawf', state_code: 'JA', hasCities: true },
            {
                id: 1251,
                name: 'Al Mahrah',
                state_code: 'MR',
                hasCities: true
            },
            {
                id: 1235,
                name: 'Al Mahwit',
                state_code: 'MW',
                hasCities: true
            },
            { id: 1246, name: 'Dhamar', state_code: 'DH', hasCities: true },
            {
                id: 1238,
                name: 'Hadhramaut',
                state_code: 'HD',
                hasCities: true
            },
            { id: 1244, name: 'Hajjah', state_code: 'HJ', hasCities: true },
            { id: 1233, name: 'Ibb', state_code: 'IB', hasCities: true },
            { id: 1245, name: 'Lahij', state_code: 'LA', hasCities: true },
            { id: 1234, name: "Ma'rib", state_code: 'MA', hasCities: true },
            { id: 1248, name: 'Raymah', state_code: 'RA', hasCities: true },
            { id: 1249, name: 'Saada', state_code: 'SD', hasCities: true },
            { id: 1236, name: "Sana'a", state_code: 'SN', hasCities: true },
            { id: 1232, name: "Sana'a", state_code: 'SA', hasCities: false },
            { id: 1247, name: 'Shabwah', state_code: 'SH', hasCities: true },
            { id: 1239, name: 'Socotra', state_code: 'SU', hasCities: true },
            { id: 1231, name: "Ta'izz", state_code: 'TA', hasCities: true }
        ]
    },
    {
        id: 246,
        states: [
            {
                id: 1986,
                name: 'Central Province',
                state_code: '02',
                hasCities: true
            },
            {
                id: 1984,
                name: 'Copperbelt Province',
                state_code: '08',
                hasCities: true
            },
            {
                id: 1991,
                name: 'Eastern Province',
                state_code: '03',
                hasCities: true
            },
            {
                id: 1987,
                name: 'Luapula Province',
                state_code: '04',
                hasCities: true
            },
            {
                id: 1988,
                name: 'Lusaka Province',
                state_code: '09',
                hasCities: true
            },
            {
                id: 1989,
                name: 'Muchinga Province',
                state_code: '10',
                hasCities: true
            },
            {
                id: 1982,
                name: 'Northern Province',
                state_code: '05',
                hasCities: true
            },
            {
                id: 1985,
                name: 'Northwestern Province',
                state_code: '06',
                hasCities: true
            },
            {
                id: 1990,
                name: 'Southern Province',
                state_code: '07',
                hasCities: true
            },
            {
                id: 1983,
                name: 'Western Province',
                state_code: '01',
                hasCities: true
            }
        ]
    },
    {
        id: 247,
        states: [
            {
                id: 1956,
                name: 'Bulawayo Province',
                state_code: 'BU',
                hasCities: true
            },
            {
                id: 1958,
                name: 'Harare Province',
                state_code: 'HA',
                hasCities: true
            },
            {
                id: 1959,
                name: 'Manicaland',
                state_code: 'MA',
                hasCities: true
            },
            {
                id: 1955,
                name: 'Mashonaland Central Province',
                state_code: 'MC',
                hasCities: true
            },
            {
                id: 1951,
                name: 'Mashonaland East Province',
                state_code: 'ME',
                hasCities: true
            },
            {
                id: 1953,
                name: 'Mashonaland West Province',
                state_code: 'MW',
                hasCities: true
            },
            {
                id: 1960,
                name: 'Masvingo Province',
                state_code: 'MV',
                hasCities: true
            },
            {
                id: 1954,
                name: 'Matabeleland North Province',
                state_code: 'MN',
                hasCities: true
            },
            {
                id: 1952,
                name: 'Matabeleland South Province',
                state_code: 'MS',
                hasCities: true
            },
            {
                id: 1957,
                name: 'Midlands Province',
                state_code: 'MI',
                hasCities: true
            }
        ]
    }
];
